import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | undefined;
export type InputMaybe<T> = T | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: string; output: string; }
  DateTime: { input: string; output: string; }
  Decimal: { input: number; output: number; }
};

export type AccessStatus = {
  status: ListingAccessStatuses;
};

/** The access token object */
export type AccessToken = {
  /** The raw refresh token */
  refreshToken: Scalars['String']['output'];
  /** The raw access token */
  token: Scalars['String']['output'];
};

/** The account object */
export type Account = {
  /** The accounts review summaries array */
  accountReviewSummaries: Array<AccountReviewSummary>;
  /** The number of active listings belonging to an account */
  activeListingsCount: Scalars['Int']['output'];
  /** The address line one associated with the account */
  addressLineOne?: Maybe<Scalars['String']['output']>;
  /** The address line two associated with the account */
  addressLineTwo?: Maybe<Scalars['String']['output']>;
  /** Flag indicating if the account has been archived */
  archived: Scalars['Boolean']['output'];
  /** The coupon available to be applied to the account */
  availableCoupon?: Maybe<Coupon>;
  /** The avatar file name */
  avatarFileName?: Maybe<Scalars['String']['output']>;
  /** The account avatar path, relative to the endpoint */
  avatarPath?: Maybe<Scalars['String']['output']>;
  /** The avatar processing status */
  avatarProcessing: Scalars['Boolean']['output'];
  /** The avatar upload url */
  avatarUploadUrl?: Maybe<Scalars['String']['output']>;
  /** The account host image URL */
  avatarUrl?: Maybe<Scalars['String']['output']>;
  /** The subscription associated with the listing */
  billingSubscription?: Maybe<BillingSubscription>;
  /** The strategy implemented for book direct urls for the account */
  bookDirectUrlStrategy?: Maybe<Scalars['String']['output']>;
  /** The account booking website url */
  bookDirectWebsiteUrl?: Maybe<Scalars['String']['output']>;
  /** The city associated with the account */
  city?: Maybe<Scalars['String']['output']>;
  /** The account company name */
  companyName?: Maybe<Scalars['String']['output']>;
  /** The country associated with the account */
  countryOrRegionLongName?: Maybe<Scalars['String']['output']>;
  /**
   * The coupon available to be applied to the account
   * @deprecated This will be deprecated soon use 'available_coupon' instead
   */
  coupon?: Maybe<Coupon>;
  /** Whether the account owner has a card on file in Stripe */
  creditCardOnFile: Scalars['Boolean']['output'];
  /** The default listing level for the account */
  defaultListingLevel: SubscriptionType;
  /** The account description */
  description?: Maybe<Scalars['String']['output']>;
  /** The account email */
  email?: Maybe<Scalars['String']['output']>;
  /** The account facebook page URL */
  facebookPageUrl?: Maybe<Scalars['String']['output']>;
  /** Datetime the account first published a listing */
  firstPublishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The hero file name */
  heroFileName?: Maybe<Scalars['String']['output']>;
  /** The account hero path, relative to the endpoint */
  heroPath?: Maybe<Scalars['String']['output']>;
  /** The hero processing status */
  heroProcessing: Scalars['Boolean']['output'];
  /** The hero upload url */
  heroUploadUrl?: Maybe<Scalars['String']['output']>;
  /** The account hero image URL */
  heroUrl?: Maybe<Scalars['String']['output']>;
  /** The account homeowner marketing url */
  homeownerMarketingUrl?: Maybe<Scalars['String']['output']>;
  /** The account ID */
  id: Scalars['ID']['output'];
  /** The year the account has been in business since */
  inBusinessSince?: Maybe<Scalars['Int']['output']>;
  /** Datetime the account was created */
  insertedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The listing Instagram URL */
  instagramUrl?: Maybe<Scalars['String']['output']>;
  /** The listing Instagram username */
  instagramUsername?: Maybe<Scalars['String']['output']>;
  /** Flag indicating if the account is pay per reservation */
  isPpr: Scalars['Boolean']['output'];
  /** The latest task ran on the account */
  latestTask?: Maybe<Task>;
  /** The account linkedin page URL */
  linkedinUrl?: Maybe<Scalars['String']['output']>;
  /** The number of listings that the account has at each level */
  listingLevels: ListingLevels;
  /** The listing owned by the account */
  listings: Array<Listing>;
  /** The account website url */
  marketingWebsiteUrl?: Maybe<Scalars['String']['output']>;
  /** The number of listings that the account said they had */
  numberOfClaimedListings?: Maybe<Scalars['Int']['output']>;
  /** The users that owns the account */
  owner: User;
  /** The account phone number */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** The pms_conneciton for the account */
  pmsConnection?: Maybe<PmsConnection>;
  /**
   * The pms_connecton type or the pms_software that the account reported at sign up
   * @deprecated This will be deprecated soon use 'reported_pms_software' and 'pms_connection' instead
   */
  pmsSoftware?: Maybe<Scalars['String']['output']>;
  /** The accounts policies array */
  policies: Array<Policy>;
  /** The postal code associated with the account */
  postalCode?: Maybe<Scalars['String']['output']>;
  /** Flag indicating if the account was created as a private account */
  private: Scalars['Boolean']['output'];
  /** The pms_software that the account reported at sign up */
  reportedPmsSoftware?: Maybe<Scalars['String']['output']>;
  salesforceUrl?: Maybe<Scalars['String']['output']>;
  /** The account SEO friendly url slug */
  slug: Scalars['String']['output'];
  /** The state/province long name associated with the account */
  stateOrProvinceLongName?: Maybe<Scalars['String']['output']>;
  /** The Stripe customer ID associated with the account */
  stripeCustomerId: Scalars['String']['output'];
  /** The account title */
  title?: Maybe<Scalars['String']['output']>;
  /** The listing Twitter handle */
  twitterHandle?: Maybe<Scalars['String']['output']>;
  /** The listing Twitter URL */
  twitterUrl?: Maybe<Scalars['String']['output']>;
  /** The users that belong to the account */
  users: Array<User>;
  /** The account youtube page URL */
  youtubeUrl?: Maybe<Scalars['String']['output']>;
};


/** The account object */
export type AccountListingsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type AccountBulkUpdateLocationObfuscatedInput = {
  /** Set location_obfuscated to this value for all listings on the account */
  obfuscated: Scalars['Boolean']['input'];
};

export type AccountBulkUpdateLocationObfuscatedResult = AccountBulkUpdateResults | NotFoundError | UnauthenticatedError | ValidationErrorCollection;

export type AccountBulkUpdateResults = {
  failureCount: Scalars['Int']['output'];
  successCount: Scalars['Int']['output'];
};

/** Response for fetching an active account by its id */
export type AccountByIdResponse = Account | NotFoundError;

/** Response for fetching an account by its slug */
export type AccountBySlugResponse = Account | NotFoundError;

/** Cancellation policy record */
export type AccountCancellationPolicy = Policy & {
  /** The cancellation policy description */
  cancellationPolicy: Scalars['String']['output'];
  /** The policy ID */
  id: Scalars['ID']['output'];
  /** The policy type */
  type: PolicyType;
};

/** Response for getting cards */
export type AccountCardsListAllResponse = CardCollection | ServiceUnavailableError | UnauthenticatedError | UnauthorizedError;

/** Accounts collection object contains a paginated collection of accounts and meta data about the collection */
export type AccountCollection = {
  /** The collection of accounts for a given page */
  entries: Array<Account>;
  /** The meta information containing additional info about the collection */
  meta: CollectionInfo;
};

/** Response for fetching the account for the current user */
export type AccountForCurrentUserResponse = Account | UnauthenticatedError;

/** The sort options supported for account listings */
export enum AccountListingSortOptions {
  /** The published at value in ascending order (newest -> oldest) */
  PublishedAtNewestFirst = 'PUBLISHED_AT_NEWEST_FIRST',
  /** The published at value in descending order (oldest -> newest) */
  PublishedAtOldestFirst = 'PUBLISHED_AT_OLDEST_FIRST'
}

/** Response for getting the listings for the current authenticated user's account */
export type AccountListingsResponse = ListingCollection | UnauthenticatedError;

/** Account review summary object */
export type AccountReviewSummary = {
  /** The review summary ID */
  id: Scalars['String']['output'];
  /** The review summary image URL (currently only used for tripadvisor) */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** The review summary total number of reviews */
  numberOfReviews?: Maybe<Scalars['Int']['output']>;
  /** The review summary rating */
  rating: Scalars['Float']['output'];
  /** The review summary source */
  source: AccountReviewSummarySource;
  /** The review summary source_id */
  sourceId: Scalars['String']['output'];
  /** The review summary URL */
  url?: Maybe<Scalars['String']['output']>;
};

export type AccountReviewSummaryCreateInput = {
  /** The account review summary source */
  source: AccountReviewSummarySource;
  /** The account review summary source ID */
  sourceId: Scalars['String']['input'];
};

/** The result of the create account review summary mutation for an authenticated innkeeper */
export type AccountReviewSummaryCreateResult = AccountReviewSummary | NotFoundError | UnauthenticatedError | ValidationErrorCollection;

/** The review summary source enum */
export enum AccountReviewSummarySource {
  /** The review summary source google_reviews enum value */
  GoogleReviews = 'GOOGLE_REVIEWS',
  /** The review summary source tripadvisor enum value */
  TripAdvisor = 'TRIP_ADVISOR'
}

export enum AccountRole {
  Member = 'MEMBER',
  Owner = 'OWNER'
}

/** Terms and conditions policy record */
export type AccountTermsAndConditions = Policy & {
  /** The policy ID */
  id: Scalars['ID']['output'];
  /** The terms and conditions link */
  termsLink: Scalars['String']['output'];
  /** The policy type */
  type: PolicyType;
};

export type AccountUpdateAllListingSubscriptionsInput = {
  /** The plan id for the listing subscriptions */
  planId: Scalars['String']['input'];
  /** The promo code for the subscription */
  promoCode?: InputMaybe<Scalars['String']['input']>;
};

export type AccountUpdateAllListingSubscriptionsResult = AccountBulkUpdateResults | NotFoundError | UnauthenticatedError | ValidationErrorCollection;

export type AccountUpdateInput = {
  addressLineOne?: InputMaybe<Scalars['String']['input']>;
  addressLineTwo?: InputMaybe<Scalars['String']['input']>;
  avatarUploadUrl?: InputMaybe<Scalars['String']['input']>;
  bookDirectWebsiteUrl?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  countryOrRegionLongName?: InputMaybe<Scalars['String']['input']>;
  defaultListingLevel?: InputMaybe<SubscriptionType>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  facebookPageUrl?: InputMaybe<Scalars['String']['input']>;
  heroUploadUrl?: InputMaybe<Scalars['String']['input']>;
  homeownerMarketingUrl?: InputMaybe<Scalars['String']['input']>;
  inBusinessSince?: InputMaybe<Scalars['Int']['input']>;
  instagramUsername?: InputMaybe<Scalars['String']['input']>;
  linkedinUrl?: InputMaybe<Scalars['String']['input']>;
  marketingWebsiteUrl?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  stateOrProvinceLongName?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  twitterHandle?: InputMaybe<Scalars['String']['input']>;
  youtubeUrl?: InputMaybe<Scalars['String']['input']>;
};

/** The result of the account create mutation for an authenticated user */
export type AccountUpdateResult = Account | UnauthenticatedError | ValidationErrorCollection;

/** Response for getting the accounts */
export type AccountsResponse = AccountCollection;

/** The admin object */
export type Admin = {
  accessToken?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

/** Response for creating an access token when authenticated as an admin */
export type AdminAccessTokenCreateResponse = AccessToken | NotFoundError | UnauthenticatedError;

export type AdminAccessTokenInput = {
  innkeeperId: Scalars['ID']['input'];
};

/** The result of the admin account update mutation for an authenticated user */
export type AdminAccountArchiveResult = Account | NotFoundError | UnauthenticatedError;

/** Response for getting a account by an ID when authenticated as an admin */
export type AdminAccountByIdResponse = Account | NotFoundError | UnauthenticatedError;

export type AdminAccountListingPubishableStatusCountsResponse = ListingPubishableStatusCounts | NotFoundError | UnauthenticatedError;

export type AdminAccountPublishAllListingsResult = AccountBulkUpdateResults | NotFoundError | UnauthenticatedError;

/** The result of the admin account remove pms connection mutation for an authenticated user */
export type AdminAccountRemovePmsConnectionResult = Account | NotFoundError | UnauthenticatedError;

export type AdminAccountResult = Account | NotFoundError | UnauthenticatedError | ValidationErrorCollection;

export type AdminAccountUnpublishAllListingsResult = AccountBulkUpdateResults | NotFoundError | UnauthenticatedError;

export type AdminAccountUpdateAllListingSubscriptionsResult = AccountBulkUpdateResults | NotFoundError | UnauthenticatedError | ValidationErrorCollection;

export type AdminAccountUpdateBookingUrlsResult = AccountBulkUpdateResults | NotFoundError | UnauthenticatedError;

export type AdminAccountUpdateInput = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  addressLineOne?: InputMaybe<Scalars['String']['input']>;
  addressLineTwo?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  countryOrRegionLongName?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  pmsSoftware?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  stateOrProvinceLongName?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** The result of the admin account update mutation for an authenticated user */
export type AdminAccountUpdateResult = Account | UnauthenticatedError | ValidationErrorCollection;

/** Response for account accounts when authenticated as an admin */
export type AdminAccountsListAllResponse = AccountCollection | UnauthenticatedError;

export type AdminGiftCardAdjustBalanceInput = {
  /** The amount to adjust the gift card balance */
  amountCents?: InputMaybe<Scalars['Int']['input']>;
  /** The reason for the balance adjustment */
  journalTransactionDescription: Scalars['String']['input'];
};

/** Response for getting a gift card by its ID when authenticated as an admin */
export type AdminGiftCardByIdResponse = GiftCard | NotFoundError | UnauthenticatedError;

export type AdminGiftCardCreateInput = {
  imageUploadUrl?: InputMaybe<Scalars['String']['input']>;
  initialBalanceTransactionDescription: Scalars['String']['input'];
  /** The gift card order amount in cents */
  orderAmountCents: Scalars['Int']['input'];
  /** The gift card recipient's address line one */
  recipientAddressLineOne?: InputMaybe<Scalars['String']['input']>;
  /** The gift card recipient's address line two */
  recipientAddressLineTwo?: InputMaybe<Scalars['String']['input']>;
  /** The gift card recipient's address city */
  recipientCity?: InputMaybe<Scalars['String']['input']>;
  /** The gift card recipient's address country */
  recipientCountryShortName?: InputMaybe<Scalars['String']['input']>;
  /** The gift card recipient's email */
  recipientEmail?: InputMaybe<Scalars['String']['input']>;
  /** The gift card recipient's first name */
  recipientFirstName: Scalars['String']['input'];
  /** The gift card recipient's last name */
  recipientLastName: Scalars['String']['input'];
  /** The gift card recipient's address postal code */
  recipientPostalCode?: InputMaybe<Scalars['String']['input']>;
  /** The gift card recipient's address state or province long name */
  recipientStateOrProvinceLongName?: InputMaybe<Scalars['String']['input']>;
  /** The gift card sender's address line one */
  senderAddressLineOne: Scalars['String']['input'];
  /** The gift card sender's address line two */
  senderAddressLineTwo?: InputMaybe<Scalars['String']['input']>;
  /** The gift card sender's address city */
  senderCity: Scalars['String']['input'];
  /** The gift card sender's country name */
  senderCountryShortName: Scalars['String']['input'];
  /** The gift card sender's email */
  senderEmail: Scalars['String']['input'];
  /** The gift card sender's frist name */
  senderFirstName: Scalars['String']['input'];
  /** The gift card sender's last name */
  senderLastName: Scalars['String']['input'];
  /** The gift card sender's message to the recipient */
  senderMessage?: InputMaybe<Scalars['String']['input']>;
  /** The gift card sender's phone number */
  senderPhoneNumber: Scalars['String']['input'];
  /** The gift card sender's postal code */
  senderPostalCode: Scalars['String']['input'];
  /** The gift card sender's address state or province long name */
  senderStateOrProvinceLongName: Scalars['String']['input'];
  /** The gift card shipping type */
  shippingType?: InputMaybe<GiftCardShippingType>;
  /** The gift card type */
  type: GiftCardType;
};

export type AdminGiftCardDeactivateInput = {
  /** The reason the gift card is being deactivated */
  deactivationDescription: Scalars['String']['input'];
};

export type AdminGiftCardImageCreateInput = {
  active: Scalars['Boolean']['input'];
  imageUploadUrl: Scalars['String']['input'];
};

/** Response for listing gift card images when authenticated as an admin */
export type AdminGiftCardImageListAllResponse = GiftCardImageCollection | UnauthenticatedError;

export type AdminGiftCardImageUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AdminGiftCardIssueInput = {
  /** The gift card certificate number */
  certificateNumber: Scalars['String']['input'];
};

/** Response for listing gift cards when authenticated as an admin */
export type AdminGiftCardListAllResponse = GiftCardCollection | UnauthenticatedError;

export type AdminGiftCardNoteCreateInput = {
  body: Scalars['String']['input'];
  giftCardId: Scalars['String']['input'];
};

export type AdminGiftCardRefundInput = {
  /** The amount to refund. If left blank, the maximum amount will be refunded. Must be less than or equal to the maximum amount (smaller of current balance and original purchase amount). */
  amountCents?: InputMaybe<Scalars['Int']['input']>;
  /** The reason for the refund */
  refundTransactionDescription: Scalars['String']['input'];
};

/** The result of a gift card mutation */
export type AdminGiftCardResult = GiftCard | NotFoundError | UnauthenticatedError | ValidationErrorCollection;

export type AdminGiftCardUpdateInput = {
  imageUploadUrl?: InputMaybe<Scalars['String']['input']>;
  /** The gift card order number */
  orderNumber?: InputMaybe<Scalars['String']['input']>;
  /** The gift card recipient's address line one */
  recipientAddressLineOne?: InputMaybe<Scalars['String']['input']>;
  /** The gift card recipient's address line two */
  recipientAddressLineTwo?: InputMaybe<Scalars['String']['input']>;
  /** The gift card recipient's address city */
  recipientCity?: InputMaybe<Scalars['String']['input']>;
  /** The gift card recipient's address country */
  recipientCountryShortName?: InputMaybe<Scalars['String']['input']>;
  /** The gift card recipient's email */
  recipientEmail?: InputMaybe<Scalars['String']['input']>;
  /** The gift card recipient's first name */
  recipientFirstName?: InputMaybe<Scalars['String']['input']>;
  /** The gift card recipient's last name */
  recipientLastName?: InputMaybe<Scalars['String']['input']>;
  /** The gift card recipient's address postal code */
  recipientPostalCode?: InputMaybe<Scalars['String']['input']>;
  /** The gift card recipient's address state or province long name */
  recipientStateOrProvinceLongName?: InputMaybe<Scalars['String']['input']>;
  /** The gift card sender's address line one */
  senderAddressLineOne?: InputMaybe<Scalars['String']['input']>;
  /** The gift card sender's address line two */
  senderAddressLineTwo?: InputMaybe<Scalars['String']['input']>;
  /** The gift card sender's address city */
  senderCity?: InputMaybe<Scalars['String']['input']>;
  /** The gift card sender's country name */
  senderCountryShortName?: InputMaybe<Scalars['String']['input']>;
  /** The gift card sender's email */
  senderEmail?: InputMaybe<Scalars['String']['input']>;
  /** The gift card sender's frist name */
  senderFirstName?: InputMaybe<Scalars['String']['input']>;
  /** The gift card sender's last name */
  senderLastName?: InputMaybe<Scalars['String']['input']>;
  /** The gift card sender's message to the recipient */
  senderMessage?: InputMaybe<Scalars['String']['input']>;
  /** The gift card sender's phone number */
  senderPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** The gift card sender's postal code */
  senderPostalCode?: InputMaybe<Scalars['String']['input']>;
  /** The gift card sender's address state or province long name */
  senderStateOrProvinceLongName?: InputMaybe<Scalars['String']['input']>;
  /** The shipping provider for a physical card */
  shippingProvider?: InputMaybe<ShippingProviderType>;
  /** The tracking number for a physical card */
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
};

export type AdminGoogleSocialSessionInput = {
  /** The access token returned from Google OAuth flow */
  accessToken: Scalars['String']['input'];
};

/** The result of the admin session mutation */
export type AdminGoogleSocialSessionResponse = Admin | UnauthenticatedError;

/** Response for getting an innkeeper ID when authenticated as an admin */
export type AdminInnkeeperByIdResponse = Innkeeper | NotFoundError | UnauthenticatedError;

/** Response for getting an innkeeper by its listing ID when authenticated as an admin */
export type AdminInnkeeperByListingIdResponse = Innkeeper | NotFoundError | UnauthenticatedError;

/** Response for getting a listing by an user ID when authenticated as an admin */
export type AdminListingByIdResponse = Listing | NotFoundError | UnauthenticatedError;

export type AdminListingConfigFieldMappingUpdateInput = {
  configOverrides: Array<InputMaybe<ConfigOverrideInput>>;
  listingId: Scalars['ID']['input'];
};

export type AdminListingConfigFieldMappingUpdateResult = Listing | UnauthenticatedError | ValidationErrorCollection;

export type AdminListingPublishInput = {
  /** The Listing ID */
  listingId: Scalars['ID']['input'];
  /** The IP address that is publishing the listing */
  publishIpAddress?: InputMaybe<Scalars['String']['input']>;
};

/** The result of the listing publish mutation for an admin */
export type AdminListingPublishResult = Listing | NotFoundError | UnauthenticatedError | ValidationErrorCollection;

export type AdminListingRecordPayoutInput = {
  /** The amount of commission taken. If left blank, the commission will be calculated by the listing's default comission percentage. */
  commissionAmountCents?: InputMaybe<Scalars['Int']['input']>;
  /** The redemption transactions payed by this payout */
  giftCardRedemptionTransactionIds: Array<Scalars['String']['input']>;
  /** The id of the issued payout */
  paymentServiceTransactionId: Scalars['String']['input'];
  /** The type of service used to issue the payout */
  paymentServiceTransactionType: PaymentServiceTransactionType;
};

export type AdminListingResult = Listing | NotFoundError | UnauthenticatedError | ValidationErrorCollection;

export type AdminListingUpdateInput = {
  /** The listing address line one */
  addressLineOne?: InputMaybe<Scalars['String']['input']>;
  /** The listing address line two */
  addressLineTwo?: InputMaybe<Scalars['String']['input']>;
  /** The listing airbnb url */
  airbnbUrl?: InputMaybe<Scalars['String']['input']>;
  /** The listing book direct website URL */
  bookDirectWebsiteUrl?: InputMaybe<Scalars['String']['input']>;
  /** The listing city */
  city?: InputMaybe<Scalars['String']['input']>;
  /** The listing country or region long name */
  countryOrRegionLongName?: InputMaybe<Scalars['String']['input']>;
  /** The listing text description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The listing location latitude */
  lat?: InputMaybe<Scalars['Float']['input']>;
  /** The listing license number */
  licenseNumber?: InputMaybe<Scalars['String']['input']>;
  /** The listing location longitude */
  lng?: InputMaybe<Scalars['Float']['input']>;
  /** Flag indicating if the location was manually set by an admin */
  locationSetManually?: InputMaybe<Scalars['Boolean']['input']>;
  /** The listing marketing website URL */
  marketingWebsiteUrl?: InputMaybe<Scalars['String']['input']>;
  /** The listing name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The fee to payout with check in cents */
  payoutCheckFeeCents?: InputMaybe<Scalars['Int']['input']>;
  /** The listing payout commission percentage */
  payoutCommissionPercentage?: InputMaybe<Scalars['Decimal']['input']>;
  /** The listing google place ID */
  placeId?: InputMaybe<Scalars['String']['input']>;
  /** The listing google place name */
  placeName?: InputMaybe<Scalars['String']['input']>;
  /** The listing postal code */
  postalCode?: InputMaybe<Scalars['String']['input']>;
  /** The listing public email */
  publicEmail?: InputMaybe<Scalars['String']['input']>;
  /** The listing public phone number */
  publicPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** The type of search promotion for the listing */
  searchPromotionType?: InputMaybe<SearchPromotionType>;
  /** The listing state or province long name */
  stateOrProvinceLongName?: InputMaybe<Scalars['String']['input']>;
  /** The listing vrbo url */
  vrboUrl?: InputMaybe<Scalars['String']['input']>;
};

/** Response for listing listings when authenticated as an admin */
export type AdminListingsListAllResponse = ListingCollection | UnauthenticatedError;

export type AdminMigrateStreamlineToPartnerConnectionInput = {
  accountId: Scalars['ID']['input'];
  advertiserId: Scalars['String']['input'];
  tokenKey: Scalars['String']['input'];
  tokenSecret: Scalars['String']['input'];
};

export type AdminMigrateStreamlineToPartnerConnectionResult = PmsConnection | UnauthenticatedError | ValidationErrorCollection;

/** Response for getting pms connection */
export type AdminPmsConnectionForAccountResponse = NotFoundError | PmsConnection | UnauthenticatedError;

export type AdminPmsConnectionPmsFieldMappingUpdateInput = {
  configOverrides: Array<InputMaybe<ConfigOverrideInput>>;
  pmsConnectionId: Scalars['ID']['input'];
};

export type AdminPmsConnectionPmsFieldMappingUpdateResult = PmsConnection | UnauthenticatedError | ValidationErrorCollection;

export type AdminPmsConnectionRetryInput = {
  pmsConnectionId: Scalars['ID']['input'];
};

export type AdminPmsConnectionRetryResult = NotFoundError | PmsConnection | UnauthenticatedError;

export type AdminRegionFindOrCreateForListingInput = {
  listingId: Scalars['ID']['input'];
  placeId: Scalars['String']['input'];
};

/** Response for listing regions associated with a listing when authenticated as an admin */
export type AdminRegionListAllForListingIdResponse = NotFoundError | RegionCollection | UnauthenticatedError;

export type AdminRegionResult = NotFoundError | Region | UnauthenticatedError | ValidationErrorCollection;

/** Response for adding search page content when authenticated as an admin */
export type AdminSearchPageContentCreateResponse = SearchPageContent | UnauthenticatedError | ValidationErrorCollection;

/** Response for adding search page content when authenticated as an admin */
export type AdminSearchPageContentDeleteResponse = NotFoundError | SearchPageContent | UnauthenticatedError | ValidationErrorCollection;

/** Response for finding a search page content by its ID when authenticated as an admin */
export type AdminSearchPageContentFindByIdResponse = NotFoundError | SearchPageContent | UnauthenticatedError;

/** Response for removing a region for a search page content */
export type AdminSearchPageContentRemoveRegionResponse = NotFoundError | SearchPageContent | UnauthenticatedError | ValidationErrorCollection;

export type AdminSearchPageContentUpdateInput = {
  aboutItemsTitle?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  faqsTitle?: InputMaybe<Scalars['String']['input']>;
  h1?: InputMaybe<Scalars['String']['input']>;
  h1ParagraphRaw?: InputMaybe<Scalars['String']['input']>;
  h2?: InputMaybe<Scalars['String']['input']>;
  h2ParagraphRaw?: InputMaybe<Scalars['String']['input']>;
  heroImageHtmlAlt?: InputMaybe<Scalars['String']['input']>;
  heroImageUploadUrl?: InputMaybe<Scalars['String']['input']>;
  htmlMetaDescription?: InputMaybe<Scalars['String']['input']>;
  htmlMetaTitle?: InputMaybe<Scalars['String']['input']>;
  isPopular?: InputMaybe<Scalars['Boolean']['input']>;
  searchType?: InputMaybe<SearchPageContentType>;
};

/** Response for removing a region for a search page content */
export type AdminSearchPageContentUpdateRegionResponse = NotFoundError | SearchPageContent | UnauthenticatedError | ValidationErrorCollection;

/** Response for adding search page content when authenticated as an admin */
export type AdminSearchPageContentUpdateResponse = NotFoundError | SearchPageContent | UnauthenticatedError | ValidationErrorCollection;

export type AdminSearchPageLinkCreateInput = {
  href: Scalars['String']['input'];
  searchPageContentId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
  type: SearchPageLinkType;
};

/** Response for finding a search page link by its ID when authenticated as an admin */
export type AdminSearchPageLinkFindByIdResponse = NotFoundError | SearchPageLink | UnauthenticatedError;

/** Response for adding search page link when authenticated as an admin */
export type AdminSearchPageLinkResult = NotFoundError | SearchPageLink | UnauthenticatedError | ValidationErrorCollection;

export type AdminSearchPageLinkUpdateInput = {
  href?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<SearchPageLinkType>;
};

export type AdminSearchPageParagraphCreateInput = {
  bodyRaw: Scalars['String']['input'];
  searchPageContentId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
  type: SearchPageParagraphType;
};

/** Response for finding a search page paragraph by its ID when authenticated as an admin */
export type AdminSearchPageParagraphFindByIdResponse = NotFoundError | SearchPageParagraph | UnauthenticatedError;

export type AdminSearchPageParagraphResult = NotFoundError | SearchPageParagraph | UnauthenticatedError | ValidationErrorCollection;

export type AdminSearchPageParagraphUpdateInput = {
  bodyRaw?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<SearchPageParagraphType>;
};

export type AdminSetSubscriptionInput = {
  listingId: Scalars['String']['input'];
  planId: Scalars['String']['input'];
};

/** The result of the set subscription mutation for an authenticated innkeeper */
export type AdminSetSubscriptionResult = Listing | NotFoundError | UnauthenticatedError | ValidationErrorCollection;

export type AdminTaskCreateListingsCsvImportInput = {
  accountId: Scalars['ID']['input'];
  csvUrl: Scalars['String']['input'];
};

export type AdminTaskCreateListingsCsvImportResult = NotFoundError | Task | UnauthenticatedError | ValidationErrorCollection;

/** Response for listing all transactions when authenticated as an admin */
export type AdminTransactionListAllResponse = TransactionCollection | UnauthenticatedError;

/** Response for listing all transactions when authenticated as an admin */
export type AdminTransactionsReadyForPayoutListAllResponse = NotFoundError | TransactionCollection | UnauthenticatedError;

/** Response for summing up all transaction amounts when authenticated as an admin */
export type AdminTransactionsSumAmountsCentsResponse = IntegerValue | UnauthenticatedError;

/** Response for getting a user by an innkeeper ID when authenticated as an admin */
export type AdminUserByIdResponse = NotFoundError | UnauthenticatedError | User;

export type AdminUserResult = NotFoundError | UnauthenticatedError | User | ValidationErrorCollection;

export type AdminUserUpdateInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  identityVerified?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type AdminUserUpdatePasswordInput = {
  newPassword?: InputMaybe<Scalars['String']['input']>;
};

/** Response for user users when authenticated as an admin */
export type AdminUsersListAllResponse = UnauthenticatedError | UserCollection;

/** Affiliation object */
export type Affiliation = {
  /** The affiliation ID */
  id: Scalars['String']['output'];
  /** The affiliation name */
  name: Scalars['String']['output'];
  /** The affiliation type */
  type: AffiliationType;
};

export type AffiliationCollection = {
  /** The collection of affiliations for a given page */
  entries: Array<Affiliation>;
  /** The meta information containing additional info about the collection */
  meta: CollectionInfo;
};

export type AffiliationDeleteInput = {
  /** The ID of an existing affiliation. */
  id: Scalars['ID']['input'];
  /** The ID of the listing id. */
  listingId: Scalars['ID']['input'];
};

/** The result of the delete affiliation mutation for an authenticated innkeeper */
export type AffiliationDeleteResult = Affiliation | NotFoundError | UnauthenticatedError;

export type AffiliationFindOrCreateInput = {
  /** The ID of an existing affiliation. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the listing id. */
  listingId: Scalars['ID']['input'];
  /** The name of a new affiliation. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The type of affiliation. */
  type?: InputMaybe<AffiliationType>;
};

/** The result of the find or create affiliation mutation for an authenticated innkeeper */
export type AffiliationFindOrCreateResult = Affiliation | UnauthenticatedError | ValidationErrorCollection;

/** Response for searching for affiliations when authenticated as an innkeeper */
export type AffiliationSearchResponse = AffiliationCollection | UnauthenticatedError;

/** The affiliation type enum */
export enum AffiliationType {
  /** The affiliation associations type enum value */
  Associations = 'ASSOCIATIONS',
  /** The affiliation awards type enum value */
  Awards = 'AWARDS',
  /** The affiliation inspections type enum value */
  Inspections = 'INSPECTIONS'
}

/** The affiliation type enum */
export enum AffiliationTypeFilter {
  /** All the affiliations */
  All = 'ALL',
  /** The affiliation associations type enum value */
  Associations = 'ASSOCIATIONS',
  /** The affiliation awards type enum value */
  Awards = 'AWARDS',
  /** The affiliation inspections type enum value */
  Inspections = 'INSPECTIONS'
}

/** Availability object */
export type Availability = {
  /** Availability status */
  available: Scalars['Boolean']['output'];
  /** Check in allowed status */
  checkInAllowed: Scalars['Boolean']['output'];
  /** Check out allowed status */
  checkOutAllowed: Scalars['Boolean']['output'];
  /** Datetime the min stay date starts on */
  date: Scalars['Date']['output'];
  /** Number of days the max stay is. */
  maxNights?: Maybe<Scalars['Int']['output']>;
  /** Number of days the min stay is. */
  minNights?: Maybe<Scalars['Int']['output']>;
};

export type BarefootPmsConnectionCreateInput = {
  accountId: Scalars['String']['input'];
};

/** Billing subscription object for listings */
export type BillingSubscription = {
  currentPeriodEnd: Scalars['String']['output'];
  id: Scalars['String']['output'];
  startDate: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

/** Blog post object */
export type BlogPost = {
  /** The blog post ID */
  id: Scalars['ID']['output'];
  /** The blog post image URL */
  imageUrl: Scalars['String']['output'];
  /** The blog post published at time */
  publishedAt: Scalars['DateTime']['output'];
  /** The blog post title */
  title: Scalars['String']['output'];
  /** The blog post URL */
  url: Scalars['String']['output'];
};

export enum BookDirectUrlStrategy {
  ExternalId = 'EXTERNAL_ID',
  ExternalIdWithoutUserId = 'EXTERNAL_ID_WITHOUT_USER_ID',
  KeyboardId = 'KEYBOARD_ID',
  NameAndExternalId = 'NAME_AND_EXTERNAL_ID',
  NameConcat = 'NAME_CONCAT',
  NameConcatWithoutSpecialCharacters = 'NAME_CONCAT_WITHOUT_SPECIAL_CHARACTERS'
}

export type BookDirectWebsiteUrlParamsTemplateInput = {
  /** The adult count to be used in the book direct URL */
  adultCount: Scalars['Int']['input'];
  /** The check in date to be used in the book direct URL */
  checkInDate: Scalars['Date']['input'];
  /** The check out date to be used in the book direct URL */
  checkOutDate: Scalars['Date']['input'];
  /** The child count to be used in the book direct URL */
  childCount: Scalars['Int']['input'];
  /** The infant count to be used in the book direct URL */
  infantCount: Scalars['Int']['input'];
  /** The pet count to be used in the book direct URL */
  petCount: Scalars['Int']['input'];
};

/** Listing Quote object */
export type BookingQuote = {
  /** Datetime the quote requested for check-in */
  checkInDate?: Maybe<Scalars['Date']['output']>;
  /** Datetime the quote requested for checkout */
  checkOutDate?: Maybe<Scalars['Date']['output']>;
  /** The listing the quote is for */
  listing: Listing;
  /** The id of the listing */
  listingId?: Maybe<Scalars['String']['output']>;
  numberOfAdults?: Maybe<Scalars['Int']['output']>;
  numberOfChildren?: Maybe<Scalars['Int']['output']>;
  numberOfInfants?: Maybe<Scalars['Int']['output']>;
  numberOfPets?: Maybe<Scalars['Int']['output']>;
  /** The payment schedule for the quote */
  paymentSchedule: Array<PaymentItem>;
  /** The items that make up the quote */
  quoteItems: Array<QuoteItems>;
  /** The total cost of the quote */
  totalCostCents?: Maybe<Scalars['Int']['output']>;
  /** The total recoverable cost of the quote */
  totalRecoverableCostCents?: Maybe<Scalars['Int']['output']>;
  /** The total cost of the quote without taxes. Only available for itemized quotes */
  totalWithoutTaxesCents?: Maybe<Scalars['Int']['output']>;
};

/** Response for getting the booking quotes on a listing */
export type BookingQuoteResponse = BookingQuote | BookingQuoteUnavailable | BookingQuoteUnsupported | NotFoundError | ServiceUnavailableError | ValidationError;

/** A booking quote is not available */
export type BookingQuoteUnavailable = {
  message: Scalars['String']['output'];
};

/** A booking quote is not supported */
export type BookingQuoteUnsupported = {
  message: Scalars['String']['output'];
};

export type BooksterPmsConnectionCreateInput = {
  password: Scalars['String']['input'];
};

export type BoostPmsConnectionCreateInput = {
  accountId: Scalars['String']['input'];
};

export type CancelReservationInput = {
  reservationId: Scalars['ID']['input'];
};

export type CancelReservationResult = NotFoundError | Reservation | UnauthenticatedError | ValidationErrorCollection;

/** Card object */
export type Card = {
  /** The zip code for the card */
  addressZip?: Maybe<Scalars['String']['output']>;
  /** The card brand */
  brand: Scalars['String']['output'];
  /** The month the card expires */
  expMonth: Scalars['Int']['output'];
  /** The year the card expires */
  expYear: Scalars['Int']['output'];
  /** The last four digits of the card */
  last4: Scalars['String']['output'];
};

export type CardCollection = {
  /** The collection of cards for a given page */
  entries: Array<Card>;
  /** The meta information containing additional info about the collection */
  meta: CollectionInfo;
};

/** Response for getting cards */
export type CardsListAllResponse = CardCollection | ServiceUnavailableError | UnauthenticatedError;

export type CiirusPmsConnectionCreateInput = {
  accountId: Scalars['String']['input'];
};

/** Collection info object */
export type CollectionInfo = {
  /** The current page value in the collection */
  currentPage?: Maybe<Scalars['Int']['output']>;
  /** The next page value in the collection */
  nextPage?: Maybe<Scalars['Int']['output']>;
  /** The previous page value in the collection */
  previousPage?: Maybe<Scalars['Int']['output']>;
  /** The number of entries for the whole collection */
  totalEntries?: Maybe<Scalars['Int']['output']>;
  /** The number of pages for the whole collection */
  totalPages?: Maybe<Scalars['Int']['output']>;
};

/** A comparison quote */
export type ComparisonQuote = {
  /** Datetime the quote requested for check-in */
  checkInDate: Scalars['Date']['output'];
  /** Datetime the quote requested for checkout */
  checkOutDate: Scalars['Date']['output'];
  externalListingId: Scalars['String']['output'];
  externalSource: Scalars['String']['output'];
  numberOfAdults: Scalars['Int']['output'];
  numberOfChildren: Scalars['Int']['output'];
  numberOfInfants: Scalars['Int']['output'];
  numberOfPets: Scalars['Int']['output'];
  /** The total cost of the quote at some point depending on the price_type field */
  priceCents: Scalars['Int']['output'];
};

/** Response for getting the comparison quote on a listing */
export type ComparisonQuoteResponse = ComparisonQuote | ComparisonQuoteUnsupported | NotFoundError | UnprocessableContentError | ValidationError;

/** A comparison quote is not supported */
export type ComparisonQuoteUnsupported = {
  message: Scalars['String']['output'];
};

export type ConfigItem = {
  fieldName: Scalars['String']['output'];
  options: Array<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

export type ConfigOverrideInput = {
  fieldName: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

/** An error encountered with out of date data */
export type ConflictError = {
  message: Scalars['String']['output'];
};

/** Coupon object */
export type Coupon = {
  amountOffCents?: Maybe<Scalars['Int']['output']>;
  applicableSubscriptions?: Maybe<Array<Maybe<SubscriptionType>>>;
  endDate?: Maybe<Scalars['Date']['output']>;
  name: Scalars['String']['output'];
  percentOff?: Maybe<Scalars['Float']['output']>;
  promoCode?: Maybe<Scalars['String']['output']>;
  /** @deprecated This will be deprecated soon use 'applicable_subscriptions' instead */
  subscriptionTypes?: Maybe<Array<Maybe<SubscriptionType>>>;
};

/** Response for looking up a coupon by its promo code */
export type CouponFindByPromoCodeResponse = Coupon | NotFoundError;

/** Response for fetching an active accounts coupon */
export type CouponFindForAccountResponse = Coupon | NotFoundError | UnauthenticatedError;

/** The result of creating a gift card */
export type CreateGiftCardResponse = GiftCard | ValidationErrorCollection;

export type CreateLeadInput = {
  company: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  numberOfListings: Scalars['Int']['input'];
  phone: Scalars['String']['input'];
  pmsSoftware: Scalars['String']['input'];
  website?: InputMaybe<Scalars['String']['input']>;
};

export type CreateLeadResult = LeadCreatedMessage | ValidationErrorCollection;

export type CreateReservationInput = {
  /** The card address city for the reservation */
  cardAddressCity: Scalars['String']['input'];
  /** The card address country for the reservation */
  cardAddressCountry: Scalars['String']['input'];
  /** The card address line 1 for the reservation */
  cardAddressLine1: Scalars['String']['input'];
  /** The card address line 2 for the reservation */
  cardAddressLine2?: InputMaybe<Scalars['String']['input']>;
  /** The card address state for the reservation */
  cardAddressState: Scalars['String']['input'];
  /** The card address zip for the reservation */
  cardAddressZip: Scalars['String']['input'];
  /** The card cvc for the reservation */
  cardCvc: Scalars['String']['input'];
  /** The card expiration month for the reservation */
  cardExpMonth: Scalars['String']['input'];
  /** The card expiration year for the reservation */
  cardExpYear: Scalars['String']['input'];
  /** The card name for the reservation */
  cardName: Scalars['String']['input'];
  /** The card number for the reservation */
  cardNumber: Scalars['String']['input'];
  orderId: Scalars['ID']['input'];
};

export type CreateReservationResult = NotFoundError | Reservation | UnauthenticatedError | ValidationErrorCollection;

export type CreateSubscriptionInput = {
  /** The promo code for the subscription */
  promoCode?: InputMaybe<Scalars['String']['input']>;
  /** The tokenized card given by Stripe */
  stripeTokenId: Scalars['String']['input'];
};

/** The result of creating a subscription mutation for an authenticated host */
export type CreateSubscriptionResult = Account | ConflictError | NotFoundError | UnauthenticatedError | ValidationErrorCollection;

/** Response for getting the current authenticated admin */
export type CurrentAdminResponse = Admin | UnauthenticatedError;

/** Response for getting the current authenticated innkeeper */
export type CurrentInnkeeperResponse = Innkeeper | UnauthenticatedError;

/** Response for getting the current authenticated user */
export type CurrentUserResponse = UnauthenticatedError | User;

export type CursorCollectionMetadata = {
  cursorAfter?: Maybe<Scalars['String']['output']>;
  cursorBefore?: Maybe<Scalars['String']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type DemoPmsConnectionCreateInput = {
  apiKey: Scalars['String']['input'];
};

/** The result of creating an email verification for an authenticated innkeeper */
export type EmailVerificationCreateResult = EmailVerificationMessage | UnauthenticatedError | ValidationErrorCollection;

export type EmailVerificationMessage = {
  message: Scalars['String']['output'];
};

/** The result of the set card mutation for an authenticated innkeeper */
export type EmailVerificationUpdateResult = EmailVerificationMessage | NotFoundError | UnauthenticatedError | ValidationErrorCollection;

export type EscapiaPmsConnectionCreateInput = {
  accountId: Scalars['String']['input'];
};

export enum ExternalSource {
  Barefoot = 'BAREFOOT',
  Bnbfinder = 'BNBFINDER',
  Bookster = 'BOOKSTER',
  Boost = 'BOOST',
  Ciirus = 'CIIRUS',
  Csv = 'CSV',
  Demo = 'DEMO',
  Escapia = 'ESCAPIA',
  Guesty = 'GUESTY',
  Hostaway = 'HOSTAWAY',
  Hostfully = 'HOSTFULLY',
  LiveList = 'LIVE_LIST',
  Lodgify = 'LODGIFY',
  Lodgix = 'LODGIX',
  NextPax = 'NEXT_PAX',
  OwnerRez = 'OWNER_REZ',
  RedAwning = 'RED_AWNING',
  RentalsUnited = 'RENTALS_UNITED',
  Streamline = 'STREAMLINE',
  StreamlinePartner = 'STREAMLINE_PARTNER',
  Track = 'TRACK',
  VacayHome = 'VACAY_HOME'
}

/** Feature object used for filtering listings and providing additional meta data about a listing */
export type Feature = {
  /** The feature category name */
  categoryName: Scalars['String']['output'];
  /** The feature display name */
  displayName: Scalars['String']['output'];
  /** The feature key */
  key: FeatureKey;
  /**
   * The legacy feature key
   * @deprecated This will be deprecated soon use 'key' instead
   */
  legacyKey: Scalars['String']['output'];
  /** A boolean indicating whether or not the feature is promoted */
  promoted: Scalars['Boolean']['output'];
};

/** Feature key enums are guaranteed to be unique */
export enum FeatureKey {
  AcceptsGiftCard = 'ACCEPTS_GIFT_CARD',
  AdaCompliant = 'ADA_COMPLIANT',
  AdultsOnly = 'ADULTS_ONLY',
  AfternoonTea = 'AFTERNOON_TEA',
  AirConditioning = 'AIR_CONDITIONING',
  AllowsChildren = 'ALLOWS_CHILDREN',
  Apartment = 'APARTMENT',
  BabysitterRecommendations = 'BABYSITTER_RECOMMENDATIONS',
  BabyBath = 'BABY_BATH',
  BabyMonitor = 'BABY_MONITOR',
  BabySafetyGates = 'BABY_SAFETY_GATES',
  Backyard = 'BACKYARD',
  BakingSheet = 'BAKING_SHEET',
  Balcony = 'BALCONY',
  Bar = 'BAR',
  BarbecueUtensils = 'BARBECUE_UTENSILS',
  Bathrobes = 'BATHROBES',
  Bathtub = 'BATHTUB',
  BathtubShowerCombo = 'BATHTUB_SHOWER_COMBO',
  BayView = 'BAY_VIEW',
  BbqGrills = 'BBQ_GRILLS',
  Beachfront = 'BEACHFRONT',
  BeachView = 'BEACH_VIEW',
  BedLinens = 'BED_LINENS',
  Bidet = 'BIDET',
  BlackoutCurtains = 'BLACKOUT_CURTAINS',
  Blender = 'BLENDER',
  BoardGames = 'BOARD_GAMES',
  BoatFriendly = 'BOAT_FRIENDLY',
  BodySoap = 'BODY_SOAP',
  BooksAndReadingMaterial = 'BOOKS_AND_READING_MATERIAL',
  BreadMaker = 'BREAD_MAKER',
  BreakfastIncluded = 'BREAKFAST_INCLUDED',
  Budget = 'BUDGET',
  Bungalows = 'BUNGALOWS',
  BusinessTravel = 'BUSINESS_TRAVEL',
  CanalView = 'CANAL_VIEW',
  CarbonMonoxideAlarm = 'CARBON_MONOXIDE_ALARM',
  CeilingFan = 'CEILING_FAN',
  ChangingTable = 'CHANGING_TABLE',
  CheckInCheckOutOnlinePhone = 'CHECK_IN_CHECK_OUT_ONLINE_PHONE',
  ChildrensBooksAndToys = 'CHILDRENS_BOOKS_AND_TOYS',
  ChildrensDinnerware = 'CHILDRENS_DINNERWARE',
  CitySkylineView = 'CITY_SKYLINE_VIEW',
  CleaningProducts = 'CLEANING_PRODUCTS',
  ClothingStorage = 'CLOTHING_STORAGE',
  Coffee = 'COFFEE',
  CoffeeMaker = 'COFFEE_MAKER',
  CoffeeService = 'COFFEE_SERVICE',
  ComplimentaryBeveragePantries = 'COMPLIMENTARY_BEVERAGE_PANTRIES',
  Concierge = 'CONCIERGE',
  Conditioner = 'CONDITIONER',
  Condominium = 'CONDOMINIUM',
  ConnectingRooms = 'CONNECTING_ROOMS',
  ContactlessCheckIn = 'CONTACTLESS_CHECK_IN',
  ContactlessCheckOut = 'CONTACTLESS_CHECK_OUT',
  Contemporary = 'CONTEMPORARY',
  ContinentalBreakfast = 'CONTINENTAL_BREAKFAST',
  CookingBasics = 'COOKING_BASICS',
  CountryInn = 'COUNTRY_INN',
  CourtyardView = 'COURTYARD_VIEW',
  Crib = 'CRIB',
  DailyHousekeeping = 'DAILY_HOUSEKEEPING',
  DesertView = 'DESERT_VIEW',
  DesignatedSmokingAreas = 'DESIGNATED_SMOKING_AREAS',
  DiningArea = 'DINING_AREA',
  DiningTable = 'DINING_TABLE',
  DinnerAvailableForAdditionalCost = 'DINNER_AVAILABLE_FOR_ADDITIONAL_COST',
  DinnerIncludedInRoomRate = 'DINNER_INCLUDED_IN_ROOM_RATE',
  DishesAndSilverware = 'DISHES_AND_SILVERWARE',
  Dishwasher = 'DISHWASHER',
  Downtown = 'DOWNTOWN',
  Dryer = 'DRYER',
  DryerRackForClothing = 'DRYER_RACK_FOR_CLOTHING',
  ElectricVehicleChargingStation = 'ELECTRIC_VEHICLE_CHARGING_STATION',
  Elevator = 'ELEVATOR',
  Elliptical = 'ELLIPTICAL',
  EthernetConnection = 'ETHERNET_CONNECTION',
  EveningTurndown = 'EVENING_TURNDOWN',
  ExtraPillowsAndBlankets = 'EXTRA_PILLOWS_AND_BLANKETS',
  FamilyTravel = 'FAMILY_TRAVEL',
  FencedBackyard = 'FENCED_BACKYARD',
  Firepit = 'FIREPIT',
  FireplaceGuards = 'FIREPLACE_GUARDS',
  FireExtinguisher = 'FIRE_EXTINGUISHER',
  FirePlaceInRooms = 'FIRE_PLACE_IN_ROOMS',
  FirstAidKit = 'FIRST_AID_KIT',
  Freezer = 'FREEZER',
  FreeCancellation = 'FREE_CANCELLATION',
  FreeParking = 'FREE_PARKING',
  FreeStreetParking = 'FREE_STREET_PARKING',
  FreeUseOfBeachChairsAndTowels = 'FREE_USE_OF_BEACH_CHAIRS_AND_TOWELS',
  FreeUseOfBicycles = 'FREE_USE_OF_BICYCLES',
  FreeWeights = 'FREE_WEIGHTS',
  FreeWiFi = 'FREE_WI_FI',
  FullBreakfast = 'FULL_BREAKFAST',
  GameConsole = 'GAME_CONSOLE',
  GameRoom = 'GAME_ROOM',
  Garden = 'GARDEN',
  GardenView = 'GARDEN_VIEW',
  GayLesbianTravel = 'GAY_LESBIAN_TRAVEL',
  GiftShop = 'GIFT_SHOP',
  GrandVistas = 'GRAND_VISTAS',
  GroupFacilities = 'GROUP_FACILITIES',
  Guesthouse = 'GUESTHOUSE',
  GuestCottage = 'GUEST_COTTAGE',
  Gym = 'GYM',
  HairDryer = 'HAIR_DRYER',
  Hammock = 'HAMMOCK',
  Hangers = 'HANGERS',
  HarborView = 'HARBOR_VIEW',
  Heater = 'HEATER',
  HeavyContinentalBreakfast = 'HEAVY_CONTINENTAL_BREAKFAST',
  HighChair = 'HIGH_CHAIR',
  HighQualityBedding = 'HIGH_QUALITY_BEDDING',
  HistoricHotel = 'HISTORIC_HOTEL',
  HistoricProperty = 'HISTORIC_PROPERTY',
  Homestay = 'HOMESTAY',
  HotTub = 'HOT_TUB',
  HotWater = 'HOT_WATER',
  HotWaterKettle = 'HOT_WATER_KETTLE',
  HypoallergenicBedding = 'HYPOALLERGENIC_BEDDING',
  Igloo = 'IGLOO',
  InRoomBreakfast = 'IN_ROOM_BREAKFAST',
  InRoomBreakfastAvailable = 'IN_ROOM_BREAKFAST_AVAILABLE',
  InRoomClimateControl = 'IN_ROOM_CLIMATE_CONTROL',
  IronIroningBoard = 'IRON_IRONING_BOARD',
  Island = 'ISLAND',
  JacuzziInRoom = 'JACUZZI_IN_ROOM',
  Kayak = 'KAYAK',
  KingBedsOnsite = 'KING_BEDS_ONSITE',
  Lakefront = 'LAKEFRONT',
  LakeView = 'LAKE_VIEW',
  LaundromatNearby = 'LAUNDROMAT_NEARBY',
  LaundryFacilities = 'LAUNDRY_FACILITIES',
  Loft = 'LOFT',
  LongTermStaysAllowed = 'LONG_TERM_STAYS_ALLOWED',
  LuggageDropoffAllowed = 'LUGGAGE_DROPOFF_ALLOWED',
  Luxury = 'LUXURY',
  Mansion = 'MANSION',
  MarinaView = 'MARINA_VIEW',
  MeetingsEvents = 'MEETINGS_EVENTS',
  MeetingRooms = 'MEETING_ROOMS',
  Microwave = 'MICROWAVE',
  MidRange = 'MID_RANGE',
  Minibar = 'MINIBAR',
  MiniFridge = 'MINI_FRIDGE',
  MosquitoNet = 'MOSQUITO_NET',
  MountainView = 'MOUNTAIN_VIEW',
  MultilingualStaff = 'MULTILINGUAL_STAFF',
  NearAGolfCourse = 'NEAR_A_GOLF_COURSE',
  NearNightlife = 'NEAR_NIGHTLIFE',
  NearPublicTransportation = 'NEAR_PUBLIC_TRANSPORTATION',
  NonSmoking = 'NON_SMOKING',
  Oceanfront = 'OCEANFRONT',
  OceanView = 'OCEAN_VIEW',
  OutdoorDiningArea = 'OUTDOOR_DINING_AREA',
  OutdoorFirePit = 'OUTDOOR_FIRE_PIT',
  OutdoorFurniture = 'OUTDOOR_FURNITURE',
  OutdoorKitchen = 'OUTDOOR_KITCHEN',
  OutdoorMovieTheater = 'OUTDOOR_MOVIE_THEATER',
  OutdoorShower = 'OUTDOOR_SHOWER',
  OutletCovers = 'OUTLET_COVERS',
  Oven = 'OVEN',
  PaidParkingOffPremises = 'PAID_PARKING_OFF_PREMISES',
  PaidParkingOnPremises = 'PAID_PARKING_ON_PREMISES',
  ParkView = 'PARK_VIEW',
  PetsNotAllowed = 'PETS_NOT_ALLOWED',
  PetFriendly = 'PET_FRIENDLY',
  Piano = 'PIANO',
  PingPongTable = 'PING_PONG_TABLE',
  Pool = 'POOL',
  PoolTable = 'POOL_TABLE',
  PortableFans = 'PORTABLE_FANS',
  PrivateBathrooms = 'PRIVATE_BATHROOMS',
  PrivateEntrances = 'PRIVATE_ENTRANCES',
  PrivateHome = 'PRIVATE_HOME',
  ProfessionalBedAndBreakfast = 'PROFESSIONAL_BED_AND_BREAKFAST',
  RecordPlayer = 'RECORD_PLAYER',
  Refrigerator = 'REFRIGERATOR',
  ResortView = 'RESORT_VIEW',
  Riverfront = 'RIVERFRONT',
  RiverView = 'RIVER_VIEW',
  RollawayAvailable = 'ROLLAWAY_AVAILABLE',
  RollInShower = 'ROLL_IN_SHOWER',
  Romantic = 'ROMANTIC',
  RoomDarkeningShades = 'ROOM_DARKENING_SHADES',
  RoomHasKitchen = 'ROOM_HAS_KITCHEN',
  RyokanJapan = 'RYOKAN_JAPAN',
  Safe = 'SAFE',
  Sauna = 'SAUNA',
  SeaView = 'SEA_VIEW',
  Shampoo = 'SHAMPOO',
  ShowerGel = 'SHOWER_GEL',
  SingleLevelHome = 'SINGLE_LEVEL_HOME',
  SittingArea = 'SITTING_AREA',
  SkiInSkiOut = 'SKI_IN_SKI_OUT',
  Slippers = 'SLIPPERS',
  SmokeAlarm = 'SMOKE_ALARM',
  SmokingPermitted = 'SMOKING_PERMITTED',
  Sofabed = 'SOFABED',
  SoundSystem = 'SOUND_SYSTEM',
  Spa = 'SPA',
  StationaryBike = 'STATIONARY_BIKE',
  Stove = 'STOVE',
  StrictDailyCleaningRegimen = 'STRICT_DAILY_CLEANING_REGIMEN',
  SuitableForChildren = 'SUITABLE_FOR_CHILDREN',
  SuitableForInfants = 'SUITABLE_FOR_INFANTS',
  TableCornerGuards = 'TABLE_CORNER_GUARDS',
  Tent = 'TENT',
  Toaster = 'TOASTER',
  Train = 'TRAIN',
  TrashCompactor = 'TRASH_COMPACTOR',
  TravelCrib = 'TRAVEL_CRIB',
  Treadmill = 'TREADMILL',
  Tv = 'TV',
  TwoBedsInRoom = 'TWO_BEDS_IN_ROOM',
  UrbanInn = 'URBAN_INN',
  ValleyView = 'VALLEY_VIEW',
  VegetarianMeals = 'VEGETARIAN_MEALS',
  VineyardView = 'VINEYARD_VIEW',
  Washer = 'WASHER',
  WasherAndDryer = 'WASHER_AND_DRYER',
  Waterfront = 'WATERFRONT',
  Weddings = 'WEDDINGS',
  WheelchairFriendly = 'WHEELCHAIR_FRIENDLY',
  WhirlpoolTubAllRooms = 'WHIRLPOOL_TUB_ALL_ROOMS',
  WhirlpoolTubSomeRooms = 'WHIRLPOOL_TUB_SOME_ROOMS',
  WholeHouseBuildingRental = 'WHOLE_HOUSE_BUILDING_RENTAL',
  WindowGuards = 'WINDOW_GUARDS',
  Winery = 'WINERY',
  WineGlasses = 'WINE_GLASSES',
  Workspace = 'WORKSPACE',
  YogaMat = 'YOGA_MAT'
}

export enum FieldNames {
  AddressLine_1 = 'ADDRESS_LINE_1',
  AddressLine_2 = 'ADDRESS_LINE_2',
  BookDirectWebsiteUrl = 'BOOK_DIRECT_WEBSITE_URL',
  Checkout = 'CHECKOUT',
  CheckIn = 'CHECK_IN',
  City = 'CITY',
  Country = 'COUNTRY',
  Description = 'DESCRIPTION',
  ExternalId = 'EXTERNAL_ID',
  FacebookPageUrl = 'FACEBOOK_PAGE_URL',
  FilterAcceptsGiftCard = 'FILTER_ACCEPTS_GIFT_CARD',
  FilterAdaCompliant = 'FILTER_ADA_COMPLIANT',
  FilterAdultsOnly = 'FILTER_ADULTS_ONLY',
  FilterAfternoonTea = 'FILTER_AFTERNOON_TEA',
  FilterAirConditioning = 'FILTER_AIR_CONDITIONING',
  FilterAllowsChildren = 'FILTER_ALLOWS_CHILDREN',
  FilterApartment = 'FILTER_APARTMENT',
  FilterBabysitterRecommendations = 'FILTER_BABYSITTER_RECOMMENDATIONS',
  FilterBabyBath = 'FILTER_BABY_BATH',
  FilterBabyMonitor = 'FILTER_BABY_MONITOR',
  FilterBabySafetyGates = 'FILTER_BABY_SAFETY_GATES',
  FilterBackyard = 'FILTER_BACKYARD',
  FilterBakingSheet = 'FILTER_BAKING_SHEET',
  FilterBalcony = 'FILTER_BALCONY',
  FilterBar = 'FILTER_BAR',
  FilterBarbecueUtensils = 'FILTER_BARBECUE_UTENSILS',
  FilterBathrobes = 'FILTER_BATHROBES',
  FilterBathtub = 'FILTER_BATHTUB',
  FilterBathtubShowerCombo = 'FILTER_BATHTUB_SHOWER_COMBO',
  FilterBayView = 'FILTER_BAY_VIEW',
  FilterBbqGrills = 'FILTER_BBQ_GRILLS',
  FilterBeachfront = 'FILTER_BEACHFRONT',
  FilterBeachView = 'FILTER_BEACH_VIEW',
  FilterBedLinens = 'FILTER_BED_LINENS',
  FilterBidet = 'FILTER_BIDET',
  FilterBlackoutCurtains = 'FILTER_BLACKOUT_CURTAINS',
  FilterBlender = 'FILTER_BLENDER',
  FilterBoardGames = 'FILTER_BOARD_GAMES',
  FilterBoatFriendly = 'FILTER_BOAT_FRIENDLY',
  FilterBodySoap = 'FILTER_BODY_SOAP',
  FilterBooksAndReadingMaterial = 'FILTER_BOOKS_AND_READING_MATERIAL',
  FilterBreadMaker = 'FILTER_BREAD_MAKER',
  FilterBreakfastIncluded = 'FILTER_BREAKFAST_INCLUDED',
  FilterBudget = 'FILTER_BUDGET',
  FilterBusinessTravel = 'FILTER_BUSINESS_TRAVEL',
  FilterCanalView = 'FILTER_CANAL_VIEW',
  FilterCarbonMonoxideAlarm = 'FILTER_CARBON_MONOXIDE_ALARM',
  FilterCeilingFan = 'FILTER_CEILING_FAN',
  FilterChangingTable = 'FILTER_CHANGING_TABLE',
  FilterCheckInCheckOutOnlinePhone = 'FILTER_CHECK_IN_CHECK_OUT_ONLINE_PHONE',
  FilterChildrensBooksAndToys = 'FILTER_CHILDRENS_BOOKS_AND_TOYS',
  FilterChildrensDinnerware = 'FILTER_CHILDRENS_DINNERWARE',
  FilterCitySkylineView = 'FILTER_CITY_SKYLINE_VIEW',
  FilterCleaningProducts = 'FILTER_CLEANING_PRODUCTS',
  FilterClothingStorage = 'FILTER_CLOTHING_STORAGE',
  FilterCoffee = 'FILTER_COFFEE',
  FilterCoffeeMaker = 'FILTER_COFFEE_MAKER',
  FilterCoffeeService = 'FILTER_COFFEE_SERVICE',
  FilterComplimentaryBeveragePantries = 'FILTER_COMPLIMENTARY_BEVERAGE_PANTRIES',
  FilterConcierge = 'FILTER_CONCIERGE',
  FilterConditioner = 'FILTER_CONDITIONER',
  FilterCondominium = 'FILTER_CONDOMINIUM',
  FilterConnectingRooms = 'FILTER_CONNECTING_ROOMS',
  FilterContactlessCheckIn = 'FILTER_CONTACTLESS_CHECK_IN',
  FilterContactlessCheckOut = 'FILTER_CONTACTLESS_CHECK_OUT',
  FilterContemporary = 'FILTER_CONTEMPORARY',
  FilterContinentalBreakfast = 'FILTER_CONTINENTAL_BREAKFAST',
  FilterCookingBasics = 'FILTER_COOKING_BASICS',
  FilterCountryInn = 'FILTER_COUNTRY_INN',
  FilterCourtyardView = 'FILTER_COURTYARD_VIEW',
  FilterCrib = 'FILTER_CRIB',
  FilterDailyHousekeeping = 'FILTER_DAILY_HOUSEKEEPING',
  FilterDesertView = 'FILTER_DESERT_VIEW',
  FilterDesignatedSmokingAreas = 'FILTER_DESIGNATED_SMOKING_AREAS',
  FilterDiningArea = 'FILTER_DINING_AREA',
  FilterDiningTable = 'FILTER_DINING_TABLE',
  FilterDinnerAvailableForAdditionalCost = 'FILTER_DINNER_AVAILABLE_FOR_ADDITIONAL_COST',
  FilterDinnerIncludedInRoomRate = 'FILTER_DINNER_INCLUDED_IN_ROOM_RATE',
  FilterDishesAndSilverware = 'FILTER_DISHES_AND_SILVERWARE',
  FilterDishwasher = 'FILTER_DISHWASHER',
  FilterDowntown = 'FILTER_DOWNTOWN',
  FilterDryer = 'FILTER_DRYER',
  FilterDryerRackForClothing = 'FILTER_DRYER_RACK_FOR_CLOTHING',
  FilterElectricVehicleChargingStation = 'FILTER_ELECTRIC_VEHICLE_CHARGING_STATION',
  FilterElevator = 'FILTER_ELEVATOR',
  FilterElliptical = 'FILTER_ELLIPTICAL',
  FilterEthernetConnection = 'FILTER_ETHERNET_CONNECTION',
  FilterEveningTurndown = 'FILTER_EVENING_TURNDOWN',
  FilterExtraPillowsAndBlankets = 'FILTER_EXTRA_PILLOWS_AND_BLANKETS',
  FilterFamilyTravel = 'FILTER_FAMILY_TRAVEL',
  FilterFencedBackyard = 'FILTER_FENCED_BACKYARD',
  FilterFirepit = 'FILTER_FIREPIT',
  FilterFireplaceGuards = 'FILTER_FIREPLACE_GUARDS',
  FilterFireExtinguisher = 'FILTER_FIRE_EXTINGUISHER',
  FilterFirePlaceInRooms = 'FILTER_FIRE_PLACE_IN_ROOMS',
  FilterFirstAidKit = 'FILTER_FIRST_AID_KIT',
  FilterFreezer = 'FILTER_FREEZER',
  FilterFreeCancellation = 'FILTER_FREE_CANCELLATION',
  FilterFreeParking = 'FILTER_FREE_PARKING',
  FilterFreeStreetParking = 'FILTER_FREE_STREET_PARKING',
  FilterFreeUseOfBeachChairsAndTowels = 'FILTER_FREE_USE_OF_BEACH_CHAIRS_AND_TOWELS',
  FilterFreeUseOfBicycles = 'FILTER_FREE_USE_OF_BICYCLES',
  FilterFreeWeights = 'FILTER_FREE_WEIGHTS',
  FilterFreeWiFi = 'FILTER_FREE_WI_FI',
  FilterFullBreakfast = 'FILTER_FULL_BREAKFAST',
  FilterGameConsole = 'FILTER_GAME_CONSOLE',
  FilterGameRoom = 'FILTER_GAME_ROOM',
  FilterGarden = 'FILTER_GARDEN',
  FilterGardenView = 'FILTER_GARDEN_VIEW',
  FilterGayLesbianTravel = 'FILTER_GAY_LESBIAN_TRAVEL',
  FilterGiftShop = 'FILTER_GIFT_SHOP',
  FilterGrandVistas = 'FILTER_GRAND_VISTAS',
  FilterGroupFacilities = 'FILTER_GROUP_FACILITIES',
  FilterGuesthouse = 'FILTER_GUESTHOUSE',
  FilterGuestCottage = 'FILTER_GUEST_COTTAGE',
  FilterGym = 'FILTER_GYM',
  FilterHairDryer = 'FILTER_HAIR_DRYER',
  FilterHammock = 'FILTER_HAMMOCK',
  FilterHangers = 'FILTER_HANGERS',
  FilterHarborView = 'FILTER_HARBOR_VIEW',
  FilterHeater = 'FILTER_HEATER',
  FilterHeavyContinentalBreakfast = 'FILTER_HEAVY_CONTINENTAL_BREAKFAST',
  FilterHighChair = 'FILTER_HIGH_CHAIR',
  FilterHighQualityBedding = 'FILTER_HIGH_QUALITY_BEDDING',
  FilterHistoricProperty = 'FILTER_HISTORIC_PROPERTY',
  FilterHomestay = 'FILTER_HOMESTAY',
  FilterHotTub = 'FILTER_HOT_TUB',
  FilterHotWater = 'FILTER_HOT_WATER',
  FilterHotWaterKettle = 'FILTER_HOT_WATER_KETTLE',
  FilterHypoallergenicBedding = 'FILTER_HYPOALLERGENIC_BEDDING',
  FilterIgloo = 'FILTER_IGLOO',
  FilterInRoomBreakfast = 'FILTER_IN_ROOM_BREAKFAST',
  FilterInRoomBreakfastAvailable = 'FILTER_IN_ROOM_BREAKFAST_AVAILABLE',
  FilterInRoomClimateControl = 'FILTER_IN_ROOM_CLIMATE_CONTROL',
  FilterIronIroningBoard = 'FILTER_IRON_IRONING_BOARD',
  FilterIsland = 'FILTER_ISLAND',
  FilterJacuzziInRoom = 'FILTER_JACUZZI_IN_ROOM',
  FilterKayak = 'FILTER_KAYAK',
  FilterKingBedsOnsite = 'FILTER_KING_BEDS_ONSITE',
  FilterLakefront = 'FILTER_LAKEFRONT',
  FilterLakeView = 'FILTER_LAKE_VIEW',
  FilterLaundromatNearby = 'FILTER_LAUNDROMAT_NEARBY',
  FilterLaundryFacilities = 'FILTER_LAUNDRY_FACILITIES',
  FilterLoft = 'FILTER_LOFT',
  FilterLongTermStaysAllowed = 'FILTER_LONG_TERM_STAYS_ALLOWED',
  FilterLuggageDropoffAllowed = 'FILTER_LUGGAGE_DROPOFF_ALLOWED',
  FilterLuxury = 'FILTER_LUXURY',
  FilterMansion = 'FILTER_MANSION',
  FilterMarinaView = 'FILTER_MARINA_VIEW',
  FilterMeetingsEvents = 'FILTER_MEETINGS_EVENTS',
  FilterMeetingRooms = 'FILTER_MEETING_ROOMS',
  FilterMicrowave = 'FILTER_MICROWAVE',
  FilterMidRange = 'FILTER_MID_RANGE',
  FilterMinibar = 'FILTER_MINIBAR',
  FilterMiniFridge = 'FILTER_MINI_FRIDGE',
  FilterMosquitoNet = 'FILTER_MOSQUITO_NET',
  FilterMountainView = 'FILTER_MOUNTAIN_VIEW',
  FilterMultilingualStaff = 'FILTER_MULTILINGUAL_STAFF',
  FilterNearAGolfCourse = 'FILTER_NEAR_A_GOLF_COURSE',
  FilterNearNightlife = 'FILTER_NEAR_NIGHTLIFE',
  FilterNearPublicTransportation = 'FILTER_NEAR_PUBLIC_TRANSPORTATION',
  FilterNonSmoking = 'FILTER_NON_SMOKING',
  FilterOceanfront = 'FILTER_OCEANFRONT',
  FilterOceanView = 'FILTER_OCEAN_VIEW',
  FilterOutdoorDiningArea = 'FILTER_OUTDOOR_DINING_AREA',
  FilterOutdoorFirePit = 'FILTER_OUTDOOR_FIRE_PIT',
  FilterOutdoorFurniture = 'FILTER_OUTDOOR_FURNITURE',
  FilterOutdoorKitchen = 'FILTER_OUTDOOR_KITCHEN',
  FilterOutdoorMovieTheater = 'FILTER_OUTDOOR_MOVIE_THEATER',
  FilterOutdoorShower = 'FILTER_OUTDOOR_SHOWER',
  FilterOutletCovers = 'FILTER_OUTLET_COVERS',
  FilterOven = 'FILTER_OVEN',
  FilterPaidParkingOffPremises = 'FILTER_PAID_PARKING_OFF_PREMISES',
  FilterPaidParkingOnPremises = 'FILTER_PAID_PARKING_ON_PREMISES',
  FilterParkView = 'FILTER_PARK_VIEW',
  FilterPetsNotAllowed = 'FILTER_PETS_NOT_ALLOWED',
  FilterPetFriendly = 'FILTER_PET_FRIENDLY',
  FilterPiano = 'FILTER_PIANO',
  FilterPingPongTable = 'FILTER_PING_PONG_TABLE',
  FilterPool = 'FILTER_POOL',
  FilterPoolTable = 'FILTER_POOL_TABLE',
  FilterPortableFans = 'FILTER_PORTABLE_FANS',
  FilterPrivateBathrooms = 'FILTER_PRIVATE_BATHROOMS',
  FilterPrivateEntrances = 'FILTER_PRIVATE_ENTRANCES',
  FilterPrivateHome = 'FILTER_PRIVATE_HOME',
  FilterProfessionalBedAndBreakfast = 'FILTER_PROFESSIONAL_BED_AND_BREAKFAST',
  FilterRecordPlayer = 'FILTER_RECORD_PLAYER',
  FilterRefrigerator = 'FILTER_REFRIGERATOR',
  FilterResortView = 'FILTER_RESORT_VIEW',
  FilterRiverfront = 'FILTER_RIVERFRONT',
  FilterRiverView = 'FILTER_RIVER_VIEW',
  FilterRollawayAvailable = 'FILTER_ROLLAWAY_AVAILABLE',
  FilterRollInShower = 'FILTER_ROLL_IN_SHOWER',
  FilterRomantic = 'FILTER_ROMANTIC',
  FilterRoomDarkeningShades = 'FILTER_ROOM_DARKENING_SHADES',
  FilterRoomHasKitchen = 'FILTER_ROOM_HAS_KITCHEN',
  FilterRyokanJapan = 'FILTER_RYOKAN_JAPAN',
  FilterSafe = 'FILTER_SAFE',
  FilterSauna = 'FILTER_SAUNA',
  FilterSeaView = 'FILTER_SEA_VIEW',
  FilterShampoo = 'FILTER_SHAMPOO',
  FilterShowerGel = 'FILTER_SHOWER_GEL',
  FilterSingleLevelHome = 'FILTER_SINGLE_LEVEL_HOME',
  FilterSittingArea = 'FILTER_SITTING_AREA',
  FilterSkiInSkiOut = 'FILTER_SKI_IN_SKI_OUT',
  FilterSlippers = 'FILTER_SLIPPERS',
  FilterSmokeAlarm = 'FILTER_SMOKE_ALARM',
  FilterSmokingPermitted = 'FILTER_SMOKING_PERMITTED',
  FilterSofabed = 'FILTER_SOFABED',
  FilterSoundSystem = 'FILTER_SOUND_SYSTEM',
  FilterSpa = 'FILTER_SPA',
  FilterStationaryBike = 'FILTER_STATIONARY_BIKE',
  FilterStove = 'FILTER_STOVE',
  FilterStrictDailyCleaningRegimen = 'FILTER_STRICT_DAILY_CLEANING_REGIMEN',
  FilterSuitableForChildren = 'FILTER_SUITABLE_FOR_CHILDREN',
  FilterSuitableForInfants = 'FILTER_SUITABLE_FOR_INFANTS',
  FilterTableCornerGuards = 'FILTER_TABLE_CORNER_GUARDS',
  FilterTent = 'FILTER_TENT',
  FilterToaster = 'FILTER_TOASTER',
  FilterTrain = 'FILTER_TRAIN',
  FilterTrashCompactor = 'FILTER_TRASH_COMPACTOR',
  FilterTravelCrib = 'FILTER_TRAVEL_CRIB',
  FilterTreadmill = 'FILTER_TREADMILL',
  FilterTv = 'FILTER_TV',
  FilterTwoBedsInRoom = 'FILTER_TWO_BEDS_IN_ROOM',
  FilterUrbanInn = 'FILTER_URBAN_INN',
  FilterValleyView = 'FILTER_VALLEY_VIEW',
  FilterVegetarianMeals = 'FILTER_VEGETARIAN_MEALS',
  FilterVineyardView = 'FILTER_VINEYARD_VIEW',
  FilterWasher = 'FILTER_WASHER',
  FilterWasherAndDryer = 'FILTER_WASHER_AND_DRYER',
  FilterWaterfront = 'FILTER_WATERFRONT',
  FilterWeddings = 'FILTER_WEDDINGS',
  FilterWheelchairFriendly = 'FILTER_WHEELCHAIR_FRIENDLY',
  FilterWhirlpoolTubAllRooms = 'FILTER_WHIRLPOOL_TUB_ALL_ROOMS',
  FilterWhirlpoolTubSomeRooms = 'FILTER_WHIRLPOOL_TUB_SOME_ROOMS',
  FilterWholeHouseBuildingRental = 'FILTER_WHOLE_HOUSE_BUILDING_RENTAL',
  FilterWindowGuards = 'FILTER_WINDOW_GUARDS',
  FilterWinery = 'FILTER_WINERY',
  FilterWineGlasses = 'FILTER_WINE_GLASSES',
  FilterWorkspace = 'FILTER_WORKSPACE',
  FilterYogaMat = 'FILTER_YOGA_MAT',
  GuestCapacity = 'GUEST_CAPACITY',
  HostBio = 'HOST_BIO',
  HostDisplayName = 'HOST_DISPLAY_NAME',
  Images = 'IMAGES',
  InstagramUsername = 'INSTAGRAM_USERNAME',
  Lat = 'LAT',
  Lng = 'LNG',
  LocationObfuscated = 'LOCATION_OBFUSCATED',
  MarketingWebsiteUrl = 'MARKETING_WEBSITE_URL',
  Name = 'NAME',
  NumberOfBathrooms = 'NUMBER_OF_BATHROOMS',
  NumberOfFloors = 'NUMBER_OF_FLOORS',
  NumberOfRooms = 'NUMBER_OF_ROOMS',
  PinterestUsername = 'PINTEREST_USERNAME',
  PlaceId = 'PLACE_ID',
  PlaceName = 'PLACE_NAME',
  PostalCode = 'POSTAL_CODE',
  PropertyType = 'PROPERTY_TYPE',
  PublicEmail = 'PUBLIC_EMAIL',
  PublicPhoneNumber = 'PUBLIC_PHONE_NUMBER',
  State = 'STATE',
  TwitterHandle = 'TWITTER_HANDLE',
  UniquePropertyType = 'UNIQUE_PROPERTY_TYPE'
}

export type FreePromoCreateReservationInput = {
  orderId: Scalars['ID']['input'];
  /** The promo code for the free reservation */
  promoCode: Scalars['String']['input'];
};

export type FreePromoCreateReservationResult = InvalidPromoCodeError | NotFoundError | Reservation | UnauthenticatedError | ValidationErrorCollection;

/** Gallery asset object */
export type GalleryAsset = {
  /** The gallery asset description */
  description?: Maybe<Scalars['String']['output']>;
  /** The endpoint of the image host */
  endpoint?: Maybe<Scalars['String']['output']>;
  /** The gallery asset ID */
  id: Scalars['String']['output'];
  /** The path for the image, relative to the endpoint */
  path?: Maybe<Scalars['String']['output']>;
  /** The position of the gallery asset */
  position: Scalars['Float']['output'];
  /** The gallery asset processing flag */
  processing: Scalars['Boolean']['output'];
  /** The gallery asset raw URL (no-cache) */
  rawUrl?: Maybe<Scalars['String']['output']>;
  /**
   * The gallery asset thumb URL
   * @deprecated Use path and endpoint fields with media CDN for image variants
   */
  thumbUrl?: Maybe<Scalars['String']['output']>;
  /** The gallery asset URL */
  url?: Maybe<Scalars['String']['output']>;
};

/** Response for getting an innkeepers gallery asset by its ID */
export type GalleryAssetByIdResponse = GalleryAsset | NotFoundError | UnauthenticatedError;

export type GalleryAssetCreateInput = {
  /** The listing id. */
  listingId: Scalars['ID']['input'];
  /** The gallery asset position. */
  position?: InputMaybe<Scalars['Int']['input']>;
  /** The gallery asset raw upload url. */
  rawUploadUrl: Scalars['String']['input'];
};

/** The result of the gallery asset create */
export type GalleryAssetCreateResponse = GalleryAsset | UnauthenticatedError | ValidationErrorCollection;

export type GalleryAssetDeleteInput = {
  /** The ID of an existing gallery asset. */
  id: Scalars['ID']['input'];
  /** The listing ID. */
  listingId: Scalars['ID']['input'];
};

/** The result of the gallery asset update image */
export type GalleryAssetDeleteResponse = GalleryAsset | NotFoundError | UnauthenticatedError;

export type GalleryAssetOrderInput = {
  /** The ID of an existing gallery asset. */
  id: Scalars['ID']['input'];
  /** The Listing ID of an existing listing. */
  listingId: Scalars['ID']['input'];
  /** The ID of the previous gallery asset. */
  previousGalleryAssetId: Scalars['ID']['input'];
};

/** The result of the gallery asset order */
export type GalleryAssetOrderResponse = GalleryAsset | NotFoundError | UnauthenticatedError | ValidationErrorCollection;

export type GalleryAssetUpdateImageInput = {
  /** The ID of an existing gallery asset. */
  id: Scalars['ID']['input'];
  /** The listing ID. */
  listingId: Scalars['ID']['input'];
  /** The upload url for the gallery asset. */
  uploadUrl: Scalars['String']['input'];
};

/** The result of the gallery asset update image */
export type GalleryAssetUpdateImageResponse = GalleryAsset | NotFoundError | UnauthenticatedError | ValidationErrorCollection;

export type GalleryAssetUpdateInput = {
  /** The ID of an existing gallery asset. */
  id: Scalars['ID']['input'];
  /** The listing ID. */
  listingId: Scalars['ID']['input'];
  /** The position for the gallery asset. */
  position: Scalars['Int']['input'];
};

/** The result of the gallery asset update */
export type GalleryAssetUpdateResponse = GalleryAsset | NotFoundError | UnauthenticatedError | ValidationErrorCollection;

/** Geometric data for the place */
export type Geometry = {
  /** The center point for the given place */
  centerPoint?: Maybe<Point>;
  /** The north east point for the given place */
  northEastPoint?: Maybe<Point>;
  /** The south west point for the given place */
  southWestPoint?: Maybe<Point>;
};

/** Gift card object */
export type GiftCard = {
  /** The gift card certificate number */
  certificateNumber?: Maybe<Scalars['String']['output']>;
  /** The time the gift card was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** The gift card current balance in cents */
  currentBalanceCents: Scalars['Int']['output'];
  /** The admin that deactivated the gift card */
  deactivatedByAdmin?: Maybe<Admin>;
  /** The reason the gift card was deactivated */
  deactivationDescription?: Maybe<Scalars['String']['output']>;
  /** The gift card ID */
  id: Scalars['ID']['output'];
  /** The endpoint of the image host */
  imageEndpoint?: Maybe<Scalars['String']['output']>;
  /** The image path, relative to the endpoint */
  imagePath?: Maybe<Scalars['String']['output']>;
  /** The image processing flag */
  imageProcessing: Scalars['Boolean']['output'];
  imageUploadUrl?: Maybe<Scalars['String']['output']>;
  /** The gift card image */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** The time that the gift card was issued */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The admin that issued the gift card */
  issuedByAdmin?: Maybe<Admin>;
  /** The gift card notes array */
  notes: Array<GiftCardNote>;
  /** The gift card order amount in cents */
  orderAmountCents: Scalars['Int']['output'];
  /** The gift card order number */
  orderNumber?: Maybe<Scalars['String']['output']>;
  /** The client secret for completing payment intents */
  paymentServiceTransactionClientSecret?: Maybe<Scalars['String']['output']>;
  /** The promo that was applied to the gift card when it was created */
  promo?: Maybe<GiftCardPromos>;
  /** The parent gift card that qualified for the promotion */
  qualifiedPromotionalGiftCard?: Maybe<GiftCard>;
  /** The parent gift card that qualified for the promotion */
  qualifiedPromotionalGiftCards: Array<Maybe<GiftCard>>;
  /** The gift card recipient's address line one */
  recipientAddressLineOne?: Maybe<Scalars['String']['output']>;
  /** The gift card recipient's address line two */
  recipientAddressLineTwo?: Maybe<Scalars['String']['output']>;
  /** The gift card recipient's address city */
  recipientCity?: Maybe<Scalars['String']['output']>;
  /** The gift card recipient's address country */
  recipientCountryShortName?: Maybe<Scalars['String']['output']>;
  /** The gift card recipient's email */
  recipientEmail?: Maybe<Scalars['String']['output']>;
  /** The gift card recipient's first name */
  recipientFirstName: Scalars['String']['output'];
  /** The gift card recipient's last name */
  recipientLastName?: Maybe<Scalars['String']['output']>;
  /** The gift card recipient's address lat */
  recipientLat?: Maybe<Scalars['Float']['output']>;
  /** The gift card recipient's address lng */
  recipientLng?: Maybe<Scalars['Float']['output']>;
  /** The gift card recipient's address postal code */
  recipientPostalCode?: Maybe<Scalars['String']['output']>;
  /** The gift card recipient's address state or province long name */
  recipientStateOrProvinceLongName?: Maybe<Scalars['String']['output']>;
  /** The gift card sender's address line one */
  senderAddressLineOne?: Maybe<Scalars['String']['output']>;
  /** The gift card sender's address line two */
  senderAddressLineTwo?: Maybe<Scalars['String']['output']>;
  /** The gift card sender's address city */
  senderCity?: Maybe<Scalars['String']['output']>;
  /** The gift card sender's country name */
  senderCountryShortName?: Maybe<Scalars['String']['output']>;
  /** The gift card sender's email */
  senderEmail?: Maybe<Scalars['String']['output']>;
  /** The gift card sender's frist name */
  senderFirstName: Scalars['String']['output'];
  /** The gift card sender's last name */
  senderLastName?: Maybe<Scalars['String']['output']>;
  /** The gift card sender's message to the recipient */
  senderMessage?: Maybe<Scalars['String']['output']>;
  /** The gift card sender's phone number */
  senderPhoneNumber?: Maybe<Scalars['String']['output']>;
  /** The gift card sender's postal code */
  senderPostalCode?: Maybe<Scalars['String']['output']>;
  /** The gift card sender's address state or province long name */
  senderStateOrProvinceLongName?: Maybe<Scalars['String']['output']>;
  /** The gift card shipping fee in cents */
  shippingFeeCents: Scalars['Int']['output'];
  /** The shipping provider for a physical card */
  shippingProvider?: Maybe<ShippingProviderType>;
  /** The gift card shipping type */
  shippingType?: Maybe<GiftCardShippingType>;
  /** The gift card status */
  status: GiftCardStatus;
  /** The tracking number for a physical card */
  trackingNumber?: Maybe<Scalars['String']['output']>;
  /** The gift card transactions array */
  transactions: Array<Transaction>;
  /** The gift card type */
  type: GiftCardType;
  /** The time that the gift card was verified */
  verifiedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The admin that verified the gift card */
  verifiedByAdmin?: Maybe<Admin>;
};

/** Response for fetching a gift card by cert number */
export type GiftCardByCertificateNumberResponse = GiftCard | NotFoundError;

/** Response for fetching a gift card by cert number */
export type GiftCardByIdResponse = GiftCard | NotFoundError;

export type GiftCardByPaymentServiceTransactionClientSecretResponse = GiftCard | NotFoundError;

export type GiftCardCollection = {
  /** The collection of gift cards for a given page */
  entries: Array<GiftCard>;
  /** The meta information containing additional info about the collection */
  meta: CollectionInfo;
};

export type GiftCardCreateInput = {
  imageUploadUrl?: InputMaybe<Scalars['String']['input']>;
  /** The gift card order amount in cents */
  orderAmountCents: Scalars['Int']['input'];
  promo?: InputMaybe<GiftCardPromos>;
  /** The gift card recipient's address line one */
  recipientAddressLineOne?: InputMaybe<Scalars['String']['input']>;
  /** The gift card recipient's address line two */
  recipientAddressLineTwo?: InputMaybe<Scalars['String']['input']>;
  /** The gift card recipient's address city */
  recipientCity?: InputMaybe<Scalars['String']['input']>;
  /** The gift card recipient's address country */
  recipientCountryShortName?: InputMaybe<Scalars['String']['input']>;
  /** The gift card recipient's email */
  recipientEmail?: InputMaybe<Scalars['String']['input']>;
  /** The gift card recipient's first name */
  recipientFirstName: Scalars['String']['input'];
  /** The gift card recipient's address postal code */
  recipientPostalCode?: InputMaybe<Scalars['String']['input']>;
  /** The gift card recipient's address state or province long name */
  recipientStateOrProvinceLongName?: InputMaybe<Scalars['String']['input']>;
  /** The gift card sender's first name */
  senderFirstName: Scalars['String']['input'];
  /** The gift card sender's message to the recipient */
  senderMessage?: InputMaybe<Scalars['String']['input']>;
  /** The gift card shipping type */
  shippingType?: InputMaybe<GiftCardShippingType>;
  /** The gift card type */
  type: GiftCardType;
};

/** The gift card image object */
export type GiftCardImage = {
  /** The gift card image active flag */
  active: Scalars['Boolean']['output'];
  /** The gift card image ID */
  id: Scalars['ID']['output'];
  /** The endpoint of the image host */
  imageEndpoint?: Maybe<Scalars['String']['output']>;
  /** The image path, relative to the endpoint */
  imagePath?: Maybe<Scalars['String']['output']>;
  /** The gift card image processing flag */
  imageProcessing: Scalars['Boolean']['output'];
  /** The gift card image name */
  imageUrl?: Maybe<Scalars['String']['output']>;
};

/** Response for getting a gift card image by its ID when authenticated as an admin */
export type GiftCardImageByIdResponse = GiftCardImage | NotFoundError | UnauthenticatedError;

export type GiftCardImageCollection = {
  /** The collection of gift card images for a given page */
  entries: Array<GiftCardImage>;
  /** The meta information containing additional info about the collection */
  meta: CollectionInfo;
};

/** The result of an authed admin gift card image create mutation */
export type GiftCardImageCreateResponse = GiftCardImage | UnauthenticatedError | ValidationErrorCollection;

/** The result of an authed admin gift card image delete mutation */
export type GiftCardImageDeleteResponse = GiftCardImage | NotFoundError | UnauthenticatedError;

/** The result of an authed admin gift card image update mutation */
export type GiftCardImageUpdateResponse = GiftCardImage | NotFoundError | UnauthenticatedError | ValidationErrorCollection;

/** Transaction recorded when a gift card is create by an admin */
export type GiftCardInitialBalanceTransaction = Transaction & {
  /** The admin that created the transaction */
  admin?: Maybe<Admin>;
  /** The transaction amount in cents */
  amountCents: Scalars['Int']['output'];
  /** The time the transaction was created */
  createdAt: Scalars['DateTime']['output'];
  /** A short description as to why the gift card was created */
  description: Scalars['String']['output'];
  /** The transaction ID */
  id: Scalars['ID']['output'];
  /** The gift card that was the recipient of the transaction */
  recipient: GiftCard;
  /** The transaction type */
  type: TransactionType;
  /** The last time the transaction was updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** Transaction recorded when a gift card journal entry is created */
export type GiftCardJournalTransaction = Transaction & {
  /** The admin that created the transaction */
  admin?: Maybe<Admin>;
  /** The transaction amount in cents */
  amountCents: Scalars['Int']['output'];
  /** The time the transaction was created */
  createdAt: Scalars['DateTime']['output'];
  /** A short description as to why the transaction was created */
  description: Scalars['String']['output'];
  /** The transaction ID */
  id: Scalars['ID']['output'];
  /** The gift card that was the recipient of the amount */
  recipient: GiftCard;
  /** The transaction type */
  type: TransactionType;
  /** The last time the transaction was updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** The gift card note object */
export type GiftCardNote = {
  /** The body text on the note */
  body: Scalars['String']['output'];
  /** The time the gift card note was created */
  createdAt: Scalars['DateTime']['output'];
  /** The admin that created the gift card note */
  createdByAdmin: Admin;
  /** The gift card note ID */
  id: Scalars['ID']['output'];
  /** Datetime the gift card note was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** The result of an authed admin gift card note create mutation */
export type GiftCardNoteCreateResponse = GiftCardNote | UnauthenticatedError | ValidationErrorCollection;

/** The result of an authed admin gift card note delete mutation */
export type GiftCardNoteDeleteResponse = GiftCardNote | NotFoundError | UnauthenticatedError;

export enum GiftCardPromos {
  BigHolidayTwentyTwo = 'BIG_HOLIDAY_TWENTY_TWO',
  FreePriorityExpressShipping = 'FREE_PRIORITY_EXPRESS_SHIPPING',
  FreePriorityShipping = 'FREE_PRIORITY_SHIPPING',
  HolidayTwentyTwo = 'HOLIDAY_TWENTY_TWO'
}

/** Transaction recorded when a gift card is purchased */
export type GiftCardPurchasedTransaction = Transaction & {
  /** The transaction amount in cents */
  amountCents: Scalars['Int']['output'];
  /** The time the transaction was created */
  createdAt: Scalars['DateTime']['output'];
  /** The transaction ID */
  id: Scalars['ID']['output'];
  /** The gift card payment source ID */
  paymentServiceTransactionId: Scalars['String']['output'];
  /** The gift card payment source brand e.g. Visa etc. */
  paymentSourceBrand: Scalars['String']['output'];
  /** The gift card payment source ID (last 4 of CC, payment account id, etc) */
  paymentSourceId: Scalars['String']['output'];
  /** The gift card payment source type */
  paymentSourceType: TransactionPaymentSourceType;
  /** The gift card that was the recipient of the amount */
  recipient: GiftCard;
  /** The transaction type */
  type: TransactionType;
  /** The last time the transaction was updated */
  updatedAt: Scalars['DateTime']['output'];
};

export type GiftCardRedeemInput = {
  /** The amount to redeem from the gift card balance */
  amountCents?: InputMaybe<Scalars['Int']['input']>;
  /** The Listing ID */
  listingId: Scalars['ID']['input'];
  /** Reason for the redemption */
  redemptionTransactionDescription: Scalars['String']['input'];
};

/** The result of redeeming a gift card */
export type GiftCardRedeemResponse = GiftCard | NotFoundError | UnauthenticatedError | UnverifiedError | ValidationErrorCollection;

/** Transaction recorded when a gift card has an amount redeemed */
export type GiftCardRedemptionTransaction = Transaction & {
  /** The transaction amount in cents */
  amountCents: Scalars['Int']['output'];
  /** The time the transaction was created */
  createdAt: Scalars['DateTime']['output'];
  /** The transaction ID */
  id: Scalars['ID']['output'];
  /** The gift card that was used to pay the amount */
  payor: GiftCard;
  /** The listing that redeemed the gift card amount */
  recipient: Listing;
  /** The transaction type */
  type: TransactionType;
  /** The last time the transaction was updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** Transaction recorded when a gift card is refunded to the purchasor */
export type GiftCardRefundTransaction = Transaction & {
  /** The admin that created the transaction */
  admin?: Maybe<Admin>;
  /** The transaction amount in cents */
  amountCents: Scalars['Int']['output'];
  /** The time the transaction was created */
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  /** The transaction ID */
  id: Scalars['ID']['output'];
  /** The payment refund source ID */
  paymentServiceTransactionId: Scalars['String']['output'];
  /** The payment refund source type */
  paymentServiceTransactionType: PaymentServiceTransactionType;
  /** The gift card that was the payor of the transaction */
  payor: GiftCard;
  /** The transaction type */
  type: TransactionType;
  /** The last time the transaction was updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** The gift card shipping type */
export enum GiftCardShippingType {
  /** Free shipping */
  Free = 'FREE',
  /** USPS Priority Mail */
  Priority = 'PRIORITY',
  /** USPS Next Day */
  PriorityExpress = 'PRIORITY_EXPRESS'
}

/** The sort options supported for gift cards */
export enum GiftCardSortOptions {
  CreatedAtNewestFirst = 'CREATED_AT_NEWEST_FIRST',
  CreatedAtOldestFirst = 'CREATED_AT_OLDEST_FIRST',
  CurrentBalanceHighestFirst = 'CURRENT_BALANCE_HIGHEST_FIRST',
  CurrentBalanceLowestFirst = 'CURRENT_BALANCE_LOWEST_FIRST'
}

/** The gift card status */
export enum GiftCardStatus {
  /** The gift card is currently active */
  Active = 'ACTIVE',
  /** The gift card has been deactivated */
  Deactivated = 'DEACTIVATED',
  /** The gift card is waiting to be issued to the recipient */
  Unissued = 'UNISSUED',
  /** The gift card is waiting for the purchase to be confirmed */
  Unpurchased = 'UNPURCHASED',
  /** The gift card is waiting for verification */
  Unverified = 'UNVERIFIED'
}

/** The gift card type */
export enum GiftCardType {
  /** Digital gift card that is sent via email */
  Digital = 'DIGITAL',
  /** Physical gift card that is sent in the mail */
  Physical = 'PHYSICAL'
}

export type GiftCardUpdateUnpurchasedInput = {
  /** The gift card ID */
  id: Scalars['ID']['input'];
  /** The gift card order amount in cents */
  orderAmountCents?: InputMaybe<Scalars['Int']['input']>;
  promo?: InputMaybe<GiftCardPromos>;
  /** The senders email */
  senderEmail: Scalars['String']['input'];
  /** The gift card shipping type */
  shippingType?: InputMaybe<GiftCardShippingType>;
};

/** The result of redeeming a gift card */
export type GiftCardUpdateUnpurchasedResponse = GiftCard | NotFoundError | ValidationErrorCollection;

export type GuestyPmsConnectionCreateInput = {
  accessToken: Scalars['String']['input'];
};

export type HostawayPmsConnectionCreateInput = {
  clientId: Scalars['String']['input'];
  clientSecret: Scalars['String']['input'];
};

export type HostfullyPmsConnectionCreateInput = {
  agencyUid: Scalars['String']['input'];
};

export enum IdentityProvider {
  Apple = 'APPLE',
  Email = 'EMAIL',
  Facebook = 'FACEBOOK',
  Google = 'GOOGLE'
}

/** Innkeeper object */
export type Innkeeper = {
  /** The innkeeper access token */
  accessToken?: Maybe<Scalars['String']['output']>;
  /** The role this user has for the host-side account */
  accountRole?: Maybe<AccountRole>;
  /** Flag indicating if the account has been claimed */
  claimable: Scalars['Boolean']['output'];
  /** The innkeeper email */
  email: Scalars['String']['output'];
  /** The innkeeper first name */
  firstName?: Maybe<Scalars['String']['output']>;
  /** The innkeeper ID */
  id: Scalars['ID']['output'];
  /** Flag indicating if the account identity has been verified */
  identityVerified: Scalars['Boolean']['output'];
  /** The last time the innkeeper authenticated themselves on the platform */
  lastAuthenticatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The innkeeper last name */
  lastName?: Maybe<Scalars['String']['output']>;
  /** The innkeeper payment service ID */
  paymentServiceUserId: Scalars['String']['output'];
  /** The innkeeper phone number */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** The innkeeper account that referred this innkeeper */
  referredByUser?: Maybe<Innkeeper>;
  /** The innkeeper account ID that referred this innkeeper */
  referredByUserId?: Maybe<Scalars['String']['output']>;
  /** The innkeeper refresh token */
  refreshToken?: Maybe<Scalars['String']['output']>;
  /** The date time the account was registered */
  registeredAt?: Maybe<Scalars['DateTime']['output']>;
};

export type IntegerValue = {
  value: Scalars['Int']['output'];
};

/** A booking quote is not available */
export type InternalBookingQuoteUnavailable = {
  message: Scalars['String']['output'];
};

export type InvalidPromoCodeError = {
  message: Scalars['String']['output'];
};

export type LeadCreatedMessage = {
  message: Scalars['String']['output'];
};

/** Response for getting the listings favorited by the current authenticated user */
export type ListAllFavoritedResponse = ListingCollection | UnauthenticatedError;

/** Listing object */
export type Listing = {
  /** The account that the listing belongs to */
  account: Account;
  /** The listing address line one */
  addressLineOne?: Maybe<Scalars['String']['output']>;
  /** The listing address line two */
  addressLineTwo?: Maybe<Scalars['String']['output']>;
  /** The listing affiliations array */
  affiliations: Array<Affiliation>;
  /** The listing Airbnb URL */
  airbnbUrl?: Maybe<Scalars['String']['output']>;
  /** Flag indicating if the listing has been archived */
  archived: Scalars['Boolean']['output'];
  /** Datetime the listing was archived */
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The listing book direct website URL */
  bookDirectWebsiteUrl?: Maybe<Scalars['String']['output']>;
  /**
   * The template for additional listing book direct website URL parameters. Details:
   * - Template engine: Handlebars
   * - Expected helper functions: registerHelper, compile, add
   * - Input object shape: BookDirectWebsiteUrlParamsTemplateInput
   */
  bookDirectWebsiteUrlParamsTemplate?: Maybe<Scalars['String']['output']>;
  /** The listing cancellation policy */
  cancellationPolicy?: Maybe<Scalars['String']['output']>;
  /** The check in time for a listing */
  checkIn?: Maybe<SupportedCheckInAndOutTimes>;
  /** The checkout time for a listing */
  checkout?: Maybe<SupportedCheckInAndOutTimes>;
  /** The listing city */
  city?: Maybe<Scalars['String']['output']>;
  /** The listing country or region long name */
  countryOrRegionLongName?: Maybe<Scalars['String']['output']>;
  /** The current account balance for the listing */
  currentBalanceCents: Scalars['Int']['output'];
  /** The listing text description */
  description?: Maybe<Scalars['String']['output']>;
  /** The listing's distance from the center point of a search */
  distanceFromSearchPoint?: Maybe<Scalars['Float']['output']>;
  /** The external id of the listing */
  externalId?: Maybe<Scalars['String']['output']>;
  /** The external source of the listing */
  externalSource?: Maybe<ExternalSource>;
  /** The listing FaceBook page URL */
  facebookPageUrl?: Maybe<Scalars['String']['output']>;
  /** Flag indicating whether the listing has been featured by the property owner */
  featuredByOwner: Scalars['Boolean']['output'];
  /** The listing features array */
  features: Array<Feature>;
  /** Datetime the listing was first published */
  firstPublishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The listing gallery assets array */
  galleryAssets: Array<GalleryAsset>;
  /** The gust capacity */
  guestCapacity?: Maybe<Scalars['Int']['output']>;
  /** The listing host bio/description */
  hostBio?: Maybe<Scalars['String']['output']>;
  /** The listing host display name */
  hostDisplayName?: Maybe<Scalars['String']['output']>;
  /** The endpoint of the listing host image */
  hostImageEndpoint?: Maybe<Scalars['String']['output']>;
  /** The listing host image path, relative to the endpoint */
  hostImagePath?: Maybe<Scalars['String']['output']>;
  /** The listing host image processing flag */
  hostImageProcessing: Scalars['Boolean']['output'];
  /** The listing host image URL */
  hostImageUrl?: Maybe<Scalars['String']['output']>;
  /** The listing ID */
  id: Scalars['ID']['output'];
  /** Datetime the listing was created */
  insertedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The listing Instagram URL */
  instagramUrl?: Maybe<Scalars['String']['output']>;
  /** The listing Instagram username */
  instagramUsername?: Maybe<Scalars['String']['output']>;
  /** Flag indicating if the listing is part of the diamond collection */
  isDiamondCollection: Scalars['Boolean']['output'];
  /** Flag indicating if the listing is favorited or not */
  isFavorited: Scalars['Boolean']['output'];
  /** Datetime the listing was last published */
  lastPublishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The listing location latitude */
  lat?: Maybe<Scalars['Float']['output']>;
  /** The listing license number */
  licenseNumber?: Maybe<Scalars['String']['output']>;
  /** The floor the listing exists on */
  listedFloor?: Maybe<Scalars['Int']['output']>;
  /** The listing level */
  listingLevel: SubscriptionType;
  /** The listing location longitude */
  lng?: Maybe<Scalars['Float']['output']>;
  /** Exact location not given */
  locationObfuscated: Scalars['Boolean']['output'];
  /** Flag indicating if the location was manually set by an admin */
  locationSetManually: Scalars['Boolean']['output'];
  /** The listing marketing website URL */
  marketingWebsiteUrl?: Maybe<Scalars['String']['output']>;
  /** The maximum stay price in cents */
  maxPrice?: Maybe<Scalars['Int']['output']>;
  /** The minimum stay price in cents */
  minPrice?: Maybe<Scalars['Int']['output']>;
  /** The listing name */
  name?: Maybe<Scalars['String']['output']>;
  /** The number of bathrroms */
  numberOfBathrooms?: Maybe<Scalars['Float']['output']>;
  /** The number of floors */
  numberOfFloors?: Maybe<Scalars['Int']['output']>;
  /** The number of rooms */
  numberOfRooms?: Maybe<Scalars['Int']['output']>;
  /** The user identity that owns the listing */
  owner: User;
  /** The fee to payout with check in cents */
  payoutCheckFeeCents?: Maybe<Scalars['Int']['output']>;
  /** The payout commission percentage on the listing */
  payoutCommissionPercentage?: Maybe<Scalars['Decimal']['output']>;
  /** The listing Pinterest URL */
  pinterestUrl?: Maybe<Scalars['String']['output']>;
  /** The listing Pinterest username */
  pinterestUsername?: Maybe<Scalars['String']['output']>;
  /** The listing google place ID */
  placeId?: Maybe<Scalars['String']['output']>;
  /** The listing google place name */
  placeName?: Maybe<Scalars['String']['output']>;
  /** The listing policies array */
  policies: Array<PolicyUnion>;
  /** The listing postal code */
  postalCode?: Maybe<Scalars['String']['output']>;
  /** The precise listing address line one */
  preciseAddressLineOne?: Maybe<Scalars['String']['output']>;
  /** The precise listing address line two */
  preciseAddressLineTwo?: Maybe<Scalars['String']['output']>;
  /** The precise listing location latitude */
  preciseLat?: Maybe<Scalars['Float']['output']>;
  /** The precise listing location longitude */
  preciseLng?: Maybe<Scalars['Float']['output']>;
  /** The listing price object */
  priceDisplay?: Maybe<PriceDisplay>;
  /** The property type for the listing */
  propertyType?: Maybe<PropertyType>;
  /** The listing public email */
  publicEmail?: Maybe<Scalars['String']['output']>;
  /** The listing public phone number */
  publicPhoneNumber?: Maybe<Scalars['String']['output']>;
  /** The ip address at the time the listing was published */
  publishIpAddress?: Maybe<Scalars['String']['output']>;
  /** Flag indicating if the listing is published or not */
  published: Scalars['Boolean']['output'];
  /** The listing reviews array */
  reviews?: Maybe<Array<ListingReview>>;
  /** The listing reviews average rating */
  reviewsAverageRating?: Maybe<Scalars['Float']['output']>;
  /** The listing reviews count */
  reviewsCount?: Maybe<Scalars['Int']['output']>;
  /** The search promotion type for the listing */
  searchPromotionType?: Maybe<SearchPromotionType>;
  /** Whether or not the listing's availability is capable of displaying in search results */
  searchableAvailability: Scalars['Boolean']['output'];
  /** Whether or not the listing's real-time rates are capable of displaying in search results */
  searchableRates?: Maybe<Scalars['Boolean']['output']>;
  /** The listing SEO friendly url slug */
  slug: Scalars['String']['output'];
  /** The listing state or province long name */
  stateOrProvinceLongName?: Maybe<Scalars['String']['output']>;
  /** The listing level */
  subscriptionType: SubscriptionType;
  /** Flag indicating if the listing supports bookings or not */
  supportsBookings: Scalars['Boolean']['output'];
  /** Flag indicating if the listing supports booking quotes or not */
  supportsQuotes: Scalars['Boolean']['output'];
  /** The listing Twitter handle */
  twitterHandle?: Maybe<Scalars['String']['output']>;
  /** The listing Twitter URL */
  twitterUrl?: Maybe<Scalars['String']['output']>;
  /** The unique property type for the listing */
  uniquePropertyType?: Maybe<UniquePropertyType>;
  /** The errors preventing auto-publish */
  unpublishableErrors: Array<ListingValidationError>;
  /** Datetime the listing was unpublished published. Will be null if published regardless of past history. */
  unpublishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Datetime the listing was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The external source of the listing */
  userConfig: Array<ConfigItem>;
  /** The listing vrbo URL */
  vrboUrl?: Maybe<Scalars['String']['output']>;
  /** Flag indicating a W9 on file for the listing */
  wNineOnFile: Scalars['Boolean']['output'];
  /** The listing YouTube page URL */
  youtubeUrl?: Maybe<Scalars['String']['output']>;
};


/** Listing object */
export type ListingBookDirectWebsiteUrlParamsTemplateArgs = {
  bookDirectWebsiteUrlParamsTemplateInput?: InputMaybe<BookDirectWebsiteUrlParamsTemplateInput>;
};


/** Listing object */
export type ListingGalleryAssetsArgs = {
  numberOfAssets?: InputMaybe<Scalars['Int']['input']>;
  processing?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Listing object */
export type ListingPriceDisplayArgs = {
  checkInDate?: InputMaybe<Scalars['Date']['input']>;
  checkOutDate?: InputMaybe<Scalars['Date']['input']>;
  guests?: InputMaybe<Scalars['Int']['input']>;
  pets?: InputMaybe<Scalars['Int']['input']>;
};


/** Listing object */
export type ListingReviewsArgs = {
  numberOfReviews?: InputMaybe<Scalars['Int']['input']>;
};

/** The statuses for private listing access records */
export enum ListingAccessStatuses {
  Approved = 'APPROVED',
  Denied = 'DENIED',
  Requested = 'REQUESTED'
}

export type ListingApproveAccessForUserInput = {
  /** The Listing ID */
  listingId: Scalars['ID']['input'];
  /** The User ID for the user whose access is being approved */
  userId: Scalars['ID']['input'];
};

/** The result of the listing approve access mutation for an authenticated user */
export type ListingApproveAccessForUserResult = Listing | NotFoundError | UnauthenticatedError | ValidationErrorCollection;

/** Booking Info object */
export type ListingBookingInfo = {
  /** The array containing availability details for a listing */
  availabilityDates: Array<Availability>;
};

/** Response for fetching booking info on a listing */
export type ListingBookingInfoResponse = ListingBookingInfo | NotFoundError;

/** Response for fetching an active listing by its external_id */
export type ListingByExternalIdAndSourceResponse = Listing | NotFoundError;

/** Response for fetching an active listing by its id and account */
export type ListingByIdAndUserResponse = Listing | NotFoundError;

/** Response for fetching an active listing by its slug */
export type ListingBySlugResponse = Listing | NotFoundError | UnauthenticatedError | UnauthorizedError;

/** Cancellation policy record */
export type ListingCancellationPolicy = Policy & {
  /** The cancellation policy description */
  cancellationPolicy: Scalars['String']['output'];
  /** The policy ID */
  id: Scalars['ID']['output'];
  /** The policy type */
  type: PolicyType;
};

/** Listings collection object contains a paginated collection of listings and meta data about the collection */
export type ListingCollection = {
  /** The collection of listings for a given page */
  entries: Array<Listing>;
  /** The meta information containing additional info about the collection */
  meta: CollectionInfo;
};

export type ListingCreateInput = {
  /** The listing address line one */
  addressLineOne: Scalars['String']['input'];
  /** The listing address line two */
  addressLineTwo?: InputMaybe<Scalars['String']['input']>;
  /** The listing city */
  city: Scalars['String']['input'];
  /** The listing country or region long name */
  countryOrRegionLongName: Scalars['String']['input'];
  /** The listing location latitude */
  lat: Scalars['Float']['input'];
  /** The listing license_number policy */
  licenseNumber?: InputMaybe<Scalars['String']['input']>;
  /** The listing location longitude */
  lng: Scalars['Float']['input'];
  /** The location provided will be obfuscated. */
  locationObfuscated?: InputMaybe<Scalars['Boolean']['input']>;
  /** The listing google place ID */
  placeId: Scalars['String']['input'];
  /** The listing google place name */
  placeName: Scalars['String']['input'];
  /** The listing postal code */
  postalCode: Scalars['String']['input'];
  /** The property type for the listing that is being created */
  propertyType: PropertyType;
  /** The listing state or province long name */
  stateOrProvinceLongName: Scalars['String']['input'];
  /** The unique property type for the listing that is being created */
  uniquePropertyType?: InputMaybe<UniquePropertyType>;
};

/** The result of the listing create mutation for an authenticated user */
export type ListingCreateResult = Listing | UnauthenticatedError | ValidationErrorCollection;

export type ListingDeleteInput = {
  /** The ID of the listing id. */
  listingId: Scalars['ID']['input'];
};

/** The result of the delete listing mutation for an authenticated innkeeper */
export type ListingDeleteResult = Listing | NotFoundError | UnauthenticatedError;

export type ListingDenyAccessForUserInput = {
  /** The Listing ID */
  listingId: Scalars['ID']['input'];
  /** The User ID for the user whose access is being approved */
  userId: Scalars['ID']['input'];
};

/** The result of the listing deny access mutation for an authenticated user */
export type ListingDenyAccessForUserResult = Listing | NotFoundError | UnauthenticatedError | ValidationErrorCollection;

export type ListingFavoriteCreateInput = {
  /** The favorited listing's distance from the current search point */
  distanceFromSearchPoint?: InputMaybe<Scalars['Float']['input']>;
  /** The Listing ID */
  listingId: Scalars['ID']['input'];
};

/** The result of the listing favorite create mutation for an authenticated user */
export type ListingFavoriteCreateResult = Listing | NotFoundError | UnauthenticatedError | ValidationErrorCollection;

export type ListingFavoriteDeleteInput = {
  /** The (un)favorited listing's distance from the current search point */
  distanceFromSearchPoint?: InputMaybe<Scalars['Float']['input']>;
  /** The Listing ID */
  listingId: Scalars['ID']['input'];
};

/** The result of the listing favorite create mutation for an authenticated user */
export type ListingFavoriteDeleteResult = Listing | NotFoundError | UnauthenticatedError | ValidationErrorCollection;

/** The sort options supported for listings */
export enum ListingFavoriteSortOptions {
  /** The created at time with the newest favorites appearing first */
  FavoritedAtNewestFirst = 'FAVORITED_AT_NEWEST_FIRST',
  /** The created at time with the oldest favorites appearing first */
  FavoritedAtOldestFirst = 'FAVORITED_AT_OLDEST_FIRST'
}

/** Transaction recorded when a listing journal entry is created */
export type ListingJournalTransaction = Transaction & {
  /** The admin that created the transaction */
  admin?: Maybe<Admin>;
  /** The transaction amount in cents */
  amountCents: Scalars['Int']['output'];
  /** The time the transaction was created */
  createdAt: Scalars['DateTime']['output'];
  /** A short description as to why the transaction was created */
  description: Scalars['String']['output'];
  /** The transaction ID */
  id: Scalars['ID']['output'];
  /** The transaction that paid out this journal transaction */
  payoutTransaction?: Maybe<ListingPayoutTransaction>;
  /** The listing that was the recipient of the transaction */
  recipient: Listing;
  /** The transaction type */
  type: TransactionType;
  /** The last time the transaction was updated */
  updatedAt: Scalars['DateTime']['output'];
};

export type ListingLevels = {
  /** The number of listings at bronze */
  bronze: Scalars['Int']['output'];
  /** The number of listings at free */
  free: Scalars['Int']['output'];
  /** The number of listings at gold */
  gold: Scalars['Int']['output'];
  /** The number of listings at silver */
  silver: Scalars['Int']['output'];
};

/** Transaction recorded when a listing balance is paid out */
export type ListingPayoutTransaction = Transaction & {
  /** The admin that created the transaction */
  admin?: Maybe<Admin>;
  /** The transaction amount in cents */
  amountCents: Scalars['Int']['output'];
  /** The bnbfinder commission amount in cents */
  commissionAmountCents: Scalars['Int']['output'];
  /** The time the transaction was created */
  createdAt: Scalars['DateTime']['output'];
  /** The transaction ID */
  id: Scalars['ID']['output'];
  /** The listing payment source ID */
  paymentServiceTransactionId: Scalars['String']['output'];
  /** The listing payment source type */
  paymentServiceTransactionType: PaymentServiceTransactionType;
  /** The listing that was the payor of the transaction */
  payor: Listing;
  /** The transaction type */
  type: TransactionType;
  /** The last time the transaction was updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** Response for getting the listing for the current authenticated innkeeper */
export type ListingPrivateAccessForUserResponse = AccessStatus | NotFoundError | ValidationErrorCollection;

export type ListingPubishableStatusCounts = {
  publishable: Scalars['Int']['output'];
  unpublishable: Scalars['Int']['output'];
};

export type ListingPublishInput = {
  /** The Listing ID */
  listingId: Scalars['ID']['input'];
  /** The IP address that is publishing the listing */
  publishIpAddress?: InputMaybe<Scalars['String']['input']>;
};

/** The result of the listing publish mutation for an authenticated user */
export type ListingPublishResult = Listing | UnauthenticatedError | ValidationErrorCollection;

/** Transaction recorded when a listing redeems an amount from a gift card */
export type ListingRedemptionTransaction = Transaction & {
  /** The transaction amount in cents */
  amountCents: Scalars['Int']['output'];
  /** The time the transaction was created */
  createdAt: Scalars['DateTime']['output'];
  /** A short description about the redmption */
  description: Scalars['String']['output'];
  /** The transaction ID */
  id: Scalars['ID']['output'];
  /** The gift card that was the payor of the transaction */
  payor: GiftCard;
  /** The transaction that paid out this redemption */
  payoutTransaction?: Maybe<ListingPayoutTransaction>;
  /** The listing that was the recipient of the transaction */
  recipient: Listing;
  /** The transaction type */
  type: TransactionType;
  /** The last time the transaction was updated */
  updatedAt: Scalars['DateTime']['output'];
};

export type ListingRequestAccessForUserInput = {
  /** The Listing slug */
  listingSlug: Scalars['String']['input'];
};

/** The result of the listing request access mutation for an authenticated user */
export type ListingRequestAccessForUserResult = AccessStatus | Listing | NotFoundError | UnauthenticatedError | ValidationErrorCollection;

/** Listing Review object */
export type ListingReview = {
  /** The author for the review */
  authorName?: Maybe<Scalars['String']['output']>;
  /** The body for the review */
  body?: Maybe<Scalars['String']['output']>;
  /** The date for the review */
  date?: Maybe<Scalars['Date']['output']>;
  /** The Listing Review ID */
  id: Scalars['ID']['output'];
  /** The rating for the review */
  rating?: Maybe<Scalars['Float']['output']>;
};

export type ListingReviewCollection = {
  /** The collection of reviews for a given listing */
  entries: Array<ListingReview>;
  /** The meta information containing additional info about the collection */
  meta: CollectionInfo;
};

/** Response for fetching reviews on a listing */
export type ListingReviewsListAllForListingResponse = ListingReviewCollection | NotFoundError;

export type ListingSearchCursorCollection = {
  /** The collection of listings for the given search */
  entries: Array<Listing>;
  metadata: CursorCollectionMetadata;
  /** Information about the region being searched */
  searchPlace?: Maybe<SearchPlace>;
};

/** The sort options supported for listings */
export enum ListingSortOptions {
  /** Random value (changes periodically) */
  Random = 'RANDOM',
  /** The state or province long name value in ascending order (A -> Z) */
  StateOrProvinceLongNameAsc = 'STATE_OR_PROVINCE_LONG_NAME_ASC',
  /** The state or province long name value in descending order (Z -> A) */
  StateOrProvinceLongNameDesc = 'STATE_OR_PROVINCE_LONG_NAME_DESC'
}

/** The result of the listing unpublish mutation for an authenticated user */
export type ListingUnpublishResult = Listing | NotFoundError | UnauthenticatedError | ValidationErrorCollection;

export type ListingUpdateInput = {
  /** The listing address line one */
  addressLineOne?: InputMaybe<Scalars['String']['input']>;
  /** The listing address line two */
  addressLineTwo?: InputMaybe<Scalars['String']['input']>;
  /** The listing book direct website URL */
  bookDirectWebsiteUrl?: InputMaybe<Scalars['String']['input']>;
  checkIn?: InputMaybe<SupportedCheckInAndOutTimes>;
  checkout?: InputMaybe<SupportedCheckInAndOutTimes>;
  /** The listing city */
  city?: InputMaybe<Scalars['String']['input']>;
  /** The listing country or region long name */
  countryOrRegionLongName?: InputMaybe<Scalars['String']['input']>;
  /** The listing text description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The URL for a listings facebook page */
  facebookPageUrl?: InputMaybe<Scalars['String']['input']>;
  featureKeys?: InputMaybe<Array<FeatureKey>>;
  guestCapacity?: InputMaybe<Scalars['Int']['input']>;
  /** The listing's host bio */
  hostBio?: InputMaybe<Scalars['String']['input']>;
  /** The listing's host display name */
  hostDisplayName?: InputMaybe<Scalars['String']['input']>;
  /** The listing's host image upload URL */
  hostImageUploadUrl?: InputMaybe<Scalars['String']['input']>;
  /** The listing's instagram username */
  instagramUsername?: InputMaybe<Scalars['String']['input']>;
  /** The listing location latitude */
  lat?: InputMaybe<Scalars['Float']['input']>;
  /** The listing license number */
  licenseNumber?: InputMaybe<Scalars['String']['input']>;
  listedFloor?: InputMaybe<Scalars['Int']['input']>;
  /** The Listing ID */
  listingId: Scalars['ID']['input'];
  /** The listing location longitude */
  lng?: InputMaybe<Scalars['Float']['input']>;
  locationObfuscated?: InputMaybe<Scalars['Boolean']['input']>;
  /** The listing marketing website URL */
  marketingWebsiteUrl?: InputMaybe<Scalars['String']['input']>;
  /** The maximum stay price in cents */
  maxPrice?: InputMaybe<Scalars['Int']['input']>;
  /** The minimum stay price in cents */
  minPrice?: InputMaybe<Scalars['Int']['input']>;
  /** The listing name */
  name?: InputMaybe<Scalars['String']['input']>;
  numberOfBathrooms?: InputMaybe<Scalars['Float']['input']>;
  numberOfFloors?: InputMaybe<Scalars['Int']['input']>;
  numberOfRooms?: InputMaybe<Scalars['Int']['input']>;
  /** The listing's pinterest username */
  pinterestUsername?: InputMaybe<Scalars['String']['input']>;
  /** The listing google place ID */
  placeId?: InputMaybe<Scalars['String']['input']>;
  /** The listing google place name */
  placeName?: InputMaybe<Scalars['String']['input']>;
  /** The listing postal code */
  postalCode?: InputMaybe<Scalars['String']['input']>;
  /** The property type for the listing that is being updated */
  propertyType?: InputMaybe<PropertyType>;
  /** The listing public email */
  publicEmail?: InputMaybe<Scalars['String']['input']>;
  /** The listing public phone number */
  publicPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** The listing state or province long name */
  stateOrProvinceLongName?: InputMaybe<Scalars['String']['input']>;
  /** The listing's twitter handle */
  twitterHandle?: InputMaybe<Scalars['String']['input']>;
  /** The unique property type for the listing that is being updated */
  uniquePropertyType?: InputMaybe<UniquePropertyType>;
  /** The listing's YouTube URL */
  youtubeUrl?: InputMaybe<Scalars['String']['input']>;
};

/** The result of the listing update mutation for an authenticated user */
export type ListingUpdateResult = Listing | UnauthenticatedError | ValidationErrorCollection;

/** An error encountered when attempting to publish a listing */
export type ListingValidationError = {
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

/** Response for getting the listings for the current authenticated user's account */
export type ListingsSearchResponse = ListingSearchCursorCollection | ValidationErrorCollection;

export enum ListingsSearchType {
  Map = 'MAP',
  Region = 'REGION'
}

export type LiveListPmsConnectionCreateInput = {
  accountId: Scalars['String']['input'];
};

export type LodgifyPmsConnectionCreateInput = {
  apiKey: Scalars['String']['input'];
};

export type LodgixPmsConnectionCreateInput = {
  apiKey: Scalars['String']['input'];
};

export enum MobileType {
  Android = 'ANDROID',
  Ios = 'IOS'
}

/** Response for checking if the mobile version is valid */
export type MobileVersionResponse = UpgradeRequiredError | Version;

export type NewsletterSubscription = {
  /** User's email */
  email: Scalars['String']['output'];
};

export type NextPaxPmsConnectionCreateInput = {
  accountId: Scalars['String']['input'];
};

/** An error encountered when the resource is not found */
export type NotFoundError = {
  message: Scalars['String']['output'];
};

/** Listing Quote object */
export type Order = {
  /** The order id */
  id: Scalars['String']['output'];
  /** The booking quote for the order */
  quote: BookingQuote;
};

export type OrderLoadInput = {
  adultCount?: InputMaybe<Scalars['Int']['input']>;
  /** The start time for the listing */
  checkInDate: Scalars['Date']['input'];
  /** The end time for the listing */
  checkOutDate: Scalars['Date']['input'];
  childCount?: InputMaybe<Scalars['Int']['input']>;
  infantCount?: InputMaybe<Scalars['Int']['input']>;
  /** The order id. If not provided a new order will be created. If order does not belong to current user a new order will be created. */
  orderId?: InputMaybe<Scalars['String']['input']>;
  petCount?: InputMaybe<Scalars['Int']['input']>;
  /** The slug for the listing */
  slug: Scalars['String']['input'];
};

/** Response for updating order */
export type OrderLoadResponse = NotFoundError | Order | OrderUnavailable | OrderUnsupported | UnauthenticatedError | ValidationError;

/** A order is not available */
export type OrderUnavailable = {
  message: Scalars['String']['output'];
};

/** A booking order is not supported */
export type OrderUnsupported = {
  message: Scalars['String']['output'];
};

export type OwnerRezPmsConnectionCreateInput = {
  accountId: Scalars['String']['input'];
};

export type PasswordResetMessage = {
  message: Scalars['String']['output'];
};

export type PaymentItem = {
  /** The amount of the payment in cents */
  amountCents: Scalars['Int']['output'];
  /** The description of the payment */
  description?: Maybe<Scalars['String']['output']>;
  /** The date the payment is due */
  dueDate: Scalars['Date']['output'];
  /** The type of payment item */
  paymentItemType: PaymentItemType;
};

export enum PaymentItemType {
  /** Payment item is a deposit */
  Deposit = 'DEPOSIT',
  /** Payment item is an installment toward the total price. */
  Installment = 'INSTALLMENT'
}

export enum PaymentServiceTransactionType {
  Check = 'CHECK',
  Stripe = 'STRIPE'
}

/** Place object */
export type Place = {
  /** The place address line one */
  addressLineOne?: Maybe<Scalars['String']['output']>;
  /** The place address line two */
  addressLineTwo?: Maybe<Scalars['String']['output']>;
  /** The place city */
  city?: Maybe<Scalars['String']['output']>;
  /** The place country or region long name */
  countryOrRegionLongName?: Maybe<Scalars['String']['output']>;
  /** The place country or region short name */
  countryOrRegionShortName?: Maybe<Scalars['String']['output']>;
  /** Geometric data for the place */
  geometry?: Maybe<Geometry>;
  /** The Google place ID */
  id: Scalars['ID']['output'];
  /** The place name */
  name: Scalars['String']['output'];
  /** The place postal code */
  postalCode?: Maybe<Scalars['String']['output']>;
  /** The place rating value */
  ratingValue?: Maybe<Scalars['Float']['output']>;
  /** The place maximum potential rating value */
  ratingValueMax?: Maybe<Scalars['Int']['output']>;
  /** The place raw address components from the Google place API */
  rawAddressComponents?: Maybe<Array<RawAddressComponent>>;
  /** The place raw Google place geocoding types */
  rawTypes?: Maybe<Array<Scalars['String']['output']>>;
  /** The place state or province long name */
  stateOrProvinceLongName?: Maybe<Scalars['String']['output']>;
  /** The place state or province short name */
  stateOrProvinceShortName?: Maybe<Scalars['String']['output']>;
};

/** Place autocomplete object */
export type PlaceAutocompletePrediction = {
  /** The Google place ID */
  id: Scalars['ID']['output'];
  /** The place name */
  name: Scalars['String']['output'];
  /** The place raw Google place geocoding types */
  rawTypes?: Maybe<Array<Scalars['String']['output']>>;
};

/** Response for fetching a place by its address */
export type PlaceByAddressResponse = NotFoundError | Place;

/** Response for fetching a place by its ID */
export type PlaceByIdResponse = NotFoundError | Place;

/** The place type that should be returned */
export enum PlaceTypeFilter {
  /** Address specific place types */
  Address = 'ADDRESS',
  /** All place types */
  All = 'ALL',
  /** Establishment specific place types */
  Establishment = 'ESTABLISHMENT',
  /** Geocode specific place types */
  Geocode = 'GEOCODE',
  /** Region specific place types */
  Regions = 'REGIONS'
}

/** Plan object that belongs to products and subscriptions */
export type Plan = {
  /** The amount that the plan cost in cents */
  amount: Scalars['Int']['output'];
  /** The plan ID */
  id: Scalars['ID']['output'];
  /** The plan billing interval */
  interval: PlanInterval;
  /** The plan name */
  name: Scalars['String']['output'];
  /** The product ID that the plan belongs to */
  productId: Scalars['String']['output'];
};

export type PlanCollection = {
  /** The collection of plans for a given page */
  entries: Array<Plan>;
  /** The meta information containing additional info about the collection */
  meta: CollectionInfo;
};

/** The plan interval specifies billing frequency */
export enum PlanInterval {
  /** Bill for plan every day */
  Day = 'DAY',
  /** Bill for plan once per month */
  Month = 'MONTH',
  /** Bill for plan once per week */
  Week = 'WEEK',
  /** Bill for plan once per year */
  Year = 'YEAR'
}

/** Response for getting plans */
export type PlansListAllResponse = PlanCollection | ServiceUnavailableError | UnauthenticatedError;

export type PmAccountCreateInput = {
  /** The account address line one */
  addressLineOne: Scalars['String']['input'];
  /** The account address line two */
  addressLineTwo?: InputMaybe<Scalars['String']['input']>;
  /** The account city */
  city: Scalars['String']['input'];
  companyName: Scalars['String']['input'];
  /** The account country or region long name */
  countryOrRegionLongName: Scalars['String']['input'];
  homeownerMarketingUrl?: InputMaybe<Scalars['String']['input']>;
  marketingWebsiteUrl: Scalars['String']['input'];
  numberOfListings: Scalars['Int']['input'];
  pmsSoftware: Scalars['String']['input'];
  /** The account postal code */
  postalCode: Scalars['String']['input'];
  /** The account state or province long name */
  stateOrProvinceLongName: Scalars['String']['input'];
};

/** The result of the account create mutation for an authenticated user */
export type PmAccountCreateResult = Account | UnauthenticatedError | ValidationErrorCollection;

export type PmsConnection = {
  failed: Scalars['Boolean']['output'];
  failingSince?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  insertedAt: Scalars['DateTime']['output'];
  maskedCredentials?: Maybe<Scalars['String']['output']>;
  supportsBookings: Scalars['Boolean']['output'];
  supportsQuotes: Scalars['Boolean']['output'];
  type: PmsName;
  userConfig: Array<ConfigItem>;
};

export type PmsConnectionCreateResult = PmsConnection | UnauthenticatedError | ValidationErrorCollection;

export type PmsConnectionForCurrentUserResponse = NotFoundError | PmsConnection | UnauthenticatedError;

/** PMS Integration object */
export type PmsIntegration = {
  authType: Scalars['String']['output'];
  availabilitySync?: Maybe<Scalars['String']['output']>;
  contentSync?: Maybe<Scalars['String']['output']>;
  docsUrl: Scalars['String']['output'];
  fields: Array<PmsIntegrationField>;
  jiraTicketUrl: Scalars['String']['output'];
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  ratesSync?: Maybe<Scalars['String']['output']>;
  status: PmsIntegrationStatus;
  /** @deprecated This will be deprecated soon use 'fields' instead */
  supportedFields: Array<PmsIntegrationField>;
  supportsBookings?: Maybe<Scalars['Boolean']['output']>;
  supportsPricing?: Maybe<Scalars['Boolean']['output']>;
  supportsQuotes?: Maybe<Scalars['Boolean']['output']>;
  supportsReviews?: Maybe<Scalars['Boolean']['output']>;
};

export type PmsIntegrationField = {
  description?: Maybe<Scalars['String']['output']>;
  fieldName: FieldNames;
  supported: PmsIntegrationFieldSupported;
};

export enum PmsIntegrationFieldSupported {
  No = 'NO',
  Partially = 'PARTIALLY',
  Yes = 'YES'
}

export enum PmsIntegrationStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  InProgress = 'IN_PROGRESS',
  ReadyForDev = 'READY_FOR_DEV',
  WaitingOnPartnership = 'WAITING_ON_PARTNERSHIP',
  WaitingOnTestAccount = 'WAITING_ON_TEST_ACCOUNT'
}

export enum PmsName {
  Barefoot = 'BAREFOOT',
  Bnbfinder = 'BNBFINDER',
  Bookster = 'BOOKSTER',
  Boost = 'BOOST',
  Ciirus = 'CIIRUS',
  Demo = 'DEMO',
  Escapia = 'ESCAPIA',
  Guesty = 'GUESTY',
  Hostaway = 'HOSTAWAY',
  Hostfully = 'HOSTFULLY',
  LiveList = 'LIVE_LIST',
  Lodgify = 'LODGIFY',
  Lodgix = 'LODGIX',
  NextPax = 'NEXT_PAX',
  OwnerRez = 'OWNER_REZ',
  RedAwning = 'RED_AWNING',
  RentalsUnited = 'RENTALS_UNITED',
  Streamline = 'STREAMLINE',
  StreamlinePartner = 'STREAMLINE_PARTNER',
  Track = 'TRACK',
  VacayHome = 'VACAY_HOME'
}

/** Point with the given lat and lng coordinate values */
export type Point = {
  /** The lat value for the point */
  lat: Scalars['Float']['output'];
  /** The lng value for the point */
  lng: Scalars['Float']['output'];
};

/** Policy object */
export type Policy = {
  /** The policy ID */
  id: Scalars['ID']['output'];
  /** The policy type */
  type: PolicyType;
};

/** The types for policy records */
export enum PolicyType {
  AccountCancellationPolicy = 'ACCOUNT_CANCELLATION_POLICY',
  AccountTermsAndConditions = 'ACCOUNT_TERMS_AND_CONDITIONS',
  ListingCancellationPolicy = 'LISTING_CANCELLATION_POLICY'
}

export type PolicyUnion = AccountCancellationPolicy | AccountTermsAndConditions | ListingCancellationPolicy;

export type PolicyUpsertAccountCancellationPolicyInput = {
  /** The description for the account's cancellation policy */
  description: Scalars['String']['input'];
};

export type PolicyUpsertAccountCancellationPolicyResult = AccountCancellationPolicy | NotFoundError | UnauthenticatedError | ValidationErrorCollection;

export type PolicyUpsertAccountTermsAndConditionsInput = {
  /** The link for the account's terms and conditions policy */
  termsLink: Scalars['String']['input'];
  /** The upload URL for the account's terms and conditions policy */
  termsUploadUrl?: InputMaybe<Scalars['String']['input']>;
};

export type PolicyUpsertAccountTermsAndConditionsResult = AccountTermsAndConditions | NotFoundError | UnauthenticatedError | ValidationErrorCollection;

export type PolicyUpsertListingCancellationPolicyInput = {
  /** The description for the listing's cancellation policy */
  description: Scalars['String']['input'];
  /** The ID of the listing to add the cancellation policy to */
  listingId: Scalars['ID']['input'];
};

export type PolicyUpsertListingCancellationPolicyResult = ListingCancellationPolicy | NotFoundError | UnauthenticatedError | ValidationErrorCollection;

export type PriceByOtaUrl = {
  savvyStayUrl?: Maybe<Scalars['String']['output']>;
  totalWithoutTaxesCents?: Maybe<Scalars['Int']['output']>;
};

/** Response for getting the quote on a listing given an external OTA URL */
export type PriceByOtaUrlResponse = InternalBookingQuoteUnavailable | NotFoundError | PriceByOtaUrl;

/** Listing Price display object */
export type PriceDisplay = {
  /**
   * The base price before fees
   * @deprecated deprecated in favor of base_amount_cents, this will be removed soon
   */
  amountCents: Scalars['Int']['output'];
  /** The base price before fees */
  baseAmountCents: Scalars['Int']['output'];
  /** The check in date */
  checkInDate: Scalars['Date']['output'];
  /** The check out date */
  checkOutDate: Scalars['Date']['output'];
  /** The number of nights */
  nights: Scalars['Int']['output'];
  /** The subtotal after fees, without taxes */
  subtotalWithoutTaxesCents?: Maybe<Scalars['Int']['output']>;
};

export enum PriceType {
  /** The price includes taxes and all fees (total cost) */
  TotalCost = 'TOTAL_COST',
  /** The price includes fees but excludes taxes */
  TotalWithoutTax = 'TOTAL_WITHOUT_TAX'
}

export enum PropertyType {
  Apartment = 'APARTMENT',
  BedAndBreakfast = 'BED_AND_BREAKFAST',
  BoutiqueHotel = 'BOUTIQUE_HOTEL',
  GuestHouse = 'GUEST_HOUSE',
  House = 'HOUSE'
}

export enum QuoteItemizedType {
  /** The base cost for the quote */
  Base = 'BASE',
  /** The discount for the quote */
  Discount = 'DISCOUNT',
  /** The fee for the quote */
  Fee = 'FEE',
  /** The other quote item for the quote */
  Other = 'OTHER',
  /** The recoverable for the quote */
  Recoverable = 'RECOVERABLE',
  /** The tax for the quote */
  Tax = 'TAX'
}

export type QuoteItems = {
  /** The total cost of the item in cents */
  costCents: Scalars['Int']['output'];
  /** The description of the item */
  description: Scalars['String']['output'];
  /** The type of the item */
  type: QuoteItemizedType;
};

/** Raw address component from the Google place API */
export type RawAddressComponent = {
  /** The raw address component long name */
  longName: Scalars['String']['output'];
  /** The raw address component short name */
  shortName: Scalars['String']['output'];
  /** The raw address component Google place geocoding types */
  types: Array<Scalars['String']['output']>;
};

export type RedAwningPmsConnectionCreateInput = {
  apiKey: Scalars['String']['input'];
};

/** Region object */
export type Region = {
  /** The region city's slug */
  citySlug?: Maybe<Scalars['String']['output']>;
  /** The region country's slug */
  countrySlug?: Maybe<Scalars['String']['output']>;
  /** The region long name */
  description: Scalars['String']['output'];
  /** The featured flag */
  featured: Scalars['Boolean']['output'];
  /** The region ID */
  id: Scalars['ID']['output'];
  /** The endpoint of the image host */
  imageEndpoint?: Maybe<Scalars['String']['output']>;
  /** The image path, relative to the endpoint */
  imagePath?: Maybe<Scalars['String']['output']>;
  /** The image processing flag */
  imageProcessing: Scalars['Boolean']['output'];
  /** The region image */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** The region level_one's slug */
  levelOneSlug?: Maybe<Scalars['String']['output']>;
  /** The region long name */
  name: Scalars['String']['output'];
  /** The region Google place ID */
  placeId: Scalars['String']['output'];
  /** The region search page content array */
  searchPageContents: Array<SearchPageContent>;
  /** The region slug */
  slug: Scalars['String']['output'];
};

/** Region collection object contains a paginated collection of regions and meta data about the collection */
export type RegionCollection = {
  /** The collection of regions for a given page */
  entries: Array<Region>;
  /** The meta information containing additional info about the collection */
  meta: CollectionInfo;
};

export type RentalsUnitedPmsConnectionCreateInput = {
  username: Scalars['String']['input'];
};

/** Reservation object */
export type Reservation = {
  /** The cancellation policy for the reservation */
  cancellationPolicy?: Maybe<Scalars['String']['output']>;
  /** The end date for the reservation */
  endDate: Scalars['Date']['output'];
  /** The Reservation ID for the external system */
  externalReservationId: Scalars['String']['output'];
  /** The Reservation ID */
  id: Scalars['ID']['output'];
  /** The created at date for the reservation */
  insertedAt: Scalars['String']['output'];
  /** The listing that the reservation belongs to */
  listing: Listing;
  numberOfAdults?: Maybe<Scalars['Int']['output']>;
  numberOfChildren?: Maybe<Scalars['Int']['output']>;
  numberOfInfants?: Maybe<Scalars['Int']['output']>;
  numberOfPets?: Maybe<Scalars['Int']['output']>;
  /** The order that the reservation belongs to */
  order: Order;
  /**
   * The payment schedule for the quote
   * @deprecated This will be deprecated soon use 'order.quote.payment_schedule' instead
   */
  paymentSchedule: Array<PaymentItem>;
  /** The start date for the reservation */
  startDate: Scalars['Date']['output'];
  /** The status for the reservation */
  status: ReservationStatuses;
  /** Flag indicating if the reservation supports cancellations or not */
  supportsCancellations: Scalars['Boolean']['output'];
  /** The total price for the reservation */
  totalCostCents?: Maybe<Scalars['Int']['output']>;
  /** The updated at date for the reservation */
  updatedAt: Scalars['String']['output'];
};

/** Response for getting a reservation by an reservation ID when authenticated as a user */
export type ReservationByIdResponse = NotFoundError | Reservation;

/** Reservations collection object contains a paginated collection of reservations and meta data about the collection */
export type ReservationCollection = {
  /** The collection of reservations for a given page */
  entries: Array<Reservation>;
  /** The meta information containing additional info about the collection */
  meta: CollectionInfo;
};

/** The statuses for reservation records */
export enum ReservationStatuses {
  Accepted = 'ACCEPTED',
  Cancelled = 'CANCELLED',
  Error = 'ERROR',
  Processing = 'PROCESSING'
}

/** Response for getting the reservations by the current authenticated user */
export type ReservationsListAllForUserResponse = ReservationCollection | UnauthenticatedError;

export type ResetPasswordForTokenInput = {
  /** The user's new password */
  password: Scalars['String']['input'];
  /** The user's account email */
  token: Scalars['String']['input'];
};

/** The result of the user password reset for token mutation */
export type ResetPasswordForTokenResponse = NotFoundError | PasswordResetMessage | ValidationErrorCollection;

export type ResetPasswordInput = {
  /** The user's new password */
  password: Scalars['String']['input'];
};

/** The result of the user password reset mutation */
export type ResetPasswordResponse = PasswordResetMessage | UnauthenticatedError | ValidationErrorCollection;

export type RootMutationType = {
  /** Bulk update location_obfuscated for all listings on the current user's account */
  accountBulkUpdateLocationObfuscated: AccountBulkUpdateLocationObfuscatedResult;
  /** Create a review summary when authenticated innkeeper */
  accountReviewSummaryCreate: AccountReviewSummaryCreateResult;
  /** Update the account for the current authenticated user */
  accountUpdate: AccountUpdateResult;
  /** Update all listing subscriptions for account */
  accountUpdateAllListingSubscriptions: AccountUpdateAllListingSubscriptionsResult;
  /** Create an innkeeper access token when authenticated as an admin */
  adminAccessTokenCreate: AdminAccessTokenCreateResponse;
  /** Archive the account associated with the given ID */
  adminAccountArchive: AdminAccountArchiveResult;
  /** Publish all listings for account */
  adminAccountPublishAllListings: AdminAccountPublishAllListingsResult;
  /** Recreate Stripe subscription for account and migrate all listings to free */
  adminAccountRecreateStripeSubscription: AdminAccountResult;
  /** Remove the PMS connection from the account associated with the given ID */
  adminAccountRemovePmsConnection: AdminAccountRemovePmsConnectionResult;
  /** Reset Salesforce for account, setting a fresh lead as the link */
  adminAccountResetSalesforce: AdminAccountResult;
  /** Unpublish all listings for account */
  adminAccountUnpublishAllListings: AdminAccountUnpublishAllListingsResult;
  /** Update the account for the current authenticated user */
  adminAccountUpdate: AdminAccountUpdateResult;
  /** Update all listing subscriptions for account */
  adminAccountUpdateAllListingSubscriptions: AdminAccountUpdateAllListingSubscriptionsResult;
  /** Update booking engine url for all listings on account */
  adminAccountUpdateBookingUrls: AdminAccountUpdateBookingUrlsResult;
  /** Activate the gift card when authenticated as an admin */
  adminGiftCardActivate: AdminGiftCardResult;
  /** Adjust the balance of the gift card */
  adminGiftCardAdjustBalance: AdminGiftCardResult;
  /** Create a gift card when authenticated as an admin */
  adminGiftCardCreate: AdminGiftCardResult;
  /** Deactivate the gift card when authenticated as an admin */
  adminGiftCardDeactivate: AdminGiftCardResult;
  /** Re-deliver the gift card when authenticated as an admin. Only supported for digital cards, physical cards are delivered by admins. */
  adminGiftCardDeliver: AdminGiftCardResult;
  /** Create a gift card image when authenticated as an admin */
  adminGiftCardImageCreate: GiftCardImageCreateResponse;
  /** Delete a gift card image authenticated as an admin */
  adminGiftCardImageDelete: GiftCardImageDeleteResponse;
  /** Update a gift card image authenticated as an admin */
  adminGiftCardImageUpdate: GiftCardImageUpdateResponse;
  /** Issue the gift card when authenticated as an admin. Only supported for physical cards, digital cards are issued by the system. */
  adminGiftCardIssue: AdminGiftCardResult;
  /** Create a gift card note when authenticated as an admin */
  adminGiftCardNoteCreate: GiftCardNoteCreateResponse;
  /** Delete a gift card note authenticated as an admin */
  adminGiftCardNoteDelete: GiftCardNoteDeleteResponse;
  /** Issue a refund to the original purchase payment method and reduce the balance of the card. Only supported for cards with a gift_card_purchased_transaction */
  adminGiftCardRefund: AdminGiftCardResult;
  /** Update a gift card when authenticated as an admin */
  adminGiftCardUpdate: AdminGiftCardResult;
  /** Verify the gift card when authenticated as an admin */
  adminGiftCardVerify: AdminGiftCardResult;
  /** Admin Google social session mutation */
  adminGoogleSocialSession: AdminGoogleSocialSessionResponse;
  /** Update a listing's config field mapping */
  adminListingConfigFieldMappingUpdate: AdminListingConfigFieldMappingUpdateResult;
  /** Delete a listing when authenticated as an admin */
  adminListingDelete: AdminListingResult;
  /** Publish the listing as an admin */
  adminListingPublish: AdminListingPublishResult;
  /** Record a listing payout when authenticated as an admin */
  adminListingRecordPayout: AdminListingResult;
  /** Toggle listing gift card status */
  adminListingToggleAcceptsGiftCards: AdminListingResult;
  /** Toggle listing W9 on file status */
  adminListingToggleWNineOnFile: AdminListingResult;
  /** Update a listing when authenticated as an admin */
  adminListingUpdate: AdminListingResult;
  adminMigrateStreamlineToPartnerConnection: AdminMigrateStreamlineToPartnerConnectionResult;
  adminPmsConnectionPmsFieldMappingUpdate: AdminPmsConnectionPmsFieldMappingUpdateResult;
  adminPmsConnectionRetry: AdminPmsConnectionRetryResult;
  /** Find or create a region for a listing when authenticated as an admin */
  adminRegionFindOrCreateForListing: AdminRegionResult;
  /** Remove a region for a given listing when authenticated as an admin */
  adminRegionRemoveForListing: AdminRegionResult;
  /** Create a search page content authenticated as an admin */
  adminSearchPageContentCreate: AdminSearchPageContentCreateResponse;
  /** Delete a search page content authenticated as an admin */
  adminSearchPageContentDelete: AdminSearchPageContentDeleteResponse;
  /** Remove a region for a given search page content when authenticated as an admin */
  adminSearchPageContentRemoveRegion: AdminSearchPageContentRemoveRegionResponse;
  /** Update a search page content authenticated as an admin */
  adminSearchPageContentUpdate: AdminSearchPageContentUpdateResponse;
  /** Update a region for a given search page content when authenticated as an admin */
  adminSearchPageContentUpdateRegion: AdminSearchPageContentUpdateRegionResponse;
  /** Create a search page link authenticated as an admin */
  adminSearchPageLinkCreate: AdminSearchPageLinkResult;
  /** Delete a search page link authenticated as an admin */
  adminSearchPageLinkDelete: AdminSearchPageLinkResult;
  /** Update a search page link authenticated as an admin */
  adminSearchPageLinkUpdate: AdminSearchPageLinkResult;
  /** Create a search page paragraph authenticated as an admin */
  adminSearchPageParagraphCreate: AdminSearchPageParagraphResult;
  /** Delete a search page paragraph authenticated as an admin */
  adminSearchPageParagraphDelete: AdminSearchPageParagraphResult;
  adminSearchPageParagraphOrder: SearchPageParagraphOrderResponse;
  /** Update a search page paragraph authenticated as an admin */
  adminSearchPageParagraphUpdate: AdminSearchPageParagraphResult;
  /** Set a subscription for an innkeeper */
  adminSetSubscription: AdminSetSubscriptionResult;
  /** Create a listings CSV import task when authenticated as an admin */
  adminTaskCreateListingsCsvImport: AdminTaskCreateListingsCsvImportResult;
  /** Update an user when authenticated as an admin */
  adminUserUpdate: AdminUserResult;
  /** Update a user password when authenticated as an admin */
  adminUserUpdatePassword: AdminUserResult;
  /** Delete an affiliation for a listing */
  affiliationDelete: AffiliationDeleteResult;
  /** Find or create an affiliation for an innkeeper */
  affiliationFindOrCreate: AffiliationFindOrCreateResult;
  barefootPmsConnectionCreate: PmsConnectionCreateResult;
  booksterPmsConnectionCreate: PmsConnectionCreateResult;
  boostPmsConnectionCreate: PmsConnectionCreateResult;
  /** Cancel a reservation */
  cancelReservation: CancelReservationResult;
  ciirusPmsConnectionCreate: PmsConnectionCreateResult;
  createLead: CreateLeadResult;
  /** Create a reservation */
  createReservation: CreateReservationResult;
  /** Create a subscription */
  createSubscription: CreateSubscriptionResult;
  demoPmsConnectionCreate: PmsConnectionCreateResult;
  /** Create an email verification for an authenticated innkeeper */
  emailVerificationCreate: EmailVerificationCreateResult;
  /** Verify email when authenticated as innkeeper */
  emailVerificationUpdate: EmailVerificationUpdateResult;
  escapiaPmsConnectionCreate: PmsConnectionCreateResult;
  /** Create a reservation using a promo code */
  freePromoCreateReservation: FreePromoCreateReservationResult;
  /** Gallery Asset Create mutation */
  galleryAssetCreate: GalleryAssetCreateResponse;
  /** Gallery Asset Delete mutation */
  galleryAssetDelete: GalleryAssetDeleteResponse;
  /** Gallery Asset Order mutation */
  galleryAssetOrder: GalleryAssetOrderResponse;
  /** Gallery Asset Update mutation */
  galleryAssetUpdate: GalleryAssetUpdateResponse;
  /** Gallery Asset Update image mutation */
  galleryAssetUpdateImage: GalleryAssetUpdateImageResponse;
  /** Create a gift card */
  giftCardCreate: CreateGiftCardResponse;
  /** Redeem a balance from a gift card */
  giftCardRedeem: GiftCardRedeemResponse;
  /** Update an unpurchased gift card */
  giftCardUpdateUnpurchased: GiftCardUpdateUnpurchasedResponse;
  guestyPmsConnectionCreate: PmsConnectionCreateResult;
  hostawayPmsConnectionCreate: PmsConnectionCreateResult;
  hostfullyPmsConnectionCreate: PmsConnectionCreateResult;
  /** Approve access to the private listing for the given user */
  listingApproveAccessForUser: ListingApproveAccessForUserResult;
  /** Create a listing for the current authenticated user's account */
  listingCreate: ListingCreateResult;
  /** Delete a listing */
  listingDelete: ListingDeleteResult;
  /** Deny access to the private listing for the given user */
  listingDenyAccessForUser: ListingDenyAccessForUserResult;
  /** Favorite the listing for the current authenticated user */
  listingFavoriteCreate: ListingFavoriteCreateResult;
  /** Unfavorite the listing for the current authenticated user */
  listingFavoriteDelete: ListingFavoriteDeleteResult;
  /** Publish the listing for the current authenticated user */
  listingPublish: ListingPublishResult;
  /** Request access to the private listing for the given user */
  listingRequestAccessForUser: ListingRequestAccessForUserResult;
  /** Toggle listing featured flag */
  listingToggleFeaturedByOwner: ListingUpdateResult;
  /** Unpublish the listing for the current authenticated user */
  listingUnpublish: ListingUnpublishResult;
  /** Update the listing for the current authenticated user */
  listingUpdate: ListingUpdateResult;
  liveListPmsConnectionCreate: PmsConnectionCreateResult;
  lodgifyPmsConnectionCreate: PmsConnectionCreateResult;
  lodgixPmsConnectionCreate: PmsConnectionCreateResult;
  nextPaxPmsConnectionCreate: PmsConnectionCreateResult;
  /** Load an order when authenticated as a user */
  orderLoad: OrderLoadResponse;
  ownerRezPmsConnectionCreate: PmsConnectionCreateResult;
  /** Create the PM account for the current authenticated user */
  pmAccountCreate: PmAccountCreateResult;
  /** Add a cancellation policy to an account */
  policyUpsertAccountCancellationPolicy: PolicyUpsertAccountCancellationPolicyResult;
  /** Add a terms and conditions policy to an account */
  policyUpsertAccountTermsAndConditions: PolicyUpsertAccountTermsAndConditionsResult;
  /** Add a cancellation policy to an listing */
  policyUpsertListingCancellationPolicy: PolicyUpsertListingCancellationPolicyResult;
  redAwningPmsConnectionCreate: PmsConnectionCreateResult;
  rentalsUnitedPmsConnectionCreate: PmsConnectionCreateResult;
  /** Reset user password mutation */
  resetPassword: ResetPasswordResponse;
  /** Reset user password for token mutation */
  resetPasswordForToken: ResetPasswordForTokenResponse;
  /** Send password reset email mutation */
  sendPasswordResetEmail: SendPasswordResetEmailResponse;
  /** Set a card for an user's account */
  setAccountCard: SetAccountCardResult;
  /** Set a subscription for an innkeeper */
  setSubscription: SetSubscriptionResult;
  /** Set a coupon for a host subscription */
  setSubscriptionCoupon: SetSubscriptionCouponResult;
  streamlinePartnerPmsConnectionCreate: PmsConnectionCreateResult;
  streamlinePmsConnectionCreate: PmsConnectionCreateResult;
  /** Subscribe an email to the newsletter */
  subscribeEmailToNewsletter: SubscribeEmailToNewsletterResult;
  /** Starts a new PMS import task when authenticated as an admin */
  taskStartPmsImport: TaskStartPmsImportResult;
  trackPmsConnectionCreate: PmsConnectionCreateResult;
  /** User account add mutation */
  userAccountAdd: UserAccountAddResponse;
  /** User account remove mutation */
  userAccountRemove: UserAccountRemoveResponse;
  /** Add a referral code to the current user */
  userAddReferralCode: UserAddReferralCodeResponse;
  /** User Apple social session mutation */
  userAppleSocialSession: UserSessionResponse;
  /** User create mutation */
  userCreate: UserCreateResponse;
  /** User Facebook social session mutation */
  userFacebookSocialSession: UserFacebookSocialSessionResponse;
  /** User Google social session mutation */
  userGoogleSocialSession: UserSessionResponse;
  /** User account mark for deletion mutation */
  userMarkForDeletion: UserMarkForDeletionResponse;
  /** User session mutation */
  userSession: UserSessionResponse;
  /** User session refresh mutation */
  userSessionRefresh: UserSessionRefreshResponse;
  /** Upadate a current user */
  userUpdate: UserUpdateResult;
  vacayHomePmsConnectionCreate: PmsConnectionCreateResult;
};


export type RootMutationTypeAccountBulkUpdateLocationObfuscatedArgs = {
  input: AccountBulkUpdateLocationObfuscatedInput;
};


export type RootMutationTypeAccountReviewSummaryCreateArgs = {
  input: AccountReviewSummaryCreateInput;
};


export type RootMutationTypeAccountUpdateArgs = {
  input: AccountUpdateInput;
};


export type RootMutationTypeAccountUpdateAllListingSubscriptionsArgs = {
  input: AccountUpdateAllListingSubscriptionsInput;
};


export type RootMutationTypeAdminAccessTokenCreateArgs = {
  input: AdminAccessTokenInput;
};


export type RootMutationTypeAdminAccountArchiveArgs = {
  accountId: Scalars['ID']['input'];
};


export type RootMutationTypeAdminAccountPublishAllListingsArgs = {
  accountId: Scalars['ID']['input'];
};


export type RootMutationTypeAdminAccountRecreateStripeSubscriptionArgs = {
  accountId: Scalars['ID']['input'];
};


export type RootMutationTypeAdminAccountRemovePmsConnectionArgs = {
  accountId: Scalars['ID']['input'];
};


export type RootMutationTypeAdminAccountResetSalesforceArgs = {
  accountId: Scalars['ID']['input'];
};


export type RootMutationTypeAdminAccountUnpublishAllListingsArgs = {
  accountId: Scalars['ID']['input'];
};


export type RootMutationTypeAdminAccountUpdateArgs = {
  input: AdminAccountUpdateInput;
};


export type RootMutationTypeAdminAccountUpdateAllListingSubscriptionsArgs = {
  accountId: Scalars['ID']['input'];
  planId: Scalars['String']['input'];
  promoCode?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeAdminAccountUpdateBookingUrlsArgs = {
  accountId: Scalars['ID']['input'];
  strategy: BookDirectUrlStrategy;
  url: Scalars['String']['input'];
};


export type RootMutationTypeAdminGiftCardActivateArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeAdminGiftCardAdjustBalanceArgs = {
  id: Scalars['ID']['input'];
  input: AdminGiftCardAdjustBalanceInput;
};


export type RootMutationTypeAdminGiftCardCreateArgs = {
  input: AdminGiftCardCreateInput;
};


export type RootMutationTypeAdminGiftCardDeactivateArgs = {
  id: Scalars['ID']['input'];
  input: AdminGiftCardDeactivateInput;
};


export type RootMutationTypeAdminGiftCardDeliverArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeAdminGiftCardImageCreateArgs = {
  input: AdminGiftCardImageCreateInput;
};


export type RootMutationTypeAdminGiftCardImageDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeAdminGiftCardImageUpdateArgs = {
  id: Scalars['ID']['input'];
  input: AdminGiftCardImageUpdateInput;
};


export type RootMutationTypeAdminGiftCardIssueArgs = {
  id: Scalars['ID']['input'];
  input: AdminGiftCardIssueInput;
};


export type RootMutationTypeAdminGiftCardNoteCreateArgs = {
  input: AdminGiftCardNoteCreateInput;
};


export type RootMutationTypeAdminGiftCardNoteDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeAdminGiftCardRefundArgs = {
  id: Scalars['ID']['input'];
  input: AdminGiftCardRefundInput;
};


export type RootMutationTypeAdminGiftCardUpdateArgs = {
  id: Scalars['ID']['input'];
  input: AdminGiftCardUpdateInput;
};


export type RootMutationTypeAdminGiftCardVerifyArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeAdminGoogleSocialSessionArgs = {
  input: AdminGoogleSocialSessionInput;
};


export type RootMutationTypeAdminListingConfigFieldMappingUpdateArgs = {
  input: AdminListingConfigFieldMappingUpdateInput;
};


export type RootMutationTypeAdminListingDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeAdminListingPublishArgs = {
  input: AdminListingPublishInput;
};


export type RootMutationTypeAdminListingRecordPayoutArgs = {
  id: Scalars['ID']['input'];
  input: AdminListingRecordPayoutInput;
};


export type RootMutationTypeAdminListingToggleAcceptsGiftCardsArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeAdminListingToggleWNineOnFileArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeAdminListingUpdateArgs = {
  id: Scalars['ID']['input'];
  input: AdminListingUpdateInput;
};


export type RootMutationTypeAdminMigrateStreamlineToPartnerConnectionArgs = {
  input: AdminMigrateStreamlineToPartnerConnectionInput;
};


export type RootMutationTypeAdminPmsConnectionPmsFieldMappingUpdateArgs = {
  input: AdminPmsConnectionPmsFieldMappingUpdateInput;
};


export type RootMutationTypeAdminPmsConnectionRetryArgs = {
  input: AdminPmsConnectionRetryInput;
};


export type RootMutationTypeAdminRegionFindOrCreateForListingArgs = {
  input: AdminRegionFindOrCreateForListingInput;
};


export type RootMutationTypeAdminRegionRemoveForListingArgs = {
  listingId: Scalars['ID']['input'];
  placeId: Scalars['ID']['input'];
};


export type RootMutationTypeAdminSearchPageContentCreateArgs = {
  h1: Scalars['String']['input'];
  searchType: SearchPageContentType;
};


export type RootMutationTypeAdminSearchPageContentDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeAdminSearchPageContentRemoveRegionArgs = {
  searchPageContentId: Scalars['ID']['input'];
};


export type RootMutationTypeAdminSearchPageContentUpdateArgs = {
  id: Scalars['ID']['input'];
  input: AdminSearchPageContentUpdateInput;
};


export type RootMutationTypeAdminSearchPageContentUpdateRegionArgs = {
  placeId: Scalars['ID']['input'];
  searchPageContentId: Scalars['ID']['input'];
};


export type RootMutationTypeAdminSearchPageLinkCreateArgs = {
  input: AdminSearchPageLinkCreateInput;
};


export type RootMutationTypeAdminSearchPageLinkDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeAdminSearchPageLinkUpdateArgs = {
  id: Scalars['ID']['input'];
  input: AdminSearchPageLinkUpdateInput;
};


export type RootMutationTypeAdminSearchPageParagraphCreateArgs = {
  input: AdminSearchPageParagraphCreateInput;
};


export type RootMutationTypeAdminSearchPageParagraphDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeAdminSearchPageParagraphOrderArgs = {
  input: SearchPageParagraphOrderInput;
};


export type RootMutationTypeAdminSearchPageParagraphUpdateArgs = {
  id: Scalars['ID']['input'];
  input: AdminSearchPageParagraphUpdateInput;
};


export type RootMutationTypeAdminSetSubscriptionArgs = {
  input: AdminSetSubscriptionInput;
};


export type RootMutationTypeAdminTaskCreateListingsCsvImportArgs = {
  input: AdminTaskCreateListingsCsvImportInput;
};


export type RootMutationTypeAdminUserUpdateArgs = {
  id: Scalars['ID']['input'];
  input: AdminUserUpdateInput;
};


export type RootMutationTypeAdminUserUpdatePasswordArgs = {
  id: Scalars['ID']['input'];
  input: AdminUserUpdatePasswordInput;
};


export type RootMutationTypeAffiliationDeleteArgs = {
  input: AffiliationDeleteInput;
};


export type RootMutationTypeAffiliationFindOrCreateArgs = {
  input: AffiliationFindOrCreateInput;
};


export type RootMutationTypeBarefootPmsConnectionCreateArgs = {
  input: BarefootPmsConnectionCreateInput;
};


export type RootMutationTypeBooksterPmsConnectionCreateArgs = {
  input: BooksterPmsConnectionCreateInput;
};


export type RootMutationTypeBoostPmsConnectionCreateArgs = {
  input: BoostPmsConnectionCreateInput;
};


export type RootMutationTypeCancelReservationArgs = {
  input: CancelReservationInput;
};


export type RootMutationTypeCiirusPmsConnectionCreateArgs = {
  input: CiirusPmsConnectionCreateInput;
};


export type RootMutationTypeCreateLeadArgs = {
  input: CreateLeadInput;
};


export type RootMutationTypeCreateReservationArgs = {
  input: CreateReservationInput;
};


export type RootMutationTypeCreateSubscriptionArgs = {
  input: CreateSubscriptionInput;
};


export type RootMutationTypeDemoPmsConnectionCreateArgs = {
  input: DemoPmsConnectionCreateInput;
};


export type RootMutationTypeEmailVerificationUpdateArgs = {
  token: Scalars['String']['input'];
};


export type RootMutationTypeEscapiaPmsConnectionCreateArgs = {
  input: EscapiaPmsConnectionCreateInput;
};


export type RootMutationTypeFreePromoCreateReservationArgs = {
  input: FreePromoCreateReservationInput;
};


export type RootMutationTypeGalleryAssetCreateArgs = {
  input: GalleryAssetCreateInput;
};


export type RootMutationTypeGalleryAssetDeleteArgs = {
  input: GalleryAssetDeleteInput;
};


export type RootMutationTypeGalleryAssetOrderArgs = {
  input: GalleryAssetOrderInput;
};


export type RootMutationTypeGalleryAssetUpdateArgs = {
  input: GalleryAssetUpdateInput;
};


export type RootMutationTypeGalleryAssetUpdateImageArgs = {
  input: GalleryAssetUpdateImageInput;
};


export type RootMutationTypeGiftCardCreateArgs = {
  input: GiftCardCreateInput;
};


export type RootMutationTypeGiftCardRedeemArgs = {
  certificateNumber: Scalars['String']['input'];
  input: GiftCardRedeemInput;
};


export type RootMutationTypeGiftCardUpdateUnpurchasedArgs = {
  input: GiftCardUpdateUnpurchasedInput;
};


export type RootMutationTypeGuestyPmsConnectionCreateArgs = {
  input: GuestyPmsConnectionCreateInput;
};


export type RootMutationTypeHostawayPmsConnectionCreateArgs = {
  input: HostawayPmsConnectionCreateInput;
};


export type RootMutationTypeHostfullyPmsConnectionCreateArgs = {
  input: HostfullyPmsConnectionCreateInput;
};


export type RootMutationTypeListingApproveAccessForUserArgs = {
  input: ListingApproveAccessForUserInput;
};


export type RootMutationTypeListingCreateArgs = {
  input: ListingCreateInput;
};


export type RootMutationTypeListingDeleteArgs = {
  input: ListingDeleteInput;
};


export type RootMutationTypeListingDenyAccessForUserArgs = {
  input: ListingDenyAccessForUserInput;
};


export type RootMutationTypeListingFavoriteCreateArgs = {
  input: ListingFavoriteCreateInput;
};


export type RootMutationTypeListingFavoriteDeleteArgs = {
  input: ListingFavoriteDeleteInput;
};


export type RootMutationTypeListingPublishArgs = {
  input: ListingPublishInput;
};


export type RootMutationTypeListingRequestAccessForUserArgs = {
  input: ListingRequestAccessForUserInput;
};


export type RootMutationTypeListingToggleFeaturedByOwnerArgs = {
  listingId: Scalars['ID']['input'];
};


export type RootMutationTypeListingUnpublishArgs = {
  listingId: Scalars['ID']['input'];
};


export type RootMutationTypeListingUpdateArgs = {
  input: ListingUpdateInput;
};


export type RootMutationTypeLiveListPmsConnectionCreateArgs = {
  input: LiveListPmsConnectionCreateInput;
};


export type RootMutationTypeLodgifyPmsConnectionCreateArgs = {
  input: LodgifyPmsConnectionCreateInput;
};


export type RootMutationTypeLodgixPmsConnectionCreateArgs = {
  input: LodgixPmsConnectionCreateInput;
};


export type RootMutationTypeNextPaxPmsConnectionCreateArgs = {
  input: NextPaxPmsConnectionCreateInput;
};


export type RootMutationTypeOrderLoadArgs = {
  input: OrderLoadInput;
};


export type RootMutationTypeOwnerRezPmsConnectionCreateArgs = {
  input: OwnerRezPmsConnectionCreateInput;
};


export type RootMutationTypePmAccountCreateArgs = {
  input: PmAccountCreateInput;
};


export type RootMutationTypePolicyUpsertAccountCancellationPolicyArgs = {
  input: PolicyUpsertAccountCancellationPolicyInput;
};


export type RootMutationTypePolicyUpsertAccountTermsAndConditionsArgs = {
  input: PolicyUpsertAccountTermsAndConditionsInput;
};


export type RootMutationTypePolicyUpsertListingCancellationPolicyArgs = {
  input: PolicyUpsertListingCancellationPolicyInput;
};


export type RootMutationTypeRedAwningPmsConnectionCreateArgs = {
  input: RedAwningPmsConnectionCreateInput;
};


export type RootMutationTypeRentalsUnitedPmsConnectionCreateArgs = {
  input: RentalsUnitedPmsConnectionCreateInput;
};


export type RootMutationTypeResetPasswordArgs = {
  input: ResetPasswordInput;
};


export type RootMutationTypeResetPasswordForTokenArgs = {
  input: ResetPasswordForTokenInput;
};


export type RootMutationTypeSendPasswordResetEmailArgs = {
  input: SendPasswordResetEmailInput;
};


export type RootMutationTypeSetAccountCardArgs = {
  stripeTokenId: Scalars['String']['input'];
};


export type RootMutationTypeSetSubscriptionArgs = {
  input: SetSubscriptionInput;
};


export type RootMutationTypeSetSubscriptionCouponArgs = {
  input: SetSubscriptionCouponInput;
};


export type RootMutationTypeStreamlinePartnerPmsConnectionCreateArgs = {
  input: StreamlinePartnerPmsConnectionCreateInput;
};


export type RootMutationTypeStreamlinePmsConnectionCreateArgs = {
  input: StreamlinePmsConnectionCreateInput;
};


export type RootMutationTypeSubscribeEmailToNewsletterArgs = {
  email: Scalars['String']['input'];
};


export type RootMutationTypeTaskStartPmsImportArgs = {
  accountId: Scalars['ID']['input'];
};


export type RootMutationTypeTrackPmsConnectionCreateArgs = {
  input: TrackPmsConnectionCreateInput;
};


export type RootMutationTypeUserAccountAddArgs = {
  input: UserAccountAddInput;
};


export type RootMutationTypeUserAccountRemoveArgs = {
  input: UserAccountRemoveInput;
};


export type RootMutationTypeUserAddReferralCodeArgs = {
  referralCode: Scalars['String']['input'];
};


export type RootMutationTypeUserAppleSocialSessionArgs = {
  input: UserAppleSocialSessionInput;
};


export type RootMutationTypeUserCreateArgs = {
  input: UserCreateInput;
};


export type RootMutationTypeUserFacebookSocialSessionArgs = {
  input: UserFacebookSocialSessionInput;
};


export type RootMutationTypeUserGoogleSocialSessionArgs = {
  input: UserGoogleSocialSessionInput;
};


export type RootMutationTypeUserSessionArgs = {
  input: UserSessionInput;
};


export type RootMutationTypeUserSessionRefreshArgs = {
  input: UserSessionRefreshInput;
};


export type RootMutationTypeUserUpdateArgs = {
  input: UserUpdateInput;
};


export type RootMutationTypeVacayHomePmsConnectionCreateArgs = {
  input: VacayHomePmsConnectionCreateInput;
};

export type RootQueryType = {
  /** Get an account by its id */
  accountById: AccountByIdResponse;
  /** Get an account by its url friendly slug */
  accountBySlug: AccountBySlugResponse;
  /** Get the cards belonging to the current user's account */
  accountCardsListAll: AccountCardsListAllResponse;
  /** Get the account for the current user */
  accountForCurrentUser: AccountForCurrentUserResponse;
  /** Get the listings for the current authenticated user's account */
  accountListings: AccountListingsResponse;
  /** Get the active accounts */
  accountsListAllActive: AccountsResponse;
  /** Get the random accounts */
  accountsListRandom: AccountsResponse;
  /** Get account by its ID when authenticated as an admin */
  adminAccountById: AdminAccountByIdResponse;
  /** Get the cards belonging to the current user's account */
  adminAccountCardsListAll: AccountCardsListAllResponse;
  /** Get publishable and unpublishable listing counts for an account */
  adminAccountListingPubishableStatusCounts: AdminAccountListingPubishableStatusCountsResponse;
  /** List all accounts when authenticated as an admin */
  adminAccountsListAll: AdminAccountsListAllResponse;
  /** Get gift card by its ID when authenticated as an admin */
  adminGiftCardById: AdminGiftCardByIdResponse;
  /** List all gift card images when authenticated as an admin */
  adminGiftCardImageListAll: AdminGiftCardImageListAllResponse;
  /** List all gift cards when authenticated as an admin */
  adminGiftCardListAll: AdminGiftCardListAllResponse;
  /** Get innkeeper by its ID when authenticated as an admin */
  adminInnkeeperById: AdminInnkeeperByIdResponse;
  /** Get innkeeper by its listing ID when authenticated as an admin */
  adminInnkeeperByListingId: AdminInnkeeperByListingIdResponse;
  /** Get listing by its ID when authenticated as an admin */
  adminListingById: AdminListingByIdResponse;
  /** List all listings when authenticated as an admin */
  adminListingsListAll: AdminListingsListAllResponse;
  /** List all listings for specified account when authenticated as an admin */
  adminListingsListAllForAccount: AdminListingsListAllResponse;
  /** Get the pms connection belonging to the current user's account */
  adminPmsConnectionForAccount: AdminPmsConnectionForAccountResponse;
  /** Get a collection of regions that are associated with a listing when authenticated as an admin */
  adminRegionListAllForListingId: AdminRegionListAllForListingIdResponse;
  /** Find a search page content by its ID when authenticated as an admin */
  adminSearchPageContentFindById: AdminSearchPageContentFindByIdResponse;
  /** Find a search page link by its ID when authenticated as an admin */
  adminSearchPageLinkFindById: AdminSearchPageLinkFindByIdResponse;
  /** Find a search page paragraph by its ID when authenticated as an admin */
  adminSearchPageParagraphFindById: AdminSearchPageParagraphFindByIdResponse;
  /** List all transactions when authenticated as an admin */
  adminTransactionListAll: AdminTransactionListAllResponse;
  /** List all transactions ready for payout when authenticated as an admin */
  adminTransactionsReadyForPayoutListAll: AdminTransactionsReadyForPayoutListAllResponse;
  /** Get the sum of all transactions when authenticated as an admin */
  adminTransactionsSumAmountsCents: AdminTransactionsSumAmountsCentsResponse;
  /** Get user by its ID when authenticated as an admin */
  adminUserById: AdminUserByIdResponse;
  /** List all users when authenticated as an admin */
  adminUsersListAll: AdminUsersListAllResponse;
  /** Get the current authenticated innkeeper */
  affiliationSearch: AffiliationSearchResponse;
  /** List all featured blog post */
  blogPostsListAllFeatured: Array<BlogPost>;
  /** Get the booking quote for a listing within date range */
  bookingQuoteByListingAndDates: BookingQuoteResponse;
  /** Get the cards belonging to the current user */
  cardsListAll: CardsListAllResponse;
  /** Get the comparison quotes for a listing within date range */
  comparisonQuoteByListingAndDates: ComparisonQuoteResponse;
  /** Fetch available coupons for current account */
  couponFindAvailableForAccount: CouponFindForAccountResponse;
  /** Find coupon by code */
  couponFindByPromoCode: CouponFindByPromoCodeResponse;
  /** Get coupon applied to current account */
  couponFindForAccount: CouponFindForAccountResponse;
  /** Get the current authenticated admin */
  currentAdmin: CurrentAdminResponse;
  /** Get the current authenticated innkeeper */
  currentInnkeeper: CurrentInnkeeperResponse;
  /** Get the current authenticated user */
  currentUser: CurrentUserResponse;
  /** List all features */
  featuresListAll: Array<Feature>;
  /** List all features for search filters */
  featuresListAllForSearchFilters: Array<Feature>;
  /** Get the current authenticated innkeeper's gallery asset */
  galleryAssetById: GalleryAssetByIdResponse;
  /** Get gift card by its cert number */
  giftCardByCertificateNumber: GiftCardByCertificateNumberResponse;
  /** Get gift card by its ID */
  giftCardById: GiftCardByIdResponse;
  giftCardByPaymentServiceTransactionClientSecret: GiftCardByPaymentServiceTransactionClientSecretResponse;
  /** Get gift card image by its ID when authenticated as an admin */
  giftCardImageById: GiftCardImageByIdResponse;
  /** List all gift card images */
  giftCardImageListAllActive: GiftCardImageCollection;
  listSupportedByOtaUrls?: Maybe<ListingCollection>;
  /** Booking Info for listing */
  listingBookingInfo: ListingBookingInfoResponse;
  /** Get a listing by its external id */
  listingByExternalIdAndSource: ListingByExternalIdAndSourceResponse;
  /** Get a listing by its id */
  listingByIdAndUser: ListingByIdAndUserResponse;
  /** Get a listing by its url friendly slug */
  listingBySlug: ListingBySlugResponse;
  listingPrivateAccessForUser: ListingPrivateAccessForUserResponse;
  /** Reviews for listing */
  listingReviewsListAllForListing: ListingReviewsListAllForListingResponse;
  /** List all active listings */
  listingsListAllActive: ListingCollection;
  /** List all favorited listings */
  listingsListAllFavorited: ListAllFavoritedResponse;
  /** List all featured listings */
  listingsListAllFeatured: ListingCollection;
  /** Search listings */
  listingsSearch: ListingsSearchResponse;
  /** Search for all active listings for the given place */
  listingsSearchAllActiveForPlace: ListingSearchCursorCollection;
  /** Get place by address */
  placeByAddress: PlaceByAddressResponse;
  /** Get place by its ID */
  placeById: PlaceByIdResponse;
  /** List places for a given autocomplete query string */
  placesAutocomplete: Array<PlaceAutocompletePrediction>;
  /** List all plans */
  plansListAll: PlansListAllResponse;
  /** List all PMS connections */
  pmsConnectionForCurrentUser: PmsConnectionForCurrentUserResponse;
  /** List all PMS integrations */
  pmsIntegrationListAll: Array<PmsIntegration>;
  /** Get the external quote for a listing within date range */
  priceByOtaUrlListingAndDates: PriceByOtaUrlResponse;
  /** List all regions */
  regionsListAll: RegionCollection;
  /** List all featured regions */
  regionsListAllFeatured: RegionCollection;
  /** List all regions with active search page contents */
  regionsListAllWithActiveSearchPageContents: RegionCollection;
  /** Get reservation by its ID when authenticated as the user */
  reservationById: ReservationByIdResponse;
  /** List all reservations for the current authenticated user */
  reservationsListAllForUser: ReservationsListAllForUserResponse;
  /** An active search page content for the given place */
  searchPageContentForUrlPathAndType: SearchPageContentActiveForPlaceResponse;
  /** List all search page contents */
  searchPageContentListAll: SearchPageContentCollection;
  testConsent: Scalars['Int']['output'];
  /** Test an unhandled error */
  testUnhandledError: Scalars['Int']['output'];
  /** List all listing transactions for a given account when authenticated as an property owner */
  transactionListAllForAccount: TransactionListAllForAccountResponse;
  /** List all users with access records to listing */
  usersListAllWithAccessOnListingByStatus: UsersListAllWithAccessOnListingByStatusResponse;
  /** Minimum version supported by mobile */
  validateVersion: MobileVersionResponse;
};


export type RootQueryTypeAccountByIdArgs = {
  id: Scalars['String']['input'];
};


export type RootQueryTypeAccountBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type RootQueryTypeAccountListingsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeAccountsListAllActiveArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  stateOrProvinceLongNameFilter?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeAccountsListRandomArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeAdminAccountByIdArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeAdminAccountCardsListAllArgs = {
  accountId: Scalars['ID']['input'];
};


export type RootQueryTypeAdminAccountListingPubishableStatusCountsArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeAdminAccountsListAllArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pmsConnectionTypes?: InputMaybe<Array<PmsName>>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeAdminGiftCardByIdArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeAdminGiftCardImageListAllArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeAdminGiftCardListAllArgs = {
  orderDateFromFilter?: InputMaybe<Scalars['DateTime']['input']>;
  orderDateToFilter?: InputMaybe<Scalars['DateTime']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<GiftCardSortOptions>;
  statusFilter?: InputMaybe<GiftCardStatus>;
};


export type RootQueryTypeAdminInnkeeperByIdArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeAdminInnkeeperByListingIdArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeAdminListingByIdArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeAdminListingsListAllArgs = {
  acceptsGiftCards?: InputMaybe<Scalars['Boolean']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  hasAGiftCardBalance?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  placeId?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  searchPromotionTypeFilter?: InputMaybe<Array<SearchPromotionType>>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  subscriptionTypeFilter?: InputMaybe<Array<SubscriptionType>>;
};


export type RootQueryTypeAdminListingsListAllForAccountArgs = {
  accountId: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  placeId?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<AccountListingSortOptions>;
  stateOrProvinceLongNameFilter?: InputMaybe<Array<Scalars['String']['input']>>;
  subscriptionTypeFilter?: InputMaybe<Array<SubscriptionType>>;
};


export type RootQueryTypeAdminPmsConnectionForAccountArgs = {
  accountId: Scalars['ID']['input'];
};


export type RootQueryTypeAdminRegionListAllForListingIdArgs = {
  listingId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeAdminSearchPageContentFindByIdArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeAdminSearchPageLinkFindByIdArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeAdminSearchPageParagraphFindByIdArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeAdminTransactionListAllArgs = {
  accountTypesFilter?: InputMaybe<Array<TransactionAccountTypeFilters>>;
  giftCardId?: InputMaybe<Scalars['ID']['input']>;
  listingId?: InputMaybe<Scalars['ID']['input']>;
  orderDateFromFilter?: InputMaybe<Scalars['DateTime']['input']>;
  orderDateToFilter?: InputMaybe<Scalars['DateTime']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  recordType?: InputMaybe<TransactionRecordType>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<TransactionSortOptions>;
};


export type RootQueryTypeAdminTransactionsReadyForPayoutListAllArgs = {
  listingId?: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypeAdminUserByIdArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeAdminUsersListAllArgs = {
  emailOrNameQuery?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  verified?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};


export type RootQueryTypeAffiliationSearchArgs = {
  listingId: Scalars['ID']['input'];
  query: Scalars['String']['input'];
  type?: AffiliationTypeFilter;
};


export type RootQueryTypeBookingQuoteByListingAndDatesArgs = {
  adultCount?: InputMaybe<Scalars['Int']['input']>;
  checkInDate: Scalars['Date']['input'];
  checkOutDate: Scalars['Date']['input'];
  childCount?: InputMaybe<Scalars['Int']['input']>;
  infantCount?: InputMaybe<Scalars['Int']['input']>;
  petCount?: InputMaybe<Scalars['Int']['input']>;
  slug: Scalars['String']['input'];
};


export type RootQueryTypeComparisonQuoteByListingAndDatesArgs = {
  checkInDate: Scalars['Date']['input'];
  checkOutDate: Scalars['Date']['input'];
  externalListingUrl: Scalars['String']['input'];
  numberOfAdults?: Scalars['Int']['input'];
  numberOfChildren?: Scalars['Int']['input'];
  numberOfInfants?: Scalars['Int']['input'];
  numberOfPets?: Scalars['Int']['input'];
  priceType?: PriceType;
};


export type RootQueryTypeCouponFindByPromoCodeArgs = {
  promoCode: Scalars['String']['input'];
};


export type RootQueryTypeFeaturesListAllArgs = {
  propertyType?: InputMaybe<PropertyType>;
};


export type RootQueryTypeGalleryAssetByIdArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeGiftCardByCertificateNumberArgs = {
  certificateNumber: Scalars['String']['input'];
};


export type RootQueryTypeGiftCardByIdArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeGiftCardByPaymentServiceTransactionClientSecretArgs = {
  clientSecret: Scalars['String']['input'];
};


export type RootQueryTypeGiftCardImageByIdArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeGiftCardImageListAllActiveArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeListSupportedByOtaUrlsArgs = {
  otaUrls: Array<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeListingBookingInfoArgs = {
  slug: Scalars['String']['input'];
};


export type RootQueryTypeListingByExternalIdAndSourceArgs = {
  externalId: Scalars['String']['input'];
  externalSource: ExternalSource;
};


export type RootQueryTypeListingByIdAndUserArgs = {
  id: Scalars['String']['input'];
};


export type RootQueryTypeListingBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type RootQueryTypeListingPrivateAccessForUserArgs = {
  listingId: Scalars['ID']['input'];
};


export type RootQueryTypeListingReviewsListAllForListingArgs = {
  id: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeListingsListAllActiveArgs = {
  acceptsGiftCardsFilter?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  accountId?: InputMaybe<Scalars['String']['input']>;
  applyFeaturedByOwnerFilter?: InputMaybe<Scalars['Boolean']['input']>;
  checkInDate?: InputMaybe<Scalars['Date']['input']>;
  checkOutDate?: InputMaybe<Scalars['Date']['input']>;
  featuresFilter?: InputMaybe<Array<FeatureKey>>;
  minGuestCapacity?: InputMaybe<Scalars['Int']['input']>;
  minNumberOfBathrooms?: InputMaybe<Scalars['Int']['input']>;
  minNumberOfRooms?: InputMaybe<Scalars['Int']['input']>;
  onlyDiamondCollection?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  propertyTypes?: InputMaybe<Array<PropertyType>>;
  sort?: InputMaybe<ListingSortOptions>;
  stateOrProvinceLongNameFilter?: InputMaybe<Array<Scalars['String']['input']>>;
  uniquePropertyTypes?: InputMaybe<Array<InputMaybe<UniquePropertyType>>>;
};


export type RootQueryTypeListingsListAllFavoritedArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ListingFavoriteSortOptions>;
};


export type RootQueryTypeListingsListAllFeaturedArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ListingSortOptions>;
  stateOrProvinceLongNameFilter?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type RootQueryTypeListingsSearchArgs = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  centerLat?: InputMaybe<Scalars['Float']['input']>;
  centerLng?: InputMaybe<Scalars['Float']['input']>;
  checkInDate?: InputMaybe<Scalars['Date']['input']>;
  checkOutDate?: InputMaybe<Scalars['Date']['input']>;
  cursorAfter?: InputMaybe<Scalars['String']['input']>;
  cursorBefore?: InputMaybe<Scalars['String']['input']>;
  featuresFilter?: InputMaybe<Array<FeatureKey>>;
  maxPriceCents?: InputMaybe<Scalars['Int']['input']>;
  minGuestCapacity?: InputMaybe<Scalars['Int']['input']>;
  minNumberOfBathrooms?: InputMaybe<Scalars['Int']['input']>;
  minNumberOfRooms?: InputMaybe<Scalars['Int']['input']>;
  minPriceCents?: InputMaybe<Scalars['Int']['input']>;
  northEastLat?: InputMaybe<Scalars['Float']['input']>;
  northEastLng?: InputMaybe<Scalars['Float']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  petCount?: InputMaybe<Scalars['Int']['input']>;
  placeId?: InputMaybe<Scalars['String']['input']>;
  placeName?: InputMaybe<Scalars['String']['input']>;
  propertyTypes?: InputMaybe<Array<PropertyType>>;
  searchType: ListingsSearchType;
  southWestLat?: InputMaybe<Scalars['Float']['input']>;
  southWestLng?: InputMaybe<Scalars['Float']['input']>;
  uniquePropertyTypes?: InputMaybe<Array<InputMaybe<UniquePropertyType>>>;
};


export type RootQueryTypeListingsSearchAllActiveForPlaceArgs = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  checkInDate?: InputMaybe<Scalars['Date']['input']>;
  checkOutDate?: InputMaybe<Scalars['Date']['input']>;
  cursorAfter?: InputMaybe<Scalars['String']['input']>;
  cursorBefore?: InputMaybe<Scalars['String']['input']>;
  featuresFilter?: InputMaybe<Array<FeatureKey>>;
  minGuestCapacity?: InputMaybe<Scalars['Int']['input']>;
  minNumberOfBathrooms?: InputMaybe<Scalars['Int']['input']>;
  minNumberOfRooms?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  placeName?: InputMaybe<Scalars['String']['input']>;
  propertyTypes?: InputMaybe<Array<PropertyType>>;
  regionPath?: InputMaybe<Scalars['String']['input']>;
  uniquePropertyTypes?: InputMaybe<Array<InputMaybe<UniquePropertyType>>>;
};


export type RootQueryTypePlaceByAddressArgs = {
  address: Scalars['String']['input'];
};


export type RootQueryTypePlaceByIdArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypePlacesAutocompleteArgs = {
  name: Scalars['String']['input'];
  placeTypeFilter?: InputMaybe<PlaceTypeFilter>;
};


export type RootQueryTypePriceByOtaUrlListingAndDatesArgs = {
  adultCount?: InputMaybe<Scalars['Int']['input']>;
  checkInDate: Scalars['Date']['input'];
  checkOutDate: Scalars['Date']['input'];
  childCount?: InputMaybe<Scalars['Int']['input']>;
  externalOtaUrl: Scalars['String']['input'];
  infantCount?: InputMaybe<Scalars['Int']['input']>;
  petCount?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeRegionsListAllArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeRegionsListAllFeaturedArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeRegionsListAllWithActiveSearchPageContentsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  searchType?: InputMaybe<SearchPageContentType>;
};


export type RootQueryTypeReservationByIdArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeReservationsListAllForUserArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  statusFilter?: InputMaybe<Array<InputMaybe<ReservationStatuses>>>;
};


export type RootQueryTypeSearchPageContentForUrlPathAndTypeArgs = {
  searchType: SearchPageContentType;
  urlPath: Scalars['String']['input'];
};


export type RootQueryTypeSearchPageContentListAllArgs = {
  h1Query?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<SearchPageContentType>;
};


export type RootQueryTypeTransactionListAllForAccountArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeUsersListAllWithAccessOnListingByStatusArgs = {
  listingId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  statusFilter?: ListingAccessStatuses;
};


export type RootQueryTypeValidateVersionArgs = {
  platform: MobileType;
  version: Scalars['String']['input'];
};

/** Search Page Content object */
export type SearchPageContent = {
  /** The title for the about items for the search page */
  aboutItemsTitle?: Maybe<Scalars['String']['output']>;
  /** Flag indiciating if search page content is currently searchable/active */
  active: Scalars['Boolean']['output'];
  /** List of cities associated w/ this search page content */
  cities: Array<SearchPageContent>;
  /** The title for the faqs for the search page */
  faqsTitle?: Maybe<Scalars['String']['output']>;
  /** The main heading for the page */
  h1: Scalars['String']['output'];
  /** The main paragraph accompanying the h1 for the page in raw Draft.js format */
  h1ParagraphRaw?: Maybe<Scalars['String']['output']>;
  /** The secondary heading for the page */
  h2?: Maybe<Scalars['String']['output']>;
  /** The secondary paragraph accompanying the h2 for the page in raw Draft.js format */
  h2ParagraphRaw?: Maybe<Scalars['String']['output']>;
  /** The endpoint of the hero image host */
  heroImageEndpoint?: Maybe<Scalars['String']['output']>;
  /** The alt description for the main hero image */
  heroImageHtmlAlt?: Maybe<Scalars['String']['output']>;
  /** The hero image path, relative to the endpoint */
  heroImagePath?: Maybe<Scalars['String']['output']>;
  /** The image processing flag */
  heroImageProcessing: Scalars['Boolean']['output'];
  /** The upload location for the hero image */
  heroImageUploadUrl?: Maybe<Scalars['String']['output']>;
  /** The main hero image for the page */
  heroImageUrl: Scalars['String']['output'];
  /** The HTML description for the search page */
  htmlMetaDescription?: Maybe<Scalars['String']['output']>;
  /** The HTML meta title for the search page */
  htmlMetaTitle?: Maybe<Scalars['String']['output']>;
  /** The search page content ID */
  id: Scalars['ID']['output'];
  /** The region associated w/ this search page content */
  region?: Maybe<Region>;
  /** List of links associated w/ this search page content */
  searchPageLinks: Array<SearchPageLink>;
  /** List of paragraphs associated w/ this search page content */
  searchPageParagraphs: Array<SearchPageParagraph>;
  /** The search type for the content */
  searchType: SearchPageContentType;
  /** The time the search page content was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** Response for a search page content by a given place name */
export type SearchPageContentActiveForPlaceResponse = NotFoundError | SearchPageContent | ValidationErrorCollection;

/** Search page content collection object contains a paginated collection of search page contents and meta data about the collection */
export type SearchPageContentCollection = {
  /** The collection of search page content for a given page */
  entries: Array<SearchPageContent>;
  /** The meta information containing additional info about the collection */
  meta: CollectionInfo;
};

export enum SearchPageContentType {
  BedAndBreakfast = 'BED_AND_BREAKFAST',
  VacationRental = 'VACATION_RENTAL'
}

/** Search Page Link object */
export type SearchPageLink = {
  /** The href for the link */
  href: Scalars['String']['output'];
  /** The link ID */
  id: Scalars['ID']['output'];
  /** The title for the link */
  title: Scalars['String']['output'];
  /** The type of link */
  type: SearchPageLinkType;
};

/** The search page link type enum */
export enum SearchPageLinkType {
  /** Link to a nearby attraction */
  Attraction = 'ATTRACTION',
  /** Link to a blog */
  Blog = 'BLOG',
  /** Link to a similar area */
  SimilarArea = 'SIMILAR_AREA'
}

/** Search Page Paragraph object */
export type SearchPageParagraph = {
  /** The paragraph body in raw Draft.js format */
  bodyRaw: Scalars['String']['output'];
  /** The Paragraph ID */
  id: Scalars['ID']['output'];
  /** The position of the gallery asset */
  position?: Maybe<Scalars['Float']['output']>;
  /** The title for the Paragraph */
  title: Scalars['String']['output'];
  /** The type of paragraph */
  type: SearchPageParagraphType;
};

export type SearchPageParagraphOrderInput = {
  /** The ID of an existing search page paragraph. */
  id: Scalars['ID']['input'];
  /** The ID of the previous search page paragraph. */
  previousSearchPageParagraphId?: InputMaybe<Scalars['String']['input']>;
  /** The search page content id of an existing search_page_content. */
  searchPageContentId: Scalars['ID']['input'];
};

/** The result of the search page paragraph order */
export type SearchPageParagraphOrderResponse = NotFoundError | SearchPageParagraph | UnauthenticatedError | ValidationErrorCollection;

/** The search page paragraph type enum */
export enum SearchPageParagraphType {
  /** Paragraph about the search page */
  About = 'ABOUT',
  /** Paragraph w/ frequently asked question info */
  Faq = 'FAQ'
}

export type SearchPlace = {
  /** The geometry for the given place */
  geometry?: Maybe<Geometry>;
  /** The name for the given place */
  name?: Maybe<Scalars['String']['output']>;
  /** The place type for the given place */
  placeType?: Maybe<Scalars['String']['output']>;
};

export enum SearchPromotionType {
  Featured = 'FEATURED'
}

export type SendPasswordResetEmailInput = {
  /** The user's account email */
  email: Scalars['String']['input'];
};

/** The result of the send password reset email mutation */
export type SendPasswordResetEmailResponse = NotFoundError | PasswordResetMessage;

/** An error encountered when a service required to fulfill the request is unavailable */
export type ServiceUnavailableError = {
  message: Scalars['String']['output'];
};

/** The result of the set account card mutation */
export type SetAccountCardResult = Card | NotFoundError | ServiceUnavailableError | UnauthenticatedError | UnauthorizedError | ValidationErrorCollection;

export type SetSubscriptionCouponInput = {
  /** The promo code for the subscription */
  promoCode: Scalars['String']['input'];
};

/** The result of the set subscription coupon mutation for an authenticated account */
export type SetSubscriptionCouponResult = Account | NotFoundError | UnauthenticatedError;

export type SetSubscriptionInput = {
  listingId: Scalars['String']['input'];
  planId: Scalars['String']['input'];
  /** The promo code for the subscription */
  promoCode?: InputMaybe<Scalars['String']['input']>;
  referredByListingId?: InputMaybe<Scalars['ID']['input']>;
};

/** The result of the set subscription mutation for an authenticated innkeeper */
export type SetSubscriptionResult = Listing | NotFoundError | UnauthenticatedError | ValidationErrorCollection;

/** The gift card shipping provider type */
export enum ShippingProviderType {
  /** https://www.usps.com/ */
  Usps = 'USPS'
}

export type StreamlinePartnerPmsConnectionCreateInput = {
  accountId: Scalars['String']['input'];
  tokenKey: Scalars['String']['input'];
  tokenSecret: Scalars['String']['input'];
};

export type StreamlinePmsConnectionCreateInput = {
  tokenKey: Scalars['String']['input'];
  tokenSecret: Scalars['String']['input'];
};

/** The result of subscribing an email to the newsletter */
export type SubscribeEmailToNewsletterResult = NewsletterSubscription | ServiceUnavailableError | ValidationErrorCollection;

/** The subscription types */
export enum SubscriptionType {
  Bronze = 'BRONZE',
  Free = 'FREE',
  Gold = 'GOLD',
  Private = 'PRIVATE',
  Silver = 'SILVER'
}

/** The supported check in and checkout times */
export enum SupportedCheckInAndOutTimes {
  Am0100 = 'AM0100',
  Am0130 = 'AM0130',
  Am0200 = 'AM0200',
  Am0230 = 'AM0230',
  Am0300 = 'AM0300',
  Am0330 = 'AM0330',
  Am0400 = 'AM0400',
  Am0430 = 'AM0430',
  Am0500 = 'AM0500',
  Am0530 = 'AM0530',
  Am0600 = 'AM0600',
  Am0630 = 'AM0630',
  Am0700 = 'AM0700',
  Am0730 = 'AM0730',
  Am0800 = 'AM0800',
  Am0830 = 'AM0830',
  Am0900 = 'AM0900',
  Am0930 = 'AM0930',
  Am1000 = 'AM1000',
  Am1030 = 'AM1030',
  Am1100 = 'AM1100',
  Am1130 = 'AM1130',
  Am1200 = 'AM1200',
  Am1230 = 'AM1230',
  Flexible = 'FLEXIBLE',
  Pm0100 = 'PM0100',
  Pm0130 = 'PM0130',
  Pm0200 = 'PM0200',
  Pm0230 = 'PM0230',
  Pm0300 = 'PM0300',
  Pm0330 = 'PM0330',
  Pm0400 = 'PM0400',
  Pm0430 = 'PM0430',
  Pm0500 = 'PM0500',
  Pm0530 = 'PM0530',
  Pm0600 = 'PM0600',
  Pm0630 = 'PM0630',
  Pm0700 = 'PM0700',
  Pm0730 = 'PM0730',
  Pm0800 = 'PM0800',
  Pm0830 = 'PM0830',
  Pm0900 = 'PM0900',
  Pm0930 = 'PM0930',
  Pm1000 = 'PM1000',
  Pm1030 = 'PM1030',
  Pm1100 = 'PM1100',
  Pm1130 = 'PM1130',
  Pm1200 = 'PM1200',
  Pm1230 = 'PM1230'
}

/** Task object for async processes */
export type Task = {
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  finalizedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  importCount?: Maybe<Scalars['Int']['output']>;
  importSuccessCount?: Maybe<Scalars['Int']['output']>;
  importedAt?: Maybe<Scalars['DateTime']['output']>;
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  startedAt: Scalars['DateTime']['output'];
  status: TaskStatus;
};

export type TaskStartPmsImportResult = NotFoundError | Task | UnauthenticatedError | ValidationErrorCollection;

/** The task status */
export enum TaskStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Succeeded = 'SUCCEEDED'
}

export type TrackPmsConnectionCreateInput = {
  endpointUrl: Scalars['String']['input'];
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

/** Transaction object */
export type Transaction = {
  /** The transaction amount in cents */
  amountCents: Scalars['Int']['output'];
  /** The time the transaction was created */
  createdAt: Scalars['DateTime']['output'];
  /** The transaction ID */
  id: Scalars['ID']['output'];
  /** The transaction type */
  type: TransactionType;
  /** The last time the transaction was updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** The supported transaction account type filters */
export enum TransactionAccountTypeFilters {
  GiftCard = 'GIFT_CARD',
  Listing = 'LISTING'
}

export type TransactionCollection = {
  /** The collection of transactions for a given page */
  entries: Array<Transaction>;
  /** The meta information containing additional info about the collection */
  meta: CollectionInfo;
};

export type TransactionListAllForAccountResponse = TransactionCollection | UnauthenticatedError | ValidationErrorCollection;

/**
 * The gift card payment source type
 * https://stripe.com/docs/api/sources/object
 */
export enum TransactionPaymentSourceType {
  AchCreditDebit = 'ACH_CREDIT_DEBIT',
  AchCreditTransfer = 'ACH_CREDIT_TRANSFER',
  Affirm = 'AFFIRM',
  Apple = 'APPLE',
  Card = 'CARD',
  Google = 'GOOGLE',
  Link = 'LINK'
}

export enum TransactionRecordType {
  GiftCardInitialBalanceTransaction = 'GIFT_CARD_INITIAL_BALANCE_TRANSACTION',
  GiftCardJournalTransaction = 'GIFT_CARD_JOURNAL_TRANSACTION',
  GiftCardPurchasedTransaction = 'GIFT_CARD_PURCHASED_TRANSACTION',
  GiftCardRedemptionTransaction = 'GIFT_CARD_REDEMPTION_TRANSACTION',
  GiftCardRefundTransaction = 'GIFT_CARD_REFUND_TRANSACTION',
  ListingJournalTransaction = 'LISTING_JOURNAL_TRANSACTION',
  ListingPayoutTransaction = 'LISTING_PAYOUT_TRANSACTION',
  ListingRedemptionTransaction = 'LISTING_REDEMPTION_TRANSACTION'
}

/** The sort options supported for transactions */
export enum TransactionSortOptions {
  CreatedAtNewestFirst = 'CREATED_AT_NEWEST_FIRST',
  CreatedAtOldestFirst = 'CREATED_AT_OLDEST_FIRST'
}

export enum TransactionType {
  Deposit = 'DEPOSIT',
  Withdrawal = 'WITHDRAWAL'
}

/** An error encountered when the request is not unauthenticated */
export type UnauthenticatedError = {
  message: Scalars['String']['output'];
};

/** An error encountered when the request is not unauthorized */
export type UnauthorizedError = {
  message: Scalars['String']['output'];
};

export enum UniquePropertyType {
  Barn = 'BARN',
  Boat = 'BOAT',
  BoutiqueHotel = 'BOUTIQUE_HOTEL',
  Bungalow = 'BUNGALOW',
  Cabin = 'CABIN',
  CamperOrRv = 'CAMPER_OR_RV',
  Campsite = 'CAMPSITE',
  Casita = 'CASITA',
  Castle = 'CASTLE',
  Cave = 'CAVE',
  Chalet = 'CHALET',
  Condo = 'CONDO',
  Cottage = 'COTTAGE',
  DomeHouse = 'DOME_HOUSE',
  EarthenHome = 'EARTHEN_HOME',
  FarmStay = 'FARM_STAY',
  GlampingTent = 'GLAMPING_TENT',
  HistoricHotel = 'HISTORIC_HOTEL',
  Home = 'HOME',
  Hostel = 'HOSTEL',
  Houseboat = 'HOUSEBOAT',
  Hut = 'HUT',
  Lighthouse = 'LIGHTHOUSE',
  NatureLodge = 'NATURE_LODGE',
  Resort = 'RESORT',
  Rv = 'RV',
  TinyHome = 'TINY_HOME',
  Tipi = 'TIPI',
  Townhouse = 'TOWNHOUSE',
  Treehouse = 'TREEHOUSE',
  Villa = 'VILLA',
  Windmill = 'WINDMILL',
  Yurt = 'YURT'
}

/** An error encountered when the server can understand a request, but cannot process the request */
export type UnprocessableContentError = {
  message: Scalars['String']['output'];
};

/** An error encountered when the request does not have verified resource */
export type UnverifiedError = {
  message: Scalars['String']['output'];
};

/** An error response that indicates that the server refuses to perform the request using the current protocol but might be willing to do so after the client upgrades to a different protocol */
export type UpgradeRequiredError = {
  message: Scalars['String']['output'];
  minimumSupportedVersion: Scalars['String']['output'];
};

/** User object */
export type User = {
  /** The user access token */
  accessToken?: Maybe<Scalars['String']['output']>;
  /** The account that the user belongs to */
  account?: Maybe<Account>;
  /** The role this user has for the host-side account */
  accountRole?: Maybe<AccountRole>;
  /** The user avatar path, relative to the endpoint */
  avatarPath?: Maybe<Scalars['String']['output']>;
  /** The user host image processing flag */
  avatarProcessing: Scalars['Boolean']['output'];
  /** The user host image URL */
  avatarUrl?: Maybe<Scalars['String']['output']>;
  /** Flag indicating if the identity has been claimed */
  claimable: Scalars['Boolean']['output'];
  /** The user's birthday */
  dob?: Maybe<Scalars['Date']['output']>;
  /** The user email */
  email: Scalars['String']['output'];
  /** The user first name */
  firstName?: Maybe<Scalars['String']['output']>;
  /** The user ID */
  id: Scalars['ID']['output'];
  /** The identity provider used to register the user */
  identityProvider: IdentityProvider;
  /** Flag indicating if the identity has been verified */
  identityVerified: Scalars['Boolean']['output'];
  /** The last time the user authenticated themselves on the platform */
  lastAuthenticatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user last name */
  lastName?: Maybe<Scalars['String']['output']>;
  /** The Stripe customer ID associated with the account */
  paymentServiceUserId: Scalars['String']['output'];
  /** The user phone number */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** The user that referred this user */
  referredByUser?: Maybe<User>;
  /** The user identity ID that referred this user */
  referredByUserId?: Maybe<Scalars['String']['output']>;
  /** The user refresh token */
  refreshToken?: Maybe<Scalars['String']['output']>;
  /** The date time the identity was registered */
  registeredAt?: Maybe<Scalars['DateTime']['output']>;
  salesforceUrl?: Maybe<Scalars['String']['output']>;
};

export type UserAccountAddInput = {
  /** The user that will be added to the account ID */
  userEmail: Scalars['String']['input'];
};

/** The result of the user account update mutation */
export type UserAccountAddResponse = ConflictError | NotFoundError | User | ValidationErrorCollection;

export type UserAccountRemoveInput = {
  /** The user that will be added to the account ID */
  userId: Scalars['String']['input'];
};

/** The result of the user account update mutation */
export type UserAccountRemoveResponse = ConflictError | NotFoundError | User | ValidationErrorCollection;

/** The result of adding a referral code to a user */
export type UserAddReferralCodeResponse = UnauthenticatedError | User | ValidationErrorCollection;

export type UserAppleSocialSessionInput = {
  /** The access token returned from Apple OAuth flow */
  accessToken: Scalars['String']['input'];
  /** The user email provided by Apple during the first login attempt */
  email?: InputMaybe<Scalars['String']['input']>;
  /** The user first_name provided by Apple during the first login attempt */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** The user last_name provided by Apple during the first login attempt */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Optional referral code to be used during sign up */
  referralCode?: InputMaybe<Scalars['String']['input']>;
};

export type UserCollection = {
  /** The collection of users for a given page */
  entries: Array<User>;
  /** The meta information containing additional info about the collection */
  meta: CollectionInfo;
};

export type UserCreateInput = {
  /** The user's date of birth */
  dob?: InputMaybe<Scalars['Date']['input']>;
  /** The user's account email */
  email: Scalars['String']['input'];
  /** The user's first name */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** The user's last name */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** The user's account password */
  password: Scalars['String']['input'];
  /** The user's account phone number */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Optional referral code to link this user to a referral campaign */
  referralCode?: InputMaybe<Scalars['String']['input']>;
};

/** The result of the user create mutation */
export type UserCreateResponse = User | ValidationErrorCollection;

export type UserFacebookSocialSessionInput = {
  /** The access token returned from Facebook OAuth flow */
  accessToken: Scalars['String']['input'];
  /** Optional referral code to be used during sign up */
  referralCode?: InputMaybe<Scalars['String']['input']>;
  /** The signed request returned from Facebook OAuth flow */
  signedRequest?: InputMaybe<Scalars['String']['input']>;
};

/** The result of the user session mutation */
export type UserFacebookSocialSessionResponse = UnauthenticatedError | User | ValidationErrorCollection;

export type UserGoogleSocialSessionInput = {
  /** The access token returned from Google OAuth flow */
  accessToken: Scalars['String']['input'];
  /** Optional referral code to be used during sign up */
  referralCode?: InputMaybe<Scalars['String']['input']>;
};

/** The result of the user account mark for deletion mutation */
export type UserMarkForDeletionResponse = User | ValidationErrorCollection;

export type UserSessionInput = {
  /** The user's email */
  email: Scalars['String']['input'];
  /** The user's password */
  password: Scalars['String']['input'];
};

export type UserSessionRefreshInput = {
  /** The user's refresh token */
  refreshToken: Scalars['String']['input'];
};

/** The result of the user session mutation */
export type UserSessionRefreshResponse = UnauthenticatedError | User;

/** The result of the user session mutation */
export type UserSessionResponse = UnauthenticatedError | User;

export type UserUpdateInput = {
  /** The user uploaded avatar URL. */
  avatarUploadUrl?: InputMaybe<Scalars['String']['input']>;
  /** The updated date of birth for an user. */
  dob?: InputMaybe<Scalars['Date']['input']>;
  /** The updated email for an user. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** The updated first name for an user. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** The updated last name for an user. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** The updated phone number for an user. */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

/** The result of the update user mutation for an authenticated user */
export type UserUpdateResult = UnauthenticatedError | User | ValidationErrorCollection;

/** Response for getting the users with access records for the given listing */
export type UsersListAllWithAccessOnListingByStatusResponse = UnauthenticatedError | UserCollection;

export type VacayHomePmsConnectionCreateInput = {
  apiKey: Scalars['String']['input'];
  reservationApiKey: Scalars['String']['input'];
};

/** An error encountered when mutating data */
export type ValidationError = {
  field?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

/** A collection of errors encountered when mutating data */
export type ValidationErrorCollection = {
  errors: Array<ValidationError>;
};

/** The version object */
export type Version = {
  /** The version value */
  value: Scalars['String']['output'];
};

export type AccountReviewSummaryCreateMutationVariables = Exact<{
  input: AccountReviewSummaryCreateInput;
}>;


export type AccountReviewSummaryCreateMutation = { accountReviewSummaryCreate: { __typename: 'AccountReviewSummary', id: string, imageUrl?: string | undefined, numberOfReviews?: number | undefined, source: AccountReviewSummarySource, sourceId: string, url?: string | undefined, rating: number } | { __typename: 'NotFoundError', message: string } | { __typename: 'UnauthenticatedError', message: string } | { __typename: 'ValidationErrorCollection', errors: Array<{ message: string, type?: string | undefined, field?: string | undefined }> } };

export type PrivateAccountFieldsFragment = { pmsSoftware?: string | undefined, reportedPmsSoftware?: string | undefined, numberOfClaimedListings?: number | undefined, activeListingsCount: number, addressLineOne?: string | undefined, addressLineTwo?: string | undefined, city?: string | undefined, countryOrRegionLongName?: string | undefined, stateOrProvinceLongName?: string | undefined, postalCode?: string | undefined, salesforceUrl?: string | undefined, id: string, slug: string, avatarUrl?: string | undefined, avatarFileName?: string | undefined, avatarUploadUrl?: string | undefined, avatarProcessing: boolean, companyName?: string | undefined, heroFileName?: string | undefined, heroUploadUrl?: string | undefined, heroUrl?: string | undefined, heroProcessing: boolean, title?: string | undefined, description?: string | undefined, email?: string | undefined, phoneNumber?: string | undefined, marketingWebsiteUrl?: string | undefined, homeownerMarketingUrl?: string | undefined, twitterUrl?: string | undefined, instagramUrl?: string | undefined, twitterHandle?: string | undefined, instagramUsername?: string | undefined, facebookPageUrl?: string | undefined, inBusinessSince?: number | undefined, bookDirectWebsiteUrl?: string | undefined, youtubeUrl?: string | undefined, linkedinUrl?: string | undefined, accountReviewSummaries: Array<{ id: string, source: AccountReviewSummarySource, sourceId: string, numberOfReviews?: number | undefined, imageUrl?: string | undefined, rating: number }> };

export type PrivateAccountIndexFieldsFragment = { pmsSoftware?: string | undefined, reportedPmsSoftware?: string | undefined, numberOfClaimedListings?: number | undefined, activeListingsCount: number, addressLineOne?: string | undefined, addressLineTwo?: string | undefined, city?: string | undefined, countryOrRegionLongName?: string | undefined, stateOrProvinceLongName?: string | undefined, postalCode?: string | undefined, firstPublishedAt?: string | undefined, stripeCustomerId: string, creditCardOnFile: boolean, salesforceUrl?: string | undefined, archived: boolean, id: string, slug: string, avatarUrl?: string | undefined, avatarFileName?: string | undefined, avatarUploadUrl?: string | undefined, avatarProcessing: boolean, companyName?: string | undefined, heroFileName?: string | undefined, heroUploadUrl?: string | undefined, heroUrl?: string | undefined, heroProcessing: boolean, title?: string | undefined, description?: string | undefined, email?: string | undefined, phoneNumber?: string | undefined, marketingWebsiteUrl?: string | undefined, homeownerMarketingUrl?: string | undefined, twitterUrl?: string | undefined, instagramUrl?: string | undefined, twitterHandle?: string | undefined, instagramUsername?: string | undefined, facebookPageUrl?: string | undefined, inBusinessSince?: number | undefined, bookDirectWebsiteUrl?: string | undefined, youtubeUrl?: string | undefined, linkedinUrl?: string | undefined, pmsConnection?: { id: string, type: PmsName, failed: boolean, failingSince?: string | undefined, insertedAt: string, maskedCredentials?: string | undefined, userConfig: Array<{ fieldName: string, value: string, options: Array<string> }> } | undefined, listings: Array<{ id: string, lastPublishedAt?: string | undefined, firstPublishedAt?: string | undefined, name?: string | undefined, published: boolean, insertedAt?: string | undefined, listingLevel: SubscriptionType }>, owner: { id: string, email: string }, users: Array<{ id: string, firstName?: string | undefined, lastName?: string | undefined, email: string, accountRole?: AccountRole | undefined }>, billingSubscription?: { currentPeriodEnd: string } | undefined, latestTask?: { id: string, status: TaskStatus, startedAt: string, completedAt?: string | undefined, importCount?: number | undefined, importSuccessCount?: number | undefined, importedAt?: string | undefined, processedAt?: string | undefined, finalizedAt?: string | undefined, expiresAt?: string | undefined, errors?: Array<string> | undefined } | undefined, accountReviewSummaries: Array<{ id: string, source: AccountReviewSummarySource, sourceId: string, numberOfReviews?: number | undefined, imageUrl?: string | undefined, rating: number }> };

export type PublicAccountFieldsFragment = { id: string, slug: string, avatarUrl?: string | undefined, avatarFileName?: string | undefined, avatarUploadUrl?: string | undefined, avatarProcessing: boolean, companyName?: string | undefined, countryOrRegionLongName?: string | undefined, heroFileName?: string | undefined, heroUploadUrl?: string | undefined, heroUrl?: string | undefined, heroProcessing: boolean, title?: string | undefined, description?: string | undefined, email?: string | undefined, phoneNumber?: string | undefined, marketingWebsiteUrl?: string | undefined, homeownerMarketingUrl?: string | undefined, twitterUrl?: string | undefined, instagramUrl?: string | undefined, twitterHandle?: string | undefined, instagramUsername?: string | undefined, facebookPageUrl?: string | undefined, inBusinessSince?: number | undefined, bookDirectWebsiteUrl?: string | undefined, youtubeUrl?: string | undefined, linkedinUrl?: string | undefined, city?: string | undefined, stateOrProvinceLongName?: string | undefined, accountReviewSummaries: Array<{ id: string, source: AccountReviewSummarySource, sourceId: string, numberOfReviews?: number | undefined, imageUrl?: string | undefined, rating: number }> };

export type PmAccountCreateMutationVariables = Exact<{
  input: PmAccountCreateInput;
}>;


export type PmAccountCreateMutation = { pmAccountCreate: { __typename: 'Account', id: string } | { __typename: 'UnauthenticatedError', message: string } | { __typename: 'ValidationErrorCollection', errors: Array<{ field?: string | undefined, message: string, type?: string | undefined }> } };

export type AccountUpdateMutationVariables = Exact<{
  input: AccountUpdateInput;
}>;


export type AccountUpdateMutation = { accountUpdate: { __typename: 'Account', pmsSoftware?: string | undefined, reportedPmsSoftware?: string | undefined, numberOfClaimedListings?: number | undefined, activeListingsCount: number, addressLineOne?: string | undefined, addressLineTwo?: string | undefined, city?: string | undefined, countryOrRegionLongName?: string | undefined, stateOrProvinceLongName?: string | undefined, postalCode?: string | undefined, id: string, slug: string, avatarUrl?: string | undefined, avatarFileName?: string | undefined, avatarUploadUrl?: string | undefined, avatarProcessing: boolean, companyName?: string | undefined, heroFileName?: string | undefined, heroUploadUrl?: string | undefined, heroUrl?: string | undefined, heroProcessing: boolean, title?: string | undefined, description?: string | undefined, email?: string | undefined, phoneNumber?: string | undefined, marketingWebsiteUrl?: string | undefined, homeownerMarketingUrl?: string | undefined, twitterUrl?: string | undefined, instagramUrl?: string | undefined, twitterHandle?: string | undefined, instagramUsername?: string | undefined, facebookPageUrl?: string | undefined, inBusinessSince?: number | undefined, bookDirectWebsiteUrl?: string | undefined, youtubeUrl?: string | undefined, linkedinUrl?: string | undefined, accountReviewSummaries: Array<{ id: string, source: AccountReviewSummarySource, sourceId: string, numberOfReviews?: number | undefined, imageUrl?: string | undefined, rating: number }> } | { __typename: 'UnauthenticatedError', message: string } | { __typename: 'ValidationErrorCollection', errors: Array<{ field?: string | undefined, message: string, type?: string | undefined }> } };

export type CreateSubscriptionMutationVariables = Exact<{
  input: CreateSubscriptionInput;
}>;


export type CreateSubscriptionMutation = { createSubscription: { __typename: 'Account', id: string } | { __typename: 'ConflictError', message: string } | { __typename: 'NotFoundError', message: string } | { __typename: 'UnauthenticatedError', message: string } | { __typename: 'ValidationErrorCollection', errors: Array<{ field?: string | undefined, message: string, type?: string | undefined }> } };

export type SetSubscriptionCouponMutationVariables = Exact<{
  input: SetSubscriptionCouponInput;
}>;


export type SetSubscriptionCouponMutation = { setSubscriptionCoupon: { __typename: 'Account', id: string } | { __typename: 'NotFoundError', message: string } | { __typename: 'UnauthenticatedError', message: string } };

export type AccountUpdateAllListingSubscriptionsMutationVariables = Exact<{
  input: AccountUpdateAllListingSubscriptionsInput;
}>;


export type AccountUpdateAllListingSubscriptionsMutation = { accountUpdateAllListingSubscriptions: { __typename: 'AccountBulkUpdateResults', successCount: number, failureCount: number } | { __typename: 'NotFoundError', message: string } | { __typename: 'UnauthenticatedError', message: string } | { __typename: 'ValidationErrorCollection', errors: Array<{ field?: string | undefined, message: string, type?: string | undefined }> } };

export type AccountBulkUpdateLocationObfuscatedMutationVariables = Exact<{
  input: AccountBulkUpdateLocationObfuscatedInput;
}>;


export type AccountBulkUpdateLocationObfuscatedMutation = { accountBulkUpdateLocationObfuscated: { __typename: 'AccountBulkUpdateResults', successCount: number, failureCount: number } | { __typename: 'NotFoundError', message: string } | { __typename: 'UnauthenticatedError', message: string } | { __typename: 'ValidationErrorCollection', errors: Array<{ field?: string | undefined, message: string, type?: string | undefined }> } };

export type AccountsListRandomQueryVariables = Exact<{
  pageSize: Scalars['Int']['input'];
}>;


export type AccountsListRandomQuery = { accountsListRandom: { __typename: 'AccountCollection', entries: Array<{ id: string, slug: string, avatarUrl?: string | undefined, avatarProcessing: boolean, heroUploadUrl?: string | undefined, heroProcessing: boolean, companyName?: string | undefined, title?: string | undefined, description?: string | undefined, email?: string | undefined, phoneNumber?: string | undefined, marketingWebsiteUrl?: string | undefined, homeownerMarketingUrl?: string | undefined, twitterUrl?: string | undefined, instagramUrl?: string | undefined, twitterHandle?: string | undefined, instagramUsername?: string | undefined, facebookPageUrl?: string | undefined, activeListingsCount: number, inBusinessSince?: number | undefined, bookDirectWebsiteUrl?: string | undefined, youtubeUrl?: string | undefined, linkedinUrl?: string | undefined, city?: string | undefined, stateOrProvinceLongName?: string | undefined, accountReviewSummaries: Array<{ id: string, source: AccountReviewSummarySource, sourceId: string, numberOfReviews?: number | undefined, imageUrl?: string | undefined, rating: number }> }>, meta: { nextPage?: number | undefined, previousPage?: number | undefined, currentPage?: number | undefined, totalEntries?: number | undefined, totalPages?: number | undefined } } };

export type AccountByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type AccountByIdQuery = { accountById: { __typename: 'Account', id: string, slug: string, avatarUrl?: string | undefined, avatarFileName?: string | undefined, avatarUploadUrl?: string | undefined, avatarProcessing: boolean, companyName?: string | undefined, countryOrRegionLongName?: string | undefined, heroFileName?: string | undefined, heroUploadUrl?: string | undefined, heroUrl?: string | undefined, heroProcessing: boolean, title?: string | undefined, description?: string | undefined, email?: string | undefined, phoneNumber?: string | undefined, marketingWebsiteUrl?: string | undefined, homeownerMarketingUrl?: string | undefined, twitterUrl?: string | undefined, instagramUrl?: string | undefined, twitterHandle?: string | undefined, instagramUsername?: string | undefined, facebookPageUrl?: string | undefined, inBusinessSince?: number | undefined, bookDirectWebsiteUrl?: string | undefined, youtubeUrl?: string | undefined, linkedinUrl?: string | undefined, city?: string | undefined, stateOrProvinceLongName?: string | undefined, accountReviewSummaries: Array<{ id: string, source: AccountReviewSummarySource, sourceId: string, numberOfReviews?: number | undefined, imageUrl?: string | undefined, rating: number }> } | { __typename: 'NotFoundError', message: string } };

export type AccountBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type AccountBySlugQuery = { accountBySlug: { __typename: 'Account', id: string, slug: string, avatarUrl?: string | undefined, avatarFileName?: string | undefined, avatarUploadUrl?: string | undefined, avatarProcessing: boolean, companyName?: string | undefined, countryOrRegionLongName?: string | undefined, heroFileName?: string | undefined, heroUploadUrl?: string | undefined, heroUrl?: string | undefined, heroProcessing: boolean, title?: string | undefined, description?: string | undefined, email?: string | undefined, phoneNumber?: string | undefined, marketingWebsiteUrl?: string | undefined, homeownerMarketingUrl?: string | undefined, twitterUrl?: string | undefined, instagramUrl?: string | undefined, twitterHandle?: string | undefined, instagramUsername?: string | undefined, facebookPageUrl?: string | undefined, inBusinessSince?: number | undefined, bookDirectWebsiteUrl?: string | undefined, youtubeUrl?: string | undefined, linkedinUrl?: string | undefined, city?: string | undefined, stateOrProvinceLongName?: string | undefined, accountReviewSummaries: Array<{ id: string, source: AccountReviewSummarySource, sourceId: string, numberOfReviews?: number | undefined, imageUrl?: string | undefined, rating: number }> } | { __typename: 'NotFoundError', message: string } };

export type AccountForCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountForCurrentUserQuery = { accountForCurrentUser: { __typename: 'Account', pmsSoftware?: string | undefined, reportedPmsSoftware?: string | undefined, isPpr: boolean, creditCardOnFile: boolean, id: string, slug: string, avatarUrl?: string | undefined, avatarFileName?: string | undefined, avatarUploadUrl?: string | undefined, avatarProcessing: boolean, companyName?: string | undefined, countryOrRegionLongName?: string | undefined, heroFileName?: string | undefined, heroUploadUrl?: string | undefined, heroUrl?: string | undefined, heroProcessing: boolean, title?: string | undefined, description?: string | undefined, email?: string | undefined, phoneNumber?: string | undefined, marketingWebsiteUrl?: string | undefined, homeownerMarketingUrl?: string | undefined, twitterUrl?: string | undefined, instagramUrl?: string | undefined, twitterHandle?: string | undefined, instagramUsername?: string | undefined, facebookPageUrl?: string | undefined, inBusinessSince?: number | undefined, bookDirectWebsiteUrl?: string | undefined, youtubeUrl?: string | undefined, linkedinUrl?: string | undefined, city?: string | undefined, stateOrProvinceLongName?: string | undefined, latestTask?: { id: string, status: TaskStatus, startedAt: string, completedAt?: string | undefined, importCount?: number | undefined, importSuccessCount?: number | undefined } | undefined, accountReviewSummaries: Array<{ id: string, source: AccountReviewSummarySource, sourceId: string, numberOfReviews?: number | undefined, imageUrl?: string | undefined, rating: number }> } | { __typename: 'UnauthenticatedError', message: string } };

export type AccountsListAllActiveQueryVariables = Exact<{
  pageSize: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  stateOrProvinceLongNameFilter?: InputMaybe<Scalars['String']['input']>;
}>;


export type AccountsListAllActiveQuery = { accountsListAllActive: { __typename: 'AccountCollection', entries: Array<{ id: string, slug: string, avatarUrl?: string | undefined, avatarProcessing: boolean, heroUploadUrl?: string | undefined, heroProcessing: boolean, companyName?: string | undefined, title?: string | undefined, description?: string | undefined, email?: string | undefined, phoneNumber?: string | undefined, marketingWebsiteUrl?: string | undefined, homeownerMarketingUrl?: string | undefined, twitterUrl?: string | undefined, instagramUrl?: string | undefined, twitterHandle?: string | undefined, instagramUsername?: string | undefined, facebookPageUrl?: string | undefined, activeListingsCount: number, inBusinessSince?: number | undefined, bookDirectWebsiteUrl?: string | undefined, youtubeUrl?: string | undefined, linkedinUrl?: string | undefined, city?: string | undefined, stateOrProvinceLongName?: string | undefined, accountReviewSummaries: Array<{ id: string, source: AccountReviewSummarySource, sourceId: string, numberOfReviews?: number | undefined, imageUrl?: string | undefined, rating: number }> }>, meta: { nextPage?: number | undefined, previousPage?: number | undefined, currentPage?: number | undefined, totalEntries?: number | undefined, totalPages?: number | undefined } } };

export type AffiliationFindOrCreateMutationVariables = Exact<{
  input: AffiliationFindOrCreateInput;
}>;


export type AffiliationFindOrCreateMutation = { affiliationFindOrCreate: { __typename: 'Affiliation', id: string, name: string, type: AffiliationType } | { __typename: 'UnauthenticatedError', message: string } | { __typename: 'ValidationErrorCollection', errors: Array<{ message: string, type?: string | undefined, field?: string | undefined }> } };

export type AffiliationDeleteMutationVariables = Exact<{
  input: AffiliationDeleteInput;
}>;


export type AffiliationDeleteMutation = { affiliationDelete: { __typename: 'Affiliation', id: string, name: string, type: AffiliationType } | { __typename: 'NotFoundError', message: string } | { __typename: 'UnauthenticatedError', message: string } };

export type AffiliationSearchQueryVariables = Exact<{
  query: Scalars['String']['input'];
  type?: InputMaybe<AffiliationTypeFilter>;
  listingId: Scalars['ID']['input'];
}>;


export type AffiliationSearchQuery = { affiliationSearch: { __typename: 'AffiliationCollection', entries: Array<{ id: string, name: string, type: AffiliationType }> } | { __typename: 'UnauthenticatedError', message: string } };

export type BlogPostsListAllFeaturedQueryVariables = Exact<{ [key: string]: never; }>;


export type BlogPostsListAllFeaturedQuery = { blogPostsListAllFeatured: Array<{ id: string, title: string, publishedAt: string, url: string, imageUrl: string }> };

export type BookingQuoteByListingAndDatesQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  checkInDate: Scalars['Date']['input'];
  checkOutDate: Scalars['Date']['input'];
  adultCount: Scalars['Int']['input'];
  childCount: Scalars['Int']['input'];
  infantCount: Scalars['Int']['input'];
  petCount: Scalars['Int']['input'];
}>;


export type BookingQuoteByListingAndDatesQuery = { bookingQuoteByListingAndDates: { __typename: 'BookingQuote', listingId?: string | undefined, totalCostCents?: number | undefined, totalRecoverableCostCents?: number | undefined, totalWithoutTaxesCents?: number | undefined, checkInDate?: string | undefined, checkOutDate?: string | undefined, listing: { priceDisplay?: { subtotalWithoutTaxesCents?: number | undefined, baseAmountCents: number, nights: number } | undefined }, quoteItems: Array<{ costCents: number, type: QuoteItemizedType, description: string }>, paymentSchedule: Array<{ dueDate: string, amountCents: number, description?: string | undefined, paymentItemType: PaymentItemType }> } | { __typename: 'BookingQuoteUnavailable', message: string } | { __typename: 'BookingQuoteUnsupported' } | { __typename: 'NotFoundError' } | { __typename: 'ServiceUnavailableError', message: string } | { __typename: 'ValidationError', message: string } };

export type SetAccountCardMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type SetAccountCardMutation = { setAccountCard: { __typename: 'Card', brand: string, addressZip?: string | undefined, last4: string, expMonth: number, expYear: number } | { __typename: 'NotFoundError', message: string } | { __typename: 'ServiceUnavailableError', message: string } | { __typename: 'UnauthenticatedError', message: string } | { __typename: 'UnauthorizedError', message: string } | { __typename: 'ValidationErrorCollection', errors: Array<{ message: string, type?: string | undefined, field?: string | undefined }> } };

export type CardsListAllQueryVariables = Exact<{ [key: string]: never; }>;


export type CardsListAllQuery = { cardsListAll: { __typename: 'CardCollection', entries: Array<{ brand: string, addressZip?: string | undefined, last4: string, expMonth: number, expYear: number }>, meta: { currentPage?: number | undefined, nextPage?: number | undefined, previousPage?: number | undefined, totalEntries?: number | undefined, totalPages?: number | undefined } } | { __typename: 'ServiceUnavailableError' } | { __typename: 'UnauthenticatedError', message: string } };

export type AccountCardsListAllQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountCardsListAllQuery = { accountCardsListAll: { __typename: 'CardCollection', entries: Array<{ brand: string, addressZip?: string | undefined, last4: string, expMonth: number, expYear: number }>, meta: { currentPage?: number | undefined, nextPage?: number | undefined, previousPage?: number | undefined, totalEntries?: number | undefined, totalPages?: number | undefined } } | { __typename: 'ServiceUnavailableError' } | { __typename: 'UnauthenticatedError', message: string } | { __typename: 'UnauthorizedError', message: string } };

export type ComparisonQuoteByListingAndDatesQueryVariables = Exact<{
  checkInDate: Scalars['Date']['input'];
  checkOutDate: Scalars['Date']['input'];
  externalListingUrl: Scalars['String']['input'];
  numberOfAdults: Scalars['Int']['input'];
  numberOfChildren?: InputMaybe<Scalars['Int']['input']>;
  numberOfInfants?: InputMaybe<Scalars['Int']['input']>;
  numberOfPets?: InputMaybe<Scalars['Int']['input']>;
  priceType: PriceType;
}>;


export type ComparisonQuoteByListingAndDatesQuery = { comparisonQuoteByListingAndDates: { __typename: 'ComparisonQuote', checkInDate: string, checkOutDate: string, externalListingId: string, externalSource: string, numberOfAdults: number, numberOfChildren: number, numberOfInfants: number, numberOfPets: number, priceCents: number } | { __typename: 'ComparisonQuoteUnsupported' } | { __typename: 'NotFoundError', message: string } | { __typename: 'UnprocessableContentError', message: string } | { __typename: 'ValidationError', message: string } };

export type CouponFindAvailableForAccountQueryVariables = Exact<{ [key: string]: never; }>;


export type CouponFindAvailableForAccountQuery = { couponFindAvailableForAccount: { __typename: 'Coupon', amountOffCents?: number | undefined, applicableSubscriptions?: Array<SubscriptionType | undefined> | undefined, endDate?: string | undefined, name: string, percentOff?: number | undefined, promoCode?: string | undefined } | { __typename: 'NotFoundError', message: string } | { __typename: 'UnauthenticatedError' } };

export type CouponFindByPromoCodeQueryVariables = Exact<{
  promoCode: Scalars['String']['input'];
}>;


export type CouponFindByPromoCodeQuery = { couponFindByPromoCode: { __typename: 'Coupon', amountOffCents?: number | undefined, applicableSubscriptions?: Array<SubscriptionType | undefined> | undefined, endDate?: string | undefined, name: string, percentOff?: number | undefined, promoCode?: string | undefined } | { __typename: 'NotFoundError', message: string } };

export type CouponFindForAccountQueryVariables = Exact<{ [key: string]: never; }>;


export type CouponFindForAccountQuery = { couponFindForAccount: { __typename: 'Coupon', amountOffCents?: number | undefined, applicableSubscriptions?: Array<SubscriptionType | undefined> | undefined, endDate?: string | undefined, name: string, percentOff?: number | undefined, promoCode?: string | undefined } | { __typename: 'NotFoundError', message: string } | { __typename: 'UnauthenticatedError', message: string } };

export type EmailVerificationUpdateMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type EmailVerificationUpdateMutation = { emailVerificationUpdate: { __typename: 'EmailVerificationMessage', message: string } | { __typename: 'NotFoundError', message: string } | { __typename: 'UnauthenticatedError', message: string } | { __typename: 'ValidationErrorCollection', errors: Array<{ message: string, type?: string | undefined, field?: string | undefined }> } };

export type FeaturesListAllQueryVariables = Exact<{
  propertyType?: InputMaybe<PropertyType>;
}>;


export type FeaturesListAllQuery = { featuresListAll: Array<{ key: FeatureKey, displayName: string, categoryName: string, promoted: boolean }> };

export type FeaturesListAllForSearchFiltersQueryVariables = Exact<{ [key: string]: never; }>;


export type FeaturesListAllForSearchFiltersQuery = { featuresListAllForSearchFilters: Array<{ categoryName: string, displayName: string, key: FeatureKey, promoted: boolean }> };

export type GalleryAssetCreateMutationVariables = Exact<{
  input: GalleryAssetCreateInput;
}>;


export type GalleryAssetCreateMutation = { galleryAssetCreate: { __typename: 'GalleryAsset', id: string, description?: string | undefined, processing: boolean, rawUrl?: string | undefined, position: number, url?: string | undefined } | { __typename: 'UnauthenticatedError', message: string } | { __typename: 'ValidationErrorCollection', errors: Array<{ message: string, type?: string | undefined, field?: string | undefined }> } };

export type GalleryAssetDeleteMutationVariables = Exact<{
  input: GalleryAssetDeleteInput;
}>;


export type GalleryAssetDeleteMutation = { galleryAssetDelete: { __typename: 'GalleryAsset', id: string, description?: string | undefined, processing: boolean, rawUrl?: string | undefined, position: number, url?: string | undefined } | { __typename: 'NotFoundError', message: string } | { __typename: 'UnauthenticatedError', message: string } };

export type GalleryAssetOrderMutationVariables = Exact<{
  input: GalleryAssetOrderInput;
}>;


export type GalleryAssetOrderMutation = { galleryAssetOrder: { __typename: 'GalleryAsset', id: string, description?: string | undefined, processing: boolean, rawUrl?: string | undefined, position: number, url?: string | undefined } | { __typename: 'NotFoundError', message: string } | { __typename: 'UnauthenticatedError', message: string } | { __typename: 'ValidationErrorCollection', errors: Array<{ message: string, type?: string | undefined, field?: string | undefined }> } };

export type GalleryAssetUpdateImageMutationVariables = Exact<{
  input: GalleryAssetUpdateImageInput;
}>;


export type GalleryAssetUpdateImageMutation = { galleryAssetUpdateImage: { __typename: 'GalleryAsset', id: string, description?: string | undefined, processing: boolean, rawUrl?: string | undefined, position: number, url?: string | undefined } | { __typename: 'NotFoundError', message: string } | { __typename: 'UnauthenticatedError', message: string } | { __typename: 'ValidationErrorCollection', errors: Array<{ message: string, type?: string | undefined, field?: string | undefined }> } };

export type GalleryAssetUpdateMutationVariables = Exact<{
  input: GalleryAssetUpdateInput;
}>;


export type GalleryAssetUpdateMutation = { galleryAssetUpdate: { __typename: 'GalleryAsset', id: string, description?: string | undefined, processing: boolean, rawUrl?: string | undefined, position: number, url?: string | undefined } | { __typename: 'NotFoundError', message: string } | { __typename: 'UnauthenticatedError', message: string } | { __typename: 'ValidationErrorCollection', errors: Array<{ message: string, type?: string | undefined, field?: string | undefined }> } };

export type GalleryAssetByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GalleryAssetByIdQuery = { galleryAssetById: { __typename: 'GalleryAsset', id: string, description?: string | undefined, processing: boolean, rawUrl?: string | undefined, position: number, url?: string | undefined } | { __typename: 'NotFoundError', message: string } | { __typename: 'UnauthenticatedError', message: string } };

export type GiftCardImageFindByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GiftCardImageFindByIdQuery = { giftCardImageById: { __typename: 'GiftCardImage', id: string, active: boolean, imageProcessing: boolean, imageUrl?: string | undefined } | { __typename: 'NotFoundError', message: string } | { __typename: 'UnauthenticatedError', message: string } };

export type GiftCardImageListAllActiveQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
}>;


export type GiftCardImageListAllActiveQuery = { giftCardImageListAllActive: { entries: Array<{ id: string, active: boolean, imageUrl?: string | undefined, imageProcessing: boolean }>, meta: { nextPage?: number | undefined, previousPage?: number | undefined, currentPage?: number | undefined, totalEntries?: number | undefined } } };

export type GiftCardCreateMutationVariables = Exact<{
  input: GiftCardCreateInput;
}>;


export type GiftCardCreateMutation = { giftCardCreate: { __typename: 'GiftCard', id: string, paymentServiceTransactionClientSecret?: string | undefined } | { __typename: 'ValidationErrorCollection', errors: Array<{ field?: string | undefined, message: string, type?: string | undefined }> } };

export type GiftCardRedeemMutationVariables = Exact<{
  certificateNumber: Scalars['String']['input'];
  input: GiftCardRedeemInput;
}>;


export type GiftCardRedeemMutation = { giftCardRedeem: { __typename: 'GiftCard', id: string, certificateNumber?: string | undefined, createdAt?: string | undefined, currentBalanceCents: number, imageUrl?: string | undefined, imageProcessing: boolean, issuedAt?: string | undefined, orderAmountCents: number, orderNumber?: string | undefined, paymentServiceTransactionClientSecret?: string | undefined, recipientAddressLineOne?: string | undefined, recipientAddressLineTwo?: string | undefined, recipientCity?: string | undefined, recipientCountryShortName?: string | undefined, recipientEmail?: string | undefined, recipientFirstName: string, recipientLastName?: string | undefined, recipientPostalCode?: string | undefined, recipientStateOrProvinceLongName?: string | undefined, recipientLat?: number | undefined, recipientLng?: number | undefined, senderAddressLineOne?: string | undefined, senderAddressLineTwo?: string | undefined, senderCity?: string | undefined, senderCountryShortName?: string | undefined, senderEmail?: string | undefined, senderFirstName: string, senderLastName?: string | undefined, senderMessage?: string | undefined, senderPhoneNumber?: string | undefined, senderPostalCode?: string | undefined, senderStateOrProvinceLongName?: string | undefined, shippingType?: GiftCardShippingType | undefined, shippingFeeCents: number, status: GiftCardStatus, type: GiftCardType, verifiedAt?: string | undefined, deactivationDescription?: string | undefined } | { __typename: 'NotFoundError', message: string } | { __typename: 'UnauthenticatedError', message: string } | { __typename: 'UnverifiedError', message: string } | { __typename: 'ValidationErrorCollection', errors: Array<{ message: string, type?: string | undefined, field?: string | undefined }> } };

export type GiftCardUpdateUnpurchasedMutationVariables = Exact<{
  input: GiftCardUpdateUnpurchasedInput;
}>;


export type GiftCardUpdateUnpurchasedMutation = { giftCardUpdateUnpurchased: { __typename: 'GiftCard', id: string } | { __typename: 'NotFoundError', message: string } | { __typename: 'ValidationErrorCollection', errors: Array<{ message: string, type?: string | undefined, field?: string | undefined }> } };

export type GiftCardByCertificateNumberQueryVariables = Exact<{
  certificateNumber: Scalars['String']['input'];
}>;


export type GiftCardByCertificateNumberQuery = { giftCard: { __typename: 'GiftCard', id: string, createdAt?: string | undefined, currentBalanceCents: number, imageUrl?: string | undefined, imageProcessing: boolean, issuedAt?: string | undefined, orderAmountCents: number, orderNumber?: string | undefined, certificateNumber?: string | undefined, paymentServiceTransactionClientSecret?: string | undefined, recipientAddressLineOne?: string | undefined, recipientAddressLineTwo?: string | undefined, recipientCity?: string | undefined, recipientCountryShortName?: string | undefined, recipientEmail?: string | undefined, recipientFirstName: string, recipientLastName?: string | undefined, recipientPostalCode?: string | undefined, recipientStateOrProvinceLongName?: string | undefined, recipientLat?: number | undefined, recipientLng?: number | undefined, senderAddressLineOne?: string | undefined, senderAddressLineTwo?: string | undefined, senderCity?: string | undefined, senderCountryShortName?: string | undefined, senderEmail?: string | undefined, senderFirstName: string, senderLastName?: string | undefined, senderMessage?: string | undefined, senderPhoneNumber?: string | undefined, senderPostalCode?: string | undefined, senderStateOrProvinceLongName?: string | undefined, shippingType?: GiftCardShippingType | undefined, shippingFeeCents: number, status: GiftCardStatus, type: GiftCardType, verifiedAt?: string | undefined } | { __typename: 'NotFoundError', message: string } };

export type GiftCardByPaymentServiceTransactionClientSecretQueryVariables = Exact<{
  clientSecret: Scalars['String']['input'];
}>;


export type GiftCardByPaymentServiceTransactionClientSecretQuery = { giftCardByPaymentServiceTransactionClientSecret: { __typename: 'GiftCard', id: string, createdAt?: string | undefined, currentBalanceCents: number, imageUploadUrl?: string | undefined, imageUrl?: string | undefined, imageProcessing: boolean, issuedAt?: string | undefined, orderAmountCents: number, orderNumber?: string | undefined, paymentServiceTransactionClientSecret?: string | undefined, recipientAddressLineOne?: string | undefined, recipientAddressLineTwo?: string | undefined, recipientCity?: string | undefined, recipientCountryShortName?: string | undefined, recipientEmail?: string | undefined, recipientFirstName: string, recipientLastName?: string | undefined, recipientPostalCode?: string | undefined, recipientStateOrProvinceLongName?: string | undefined, recipientLat?: number | undefined, recipientLng?: number | undefined, senderAddressLineOne?: string | undefined, senderAddressLineTwo?: string | undefined, senderCity?: string | undefined, senderCountryShortName?: string | undefined, senderEmail?: string | undefined, senderFirstName: string, senderLastName?: string | undefined, senderMessage?: string | undefined, senderPhoneNumber?: string | undefined, senderPostalCode?: string | undefined, senderStateOrProvinceLongName?: string | undefined, shippingType?: GiftCardShippingType | undefined, shippingFeeCents: number, status: GiftCardStatus, type: GiftCardType, verifiedAt?: string | undefined, promo?: GiftCardPromos | undefined } | { __typename: 'NotFoundError', message: string } };

export type GiftCardByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GiftCardByIdQuery = { giftCardById: { __typename: 'GiftCard', id: string, createdAt?: string | undefined, currentBalanceCents: number, imageUploadUrl?: string | undefined, imageUrl?: string | undefined, imageProcessing: boolean, issuedAt?: string | undefined, orderAmountCents: number, orderNumber?: string | undefined, paymentServiceTransactionClientSecret?: string | undefined, recipientAddressLineOne?: string | undefined, recipientAddressLineTwo?: string | undefined, recipientCity?: string | undefined, recipientCountryShortName?: string | undefined, recipientEmail?: string | undefined, recipientFirstName: string, recipientLastName?: string | undefined, recipientPostalCode?: string | undefined, recipientStateOrProvinceLongName?: string | undefined, recipientLat?: number | undefined, recipientLng?: number | undefined, senderAddressLineOne?: string | undefined, senderAddressLineTwo?: string | undefined, senderCity?: string | undefined, senderCountryShortName?: string | undefined, senderEmail?: string | undefined, senderFirstName: string, senderLastName?: string | undefined, senderMessage?: string | undefined, senderPhoneNumber?: string | undefined, senderPostalCode?: string | undefined, senderStateOrProvinceLongName?: string | undefined, shippingType?: GiftCardShippingType | undefined, shippingFeeCents: number, status: GiftCardStatus, type: GiftCardType, verifiedAt?: string | undefined, promo?: GiftCardPromos | undefined } | { __typename: 'NotFoundError', message: string } };

export type CurrentInnkeeperQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentInnkeeperQuery = { currentInnkeeper: { __typename: 'Innkeeper', id: string, accessToken?: string | undefined, claimable: boolean, email: string, firstName?: string | undefined, identityVerified: boolean, lastName?: string | undefined, phoneNumber?: string | undefined, referredByUserId?: string | undefined, registeredAt?: string | undefined } | { __typename: 'UnauthenticatedError', message: string } };

export type CreateLeadMutationVariables = Exact<{
  input: CreateLeadInput;
}>;


export type CreateLeadMutation = { createLead: { __typename: 'LeadCreatedMessage', message: string } | { __typename: 'ValidationErrorCollection', errors: Array<{ message: string, type?: string | undefined, field?: string | undefined }> } };

export type ListingBookingInfoQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type ListingBookingInfoQuery = { listingBookingInfo: { __typename: 'ListingBookingInfo', availabilityDates: Array<{ date: string, available: boolean, checkInAllowed: boolean, checkOutAllowed: boolean, minNights?: number | undefined, maxNights?: number | undefined }> } | { __typename: 'NotFoundError', message: string } };

export type ListingReviewsListAllForListingQueryVariables = Exact<{
  id: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ListingReviewsListAllForListingQuery = { listingReviewsListAllForListing: { __typename: 'ListingReviewCollection', entries: Array<{ id: string, rating?: number | undefined, body?: string | undefined, authorName?: string | undefined, date?: string | undefined }>, meta: { currentPage?: number | undefined, nextPage?: number | undefined, previousPage?: number | undefined, totalEntries?: number | undefined } } | { __typename: 'NotFoundError', message: string } };

export type ListingFieldsFragment = { id: string, addressLineOne?: string | undefined, addressLineTwo?: string | undefined, cancellationPolicy?: string | undefined, checkIn?: SupportedCheckInAndOutTimes | undefined, checkout?: SupportedCheckInAndOutTimes | undefined, numberOfFloors?: number | undefined, listedFloor?: number | undefined, numberOfRooms?: number | undefined, numberOfBathrooms?: number | undefined, guestCapacity?: number | undefined, propertyType?: PropertyType | undefined, uniquePropertyType?: UniquePropertyType | undefined, hostImageProcessing: boolean, bookDirectWebsiteUrl?: string | undefined, city?: string | undefined, countryOrRegionLongName?: string | undefined, currentBalanceCents: number, description?: string | undefined, facebookPageUrl?: string | undefined, hostBio?: string | undefined, hostDisplayName?: string | undefined, hostImageUrl?: string | undefined, instagramUrl?: string | undefined, instagramUsername?: string | undefined, isFavorited: boolean, firstPublishedAt?: string | undefined, lastPublishedAt?: string | undefined, unpublishedAt?: string | undefined, lat?: number | undefined, lng?: number | undefined, licenseNumber?: string | undefined, locationObfuscated: boolean, locationSetManually: boolean, marketingWebsiteUrl?: string | undefined, name?: string | undefined, pinterestUrl?: string | undefined, pinterestUsername?: string | undefined, placeId?: string | undefined, placeName?: string | undefined, postalCode?: string | undefined, publicEmail?: string | undefined, youtubeUrl?: string | undefined, wNineOnFile: boolean, twitterUrl?: string | undefined, twitterHandle?: string | undefined, stateOrProvinceLongName?: string | undefined, slug: string, minPrice?: number | undefined, maxPrice?: number | undefined, published: boolean, publishIpAddress?: string | undefined, publicPhoneNumber?: string | undefined, listingLevel: SubscriptionType, isDiamondCollection: boolean, featuredByOwner: boolean, account: { id: string, slug: string, avatarUrl?: string | undefined, companyName?: string | undefined }, affiliations: Array<{ id: string, name: string, type: AffiliationType }>, features: Array<{ categoryName: string, displayName: string, key: FeatureKey, legacyKey: string, promoted: boolean }>, galleryAssets: Array<{ description?: string | undefined, id: string, processing: boolean, rawUrl?: string | undefined, position: number, url?: string | undefined }> };

export type OwnerListingFieldsFragment = { id: string, preciseAddressLineOne?: string | undefined, preciseAddressLineTwo?: string | undefined, bookDirectWebsiteUrl?: string | undefined, city?: string | undefined, checkIn?: SupportedCheckInAndOutTimes | undefined, checkout?: SupportedCheckInAndOutTimes | undefined, cancellationPolicy?: string | undefined, numberOfFloors?: number | undefined, licenseNumber?: string | undefined, listedFloor?: number | undefined, numberOfRooms?: number | undefined, numberOfBathrooms?: number | undefined, guestCapacity?: number | undefined, countryOrRegionLongName?: string | undefined, description?: string | undefined, facebookPageUrl?: string | undefined, propertyType?: PropertyType | undefined, uniquePropertyType?: UniquePropertyType | undefined, hostBio?: string | undefined, hostDisplayName?: string | undefined, hostImageProcessing: boolean, hostImageUrl?: string | undefined, instagramUrl?: string | undefined, preciseLat?: number | undefined, preciseLng?: number | undefined, locationObfuscated: boolean, marketingWebsiteUrl?: string | undefined, instagramUsername?: string | undefined, pinterestUsername?: string | undefined, name?: string | undefined, published: boolean, pinterestUrl?: string | undefined, postalCode?: string | undefined, publicEmail?: string | undefined, publicPhoneNumber?: string | undefined, slug: string, stateOrProvinceLongName?: string | undefined, twitterUrl?: string | undefined, twitterHandle?: string | undefined, youtubeUrl?: string | undefined, minPrice?: number | undefined, maxPrice?: number | undefined, listingLevel: SubscriptionType, isDiamondCollection: boolean, featuredByOwner: boolean, galleryAssets: Array<{ id: string, url?: string | undefined, rawUrl?: string | undefined, description?: string | undefined, processing: boolean, position: number }>, features: Array<{ key: FeatureKey, legacyKey: string, displayName: string, promoted: boolean, categoryName: string }>, affiliations: Array<{ id: string, type: AffiliationType, name: string }>, account: { id: string, slug: string, companyName?: string | undefined, avatarUrl?: string | undefined, owner: { id: string }, availableCoupon?: { percentOff?: number | undefined, applicableSubscriptions?: Array<SubscriptionType | undefined> | undefined } | undefined }, policies: Array<{ type: PolicyType, cancellationPolicy: string } | { type: PolicyType, termsLink: string } | { type: PolicyType, cancellationPolicy: string }> };

export type ListingUpdateMutationVariables = Exact<{
  input: ListingUpdateInput;
}>;


export type ListingUpdateMutation = { listingUpdate: { __typename: 'Listing', id: string, preciseAddressLineOne?: string | undefined, preciseAddressLineTwo?: string | undefined, bookDirectWebsiteUrl?: string | undefined, city?: string | undefined, checkIn?: SupportedCheckInAndOutTimes | undefined, checkout?: SupportedCheckInAndOutTimes | undefined, cancellationPolicy?: string | undefined, numberOfFloors?: number | undefined, licenseNumber?: string | undefined, listedFloor?: number | undefined, numberOfRooms?: number | undefined, numberOfBathrooms?: number | undefined, guestCapacity?: number | undefined, countryOrRegionLongName?: string | undefined, description?: string | undefined, facebookPageUrl?: string | undefined, propertyType?: PropertyType | undefined, uniquePropertyType?: UniquePropertyType | undefined, hostBio?: string | undefined, hostDisplayName?: string | undefined, hostImageProcessing: boolean, hostImageUrl?: string | undefined, instagramUrl?: string | undefined, preciseLat?: number | undefined, preciseLng?: number | undefined, locationObfuscated: boolean, marketingWebsiteUrl?: string | undefined, instagramUsername?: string | undefined, pinterestUsername?: string | undefined, name?: string | undefined, published: boolean, pinterestUrl?: string | undefined, postalCode?: string | undefined, publicEmail?: string | undefined, publicPhoneNumber?: string | undefined, slug: string, stateOrProvinceLongName?: string | undefined, twitterUrl?: string | undefined, twitterHandle?: string | undefined, youtubeUrl?: string | undefined, minPrice?: number | undefined, maxPrice?: number | undefined, listingLevel: SubscriptionType, isDiamondCollection: boolean, featuredByOwner: boolean, galleryAssets: Array<{ id: string, url?: string | undefined, rawUrl?: string | undefined, description?: string | undefined, processing: boolean, position: number }>, features: Array<{ key: FeatureKey, legacyKey: string, displayName: string, promoted: boolean, categoryName: string }>, affiliations: Array<{ id: string, type: AffiliationType, name: string }>, account: { id: string, slug: string, companyName?: string | undefined, avatarUrl?: string | undefined, owner: { id: string }, availableCoupon?: { percentOff?: number | undefined, applicableSubscriptions?: Array<SubscriptionType | undefined> | undefined } | undefined }, policies: Array<{ type: PolicyType, cancellationPolicy: string } | { type: PolicyType, termsLink: string } | { type: PolicyType, cancellationPolicy: string }> } | { __typename: 'UnauthenticatedError', message: string } | { __typename: 'ValidationErrorCollection', errors: Array<{ message: string, type?: string | undefined, field?: string | undefined }> } };

export type ListingPublishMutationVariables = Exact<{
  input: ListingPublishInput;
}>;


export type ListingPublishMutation = { listingPublish: { __typename: 'Listing', id: string, preciseAddressLineOne?: string | undefined, preciseAddressLineTwo?: string | undefined, bookDirectWebsiteUrl?: string | undefined, city?: string | undefined, checkIn?: SupportedCheckInAndOutTimes | undefined, checkout?: SupportedCheckInAndOutTimes | undefined, cancellationPolicy?: string | undefined, numberOfFloors?: number | undefined, licenseNumber?: string | undefined, listedFloor?: number | undefined, numberOfRooms?: number | undefined, numberOfBathrooms?: number | undefined, guestCapacity?: number | undefined, countryOrRegionLongName?: string | undefined, description?: string | undefined, facebookPageUrl?: string | undefined, propertyType?: PropertyType | undefined, uniquePropertyType?: UniquePropertyType | undefined, hostBio?: string | undefined, hostDisplayName?: string | undefined, hostImageProcessing: boolean, hostImageUrl?: string | undefined, instagramUrl?: string | undefined, preciseLat?: number | undefined, preciseLng?: number | undefined, locationObfuscated: boolean, marketingWebsiteUrl?: string | undefined, instagramUsername?: string | undefined, pinterestUsername?: string | undefined, name?: string | undefined, published: boolean, pinterestUrl?: string | undefined, postalCode?: string | undefined, publicEmail?: string | undefined, publicPhoneNumber?: string | undefined, slug: string, stateOrProvinceLongName?: string | undefined, twitterUrl?: string | undefined, twitterHandle?: string | undefined, youtubeUrl?: string | undefined, minPrice?: number | undefined, maxPrice?: number | undefined, listingLevel: SubscriptionType, isDiamondCollection: boolean, featuredByOwner: boolean, galleryAssets: Array<{ id: string, url?: string | undefined, rawUrl?: string | undefined, description?: string | undefined, processing: boolean, position: number }>, features: Array<{ key: FeatureKey, legacyKey: string, displayName: string, promoted: boolean, categoryName: string }>, affiliations: Array<{ id: string, type: AffiliationType, name: string }>, account: { id: string, slug: string, companyName?: string | undefined, avatarUrl?: string | undefined, owner: { id: string }, availableCoupon?: { percentOff?: number | undefined, applicableSubscriptions?: Array<SubscriptionType | undefined> | undefined } | undefined }, policies: Array<{ type: PolicyType, cancellationPolicy: string } | { type: PolicyType, termsLink: string } | { type: PolicyType, cancellationPolicy: string }> } | { __typename: 'UnauthenticatedError', message: string } | { __typename: 'ValidationErrorCollection', errors: Array<{ message: string, type?: string | undefined, field?: string | undefined }> } };

export type ListingUnpublishMutationVariables = Exact<{
  listingId: Scalars['ID']['input'];
}>;


export type ListingUnpublishMutation = { listingUnpublish: { __typename: 'Listing', id: string, preciseAddressLineOne?: string | undefined, preciseAddressLineTwo?: string | undefined, bookDirectWebsiteUrl?: string | undefined, city?: string | undefined, checkIn?: SupportedCheckInAndOutTimes | undefined, checkout?: SupportedCheckInAndOutTimes | undefined, cancellationPolicy?: string | undefined, numberOfFloors?: number | undefined, licenseNumber?: string | undefined, listedFloor?: number | undefined, numberOfRooms?: number | undefined, numberOfBathrooms?: number | undefined, guestCapacity?: number | undefined, countryOrRegionLongName?: string | undefined, description?: string | undefined, facebookPageUrl?: string | undefined, propertyType?: PropertyType | undefined, uniquePropertyType?: UniquePropertyType | undefined, hostBio?: string | undefined, hostDisplayName?: string | undefined, hostImageProcessing: boolean, hostImageUrl?: string | undefined, instagramUrl?: string | undefined, preciseLat?: number | undefined, preciseLng?: number | undefined, locationObfuscated: boolean, marketingWebsiteUrl?: string | undefined, instagramUsername?: string | undefined, pinterestUsername?: string | undefined, name?: string | undefined, published: boolean, pinterestUrl?: string | undefined, postalCode?: string | undefined, publicEmail?: string | undefined, publicPhoneNumber?: string | undefined, slug: string, stateOrProvinceLongName?: string | undefined, twitterUrl?: string | undefined, twitterHandle?: string | undefined, youtubeUrl?: string | undefined, minPrice?: number | undefined, maxPrice?: number | undefined, listingLevel: SubscriptionType, isDiamondCollection: boolean, featuredByOwner: boolean, galleryAssets: Array<{ id: string, url?: string | undefined, rawUrl?: string | undefined, description?: string | undefined, processing: boolean, position: number }>, features: Array<{ key: FeatureKey, legacyKey: string, displayName: string, promoted: boolean, categoryName: string }>, affiliations: Array<{ id: string, type: AffiliationType, name: string }>, account: { id: string, slug: string, companyName?: string | undefined, avatarUrl?: string | undefined, owner: { id: string }, availableCoupon?: { percentOff?: number | undefined, applicableSubscriptions?: Array<SubscriptionType | undefined> | undefined } | undefined }, policies: Array<{ type: PolicyType, cancellationPolicy: string } | { type: PolicyType, termsLink: string } | { type: PolicyType, cancellationPolicy: string }> } | { __typename: 'NotFoundError' } | { __typename: 'UnauthenticatedError', message: string } | { __typename: 'ValidationErrorCollection' } };

export type SetSubscriptionMutationVariables = Exact<{
  input: SetSubscriptionInput;
}>;


export type SetSubscriptionMutation = { setSubscription: { __typename: 'Listing', id: string, addressLineOne?: string | undefined, addressLineTwo?: string | undefined, cancellationPolicy?: string | undefined, checkIn?: SupportedCheckInAndOutTimes | undefined, checkout?: SupportedCheckInAndOutTimes | undefined, numberOfFloors?: number | undefined, listedFloor?: number | undefined, numberOfRooms?: number | undefined, numberOfBathrooms?: number | undefined, guestCapacity?: number | undefined, propertyType?: PropertyType | undefined, uniquePropertyType?: UniquePropertyType | undefined, hostImageProcessing: boolean, bookDirectWebsiteUrl?: string | undefined, city?: string | undefined, countryOrRegionLongName?: string | undefined, currentBalanceCents: number, description?: string | undefined, facebookPageUrl?: string | undefined, hostBio?: string | undefined, hostDisplayName?: string | undefined, hostImageUrl?: string | undefined, instagramUrl?: string | undefined, instagramUsername?: string | undefined, isFavorited: boolean, firstPublishedAt?: string | undefined, lastPublishedAt?: string | undefined, unpublishedAt?: string | undefined, lat?: number | undefined, lng?: number | undefined, licenseNumber?: string | undefined, locationObfuscated: boolean, locationSetManually: boolean, marketingWebsiteUrl?: string | undefined, name?: string | undefined, pinterestUrl?: string | undefined, pinterestUsername?: string | undefined, placeId?: string | undefined, placeName?: string | undefined, postalCode?: string | undefined, publicEmail?: string | undefined, youtubeUrl?: string | undefined, wNineOnFile: boolean, twitterUrl?: string | undefined, twitterHandle?: string | undefined, stateOrProvinceLongName?: string | undefined, slug: string, minPrice?: number | undefined, maxPrice?: number | undefined, published: boolean, publishIpAddress?: string | undefined, publicPhoneNumber?: string | undefined, listingLevel: SubscriptionType, isDiamondCollection: boolean, featuredByOwner: boolean, account: { id: string, slug: string, avatarUrl?: string | undefined, companyName?: string | undefined }, affiliations: Array<{ id: string, name: string, type: AffiliationType }>, features: Array<{ categoryName: string, displayName: string, key: FeatureKey, legacyKey: string, promoted: boolean }>, galleryAssets: Array<{ description?: string | undefined, id: string, processing: boolean, rawUrl?: string | undefined, position: number, url?: string | undefined }> } | { __typename: 'NotFoundError', message: string } | { __typename: 'UnauthenticatedError', message: string } | { __typename: 'ValidationErrorCollection', errors: Array<{ message: string, type?: string | undefined, field?: string | undefined }> } };

export type AdminSetSubscriptionMutationVariables = Exact<{
  input: AdminSetSubscriptionInput;
}>;


export type AdminSetSubscriptionMutation = { adminSetSubscription: { __typename: 'Listing', id: string, addressLineOne?: string | undefined, addressLineTwo?: string | undefined, cancellationPolicy?: string | undefined, checkIn?: SupportedCheckInAndOutTimes | undefined, checkout?: SupportedCheckInAndOutTimes | undefined, numberOfFloors?: number | undefined, listedFloor?: number | undefined, numberOfRooms?: number | undefined, numberOfBathrooms?: number | undefined, guestCapacity?: number | undefined, propertyType?: PropertyType | undefined, uniquePropertyType?: UniquePropertyType | undefined, hostImageProcessing: boolean, bookDirectWebsiteUrl?: string | undefined, city?: string | undefined, countryOrRegionLongName?: string | undefined, currentBalanceCents: number, description?: string | undefined, facebookPageUrl?: string | undefined, hostBio?: string | undefined, hostDisplayName?: string | undefined, hostImageUrl?: string | undefined, instagramUrl?: string | undefined, instagramUsername?: string | undefined, isFavorited: boolean, firstPublishedAt?: string | undefined, lastPublishedAt?: string | undefined, unpublishedAt?: string | undefined, lat?: number | undefined, lng?: number | undefined, licenseNumber?: string | undefined, locationObfuscated: boolean, locationSetManually: boolean, marketingWebsiteUrl?: string | undefined, name?: string | undefined, pinterestUrl?: string | undefined, pinterestUsername?: string | undefined, placeId?: string | undefined, placeName?: string | undefined, postalCode?: string | undefined, publicEmail?: string | undefined, youtubeUrl?: string | undefined, wNineOnFile: boolean, twitterUrl?: string | undefined, twitterHandle?: string | undefined, stateOrProvinceLongName?: string | undefined, slug: string, minPrice?: number | undefined, maxPrice?: number | undefined, published: boolean, publishIpAddress?: string | undefined, publicPhoneNumber?: string | undefined, listingLevel: SubscriptionType, isDiamondCollection: boolean, featuredByOwner: boolean, account: { id: string, slug: string, avatarUrl?: string | undefined, companyName?: string | undefined }, affiliations: Array<{ id: string, name: string, type: AffiliationType }>, features: Array<{ categoryName: string, displayName: string, key: FeatureKey, legacyKey: string, promoted: boolean }>, galleryAssets: Array<{ description?: string | undefined, id: string, processing: boolean, rawUrl?: string | undefined, position: number, url?: string | undefined }> } | { __typename: 'NotFoundError', message: string } | { __typename: 'UnauthenticatedError', message: string } | { __typename: 'ValidationErrorCollection', errors: Array<{ message: string, type?: string | undefined, field?: string | undefined }> } };

export type ListingCreateMutationVariables = Exact<{
  input: ListingCreateInput;
}>;


export type ListingCreateMutation = { listingCreate: { __typename: 'Listing', id: string, addressLineOne?: string | undefined, addressLineTwo?: string | undefined, cancellationPolicy?: string | undefined, checkIn?: SupportedCheckInAndOutTimes | undefined, checkout?: SupportedCheckInAndOutTimes | undefined, numberOfFloors?: number | undefined, listedFloor?: number | undefined, numberOfRooms?: number | undefined, numberOfBathrooms?: number | undefined, guestCapacity?: number | undefined, propertyType?: PropertyType | undefined, uniquePropertyType?: UniquePropertyType | undefined, hostImageProcessing: boolean, bookDirectWebsiteUrl?: string | undefined, city?: string | undefined, countryOrRegionLongName?: string | undefined, currentBalanceCents: number, description?: string | undefined, facebookPageUrl?: string | undefined, hostBio?: string | undefined, hostDisplayName?: string | undefined, hostImageUrl?: string | undefined, instagramUrl?: string | undefined, instagramUsername?: string | undefined, isFavorited: boolean, firstPublishedAt?: string | undefined, lastPublishedAt?: string | undefined, unpublishedAt?: string | undefined, lat?: number | undefined, lng?: number | undefined, licenseNumber?: string | undefined, locationObfuscated: boolean, locationSetManually: boolean, marketingWebsiteUrl?: string | undefined, name?: string | undefined, pinterestUrl?: string | undefined, pinterestUsername?: string | undefined, placeId?: string | undefined, placeName?: string | undefined, postalCode?: string | undefined, publicEmail?: string | undefined, youtubeUrl?: string | undefined, wNineOnFile: boolean, twitterUrl?: string | undefined, twitterHandle?: string | undefined, stateOrProvinceLongName?: string | undefined, slug: string, minPrice?: number | undefined, maxPrice?: number | undefined, published: boolean, publishIpAddress?: string | undefined, publicPhoneNumber?: string | undefined, listingLevel: SubscriptionType, isDiamondCollection: boolean, featuredByOwner: boolean, account: { id: string, slug: string, avatarUrl?: string | undefined, companyName?: string | undefined }, affiliations: Array<{ id: string, name: string, type: AffiliationType }>, features: Array<{ categoryName: string, displayName: string, key: FeatureKey, legacyKey: string, promoted: boolean }>, galleryAssets: Array<{ description?: string | undefined, id: string, processing: boolean, rawUrl?: string | undefined, position: number, url?: string | undefined }> } | { __typename: 'UnauthenticatedError', message: string } | { __typename: 'ValidationErrorCollection', errors: Array<{ message: string, type?: string | undefined, field?: string | undefined }> } };

export type ListingFavoriteCreateMutationVariables = Exact<{
  input: ListingFavoriteCreateInput;
}>;


export type ListingFavoriteCreateMutation = { listingFavoriteCreate: { __typename: 'Listing', id: string, addressLineOne?: string | undefined, addressLineTwo?: string | undefined, cancellationPolicy?: string | undefined, checkIn?: SupportedCheckInAndOutTimes | undefined, checkout?: SupportedCheckInAndOutTimes | undefined, numberOfFloors?: number | undefined, listedFloor?: number | undefined, numberOfRooms?: number | undefined, numberOfBathrooms?: number | undefined, guestCapacity?: number | undefined, propertyType?: PropertyType | undefined, uniquePropertyType?: UniquePropertyType | undefined, hostImageProcessing: boolean, bookDirectWebsiteUrl?: string | undefined, city?: string | undefined, countryOrRegionLongName?: string | undefined, currentBalanceCents: number, description?: string | undefined, facebookPageUrl?: string | undefined, hostBio?: string | undefined, hostDisplayName?: string | undefined, hostImageUrl?: string | undefined, instagramUrl?: string | undefined, instagramUsername?: string | undefined, isFavorited: boolean, firstPublishedAt?: string | undefined, lastPublishedAt?: string | undefined, unpublishedAt?: string | undefined, lat?: number | undefined, lng?: number | undefined, licenseNumber?: string | undefined, locationObfuscated: boolean, locationSetManually: boolean, marketingWebsiteUrl?: string | undefined, name?: string | undefined, pinterestUrl?: string | undefined, pinterestUsername?: string | undefined, placeId?: string | undefined, placeName?: string | undefined, postalCode?: string | undefined, publicEmail?: string | undefined, youtubeUrl?: string | undefined, wNineOnFile: boolean, twitterUrl?: string | undefined, twitterHandle?: string | undefined, stateOrProvinceLongName?: string | undefined, slug: string, minPrice?: number | undefined, maxPrice?: number | undefined, published: boolean, publishIpAddress?: string | undefined, publicPhoneNumber?: string | undefined, listingLevel: SubscriptionType, isDiamondCollection: boolean, featuredByOwner: boolean, account: { id: string, slug: string, avatarUrl?: string | undefined, companyName?: string | undefined }, affiliations: Array<{ id: string, name: string, type: AffiliationType }>, features: Array<{ categoryName: string, displayName: string, key: FeatureKey, legacyKey: string, promoted: boolean }>, galleryAssets: Array<{ description?: string | undefined, id: string, processing: boolean, rawUrl?: string | undefined, position: number, url?: string | undefined }> } | { __typename: 'NotFoundError' } | { __typename: 'UnauthenticatedError', message: string } | { __typename: 'ValidationErrorCollection', errors: Array<{ message: string, type?: string | undefined, field?: string | undefined }> } };

export type ListingFavoriteDeleteMutationVariables = Exact<{
  input: ListingFavoriteDeleteInput;
}>;


export type ListingFavoriteDeleteMutation = { listingFavoriteDelete: { __typename: 'Listing', id: string, addressLineOne?: string | undefined, addressLineTwo?: string | undefined, cancellationPolicy?: string | undefined, checkIn?: SupportedCheckInAndOutTimes | undefined, checkout?: SupportedCheckInAndOutTimes | undefined, numberOfFloors?: number | undefined, listedFloor?: number | undefined, numberOfRooms?: number | undefined, numberOfBathrooms?: number | undefined, guestCapacity?: number | undefined, propertyType?: PropertyType | undefined, uniquePropertyType?: UniquePropertyType | undefined, hostImageProcessing: boolean, bookDirectWebsiteUrl?: string | undefined, city?: string | undefined, countryOrRegionLongName?: string | undefined, currentBalanceCents: number, description?: string | undefined, facebookPageUrl?: string | undefined, hostBio?: string | undefined, hostDisplayName?: string | undefined, hostImageUrl?: string | undefined, instagramUrl?: string | undefined, instagramUsername?: string | undefined, isFavorited: boolean, firstPublishedAt?: string | undefined, lastPublishedAt?: string | undefined, unpublishedAt?: string | undefined, lat?: number | undefined, lng?: number | undefined, licenseNumber?: string | undefined, locationObfuscated: boolean, locationSetManually: boolean, marketingWebsiteUrl?: string | undefined, name?: string | undefined, pinterestUrl?: string | undefined, pinterestUsername?: string | undefined, placeId?: string | undefined, placeName?: string | undefined, postalCode?: string | undefined, publicEmail?: string | undefined, youtubeUrl?: string | undefined, wNineOnFile: boolean, twitterUrl?: string | undefined, twitterHandle?: string | undefined, stateOrProvinceLongName?: string | undefined, slug: string, minPrice?: number | undefined, maxPrice?: number | undefined, published: boolean, publishIpAddress?: string | undefined, publicPhoneNumber?: string | undefined, listingLevel: SubscriptionType, isDiamondCollection: boolean, featuredByOwner: boolean, account: { id: string, slug: string, avatarUrl?: string | undefined, companyName?: string | undefined }, affiliations: Array<{ id: string, name: string, type: AffiliationType }>, features: Array<{ categoryName: string, displayName: string, key: FeatureKey, legacyKey: string, promoted: boolean }>, galleryAssets: Array<{ description?: string | undefined, id: string, processing: boolean, rawUrl?: string | undefined, position: number, url?: string | undefined }> } | { __typename: 'NotFoundError' } | { __typename: 'UnauthenticatedError', message: string } | { __typename: 'ValidationErrorCollection' } };

export type ListingToggleFeaturedByOwnerMutationVariables = Exact<{
  listingId: Scalars['ID']['input'];
}>;


export type ListingToggleFeaturedByOwnerMutation = { listingToggleFeaturedByOwner: { __typename: 'Listing', id: string, addressLineOne?: string | undefined, addressLineTwo?: string | undefined, cancellationPolicy?: string | undefined, checkIn?: SupportedCheckInAndOutTimes | undefined, checkout?: SupportedCheckInAndOutTimes | undefined, numberOfFloors?: number | undefined, listedFloor?: number | undefined, numberOfRooms?: number | undefined, numberOfBathrooms?: number | undefined, guestCapacity?: number | undefined, propertyType?: PropertyType | undefined, uniquePropertyType?: UniquePropertyType | undefined, hostImageProcessing: boolean, bookDirectWebsiteUrl?: string | undefined, city?: string | undefined, countryOrRegionLongName?: string | undefined, currentBalanceCents: number, description?: string | undefined, facebookPageUrl?: string | undefined, hostBio?: string | undefined, hostDisplayName?: string | undefined, hostImageUrl?: string | undefined, instagramUrl?: string | undefined, instagramUsername?: string | undefined, isFavorited: boolean, firstPublishedAt?: string | undefined, lastPublishedAt?: string | undefined, unpublishedAt?: string | undefined, lat?: number | undefined, lng?: number | undefined, licenseNumber?: string | undefined, locationObfuscated: boolean, locationSetManually: boolean, marketingWebsiteUrl?: string | undefined, name?: string | undefined, pinterestUrl?: string | undefined, pinterestUsername?: string | undefined, placeId?: string | undefined, placeName?: string | undefined, postalCode?: string | undefined, publicEmail?: string | undefined, youtubeUrl?: string | undefined, wNineOnFile: boolean, twitterUrl?: string | undefined, twitterHandle?: string | undefined, stateOrProvinceLongName?: string | undefined, slug: string, minPrice?: number | undefined, maxPrice?: number | undefined, published: boolean, publishIpAddress?: string | undefined, publicPhoneNumber?: string | undefined, listingLevel: SubscriptionType, isDiamondCollection: boolean, featuredByOwner: boolean, account: { id: string, slug: string, avatarUrl?: string | undefined, companyName?: string | undefined }, affiliations: Array<{ id: string, name: string, type: AffiliationType }>, features: Array<{ categoryName: string, displayName: string, key: FeatureKey, legacyKey: string, promoted: boolean }>, galleryAssets: Array<{ description?: string | undefined, id: string, processing: boolean, rawUrl?: string | undefined, position: number, url?: string | undefined }> } | { __typename: 'UnauthenticatedError', message: string } | { __typename: 'ValidationErrorCollection', errors: Array<{ message: string, type?: string | undefined, field?: string | undefined }> } };

export type AccountCollectionListingsListAllQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
  accountId: Scalars['String']['input'];
  applyFeaturedByOwnerFilter?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<ListingSortOptions>;
  checkInDate?: InputMaybe<Scalars['Date']['input']>;
  checkOutDate?: InputMaybe<Scalars['Date']['input']>;
  featuresFilter?: InputMaybe<Array<FeatureKey> | FeatureKey>;
  minGuestCapacity?: InputMaybe<Scalars['Int']['input']>;
  minNumberOfBathrooms?: InputMaybe<Scalars['Int']['input']>;
  minNumberOfRooms?: InputMaybe<Scalars['Int']['input']>;
  propertyTypes?: InputMaybe<Array<PropertyType> | PropertyType>;
}>;


export type AccountCollectionListingsListAllQuery = { listingsListAllActive: { entries: Array<{ checkIn?: SupportedCheckInAndOutTimes | undefined, checkout?: SupportedCheckInAndOutTimes | undefined, cancellationPolicy?: string | undefined, city?: string | undefined, licenseNumber?: string | undefined, numberOfRooms?: number | undefined, numberOfBathrooms?: number | undefined, guestCapacity?: number | undefined, name?: string | undefined, slug: string, propertyType?: PropertyType | undefined, uniquePropertyType?: UniquePropertyType | undefined, stateOrProvinceLongName?: string | undefined, marketingWebsiteUrl?: string | undefined, bookDirectWebsiteUrl?: string | undefined, description?: string | undefined, minPrice?: number | undefined, maxPrice?: number | undefined, listingLevel: SubscriptionType, isDiamondCollection: boolean, isFavorited: boolean, id: string, searchableAvailability: boolean, featuredByOwner: boolean, galleryAssets: Array<{ id: string, url?: string | undefined }>, features: Array<{ key: FeatureKey, displayName: string, categoryName: string, promoted: boolean }>, account: { id: string, slug: string, companyName?: string | undefined, avatarUrl?: string | undefined } }>, meta: { totalEntries?: number | undefined, totalPages?: number | undefined, nextPage?: number | undefined, previousPage?: number | undefined } } };

export type FeaturedListingsListAllQueryVariables = Exact<{
  page?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
  sort?: InputMaybe<ListingSortOptions>;
  stateOrProvinceLongNameFilter?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type FeaturedListingsListAllQuery = { listingsListAllFeatured: { entries: Array<{ id: string, city?: string | undefined, listedFloor?: number | undefined, numberOfRooms?: number | undefined, numberOfBathrooms?: number | undefined, guestCapacity?: number | undefined, name?: string | undefined, slug: string, propertyType?: PropertyType | undefined, uniquePropertyType?: UniquePropertyType | undefined, stateOrProvinceLongName?: string | undefined, isFavorited: boolean, bookDirectWebsiteUrl?: string | undefined, description?: string | undefined, marketingWebsiteUrl?: string | undefined, minPrice?: number | undefined, maxPrice?: number | undefined, listingLevel: SubscriptionType, isDiamondCollection: boolean, searchableAvailability: boolean, features: Array<{ key: FeatureKey, displayName: string, categoryName: string, promoted: boolean }>, account: { id: string, slug: string, companyName?: string | undefined, avatarUrl?: string | undefined }, galleryAssets: Array<{ id: string, url?: string | undefined, description?: string | undefined }> }>, meta: { totalPages?: number | undefined, nextPage?: number | undefined, previousPage?: number | undefined } } };

export type DiamondCollectionListingsListAllQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
  stateOrProvinceLongNameFilter?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type DiamondCollectionListingsListAllQuery = { listingsListAllActive: { entries: Array<{ id: string, city?: string | undefined, listedFloor?: number | undefined, numberOfRooms?: number | undefined, numberOfBathrooms?: number | undefined, guestCapacity?: number | undefined, name?: string | undefined, slug: string, propertyType?: PropertyType | undefined, uniquePropertyType?: UniquePropertyType | undefined, stateOrProvinceLongName?: string | undefined, isFavorited: boolean, bookDirectWebsiteUrl?: string | undefined, description?: string | undefined, marketingWebsiteUrl?: string | undefined, minPrice?: number | undefined, maxPrice?: number | undefined, listingLevel: SubscriptionType, isDiamondCollection: boolean, searchableAvailability: boolean, features: Array<{ key: FeatureKey, displayName: string, categoryName: string, promoted: boolean }>, account: { id: string, slug: string, companyName?: string | undefined, avatarUrl?: string | undefined }, galleryAssets: Array<{ id: string, url?: string | undefined, description?: string | undefined }> }>, meta: { totalPages?: number | undefined, nextPage?: number | undefined, previousPage?: number | undefined } } };

export type SearchRegionForListingsByPlaceNameWithSingleAssetQueryVariables = Exact<{
  cursorAfter?: InputMaybe<Scalars['String']['input']>;
  cursorBefore?: InputMaybe<Scalars['String']['input']>;
  pageSize?: Scalars['Int']['input'];
  featuresFilter?: InputMaybe<Array<FeatureKey> | FeatureKey>;
  propertyTypes?: InputMaybe<Array<PropertyType> | PropertyType>;
  minGuestCapacity?: InputMaybe<Scalars['Int']['input']>;
  minNumberOfRooms?: InputMaybe<Scalars['Int']['input']>;
  minNumberOfBathrooms?: InputMaybe<Scalars['Int']['input']>;
  accountId?: InputMaybe<Scalars['String']['input']>;
  regionPath?: InputMaybe<Scalars['String']['input']>;
}>;


export type SearchRegionForListingsByPlaceNameWithSingleAssetQuery = { regionListingsCollection: { entries: Array<{ city?: string | undefined, propertyType?: PropertyType | undefined, numberOfRooms?: number | undefined, numberOfBathrooms?: number | undefined, guestCapacity?: number | undefined, name?: string | undefined, slug: string, stateOrProvinceLongName?: string | undefined, marketingWebsiteUrl?: string | undefined, bookDirectWebsiteUrl?: string | undefined, description?: string | undefined, minPrice?: number | undefined, maxPrice?: number | undefined, listingLevel: SubscriptionType, isDiamondCollection: boolean, isFavorited: boolean, id: string, searchableAvailability: boolean, galleryAssets: Array<{ id: string, url?: string | undefined, description?: string | undefined }>, priceDisplay?: { checkInDate: string, checkOutDate: string, baseAmountCents: number, subtotalWithoutTaxesCents?: number | undefined, nights: number } | undefined, account: { slug: string, avatarUrl?: string | undefined, companyName?: string | undefined } }> } };

export type ListingByExternalIdAndSourceQueryVariables = Exact<{
  externalId: Scalars['String']['input'];
  externalSource: ExternalSource;
}>;


export type ListingByExternalIdAndSourceQuery = { listingByExternalIdAndSource: { __typename: 'Listing', slug: string } | { __typename: 'NotFoundError', message: string } };

export type ListingBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type ListingBySlugQuery = { listingBySlug: { __typename: 'Listing', id: string, addressLineOne?: string | undefined, airbnbUrl?: string | undefined, vrboUrl?: string | undefined, bookDirectWebsiteUrl?: string | undefined, bookDirectWebsiteUrlParamsTemplate?: string | undefined, city?: string | undefined, checkIn?: SupportedCheckInAndOutTimes | undefined, checkout?: SupportedCheckInAndOutTimes | undefined, cancellationPolicy?: string | undefined, licenseNumber?: string | undefined, listedFloor?: number | undefined, numberOfFloors?: number | undefined, numberOfRooms?: number | undefined, numberOfBathrooms?: number | undefined, guestCapacity?: number | undefined, propertyType?: PropertyType | undefined, uniquePropertyType?: UniquePropertyType | undefined, description?: string | undefined, facebookPageUrl?: string | undefined, hostBio?: string | undefined, hostDisplayName?: string | undefined, hostImageUrl?: string | undefined, instagramUrl?: string | undefined, lat?: number | undefined, lng?: number | undefined, locationObfuscated: boolean, marketingWebsiteUrl?: string | undefined, name?: string | undefined, published: boolean, pinterestUrl?: string | undefined, postalCode?: string | undefined, publicEmail?: string | undefined, publicPhoneNumber?: string | undefined, slug: string, stateOrProvinceLongName?: string | undefined, twitterUrl?: string | undefined, youtubeUrl?: string | undefined, minPrice?: number | undefined, maxPrice?: number | undefined, listingLevel: SubscriptionType, isDiamondCollection: boolean, isFavorited: boolean, supportsQuotes: boolean, supportsBookings: boolean, searchableAvailability: boolean, reviewsAverageRating?: number | undefined, reviewsCount?: number | undefined, galleryAssets: Array<{ id: string, url?: string | undefined, rawUrl?: string | undefined, description?: string | undefined }>, features: Array<{ key: FeatureKey, legacyKey: string, displayName: string, promoted: boolean, categoryName: string }>, affiliations: Array<{ id: string, type: AffiliationType, name: string }>, account: { id: string, slug: string, companyName?: string | undefined, title?: string | undefined, description?: string | undefined, avatarUrl?: string | undefined, inBusinessSince?: number | undefined, city?: string | undefined, stateOrProvinceLongName?: string | undefined, activeListingsCount: number, marketingWebsiteUrl?: string | undefined, facebookPageUrl?: string | undefined, instagramUrl?: string | undefined, twitterUrl?: string | undefined, phoneNumber?: string | undefined, email?: string | undefined, linkedinUrl?: string | undefined, youtubeUrl?: string | undefined, accountReviewSummaries: Array<{ id: string, source: AccountReviewSummarySource, sourceId: string, numberOfReviews?: number | undefined, imageUrl?: string | undefined, rating: number }> }, policies: Array<{ cancellationPolicy: string } | { termsLink: string } | { cancellationPolicy: string }>, reviews?: Array<{ body?: string | undefined, rating?: number | undefined, authorName?: string | undefined, date?: string | undefined }> | undefined } | { __typename: 'NotFoundError', message: string } | { __typename: 'UnauthenticatedError' } | { __typename: 'UnauthorizedError' } };

export type ListingByIdAndUserQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ListingByIdAndUserQuery = { listingByIdAndUser: { __typename: 'Listing', id: string, preciseAddressLineOne?: string | undefined, preciseAddressLineTwo?: string | undefined, bookDirectWebsiteUrl?: string | undefined, city?: string | undefined, checkIn?: SupportedCheckInAndOutTimes | undefined, checkout?: SupportedCheckInAndOutTimes | undefined, cancellationPolicy?: string | undefined, numberOfFloors?: number | undefined, licenseNumber?: string | undefined, listedFloor?: number | undefined, numberOfRooms?: number | undefined, numberOfBathrooms?: number | undefined, guestCapacity?: number | undefined, countryOrRegionLongName?: string | undefined, description?: string | undefined, facebookPageUrl?: string | undefined, propertyType?: PropertyType | undefined, uniquePropertyType?: UniquePropertyType | undefined, hostBio?: string | undefined, hostDisplayName?: string | undefined, hostImageProcessing: boolean, hostImageUrl?: string | undefined, instagramUrl?: string | undefined, preciseLat?: number | undefined, preciseLng?: number | undefined, locationObfuscated: boolean, marketingWebsiteUrl?: string | undefined, instagramUsername?: string | undefined, pinterestUsername?: string | undefined, name?: string | undefined, published: boolean, pinterestUrl?: string | undefined, postalCode?: string | undefined, publicEmail?: string | undefined, publicPhoneNumber?: string | undefined, slug: string, stateOrProvinceLongName?: string | undefined, twitterUrl?: string | undefined, twitterHandle?: string | undefined, youtubeUrl?: string | undefined, minPrice?: number | undefined, maxPrice?: number | undefined, listingLevel: SubscriptionType, isDiamondCollection: boolean, featuredByOwner: boolean, galleryAssets: Array<{ id: string, url?: string | undefined, rawUrl?: string | undefined, description?: string | undefined, processing: boolean, position: number }>, features: Array<{ key: FeatureKey, legacyKey: string, displayName: string, promoted: boolean, categoryName: string }>, affiliations: Array<{ id: string, type: AffiliationType, name: string }>, account: { id: string, slug: string, companyName?: string | undefined, avatarUrl?: string | undefined, owner: { id: string }, availableCoupon?: { percentOff?: number | undefined, applicableSubscriptions?: Array<SubscriptionType | undefined> | undefined } | undefined }, policies: Array<{ type: PolicyType, cancellationPolicy: string } | { type: PolicyType, termsLink: string } | { type: PolicyType, cancellationPolicy: string }> } | { __typename: 'NotFoundError', message: string } };

export type AccountListingsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
}>;


export type AccountListingsQuery = { accountListings: { __typename: 'ListingCollection', entries: Array<{ id: string, addressLineOne?: string | undefined, addressLineTwo?: string | undefined, cancellationPolicy?: string | undefined, checkIn?: SupportedCheckInAndOutTimes | undefined, checkout?: SupportedCheckInAndOutTimes | undefined, numberOfFloors?: number | undefined, listedFloor?: number | undefined, numberOfRooms?: number | undefined, numberOfBathrooms?: number | undefined, guestCapacity?: number | undefined, propertyType?: PropertyType | undefined, uniquePropertyType?: UniquePropertyType | undefined, hostImageProcessing: boolean, bookDirectWebsiteUrl?: string | undefined, city?: string | undefined, countryOrRegionLongName?: string | undefined, currentBalanceCents: number, description?: string | undefined, facebookPageUrl?: string | undefined, hostBio?: string | undefined, hostDisplayName?: string | undefined, hostImageUrl?: string | undefined, instagramUrl?: string | undefined, instagramUsername?: string | undefined, isFavorited: boolean, firstPublishedAt?: string | undefined, lastPublishedAt?: string | undefined, unpublishedAt?: string | undefined, lat?: number | undefined, lng?: number | undefined, licenseNumber?: string | undefined, locationObfuscated: boolean, locationSetManually: boolean, marketingWebsiteUrl?: string | undefined, name?: string | undefined, pinterestUrl?: string | undefined, pinterestUsername?: string | undefined, placeId?: string | undefined, placeName?: string | undefined, postalCode?: string | undefined, publicEmail?: string | undefined, youtubeUrl?: string | undefined, wNineOnFile: boolean, twitterUrl?: string | undefined, twitterHandle?: string | undefined, stateOrProvinceLongName?: string | undefined, slug: string, minPrice?: number | undefined, maxPrice?: number | undefined, published: boolean, publishIpAddress?: string | undefined, publicPhoneNumber?: string | undefined, listingLevel: SubscriptionType, isDiamondCollection: boolean, featuredByOwner: boolean, account: { id: string, slug: string, avatarUrl?: string | undefined, companyName?: string | undefined }, affiliations: Array<{ id: string, name: string, type: AffiliationType }>, features: Array<{ categoryName: string, displayName: string, key: FeatureKey, legacyKey: string, promoted: boolean }>, galleryAssets: Array<{ description?: string | undefined, id: string, processing: boolean, rawUrl?: string | undefined, position: number, url?: string | undefined }> }>, meta: { nextPage?: number | undefined, previousPage?: number | undefined, currentPage?: number | undefined, totalEntries?: number | undefined, totalPages?: number | undefined } } | { __typename: 'UnauthenticatedError', message: string } };

export type ListingsListAllFavoritedQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort: ListingFavoriteSortOptions;
}>;


export type ListingsListAllFavoritedQuery = { listingsListAllFavorited: { __typename: 'ListingCollection', entries: Array<{ lat?: number | undefined, lng?: number | undefined, locationObfuscated: boolean, city?: string | undefined, propertyType?: PropertyType | undefined, numberOfRooms?: number | undefined, numberOfBathrooms?: number | undefined, guestCapacity?: number | undefined, name?: string | undefined, slug: string, stateOrProvinceLongName?: string | undefined, marketingWebsiteUrl?: string | undefined, bookDirectWebsiteUrl?: string | undefined, description?: string | undefined, minPrice?: number | undefined, maxPrice?: number | undefined, listingLevel: SubscriptionType, isDiamondCollection: boolean, isFavorited: boolean, id: string, searchableAvailability: boolean, account: { id: string, slug: string, avatarUrl?: string | undefined, companyName?: string | undefined }, galleryAssets: Array<{ id: string, url?: string | undefined }> }>, meta: { nextPage?: number | undefined, previousPage?: number | undefined, currentPage?: number | undefined, totalEntries?: number | undefined, totalPages?: number | undefined } } | { __typename: 'UnauthenticatedError', message: string } };

export type ListingsSearchQueryVariables = Exact<{
  accountId?: InputMaybe<Scalars['String']['input']>;
  centerLat?: InputMaybe<Scalars['Float']['input']>;
  centerLng?: InputMaybe<Scalars['Float']['input']>;
  features?: InputMaybe<Array<FeatureKey> | FeatureKey>;
  propertyTypes?: InputMaybe<Array<PropertyType> | PropertyType>;
  uniquePropertyTypes?: InputMaybe<Array<InputMaybe<UniquePropertyType>> | InputMaybe<UniquePropertyType>>;
  minGuestCapacity?: InputMaybe<Scalars['Int']['input']>;
  minNumberOfRooms?: InputMaybe<Scalars['Int']['input']>;
  minNumberOfBathrooms?: InputMaybe<Scalars['Int']['input']>;
  minPriceCents?: InputMaybe<Scalars['Int']['input']>;
  maxPriceCents?: InputMaybe<Scalars['Int']['input']>;
  northEastLat?: InputMaybe<Scalars['Float']['input']>;
  northEastLng?: InputMaybe<Scalars['Float']['input']>;
  cursorAfter?: InputMaybe<Scalars['String']['input']>;
  cursorBefore?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  placeId?: InputMaybe<Scalars['String']['input']>;
  searchType: ListingsSearchType;
  southWestLat?: InputMaybe<Scalars['Float']['input']>;
  southWestLng?: InputMaybe<Scalars['Float']['input']>;
  checkInDate?: InputMaybe<Scalars['Date']['input']>;
  checkOutDate?: InputMaybe<Scalars['Date']['input']>;
  petCount?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ListingsSearchQuery = { listingsSearch: { __typename: 'ListingSearchCursorCollection', entries: Array<{ lat?: number | undefined, lng?: number | undefined, locationObfuscated: boolean, city?: string | undefined, propertyType?: PropertyType | undefined, uniquePropertyType?: UniquePropertyType | undefined, numberOfRooms?: number | undefined, numberOfBathrooms?: number | undefined, guestCapacity?: number | undefined, name?: string | undefined, slug: string, stateOrProvinceLongName?: string | undefined, marketingWebsiteUrl?: string | undefined, bookDirectWebsiteUrl?: string | undefined, description?: string | undefined, minPrice?: number | undefined, maxPrice?: number | undefined, searchPromotionType?: SearchPromotionType | undefined, listingLevel: SubscriptionType, isDiamondCollection: boolean, isFavorited: boolean, id: string, searchableAvailability: boolean, reviewsAverageRating?: number | undefined, reviewsCount?: number | undefined, account: { id: string, slug: string, avatarUrl?: string | undefined, companyName?: string | undefined }, priceDisplay?: { checkInDate: string, checkOutDate: string, baseAmountCents: number, subtotalWithoutTaxesCents?: number | undefined, nights: number } | undefined, features: Array<{ key: FeatureKey, categoryName: string, displayName: string, promoted: boolean }>, galleryAssets: Array<{ id: string, url?: string | undefined }> }>, metadata: { cursorAfter?: string | undefined, cursorBefore?: string | undefined, totalCount?: number | undefined }, searchPlace?: { name?: string | undefined, placeType?: string | undefined, geometry?: { centerPoint?: { lat: number, lng: number } | undefined, northEastPoint?: { lat: number, lng: number } | undefined, southWestPoint?: { lat: number, lng: number } | undefined } | undefined } | undefined } | { __typename: 'ValidationErrorCollection', errors: Array<{ field?: string | undefined, message: string, type?: string | undefined }> } };

export type AdminListingsListAllForAccountQueryVariables = Exact<{
  accountId: Scalars['String']['input'];
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  placeId?: InputMaybe<Scalars['String']['input']>;
  stateOrProvinceLongNameFilter?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  sort?: InputMaybe<AccountListingSortOptions>;
  page: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
}>;


export type AdminListingsListAllForAccountQuery = { adminListingsListAllForAccount: { __typename: 'ListingCollection', entries: Array<{ id: string, addressLineOne?: string | undefined, addressLineTwo?: string | undefined, archived: boolean, bookDirectWebsiteUrl?: string | undefined, city?: string | undefined, countryOrRegionLongName?: string | undefined, currentBalanceCents: number, description?: string | undefined, distanceFromSearchPoint?: number | undefined, facebookPageUrl?: string | undefined, hostBio?: string | undefined, hostDisplayName?: string | undefined, hostImageUrl?: string | undefined, instagramUrl?: string | undefined, instagramUsername?: string | undefined, firstPublishedAt?: string | undefined, lat?: number | undefined, lng?: number | undefined, locationSetManually: boolean, marketingWebsiteUrl?: string | undefined, name?: string | undefined, pinterestUrl?: string | undefined, pinterestUsername?: string | undefined, placeId?: string | undefined, placeName?: string | undefined, postalCode?: string | undefined, publicEmail?: string | undefined, youtubeUrl?: string | undefined, wNineOnFile: boolean, twitterUrl?: string | undefined, twitterHandle?: string | undefined, stateOrProvinceLongName?: string | undefined, slug: string, published: boolean, publishIpAddress?: string | undefined, publicPhoneNumber?: string | undefined, listingLevel: SubscriptionType, isDiamondCollection: boolean, insertedAt?: string | undefined, propertyType?: PropertyType | undefined, isFavorited: boolean, affiliations: Array<{ id: string, name: string, type: AffiliationType }>, features: Array<{ categoryName: string, displayName: string, key: FeatureKey, legacyKey: string, promoted: boolean }>, galleryAssets: Array<{ description?: string | undefined, id: string, processing: boolean, rawUrl?: string | undefined, thumbUrl?: string | undefined, url?: string | undefined }> }>, meta: { currentPage?: number | undefined, nextPage?: number | undefined, totalPages?: number | undefined, previousPage?: number | undefined, totalEntries?: number | undefined } } | { __typename: 'UnauthenticatedError', message: string } };

export type SubscribeEmailToNewsletterMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type SubscribeEmailToNewsletterMutation = { subscribeEmailToNewsletter: { __typename: 'NewsletterSubscription', email: string } | { __typename: 'ServiceUnavailableError' } | { __typename: 'ValidationErrorCollection', errors: Array<{ field?: string | undefined, message: string, type?: string | undefined }> } };

export type UserAddReferralCodeMutationVariables = Exact<{
  referralCode: Scalars['String']['input'];
}>;


export type UserAddReferralCodeMutation = { userAddReferralCode: { message: string } | { id: string, email: string, firstName?: string | undefined, lastName?: string | undefined } | { errors: Array<{ field?: string | undefined, message: string }> } };

export type OrderLoadMutationVariables = Exact<{
  input: OrderLoadInput;
}>;


export type OrderLoadMutation = { orderLoad: { __typename: 'NotFoundError', message: string } | { __typename: 'Order', id: string, quote: { checkInDate?: string | undefined, checkOutDate?: string | undefined, listingId?: string | undefined, numberOfAdults?: number | undefined, numberOfChildren?: number | undefined, numberOfInfants?: number | undefined, numberOfPets?: number | undefined, totalCostCents?: number | undefined, totalWithoutTaxesCents?: number | undefined, totalRecoverableCostCents?: number | undefined, quoteItems: Array<{ costCents: number, type: QuoteItemizedType, description: string }>, paymentSchedule: Array<{ dueDate: string, amountCents: number, description?: string | undefined, paymentItemType: PaymentItemType }> } } | { __typename: 'OrderUnavailable', message: string } | { __typename: 'OrderUnsupported', message: string } | { __typename: 'UnauthenticatedError', message: string } | { __typename: 'ValidationError', message: string } };

export type SendPasswordResetEmailMutationVariables = Exact<{
  input: SendPasswordResetEmailInput;
}>;


export type SendPasswordResetEmailMutation = { sendPasswordResetEmail: { __typename: 'NotFoundError', message: string } | { __typename: 'PasswordResetMessage', message: string } };

export type ResetPasswordForTokenMutationVariables = Exact<{
  input: ResetPasswordForTokenInput;
}>;


export type ResetPasswordForTokenMutation = { resetPasswordForToken: { __typename: 'NotFoundError', message: string } | { __typename: 'PasswordResetMessage', message: string } | { __typename: 'ValidationErrorCollection', errors: Array<{ message: string, field?: string | undefined, type?: string | undefined }> } };

export type ResetPasswordMutationVariables = Exact<{
  input: ResetPasswordInput;
}>;


export type ResetPasswordMutation = { resetPassword: { __typename: 'PasswordResetMessage', message: string } | { __typename: 'UnauthenticatedError' } | { __typename: 'ValidationErrorCollection', errors: Array<{ message: string, field?: string | undefined, type?: string | undefined }> } };

export type PlacesAutocompleteQueryVariables = Exact<{
  query: Scalars['String']['input'];
  type: PlaceTypeFilter;
}>;


export type PlacesAutocompleteQuery = { placesAutocomplete: Array<{ id: string, name: string }> };

export type PlaceFindByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PlaceFindByIdQuery = { placeById: { __typename: 'NotFoundError', message: string } | { __typename: 'Place', addressLineOne?: string | undefined, addressLineTwo?: string | undefined, city?: string | undefined, countryOrRegionLongName?: string | undefined, countryOrRegionShortName?: string | undefined, id: string, name: string, postalCode?: string | undefined, ratingValue?: number | undefined, ratingValueMax?: number | undefined, rawTypes?: Array<string> | undefined, stateOrProvinceLongName?: string | undefined, stateOrProvinceShortName?: string | undefined, geometry?: { centerPoint?: { lat: number, lng: number } | undefined, northEastPoint?: { lat: number, lng: number } | undefined, southWestPoint?: { lat: number, lng: number } | undefined } | undefined, rawAddressComponents?: Array<{ longName: string, shortName: string, types: Array<string> }> | undefined } };

export type PlansListAllQueryVariables = Exact<{ [key: string]: never; }>;


export type PlansListAllQuery = { plansListAll: { __typename: 'PlanCollection', entries: Array<{ id: string, name: string, amount: number }> } | { __typename: 'ServiceUnavailableError' } | { __typename: 'UnauthenticatedError' } };

export type PmsConnectionFieldsFragment = { id: string, type: PmsName, failed: boolean, supportsBookings: boolean };

export type GuestyPmsConnectionCreateMutationVariables = Exact<{
  input: GuestyPmsConnectionCreateInput;
}>;


export type GuestyPmsConnectionCreateMutation = { guestyPmsConnectionCreate: { __typename: 'PmsConnection', id: string, type: PmsName, failed: boolean, supportsBookings: boolean } | { __typename: 'UnauthenticatedError' } | { __typename: 'ValidationErrorCollection', errors: Array<{ field?: string | undefined, message: string, type?: string | undefined }> } };

export type HostawayPmsConnectionCreateMutationVariables = Exact<{
  input: HostawayPmsConnectionCreateInput;
}>;


export type HostawayPmsConnectionCreateMutation = { hostawayPmsConnectionCreate: { __typename: 'PmsConnection', id: string, type: PmsName, failed: boolean, supportsBookings: boolean } | { __typename: 'UnauthenticatedError' } | { __typename: 'ValidationErrorCollection', errors: Array<{ field?: string | undefined, message: string, type?: string | undefined }> } };

export type LodgifyPmsConnectionCreateMutationVariables = Exact<{
  input: LodgifyPmsConnectionCreateInput;
}>;


export type LodgifyPmsConnectionCreateMutation = { lodgifyPmsConnectionCreate: { __typename: 'PmsConnection', id: string, type: PmsName, failed: boolean, supportsBookings: boolean } | { __typename: 'UnauthenticatedError' } | { __typename: 'ValidationErrorCollection', errors: Array<{ field?: string | undefined, message: string, type?: string | undefined }> } };

export type HostfullyPmsConnectionCreateMutationVariables = Exact<{
  input: HostfullyPmsConnectionCreateInput;
}>;


export type HostfullyPmsConnectionCreateMutation = { hostfullyPmsConnectionCreate: { __typename: 'PmsConnection', id: string, type: PmsName, failed: boolean, supportsBookings: boolean } | { __typename: 'UnauthenticatedError' } | { __typename: 'ValidationErrorCollection', errors: Array<{ field?: string | undefined, message: string, type?: string | undefined }> } };

export type OwnerRezPmsConnectionCreateMutationVariables = Exact<{
  input: OwnerRezPmsConnectionCreateInput;
}>;


export type OwnerRezPmsConnectionCreateMutation = { ownerRezPmsConnectionCreate: { __typename: 'PmsConnection', id: string, type: PmsName, failed: boolean, supportsBookings: boolean } | { __typename: 'UnauthenticatedError' } | { __typename: 'ValidationErrorCollection', errors: Array<{ field?: string | undefined, message: string, type?: string | undefined }> } };

export type DemoPmsConnectionCreateMutationVariables = Exact<{
  input: DemoPmsConnectionCreateInput;
}>;


export type DemoPmsConnectionCreateMutation = { demoPmsConnectionCreate: { __typename: 'PmsConnection', id: string, type: PmsName, failed: boolean, supportsBookings: boolean } | { __typename: 'UnauthenticatedError' } | { __typename: 'ValidationErrorCollection', errors: Array<{ field?: string | undefined, message: string, type?: string | undefined }> } };

export type BooksterPmsConnectionCreateMutationVariables = Exact<{
  input: BooksterPmsConnectionCreateInput;
}>;


export type BooksterPmsConnectionCreateMutation = { booksterPmsConnectionCreate: { __typename: 'PmsConnection', id: string, type: PmsName, failed: boolean, supportsBookings: boolean } | { __typename: 'UnauthenticatedError' } | { __typename: 'ValidationErrorCollection', errors: Array<{ field?: string | undefined, message: string, type?: string | undefined }> } };

export type LodgixPmsConnectionCreateMutationVariables = Exact<{
  input: LodgixPmsConnectionCreateInput;
}>;


export type LodgixPmsConnectionCreateMutation = { lodgixPmsConnectionCreate: { __typename: 'PmsConnection', id: string, type: PmsName, failed: boolean, supportsBookings: boolean } | { __typename: 'UnauthenticatedError' } | { __typename: 'ValidationErrorCollection', errors: Array<{ field?: string | undefined, message: string, type?: string | undefined }> } };

export type StreamlinePartnerPmsConnectionCreateMutationVariables = Exact<{
  input: StreamlinePartnerPmsConnectionCreateInput;
}>;


export type StreamlinePartnerPmsConnectionCreateMutation = { streamlinePartnerPmsConnectionCreate: { __typename: 'PmsConnection', id: string, type: PmsName, failed: boolean, supportsBookings: boolean } | { __typename: 'UnauthenticatedError' } | { __typename: 'ValidationErrorCollection', errors: Array<{ field?: string | undefined, message: string, type?: string | undefined }> } };

export type EscapiaPmsConnectionCreateMutationVariables = Exact<{
  input: EscapiaPmsConnectionCreateInput;
}>;


export type EscapiaPmsConnectionCreateMutation = { escapiaPmsConnectionCreate: { __typename: 'PmsConnection', id: string, type: PmsName, failed: boolean, supportsBookings: boolean } | { __typename: 'UnauthenticatedError' } | { __typename: 'ValidationErrorCollection', errors: Array<{ field?: string | undefined, message: string, type?: string | undefined }> } };

export type BarefootPmsConnectionCreateMutationVariables = Exact<{
  input: BarefootPmsConnectionCreateInput;
}>;


export type BarefootPmsConnectionCreateMutation = { barefootPmsConnectionCreate: { __typename: 'PmsConnection', id: string, type: PmsName, failed: boolean, supportsBookings: boolean } | { __typename: 'UnauthenticatedError' } | { __typename: 'ValidationErrorCollection', errors: Array<{ field?: string | undefined, message: string, type?: string | undefined }> } };

export type TrackPmsConnectionCreateMutationVariables = Exact<{
  input: TrackPmsConnectionCreateInput;
}>;


export type TrackPmsConnectionCreateMutation = { trackPmsConnectionCreate: { __typename: 'PmsConnection', id: string, type: PmsName, failed: boolean, supportsBookings: boolean } | { __typename: 'UnauthenticatedError' } | { __typename: 'ValidationErrorCollection', errors: Array<{ field?: string | undefined, message: string, type?: string | undefined }> } };

export type RentalsUnitedPmsConnectionCreateMutationVariables = Exact<{
  input: RentalsUnitedPmsConnectionCreateInput;
}>;


export type RentalsUnitedPmsConnectionCreateMutation = { rentalsUnitedPmsConnectionCreate: { __typename: 'PmsConnection', id: string, type: PmsName, failed: boolean, supportsBookings: boolean } | { __typename: 'UnauthenticatedError' } | { __typename: 'ValidationErrorCollection', errors: Array<{ field?: string | undefined, message: string, type?: string | undefined }> } };

export type NextPaxPmsConnectionCreateMutationVariables = Exact<{
  input: NextPaxPmsConnectionCreateInput;
}>;


export type NextPaxPmsConnectionCreateMutation = { nextPaxPmsConnectionCreate: { __typename: 'PmsConnection', id: string, type: PmsName, failed: boolean, supportsBookings: boolean } | { __typename: 'UnauthenticatedError' } | { __typename: 'ValidationErrorCollection', errors: Array<{ field?: string | undefined, message: string, type?: string | undefined }> } };

export type CiirusPmsConnectionCreateMutationVariables = Exact<{
  input: CiirusPmsConnectionCreateInput;
}>;


export type CiirusPmsConnectionCreateMutation = { ciirusPmsConnectionCreate: { __typename: 'PmsConnection', id: string, type: PmsName, failed: boolean, supportsBookings: boolean } | { __typename: 'UnauthenticatedError' } | { __typename: 'ValidationErrorCollection', errors: Array<{ field?: string | undefined, message: string, type?: string | undefined }> } };

export type BoostPmsConnectionCreateMutationVariables = Exact<{
  input: BoostPmsConnectionCreateInput;
}>;


export type BoostPmsConnectionCreateMutation = { boostPmsConnectionCreate: { __typename: 'PmsConnection', id: string, type: PmsName, failed: boolean, supportsBookings: boolean } | { __typename: 'UnauthenticatedError' } | { __typename: 'ValidationErrorCollection', errors: Array<{ field?: string | undefined, message: string, type?: string | undefined }> } };

export type LiveListPmsConnectionCreateMutationVariables = Exact<{
  input: LiveListPmsConnectionCreateInput;
}>;


export type LiveListPmsConnectionCreateMutation = { liveListPmsConnectionCreate: { __typename: 'PmsConnection', id: string, type: PmsName, failed: boolean, supportsBookings: boolean } | { __typename: 'UnauthenticatedError' } | { __typename: 'ValidationErrorCollection', errors: Array<{ field?: string | undefined, message: string, type?: string | undefined }> } };

export type VacayHomePmsConnectionCreateMutationVariables = Exact<{
  input: VacayHomePmsConnectionCreateInput;
}>;


export type VacayHomePmsConnectionCreateMutation = { vacayHomePmsConnectionCreate: { __typename: 'PmsConnection', id: string, type: PmsName, failed: boolean, supportsBookings: boolean } | { __typename: 'UnauthenticatedError' } | { __typename: 'ValidationErrorCollection', errors: Array<{ field?: string | undefined, message: string, type?: string | undefined }> } };

export type PmsConnectionForCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type PmsConnectionForCurrentUserQuery = { pmsConnectionForCurrentUser: { __typename: 'NotFoundError', message: string } | { __typename: 'PmsConnection', id: string, type: PmsName, failed: boolean, supportsBookings: boolean } | { __typename: 'UnauthenticatedError', message: string } };

export type PmsIntegrationListAllQueryVariables = Exact<{ [key: string]: never; }>;


export type PmsIntegrationListAllQuery = { pmsIntegrationListAll: Array<{ name: string, docsUrl: string, jiraTicketUrl: string, authType: string, status: PmsIntegrationStatus, contentSync?: string | undefined, availabilitySync?: string | undefined, ratesSync?: string | undefined, supportsPricing?: boolean | undefined, supportsBookings?: boolean | undefined, supportsReviews?: boolean | undefined, supportedFields: Array<{ fieldName: FieldNames, description?: string | undefined, supported: PmsIntegrationFieldSupported }>, fields: Array<{ fieldName: FieldNames, description?: string | undefined, supported: PmsIntegrationFieldSupported }> }> };

export type PolicyUpsertAccountTermsAndConditionsMutationVariables = Exact<{
  input: PolicyUpsertAccountTermsAndConditionsInput;
}>;


export type PolicyUpsertAccountTermsAndConditionsMutation = { policyUpsertAccountTermsAndConditions: { __typename: 'AccountTermsAndConditions', id: string, type: PolicyType, termsLink: string } | { __typename: 'NotFoundError', message: string } | { __typename: 'UnauthenticatedError', message: string } | { __typename: 'ValidationErrorCollection', errors: Array<{ message: string, type?: string | undefined, field?: string | undefined }> } };

export type PolicyUpsertAccountCancellationPolicyMutationVariables = Exact<{
  input: PolicyUpsertAccountCancellationPolicyInput;
}>;


export type PolicyUpsertAccountCancellationPolicyMutation = { policyUpsertAccountCancellationPolicy: { __typename: 'AccountCancellationPolicy', id: string, type: PolicyType, cancellationPolicy: string } | { __typename: 'NotFoundError', message: string } | { __typename: 'UnauthenticatedError', message: string } | { __typename: 'ValidationErrorCollection', errors: Array<{ message: string, type?: string | undefined, field?: string | undefined }> } };

export type PolicyUpsertListingCancellationPolicyMutationVariables = Exact<{
  input: PolicyUpsertListingCancellationPolicyInput;
}>;


export type PolicyUpsertListingCancellationPolicyMutation = { policyUpsertListingCancellationPolicy: { __typename: 'ListingCancellationPolicy', type: PolicyType, cancellationPolicy: string } | { __typename: 'NotFoundError', message: string } | { __typename: 'UnauthenticatedError', message: string } | { __typename: 'ValidationErrorCollection', errors: Array<{ message: string, type?: string | undefined, field?: string | undefined }> } };

export type RegionsListAllWithActiveSearchPageContentsQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  searchType: SearchPageContentType;
}>;


export type RegionsListAllWithActiveSearchPageContentsQuery = { regionsListAllWithActiveSearchPageContents: { entries: Array<{ id: string, countrySlug?: string | undefined, levelOneSlug?: string | undefined, citySlug?: string | undefined, slug: string, name: string }>, meta: { nextPage?: number | undefined, previousPage?: number | undefined, totalPages?: number | undefined } } };

export type RegionsListAllFeaturedQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
}>;


export type RegionsListAllFeaturedQuery = { regionsListAllFeatured: { __typename: 'RegionCollection', entries: Array<{ id: string, name: string, imageUrl?: string | undefined, placeId: string }>, meta: { currentPage?: number | undefined, totalEntries?: number | undefined, nextPage?: number | undefined, previousPage?: number | undefined } } };

export type CreateReservationMutationVariables = Exact<{
  input: CreateReservationInput;
}>;


export type CreateReservationMutation = { createReservation: { __typename: 'NotFoundError', message: string } | { __typename: 'Reservation', startDate: string, endDate: string, status: ReservationStatuses, id: string, externalReservationId: string } | { __typename: 'UnauthenticatedError' } | { __typename: 'ValidationErrorCollection', errors: Array<{ type?: string | undefined, field?: string | undefined, message: string }> } };

export type CancelReservationMutationVariables = Exact<{
  input: CancelReservationInput;
}>;


export type CancelReservationMutation = { cancelReservation: { __typename: 'NotFoundError', message: string } | { __typename: 'Reservation', startDate: string, endDate: string, status: ReservationStatuses, id: string, externalReservationId: string } | { __typename: 'UnauthenticatedError' } | { __typename: 'ValidationErrorCollection', errors: Array<{ type?: string | undefined, field?: string | undefined, message: string }> } };

export type FreePromoCreateReservationMutationVariables = Exact<{
  input: FreePromoCreateReservationInput;
}>;


export type FreePromoCreateReservationMutation = { freePromoCreateReservation: { __typename: 'InvalidPromoCodeError' } | { __typename: 'NotFoundError', message: string } | { __typename: 'Reservation', startDate: string, endDate: string, status: ReservationStatuses, id: string, externalReservationId: string } | { __typename: 'UnauthenticatedError' } | { __typename: 'ValidationErrorCollection', errors: Array<{ type?: string | undefined, field?: string | undefined, message: string }> } };

export type ReservationByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ReservationByIdQuery = { reservationById: { __typename: 'NotFoundError', message: string } | { __typename: 'Reservation', id: string, totalCostCents?: number | undefined, startDate: string, endDate: string, status: ReservationStatuses, externalReservationId: string, numberOfAdults?: number | undefined, numberOfChildren?: number | undefined, numberOfInfants?: number | undefined, numberOfPets?: number | undefined, cancellationPolicy?: string | undefined, supportsCancellations: boolean, paymentSchedule: Array<{ dueDate: string, amountCents: number, description?: string | undefined, paymentItemType: PaymentItemType }>, listing: { bookDirectWebsiteUrl?: string | undefined, city?: string | undefined, description?: string | undefined, marketingWebsiteUrl?: string | undefined, name?: string | undefined, slug: string, stateOrProvinceLongName?: string | undefined, guestCapacity?: number | undefined, numberOfRooms?: number | undefined, numberOfBathrooms?: number | undefined, lat?: number | undefined, lng?: number | undefined, minPrice?: number | undefined, maxPrice?: number | undefined, propertyType?: PropertyType | undefined, uniquePropertyType?: UniquePropertyType | undefined, id: string, isFavorited: boolean, listingLevel: SubscriptionType, searchableAvailability: boolean, isDiamondCollection: boolean, addressLineOne?: string | undefined, cancellationPolicy?: string | undefined, publicPhoneNumber?: string | undefined, features: Array<{ key: FeatureKey, displayName: string, categoryName: string, promoted: boolean }>, account: { id: string, slug: string, companyName?: string | undefined, avatarUrl?: string | undefined, description?: string | undefined, email?: string | undefined, marketingWebsiteUrl?: string | undefined, phoneNumber?: string | undefined }, galleryAssets: Array<{ id: string, url?: string | undefined, description?: string | undefined }> } } };

export type ReservationsListAllForCurrentUserQueryVariables = Exact<{
  statusFilter?: InputMaybe<Array<InputMaybe<ReservationStatuses>> | InputMaybe<ReservationStatuses>>;
  page: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
}>;


export type ReservationsListAllForCurrentUserQuery = { reservationsListAllForUser: { __typename: 'ReservationCollection', entries: Array<{ id: string, totalCostCents?: number | undefined, startDate: string, endDate: string, status: ReservationStatuses, listing: { bookDirectWebsiteUrl?: string | undefined, city?: string | undefined, description?: string | undefined, marketingWebsiteUrl?: string | undefined, name?: string | undefined, slug: string, stateOrProvinceLongName?: string | undefined, guestCapacity?: number | undefined, numberOfRooms?: number | undefined, numberOfBathrooms?: number | undefined, lat?: number | undefined, lng?: number | undefined, minPrice?: number | undefined, maxPrice?: number | undefined, propertyType?: PropertyType | undefined, id: string, isFavorited: boolean, listingLevel: SubscriptionType, searchableAvailability: boolean, isDiamondCollection: boolean, addressLineOne?: string | undefined, cancellationPolicy?: string | undefined, features: Array<{ key: FeatureKey, displayName: string, categoryName: string, promoted: boolean }>, account: { id: string, slug: string, companyName?: string | undefined, avatarUrl?: string | undefined }, galleryAssets: Array<{ id: string, url?: string | undefined, description?: string | undefined }> } }>, meta: { currentPage?: number | undefined, nextPage?: number | undefined, totalPages?: number | undefined, previousPage?: number | undefined, totalEntries?: number | undefined } } | { __typename: 'UnauthenticatedError', message: string } };

export type SearchPageContentsListAllQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  h1Query?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<SearchPageContentType>;
}>;


export type SearchPageContentsListAllQuery = { searchPageContentListAll: { entries: Array<{ active: boolean, searchType: SearchPageContentType, h1: string, h1ParagraphRaw?: string | undefined, h2?: string | undefined, h2ParagraphRaw?: string | undefined, heroImageHtmlAlt?: string | undefined, heroImageProcessing: boolean, heroImageUploadUrl?: string | undefined, heroImageUrl: string, htmlMetaDescription?: string | undefined, htmlMetaTitle?: string | undefined, id: string, updatedAt: string }>, meta: { previousPage?: number | undefined, nextPage?: number | undefined, totalEntries?: number | undefined, currentPage?: number | undefined } } };

export type SearchPageContentForUrlPathAndTypeQueryVariables = Exact<{
  urlPath: Scalars['String']['input'];
  searchType: SearchPageContentType;
}>;


export type SearchPageContentForUrlPathAndTypeQuery = { searchPageContentForUrlPathAndType: { __typename: 'NotFoundError', message: string } | { __typename: 'SearchPageContent', active: boolean, searchType: SearchPageContentType, h1: string, h1ParagraphRaw?: string | undefined, h2?: string | undefined, h2ParagraphRaw?: string | undefined, heroImageHtmlAlt?: string | undefined, heroImageProcessing: boolean, heroImageUploadUrl?: string | undefined, heroImageUrl: string, htmlMetaDescription?: string | undefined, htmlMetaTitle?: string | undefined, aboutItemsTitle?: string | undefined, faqsTitle?: string | undefined, id: string, updatedAt: string, cities: Array<{ searchType: SearchPageContentType, region?: { description: string, citySlug?: string | undefined, countrySlug?: string | undefined, slug: string, levelOneSlug?: string | undefined } | undefined }>, searchPageLinks: Array<{ href: string, id: string, title: string, type: SearchPageLinkType }>, searchPageParagraphs: Array<{ bodyRaw: string, id: string, title: string, type: SearchPageParagraphType }>, region?: { description: string, placeId: string } | undefined } | { __typename: 'ValidationErrorCollection' } };

export type SitemapListingsTotalCountQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
}>;


export type SitemapListingsTotalCountQuery = { listingCollection: { meta: { totalEntries?: number | undefined } } };

export type SitemapListingsListAllQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
}>;


export type SitemapListingsListAllQuery = { listingCollection: { entries: Array<{ slug: string, updatedAt?: string | undefined }>, meta: { nextPage?: number | undefined, previousPage?: number | undefined } } };

export type SitemapRegionsListBedAndBreakfastQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
}>;


export type SitemapRegionsListBedAndBreakfastQuery = { regionsListAllWithActiveSearchPageContents: { entries: Array<{ id: string, countrySlug?: string | undefined, levelOneSlug?: string | undefined, citySlug?: string | undefined, slug: string }>, meta: { nextPage?: number | undefined, previousPage?: number | undefined } } };

export type SitemapRegionsListVacationRentalsQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
}>;


export type SitemapRegionsListVacationRentalsQuery = { regionsListAllWithActiveSearchPageContents: { entries: Array<{ id: string, countrySlug?: string | undefined, levelOneSlug?: string | undefined, citySlug?: string | undefined, slug: string }>, meta: { nextPage?: number | undefined, previousPage?: number | undefined } } };

export type TaskStartPmsImportMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;


export type TaskStartPmsImportMutation = { taskStartPmsImport: { __typename: 'NotFoundError', message: string } | { __typename: 'Task', id: string } | { __typename: 'UnauthenticatedError', message: string } | { __typename: 'ValidationErrorCollection', errors: Array<{ message: string, type?: string | undefined, field?: string | undefined }> } };

export type TestUnhandledErrorQueryVariables = Exact<{ [key: string]: never; }>;


export type TestUnhandledErrorQuery = { testUnhandledError: number };

export type UserFieldsWithAccountFragment = { avatarUrl?: string | undefined, avatarProcessing: boolean, accessToken?: string | undefined, refreshToken?: string | undefined, accountRole?: AccountRole | undefined, claimable: boolean, email: string, firstName?: string | undefined, id: string, identityVerified: boolean, lastAuthenticatedAt?: string | undefined, lastName?: string | undefined, dob?: string | undefined, paymentServiceUserId: string, phoneNumber?: string | undefined, referredByUserId?: string | undefined, registeredAt?: string | undefined, account?: { id: string, isPpr: boolean, avatarUrl?: string | undefined, avatarFileName?: string | undefined, avatarUploadUrl?: string | undefined, avatarProcessing: boolean, heroUrl?: string | undefined, heroFileName?: string | undefined, heroUploadUrl?: string | undefined, heroProcessing: boolean, title?: string | undefined, companyName?: string | undefined, description?: string | undefined, email?: string | undefined, phoneNumber?: string | undefined, marketingWebsiteUrl?: string | undefined, homeownerMarketingUrl?: string | undefined, twitterUrl?: string | undefined, instagramUrl?: string | undefined, twitterHandle?: string | undefined, inBusinessSince?: number | undefined, bookDirectWebsiteUrl?: string | undefined, instagramUsername?: string | undefined, facebookPageUrl?: string | undefined, youtubeUrl?: string | undefined, linkedinUrl?: string | undefined, slug: string, insertedAt?: string | undefined, firstPublishedAt?: string | undefined, creditCardOnFile: boolean, defaultListingLevel: SubscriptionType, addressLineOne?: string | undefined, addressLineTwo?: string | undefined, city?: string | undefined, countryOrRegionLongName?: string | undefined, stateOrProvinceLongName?: string | undefined, postalCode?: string | undefined, billingSubscription?: { currentPeriodEnd: string } | undefined, latestTask?: { id: string, status: TaskStatus, startedAt: string, completedAt?: string | undefined, importCount?: number | undefined, importSuccessCount?: number | undefined, importedAt?: string | undefined, processedAt?: string | undefined, finalizedAt?: string | undefined, expiresAt?: string | undefined, errors?: Array<string> | undefined } | undefined, listings: Array<{ id: string, name?: string | undefined }>, availableCoupon?: { promoCode?: string | undefined, percentOff?: number | undefined, applicableSubscriptions?: Array<SubscriptionType | undefined> | undefined, name: string } | undefined, policies: Array<{ __typename: 'AccountCancellationPolicy', cancellationPolicy: string } | { __typename: 'AccountTermsAndConditions', termsLink: string } | { __typename: 'ListingCancellationPolicy', cancellationPolicy: string }>, accountReviewSummaries: Array<{ id: string, source: AccountReviewSummarySource, rating: number, numberOfReviews?: number | undefined, url?: string | undefined }> } | undefined };

export type UserFieldsFragment = { avatarUrl?: string | undefined, avatarProcessing: boolean, accessToken?: string | undefined, accountRole?: AccountRole | undefined, claimable: boolean, email: string, firstName?: string | undefined, id: string, identityVerified: boolean, lastAuthenticatedAt?: string | undefined, lastName?: string | undefined, paymentServiceUserId: string, phoneNumber?: string | undefined, referredByUserId?: string | undefined, registeredAt?: string | undefined };

export type UserSessionFieldsFragment = { avatarUrl?: string | undefined, accessToken?: string | undefined, email: string, firstName?: string | undefined, id: string, lastName?: string | undefined, refreshToken?: string | undefined, accountRole?: AccountRole | undefined, registeredAt?: string | undefined, lastAuthenticatedAt?: string | undefined };

export type UserCreateMutationVariables = Exact<{
  input: UserCreateInput;
}>;


export type UserCreateMutation = { userCreate: { __typename: 'User', refreshToken?: string | undefined, avatarUrl?: string | undefined, avatarProcessing: boolean, accessToken?: string | undefined, accountRole?: AccountRole | undefined, claimable: boolean, email: string, firstName?: string | undefined, id: string, identityVerified: boolean, lastAuthenticatedAt?: string | undefined, lastName?: string | undefined, paymentServiceUserId: string, phoneNumber?: string | undefined, referredByUserId?: string | undefined, registeredAt?: string | undefined } | { __typename: 'ValidationErrorCollection', errors: Array<{ field?: string | undefined, message: string, type?: string | undefined }> } };

export type UserSessionMutationVariables = Exact<{
  input: UserSessionInput;
}>;


export type UserSessionMutation = { userSession: { __typename: 'UnauthenticatedError', message: string } | { __typename: 'User', avatarUrl?: string | undefined, accessToken?: string | undefined, email: string, firstName?: string | undefined, id: string, lastName?: string | undefined, refreshToken?: string | undefined, accountRole?: AccountRole | undefined, registeredAt?: string | undefined, lastAuthenticatedAt?: string | undefined } };

export type UserAppleSocialSessionMutationVariables = Exact<{
  input: UserAppleSocialSessionInput;
}>;


export type UserAppleSocialSessionMutation = { userAppleSocialSession: { __typename: 'UnauthenticatedError', message: string } | { __typename: 'User', avatarUrl?: string | undefined, accessToken?: string | undefined, email: string, firstName?: string | undefined, id: string, lastName?: string | undefined, refreshToken?: string | undefined, accountRole?: AccountRole | undefined, registeredAt?: string | undefined, lastAuthenticatedAt?: string | undefined } };

export type UserGoogleSocialSessionMutationVariables = Exact<{
  input: UserGoogleSocialSessionInput;
}>;


export type UserGoogleSocialSessionMutation = { userGoogleSocialSession: { __typename: 'UnauthenticatedError', message: string } | { __typename: 'User', avatarUrl?: string | undefined, accessToken?: string | undefined, email: string, firstName?: string | undefined, id: string, lastName?: string | undefined, refreshToken?: string | undefined, accountRole?: AccountRole | undefined, registeredAt?: string | undefined, lastAuthenticatedAt?: string | undefined } };

export type UserFacebookSocialSessionMutationVariables = Exact<{
  input: UserFacebookSocialSessionInput;
}>;


export type UserFacebookSocialSessionMutation = { userFacebookSocialSession: { __typename: 'UnauthenticatedError', message: string } | { __typename: 'User', avatarUrl?: string | undefined, accessToken?: string | undefined, email: string, firstName?: string | undefined, id: string, lastName?: string | undefined, refreshToken?: string | undefined, accountRole?: AccountRole | undefined, registeredAt?: string | undefined, lastAuthenticatedAt?: string | undefined } | { __typename: 'ValidationErrorCollection', errors: Array<{ field?: string | undefined, message: string, type?: string | undefined }> } };

export type UserAccountAddMutationVariables = Exact<{
  input: UserAccountAddInput;
}>;


export type UserAccountAddMutation = { userAccountAdd: { __typename: 'ConflictError', message: string } | { __typename: 'NotFoundError', message: string } | { __typename: 'User', avatarUrl?: string | undefined, avatarProcessing: boolean, accessToken?: string | undefined, refreshToken?: string | undefined, accountRole?: AccountRole | undefined, claimable: boolean, email: string, firstName?: string | undefined, id: string, identityVerified: boolean, lastAuthenticatedAt?: string | undefined, lastName?: string | undefined, dob?: string | undefined, paymentServiceUserId: string, phoneNumber?: string | undefined, referredByUserId?: string | undefined, registeredAt?: string | undefined, account?: { id: string, isPpr: boolean, avatarUrl?: string | undefined, avatarFileName?: string | undefined, avatarUploadUrl?: string | undefined, avatarProcessing: boolean, heroUrl?: string | undefined, heroFileName?: string | undefined, heroUploadUrl?: string | undefined, heroProcessing: boolean, title?: string | undefined, companyName?: string | undefined, description?: string | undefined, email?: string | undefined, phoneNumber?: string | undefined, marketingWebsiteUrl?: string | undefined, homeownerMarketingUrl?: string | undefined, twitterUrl?: string | undefined, instagramUrl?: string | undefined, twitterHandle?: string | undefined, inBusinessSince?: number | undefined, bookDirectWebsiteUrl?: string | undefined, instagramUsername?: string | undefined, facebookPageUrl?: string | undefined, youtubeUrl?: string | undefined, linkedinUrl?: string | undefined, slug: string, insertedAt?: string | undefined, firstPublishedAt?: string | undefined, creditCardOnFile: boolean, defaultListingLevel: SubscriptionType, addressLineOne?: string | undefined, addressLineTwo?: string | undefined, city?: string | undefined, countryOrRegionLongName?: string | undefined, stateOrProvinceLongName?: string | undefined, postalCode?: string | undefined, billingSubscription?: { currentPeriodEnd: string } | undefined, latestTask?: { id: string, status: TaskStatus, startedAt: string, completedAt?: string | undefined, importCount?: number | undefined, importSuccessCount?: number | undefined, importedAt?: string | undefined, processedAt?: string | undefined, finalizedAt?: string | undefined, expiresAt?: string | undefined, errors?: Array<string> | undefined } | undefined, listings: Array<{ id: string, name?: string | undefined }>, availableCoupon?: { promoCode?: string | undefined, percentOff?: number | undefined, applicableSubscriptions?: Array<SubscriptionType | undefined> | undefined, name: string } | undefined, policies: Array<{ __typename: 'AccountCancellationPolicy', cancellationPolicy: string } | { __typename: 'AccountTermsAndConditions', termsLink: string } | { __typename: 'ListingCancellationPolicy', cancellationPolicy: string }>, accountReviewSummaries: Array<{ id: string, source: AccountReviewSummarySource, rating: number, numberOfReviews?: number | undefined, url?: string | undefined }> } | undefined } | { __typename: 'ValidationErrorCollection', errors: Array<{ field?: string | undefined, type?: string | undefined, message: string }> } };

export type UserSessionRefreshMutationVariables = Exact<{
  input: UserSessionRefreshInput;
}>;


export type UserSessionRefreshMutation = { userSessionRefresh: { __typename: 'UnauthenticatedError', message: string } | { __typename: 'User', avatarUrl?: string | undefined, accessToken?: string | undefined, email: string, firstName?: string | undefined, id: string, lastName?: string | undefined, refreshToken?: string | undefined, accountRole?: AccountRole | undefined, registeredAt?: string | undefined, lastAuthenticatedAt?: string | undefined } };

export type UserAccountRemoveMutationVariables = Exact<{
  input: UserAccountRemoveInput;
}>;


export type UserAccountRemoveMutation = { userAccountRemove: { __typename: 'ConflictError', message: string } | { __typename: 'NotFoundError', message: string } | { __typename: 'User', avatarUrl?: string | undefined, avatarProcessing: boolean, accessToken?: string | undefined, refreshToken?: string | undefined, accountRole?: AccountRole | undefined, claimable: boolean, email: string, firstName?: string | undefined, id: string, identityVerified: boolean, lastAuthenticatedAt?: string | undefined, lastName?: string | undefined, dob?: string | undefined, paymentServiceUserId: string, phoneNumber?: string | undefined, referredByUserId?: string | undefined, registeredAt?: string | undefined, account?: { id: string, isPpr: boolean, avatarUrl?: string | undefined, avatarFileName?: string | undefined, avatarUploadUrl?: string | undefined, avatarProcessing: boolean, heroUrl?: string | undefined, heroFileName?: string | undefined, heroUploadUrl?: string | undefined, heroProcessing: boolean, title?: string | undefined, companyName?: string | undefined, description?: string | undefined, email?: string | undefined, phoneNumber?: string | undefined, marketingWebsiteUrl?: string | undefined, homeownerMarketingUrl?: string | undefined, twitterUrl?: string | undefined, instagramUrl?: string | undefined, twitterHandle?: string | undefined, inBusinessSince?: number | undefined, bookDirectWebsiteUrl?: string | undefined, instagramUsername?: string | undefined, facebookPageUrl?: string | undefined, youtubeUrl?: string | undefined, linkedinUrl?: string | undefined, slug: string, insertedAt?: string | undefined, firstPublishedAt?: string | undefined, creditCardOnFile: boolean, defaultListingLevel: SubscriptionType, addressLineOne?: string | undefined, addressLineTwo?: string | undefined, city?: string | undefined, countryOrRegionLongName?: string | undefined, stateOrProvinceLongName?: string | undefined, postalCode?: string | undefined, billingSubscription?: { currentPeriodEnd: string } | undefined, latestTask?: { id: string, status: TaskStatus, startedAt: string, completedAt?: string | undefined, importCount?: number | undefined, importSuccessCount?: number | undefined, importedAt?: string | undefined, processedAt?: string | undefined, finalizedAt?: string | undefined, expiresAt?: string | undefined, errors?: Array<string> | undefined } | undefined, listings: Array<{ id: string, name?: string | undefined }>, availableCoupon?: { promoCode?: string | undefined, percentOff?: number | undefined, applicableSubscriptions?: Array<SubscriptionType | undefined> | undefined, name: string } | undefined, policies: Array<{ __typename: 'AccountCancellationPolicy', cancellationPolicy: string } | { __typename: 'AccountTermsAndConditions', termsLink: string } | { __typename: 'ListingCancellationPolicy', cancellationPolicy: string }>, accountReviewSummaries: Array<{ id: string, source: AccountReviewSummarySource, rating: number, numberOfReviews?: number | undefined, url?: string | undefined }> } | undefined } | { __typename: 'ValidationErrorCollection', errors: Array<{ field?: string | undefined, type?: string | undefined, message: string }> } };

export type UserUpdateMutationVariables = Exact<{
  input: UserUpdateInput;
}>;


export type UserUpdateMutation = { userUpdate: { __typename: 'UnauthenticatedError', message: string } | { __typename: 'User', id: string, email: string, firstName?: string | undefined, lastName?: string | undefined, phoneNumber?: string | undefined, avatarUrl?: string | undefined, dob?: string | undefined } | { __typename: 'ValidationErrorCollection', errors: Array<{ message: string, type?: string | undefined, field?: string | undefined }> } };

export type CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = { currentUser: { __typename: 'UnauthenticatedError', message: string } | { __typename: 'User', avatarUrl?: string | undefined, avatarProcessing: boolean, accessToken?: string | undefined, refreshToken?: string | undefined, accountRole?: AccountRole | undefined, claimable: boolean, email: string, firstName?: string | undefined, id: string, identityVerified: boolean, lastAuthenticatedAt?: string | undefined, lastName?: string | undefined, dob?: string | undefined, paymentServiceUserId: string, phoneNumber?: string | undefined, referredByUserId?: string | undefined, registeredAt?: string | undefined, account?: { id: string, isPpr: boolean, avatarUrl?: string | undefined, avatarFileName?: string | undefined, avatarUploadUrl?: string | undefined, avatarProcessing: boolean, heroUrl?: string | undefined, heroFileName?: string | undefined, heroUploadUrl?: string | undefined, heroProcessing: boolean, title?: string | undefined, companyName?: string | undefined, description?: string | undefined, email?: string | undefined, phoneNumber?: string | undefined, marketingWebsiteUrl?: string | undefined, homeownerMarketingUrl?: string | undefined, twitterUrl?: string | undefined, instagramUrl?: string | undefined, twitterHandle?: string | undefined, inBusinessSince?: number | undefined, bookDirectWebsiteUrl?: string | undefined, instagramUsername?: string | undefined, facebookPageUrl?: string | undefined, youtubeUrl?: string | undefined, linkedinUrl?: string | undefined, slug: string, insertedAt?: string | undefined, firstPublishedAt?: string | undefined, creditCardOnFile: boolean, defaultListingLevel: SubscriptionType, addressLineOne?: string | undefined, addressLineTwo?: string | undefined, city?: string | undefined, countryOrRegionLongName?: string | undefined, stateOrProvinceLongName?: string | undefined, postalCode?: string | undefined, billingSubscription?: { currentPeriodEnd: string } | undefined, latestTask?: { id: string, status: TaskStatus, startedAt: string, completedAt?: string | undefined, importCount?: number | undefined, importSuccessCount?: number | undefined, importedAt?: string | undefined, processedAt?: string | undefined, finalizedAt?: string | undefined, expiresAt?: string | undefined, errors?: Array<string> | undefined } | undefined, listings: Array<{ id: string, name?: string | undefined }>, availableCoupon?: { promoCode?: string | undefined, percentOff?: number | undefined, applicableSubscriptions?: Array<SubscriptionType | undefined> | undefined, name: string } | undefined, policies: Array<{ __typename: 'AccountCancellationPolicy', cancellationPolicy: string } | { __typename: 'AccountTermsAndConditions', termsLink: string } | { __typename: 'ListingCancellationPolicy', cancellationPolicy: string }>, accountReviewSummaries: Array<{ id: string, source: AccountReviewSummarySource, rating: number, numberOfReviews?: number | undefined, url?: string | undefined }> } | undefined } };

export const PublicAccountFieldsFragmentDoc = gql`
    fragment PublicAccountFields on Account {
  id
  slug
  avatarUrl
  avatarFileName
  avatarUploadUrl
  avatarProcessing
  companyName
  countryOrRegionLongName
  heroFileName
  heroUploadUrl
  heroUrl
  heroProcessing
  title
  description
  email
  phoneNumber
  marketingWebsiteUrl
  homeownerMarketingUrl
  twitterUrl
  instagramUrl
  twitterHandle
  instagramUsername
  facebookPageUrl
  inBusinessSince
  bookDirectWebsiteUrl
  youtubeUrl
  linkedinUrl
  city
  stateOrProvinceLongName
  accountReviewSummaries {
    id
    source
    sourceId
    numberOfReviews
    imageUrl
    rating
  }
}
    `;
export const PrivateAccountFieldsFragmentDoc = gql`
    fragment PrivateAccountFields on Account {
  pmsSoftware
  reportedPmsSoftware
  numberOfClaimedListings
  activeListingsCount
  addressLineOne
  addressLineTwo
  city
  countryOrRegionLongName
  stateOrProvinceLongName
  postalCode
  salesforceUrl
  ...PublicAccountFields
}
    ${PublicAccountFieldsFragmentDoc}`;
export const PrivateAccountIndexFieldsFragmentDoc = gql`
    fragment PrivateAccountIndexFields on Account {
  pmsSoftware
  reportedPmsSoftware
  pmsConnection {
    id
    type
    failed
    failingSince
    insertedAt
    userConfig {
      fieldName
      value
      options
    }
    maskedCredentials
  }
  numberOfClaimedListings
  activeListingsCount
  addressLineOne
  addressLineTwo
  city
  countryOrRegionLongName
  stateOrProvinceLongName
  postalCode
  firstPublishedAt
  stripeCustomerId
  creditCardOnFile
  salesforceUrl
  listings {
    id
    lastPublishedAt
    firstPublishedAt
    name
    published
    insertedAt
    listingLevel
  }
  owner {
    id
    email
  }
  users {
    id
    firstName
    lastName
    email
    accountRole
  }
  billingSubscription {
    currentPeriodEnd
  }
  latestTask {
    id
    status
    startedAt
    completedAt
    importCount
    importSuccessCount
    importedAt
    processedAt
    finalizedAt
    expiresAt
    errors
  }
  archived
  ...PublicAccountFields
}
    ${PublicAccountFieldsFragmentDoc}`;
export const ListingFieldsFragmentDoc = gql`
    fragment ListingFields on Listing {
  id
  account {
    id
    slug
    avatarUrl
    companyName
  }
  addressLineOne
  addressLineTwo
  affiliations {
    id
    name
    type
  }
  cancellationPolicy
  checkIn
  checkout
  numberOfFloors
  listedFloor
  numberOfRooms
  numberOfBathrooms
  guestCapacity
  propertyType
  uniquePropertyType
  hostImageProcessing
  bookDirectWebsiteUrl
  city
  countryOrRegionLongName
  currentBalanceCents
  description
  facebookPageUrl
  features {
    categoryName
    displayName
    key
    legacyKey
    promoted
  }
  galleryAssets {
    description
    id
    processing
    rawUrl
    position
    url
  }
  hostBio
  hostDisplayName
  hostImageUrl
  instagramUrl
  instagramUsername
  isFavorited
  firstPublishedAt
  lastPublishedAt
  unpublishedAt
  lat
  lng
  licenseNumber
  locationObfuscated
  locationSetManually
  marketingWebsiteUrl
  name
  pinterestUrl
  pinterestUsername
  placeId
  placeName
  postalCode
  publicEmail
  youtubeUrl
  wNineOnFile
  twitterUrl
  twitterHandle
  stateOrProvinceLongName
  slug
  minPrice
  maxPrice
  published
  publishIpAddress
  publicPhoneNumber
  listingLevel
  isDiamondCollection
  featuredByOwner
}
    `;
export const OwnerListingFieldsFragmentDoc = gql`
    fragment OwnerListingFields on Listing {
  id
  preciseAddressLineOne
  preciseAddressLineTwo
  bookDirectWebsiteUrl
  city
  checkIn
  checkout
  cancellationPolicy
  numberOfFloors
  licenseNumber
  listedFloor
  numberOfRooms
  numberOfBathrooms
  guestCapacity
  countryOrRegionLongName
  description
  facebookPageUrl
  propertyType
  uniquePropertyType
  hostBio
  hostDisplayName
  hostImageProcessing
  hostImageUrl
  instagramUrl
  preciseLat
  preciseLng
  locationObfuscated
  marketingWebsiteUrl
  instagramUsername
  pinterestUsername
  name
  name
  published
  pinterestUrl
  postalCode
  publicEmail
  publicPhoneNumber
  slug
  stateOrProvinceLongName
  twitterUrl
  twitterHandle
  youtubeUrl
  minPrice
  maxPrice
  galleryAssets(numberOfAssets: 100, processing: false) {
    id
    url
    rawUrl
    description
    processing
    position
  }
  features {
    key
    legacyKey
    displayName
    promoted
    categoryName
  }
  affiliations {
    id
    type
    name
  }
  listingLevel
  isDiamondCollection
  account {
    id
    slug
    companyName
    avatarUrl
    owner {
      id
    }
    availableCoupon {
      percentOff
      applicableSubscriptions
    }
  }
  featuredByOwner
  policies {
    ... on AccountTermsAndConditions {
      type
      termsLink
    }
    ... on AccountCancellationPolicy {
      type
      cancellationPolicy
    }
    ... on ListingCancellationPolicy {
      type
      cancellationPolicy
    }
  }
}
    `;
export const PmsConnectionFieldsFragmentDoc = gql`
    fragment PmsConnectionFields on PmsConnection {
  id
  type
  failed
  supportsBookings
}
    `;
export const UserFieldsWithAccountFragmentDoc = gql`
    fragment UserFieldsWithAccount on User {
  avatarUrl
  avatarProcessing
  accessToken
  refreshToken
  accountRole
  claimable
  email
  firstName
  id
  identityVerified
  lastAuthenticatedAt
  lastName
  dob
  paymentServiceUserId
  phoneNumber
  referredByUserId
  registeredAt
  account {
    id
    isPpr
    avatarUrl
    avatarFileName
    avatarUploadUrl
    avatarProcessing
    heroUrl
    heroFileName
    heroUploadUrl
    heroProcessing
    title
    companyName
    description
    email
    phoneNumber
    marketingWebsiteUrl
    homeownerMarketingUrl
    twitterUrl
    instagramUrl
    twitterHandle
    inBusinessSince
    bookDirectWebsiteUrl
    instagramUsername
    facebookPageUrl
    youtubeUrl
    linkedinUrl
    slug
    insertedAt
    firstPublishedAt
    creditCardOnFile
    defaultListingLevel
    billingSubscription {
      currentPeriodEnd
    }
    latestTask {
      id
      status
      startedAt
      completedAt
      importCount
      importSuccessCount
      importedAt
      processedAt
      finalizedAt
      expiresAt
      errors
    }
    listings {
      id
      name
    }
    addressLineOne
    addressLineTwo
    city
    countryOrRegionLongName
    stateOrProvinceLongName
    postalCode
    availableCoupon {
      promoCode
      percentOff
      applicableSubscriptions
      name
    }
    policies {
      __typename
      ... on AccountTermsAndConditions {
        termsLink
      }
      ... on AccountCancellationPolicy {
        cancellationPolicy
      }
      ... on ListingCancellationPolicy {
        cancellationPolicy
      }
    }
    accountReviewSummaries {
      id
      source
      rating
      numberOfReviews
      url
    }
  }
}
    `;
export const UserFieldsFragmentDoc = gql`
    fragment UserFields on User {
  avatarUrl
  avatarProcessing
  accessToken
  accountRole
  claimable
  email
  firstName
  id
  identityVerified
  lastAuthenticatedAt
  lastName
  paymentServiceUserId
  phoneNumber
  referredByUserId
  registeredAt
}
    `;
export const UserSessionFieldsFragmentDoc = gql`
    fragment UserSessionFields on User {
  avatarUrl
  accessToken
  email
  firstName
  id
  lastName
  refreshToken
  accountRole
  registeredAt
  lastAuthenticatedAt
}
    `;
export const AccountReviewSummaryCreateDocument = gql`
    mutation AccountReviewSummaryCreate($input: AccountReviewSummaryCreateInput!) {
  accountReviewSummaryCreate(input: $input) {
    __typename
    ... on AccountReviewSummary {
      id
      imageUrl
      numberOfReviews
      source
      sourceId
      url
      rating
    }
    ... on NotFoundError {
      message
    }
    ... on UnauthenticatedError {
      message
    }
    ... on ValidationErrorCollection {
      errors {
        message
        type
        field
      }
    }
  }
}
    `;
export type AccountReviewSummaryCreateMutationFn = Apollo.MutationFunction<AccountReviewSummaryCreateMutation, AccountReviewSummaryCreateMutationVariables>;

/**
 * __useAccountReviewSummaryCreateMutation__
 *
 * To run a mutation, you first call `useAccountReviewSummaryCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountReviewSummaryCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountReviewSummaryCreateMutation, { data, loading, error }] = useAccountReviewSummaryCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAccountReviewSummaryCreateMutation(baseOptions?: Apollo.MutationHookOptions<AccountReviewSummaryCreateMutation, AccountReviewSummaryCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AccountReviewSummaryCreateMutation, AccountReviewSummaryCreateMutationVariables>(AccountReviewSummaryCreateDocument, options);
      }
export type AccountReviewSummaryCreateMutationHookResult = ReturnType<typeof useAccountReviewSummaryCreateMutation>;
export type AccountReviewSummaryCreateMutationResult = Apollo.MutationResult<AccountReviewSummaryCreateMutation>;
export type AccountReviewSummaryCreateMutationOptions = Apollo.BaseMutationOptions<AccountReviewSummaryCreateMutation, AccountReviewSummaryCreateMutationVariables>;
export const PmAccountCreateDocument = gql`
    mutation PmAccountCreate($input: PmAccountCreateInput!) {
  pmAccountCreate(input: $input) {
    __typename
    ... on Account {
      id
    }
    ... on UnauthenticatedError {
      message
    }
    ... on ValidationErrorCollection {
      errors {
        field
        message
        type
      }
    }
  }
}
    `;
export type PmAccountCreateMutationFn = Apollo.MutationFunction<PmAccountCreateMutation, PmAccountCreateMutationVariables>;

/**
 * __usePmAccountCreateMutation__
 *
 * To run a mutation, you first call `usePmAccountCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePmAccountCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pmAccountCreateMutation, { data, loading, error }] = usePmAccountCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePmAccountCreateMutation(baseOptions?: Apollo.MutationHookOptions<PmAccountCreateMutation, PmAccountCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PmAccountCreateMutation, PmAccountCreateMutationVariables>(PmAccountCreateDocument, options);
      }
export type PmAccountCreateMutationHookResult = ReturnType<typeof usePmAccountCreateMutation>;
export type PmAccountCreateMutationResult = Apollo.MutationResult<PmAccountCreateMutation>;
export type PmAccountCreateMutationOptions = Apollo.BaseMutationOptions<PmAccountCreateMutation, PmAccountCreateMutationVariables>;
export const AccountUpdateDocument = gql`
    mutation AccountUpdate($input: AccountUpdateInput!) {
  accountUpdate(input: $input) {
    __typename
    ... on Account {
      pmsSoftware
      reportedPmsSoftware
      numberOfClaimedListings
      activeListingsCount
      addressLineOne
      addressLineTwo
      city
      countryOrRegionLongName
      stateOrProvinceLongName
      postalCode
      ...PublicAccountFields
    }
    ... on UnauthenticatedError {
      message
    }
    ... on ValidationErrorCollection {
      errors {
        field
        message
        type
      }
    }
  }
}
    ${PublicAccountFieldsFragmentDoc}`;
export type AccountUpdateMutationFn = Apollo.MutationFunction<AccountUpdateMutation, AccountUpdateMutationVariables>;

/**
 * __useAccountUpdateMutation__
 *
 * To run a mutation, you first call `useAccountUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountUpdateMutation, { data, loading, error }] = useAccountUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAccountUpdateMutation(baseOptions?: Apollo.MutationHookOptions<AccountUpdateMutation, AccountUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AccountUpdateMutation, AccountUpdateMutationVariables>(AccountUpdateDocument, options);
      }
export type AccountUpdateMutationHookResult = ReturnType<typeof useAccountUpdateMutation>;
export type AccountUpdateMutationResult = Apollo.MutationResult<AccountUpdateMutation>;
export type AccountUpdateMutationOptions = Apollo.BaseMutationOptions<AccountUpdateMutation, AccountUpdateMutationVariables>;
export const CreateSubscriptionDocument = gql`
    mutation CreateSubscription($input: CreateSubscriptionInput!) {
  createSubscription(input: $input) {
    __typename
    ... on Account {
      id
    }
    ... on NotFoundError {
      message
    }
    ... on ConflictError {
      message
    }
    ... on UnauthenticatedError {
      message
    }
    ... on ValidationErrorCollection {
      errors {
        field
        message
        type
      }
    }
  }
}
    `;
export type CreateSubscriptionMutationFn = Apollo.MutationFunction<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>;

/**
 * __useCreateSubscriptionMutation__
 *
 * To run a mutation, you first call `useCreateSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSubscriptionMutation, { data, loading, error }] = useCreateSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>(CreateSubscriptionDocument, options);
      }
export type CreateSubscriptionMutationHookResult = ReturnType<typeof useCreateSubscriptionMutation>;
export type CreateSubscriptionMutationResult = Apollo.MutationResult<CreateSubscriptionMutation>;
export type CreateSubscriptionMutationOptions = Apollo.BaseMutationOptions<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>;
export const SetSubscriptionCouponDocument = gql`
    mutation SetSubscriptionCoupon($input: SetSubscriptionCouponInput!) {
  setSubscriptionCoupon(input: $input) {
    __typename
    ... on Account {
      id
    }
    ... on UnauthenticatedError {
      message
    }
    ... on NotFoundError {
      message
    }
  }
}
    `;
export type SetSubscriptionCouponMutationFn = Apollo.MutationFunction<SetSubscriptionCouponMutation, SetSubscriptionCouponMutationVariables>;

/**
 * __useSetSubscriptionCouponMutation__
 *
 * To run a mutation, you first call `useSetSubscriptionCouponMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetSubscriptionCouponMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setSubscriptionCouponMutation, { data, loading, error }] = useSetSubscriptionCouponMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetSubscriptionCouponMutation(baseOptions?: Apollo.MutationHookOptions<SetSubscriptionCouponMutation, SetSubscriptionCouponMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetSubscriptionCouponMutation, SetSubscriptionCouponMutationVariables>(SetSubscriptionCouponDocument, options);
      }
export type SetSubscriptionCouponMutationHookResult = ReturnType<typeof useSetSubscriptionCouponMutation>;
export type SetSubscriptionCouponMutationResult = Apollo.MutationResult<SetSubscriptionCouponMutation>;
export type SetSubscriptionCouponMutationOptions = Apollo.BaseMutationOptions<SetSubscriptionCouponMutation, SetSubscriptionCouponMutationVariables>;
export const AccountUpdateAllListingSubscriptionsDocument = gql`
    mutation AccountUpdateAllListingSubscriptions($input: AccountUpdateAllListingSubscriptionsInput!) {
  accountUpdateAllListingSubscriptions(input: $input) {
    __typename
    ... on AccountBulkUpdateResults {
      successCount
      failureCount
    }
    ... on UnauthenticatedError {
      message
    }
    ... on NotFoundError {
      message
    }
    ... on ValidationErrorCollection {
      errors {
        field
        message
        type
      }
    }
  }
}
    `;
export type AccountUpdateAllListingSubscriptionsMutationFn = Apollo.MutationFunction<AccountUpdateAllListingSubscriptionsMutation, AccountUpdateAllListingSubscriptionsMutationVariables>;

/**
 * __useAccountUpdateAllListingSubscriptionsMutation__
 *
 * To run a mutation, you first call `useAccountUpdateAllListingSubscriptionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountUpdateAllListingSubscriptionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountUpdateAllListingSubscriptionsMutation, { data, loading, error }] = useAccountUpdateAllListingSubscriptionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAccountUpdateAllListingSubscriptionsMutation(baseOptions?: Apollo.MutationHookOptions<AccountUpdateAllListingSubscriptionsMutation, AccountUpdateAllListingSubscriptionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AccountUpdateAllListingSubscriptionsMutation, AccountUpdateAllListingSubscriptionsMutationVariables>(AccountUpdateAllListingSubscriptionsDocument, options);
      }
export type AccountUpdateAllListingSubscriptionsMutationHookResult = ReturnType<typeof useAccountUpdateAllListingSubscriptionsMutation>;
export type AccountUpdateAllListingSubscriptionsMutationResult = Apollo.MutationResult<AccountUpdateAllListingSubscriptionsMutation>;
export type AccountUpdateAllListingSubscriptionsMutationOptions = Apollo.BaseMutationOptions<AccountUpdateAllListingSubscriptionsMutation, AccountUpdateAllListingSubscriptionsMutationVariables>;
export const AccountBulkUpdateLocationObfuscatedDocument = gql`
    mutation AccountBulkUpdateLocationObfuscated($input: AccountBulkUpdateLocationObfuscatedInput!) {
  accountBulkUpdateLocationObfuscated(input: $input) {
    __typename
    ... on AccountBulkUpdateResults {
      successCount
      failureCount
    }
    ... on UnauthenticatedError {
      message
    }
    ... on NotFoundError {
      message
    }
    ... on ValidationErrorCollection {
      errors {
        field
        message
        type
      }
    }
  }
}
    `;
export type AccountBulkUpdateLocationObfuscatedMutationFn = Apollo.MutationFunction<AccountBulkUpdateLocationObfuscatedMutation, AccountBulkUpdateLocationObfuscatedMutationVariables>;

/**
 * __useAccountBulkUpdateLocationObfuscatedMutation__
 *
 * To run a mutation, you first call `useAccountBulkUpdateLocationObfuscatedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountBulkUpdateLocationObfuscatedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountBulkUpdateLocationObfuscatedMutation, { data, loading, error }] = useAccountBulkUpdateLocationObfuscatedMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAccountBulkUpdateLocationObfuscatedMutation(baseOptions?: Apollo.MutationHookOptions<AccountBulkUpdateLocationObfuscatedMutation, AccountBulkUpdateLocationObfuscatedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AccountBulkUpdateLocationObfuscatedMutation, AccountBulkUpdateLocationObfuscatedMutationVariables>(AccountBulkUpdateLocationObfuscatedDocument, options);
      }
export type AccountBulkUpdateLocationObfuscatedMutationHookResult = ReturnType<typeof useAccountBulkUpdateLocationObfuscatedMutation>;
export type AccountBulkUpdateLocationObfuscatedMutationResult = Apollo.MutationResult<AccountBulkUpdateLocationObfuscatedMutation>;
export type AccountBulkUpdateLocationObfuscatedMutationOptions = Apollo.BaseMutationOptions<AccountBulkUpdateLocationObfuscatedMutation, AccountBulkUpdateLocationObfuscatedMutationVariables>;
export const AccountsListRandomDocument = gql`
    query AccountsListRandom($pageSize: Int!) {
  accountsListRandom(pageSize: $pageSize) {
    __typename
    ... on AccountCollection {
      entries {
        id
        slug
        avatarUrl
        avatarProcessing
        heroUploadUrl
        heroProcessing
        companyName
        title
        description
        email
        phoneNumber
        marketingWebsiteUrl
        homeownerMarketingUrl
        twitterUrl
        instagramUrl
        twitterHandle
        instagramUsername
        facebookPageUrl
        activeListingsCount
        inBusinessSince
        bookDirectWebsiteUrl
        youtubeUrl
        linkedinUrl
        city
        stateOrProvinceLongName
        accountReviewSummaries {
          id
          source
          sourceId
          numberOfReviews
          imageUrl
          rating
        }
      }
      meta {
        nextPage
        previousPage
        currentPage
        totalEntries
        totalPages
      }
    }
  }
}
    `;

/**
 * __useAccountsListRandomQuery__
 *
 * To run a query within a React component, call `useAccountsListRandomQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountsListRandomQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountsListRandomQuery({
 *   variables: {
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useAccountsListRandomQuery(baseOptions: Apollo.QueryHookOptions<AccountsListRandomQuery, AccountsListRandomQueryVariables> & ({ variables: AccountsListRandomQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountsListRandomQuery, AccountsListRandomQueryVariables>(AccountsListRandomDocument, options);
      }
export function useAccountsListRandomLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountsListRandomQuery, AccountsListRandomQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountsListRandomQuery, AccountsListRandomQueryVariables>(AccountsListRandomDocument, options);
        }
export function useAccountsListRandomSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountsListRandomQuery, AccountsListRandomQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AccountsListRandomQuery, AccountsListRandomQueryVariables>(AccountsListRandomDocument, options);
        }
export type AccountsListRandomQueryHookResult = ReturnType<typeof useAccountsListRandomQuery>;
export type AccountsListRandomLazyQueryHookResult = ReturnType<typeof useAccountsListRandomLazyQuery>;
export type AccountsListRandomSuspenseQueryHookResult = ReturnType<typeof useAccountsListRandomSuspenseQuery>;
export type AccountsListRandomQueryResult = Apollo.QueryResult<AccountsListRandomQuery, AccountsListRandomQueryVariables>;
export function refetchAccountsListRandomQuery(variables: AccountsListRandomQueryVariables) {
      return { query: AccountsListRandomDocument, variables: variables }
    }
export const AccountByIdDocument = gql`
    query AccountById($id: String!) {
  accountById(id: $id) {
    __typename
    ... on Account {
      ...PublicAccountFields
    }
    ... on NotFoundError {
      message
    }
  }
}
    ${PublicAccountFieldsFragmentDoc}`;

/**
 * __useAccountByIdQuery__
 *
 * To run a query within a React component, call `useAccountByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAccountByIdQuery(baseOptions: Apollo.QueryHookOptions<AccountByIdQuery, AccountByIdQueryVariables> & ({ variables: AccountByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountByIdQuery, AccountByIdQueryVariables>(AccountByIdDocument, options);
      }
export function useAccountByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountByIdQuery, AccountByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountByIdQuery, AccountByIdQueryVariables>(AccountByIdDocument, options);
        }
export function useAccountByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountByIdQuery, AccountByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AccountByIdQuery, AccountByIdQueryVariables>(AccountByIdDocument, options);
        }
export type AccountByIdQueryHookResult = ReturnType<typeof useAccountByIdQuery>;
export type AccountByIdLazyQueryHookResult = ReturnType<typeof useAccountByIdLazyQuery>;
export type AccountByIdSuspenseQueryHookResult = ReturnType<typeof useAccountByIdSuspenseQuery>;
export type AccountByIdQueryResult = Apollo.QueryResult<AccountByIdQuery, AccountByIdQueryVariables>;
export function refetchAccountByIdQuery(variables: AccountByIdQueryVariables) {
      return { query: AccountByIdDocument, variables: variables }
    }
export const AccountBySlugDocument = gql`
    query AccountBySlug($slug: String!) {
  accountBySlug(slug: $slug) {
    __typename
    ... on Account {
      ...PublicAccountFields
    }
    ... on NotFoundError {
      message
    }
  }
}
    ${PublicAccountFieldsFragmentDoc}`;

/**
 * __useAccountBySlugQuery__
 *
 * To run a query within a React component, call `useAccountBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useAccountBySlugQuery(baseOptions: Apollo.QueryHookOptions<AccountBySlugQuery, AccountBySlugQueryVariables> & ({ variables: AccountBySlugQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountBySlugQuery, AccountBySlugQueryVariables>(AccountBySlugDocument, options);
      }
export function useAccountBySlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountBySlugQuery, AccountBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountBySlugQuery, AccountBySlugQueryVariables>(AccountBySlugDocument, options);
        }
export function useAccountBySlugSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountBySlugQuery, AccountBySlugQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AccountBySlugQuery, AccountBySlugQueryVariables>(AccountBySlugDocument, options);
        }
export type AccountBySlugQueryHookResult = ReturnType<typeof useAccountBySlugQuery>;
export type AccountBySlugLazyQueryHookResult = ReturnType<typeof useAccountBySlugLazyQuery>;
export type AccountBySlugSuspenseQueryHookResult = ReturnType<typeof useAccountBySlugSuspenseQuery>;
export type AccountBySlugQueryResult = Apollo.QueryResult<AccountBySlugQuery, AccountBySlugQueryVariables>;
export function refetchAccountBySlugQuery(variables: AccountBySlugQueryVariables) {
      return { query: AccountBySlugDocument, variables: variables }
    }
export const AccountForCurrentUserDocument = gql`
    query AccountForCurrentUser {
  accountForCurrentUser {
    __typename
    ... on Account {
      pmsSoftware
      reportedPmsSoftware
      isPpr
      creditCardOnFile
      latestTask {
        id
        status
        startedAt
        completedAt
        importCount
        importSuccessCount
      }
      ...PublicAccountFields
    }
    ... on UnauthenticatedError {
      message
    }
  }
}
    ${PublicAccountFieldsFragmentDoc}`;

/**
 * __useAccountForCurrentUserQuery__
 *
 * To run a query within a React component, call `useAccountForCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountForCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountForCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useAccountForCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<AccountForCurrentUserQuery, AccountForCurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountForCurrentUserQuery, AccountForCurrentUserQueryVariables>(AccountForCurrentUserDocument, options);
      }
export function useAccountForCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountForCurrentUserQuery, AccountForCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountForCurrentUserQuery, AccountForCurrentUserQueryVariables>(AccountForCurrentUserDocument, options);
        }
export function useAccountForCurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountForCurrentUserQuery, AccountForCurrentUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AccountForCurrentUserQuery, AccountForCurrentUserQueryVariables>(AccountForCurrentUserDocument, options);
        }
export type AccountForCurrentUserQueryHookResult = ReturnType<typeof useAccountForCurrentUserQuery>;
export type AccountForCurrentUserLazyQueryHookResult = ReturnType<typeof useAccountForCurrentUserLazyQuery>;
export type AccountForCurrentUserSuspenseQueryHookResult = ReturnType<typeof useAccountForCurrentUserSuspenseQuery>;
export type AccountForCurrentUserQueryResult = Apollo.QueryResult<AccountForCurrentUserQuery, AccountForCurrentUserQueryVariables>;
export function refetchAccountForCurrentUserQuery(variables?: AccountForCurrentUserQueryVariables) {
      return { query: AccountForCurrentUserDocument, variables: variables }
    }
export const AccountsListAllActiveDocument = gql`
    query AccountsListAllActive($pageSize: Int!, $page: Int!, $searchQuery: String, $stateOrProvinceLongNameFilter: String) {
  accountsListAllActive(
    pageSize: $pageSize
    page: $page
    searchQuery: $searchQuery
    stateOrProvinceLongNameFilter: $stateOrProvinceLongNameFilter
  ) {
    __typename
    ... on AccountCollection {
      entries {
        id
        slug
        avatarUrl
        avatarProcessing
        heroUploadUrl
        heroProcessing
        companyName
        title
        description
        email
        phoneNumber
        marketingWebsiteUrl
        homeownerMarketingUrl
        twitterUrl
        instagramUrl
        twitterHandle
        instagramUsername
        facebookPageUrl
        activeListingsCount
        inBusinessSince
        bookDirectWebsiteUrl
        youtubeUrl
        linkedinUrl
        city
        stateOrProvinceLongName
        accountReviewSummaries {
          id
          source
          sourceId
          numberOfReviews
          imageUrl
          rating
        }
      }
      meta {
        nextPage
        previousPage
        currentPage
        totalEntries
        totalPages
      }
    }
  }
}
    `;

/**
 * __useAccountsListAllActiveQuery__
 *
 * To run a query within a React component, call `useAccountsListAllActiveQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountsListAllActiveQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountsListAllActiveQuery({
 *   variables: {
 *      pageSize: // value for 'pageSize'
 *      page: // value for 'page'
 *      searchQuery: // value for 'searchQuery'
 *      stateOrProvinceLongNameFilter: // value for 'stateOrProvinceLongNameFilter'
 *   },
 * });
 */
export function useAccountsListAllActiveQuery(baseOptions: Apollo.QueryHookOptions<AccountsListAllActiveQuery, AccountsListAllActiveQueryVariables> & ({ variables: AccountsListAllActiveQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountsListAllActiveQuery, AccountsListAllActiveQueryVariables>(AccountsListAllActiveDocument, options);
      }
export function useAccountsListAllActiveLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountsListAllActiveQuery, AccountsListAllActiveQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountsListAllActiveQuery, AccountsListAllActiveQueryVariables>(AccountsListAllActiveDocument, options);
        }
export function useAccountsListAllActiveSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountsListAllActiveQuery, AccountsListAllActiveQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AccountsListAllActiveQuery, AccountsListAllActiveQueryVariables>(AccountsListAllActiveDocument, options);
        }
export type AccountsListAllActiveQueryHookResult = ReturnType<typeof useAccountsListAllActiveQuery>;
export type AccountsListAllActiveLazyQueryHookResult = ReturnType<typeof useAccountsListAllActiveLazyQuery>;
export type AccountsListAllActiveSuspenseQueryHookResult = ReturnType<typeof useAccountsListAllActiveSuspenseQuery>;
export type AccountsListAllActiveQueryResult = Apollo.QueryResult<AccountsListAllActiveQuery, AccountsListAllActiveQueryVariables>;
export function refetchAccountsListAllActiveQuery(variables: AccountsListAllActiveQueryVariables) {
      return { query: AccountsListAllActiveDocument, variables: variables }
    }
export const AffiliationFindOrCreateDocument = gql`
    mutation AffiliationFindOrCreate($input: AffiliationFindOrCreateInput!) {
  affiliationFindOrCreate(input: $input) {
    __typename
    ... on Affiliation {
      id
      name
      type
    }
    ... on ValidationErrorCollection {
      errors {
        message
        type
        field
      }
    }
    ... on UnauthenticatedError {
      message
    }
  }
}
    `;
export type AffiliationFindOrCreateMutationFn = Apollo.MutationFunction<AffiliationFindOrCreateMutation, AffiliationFindOrCreateMutationVariables>;

/**
 * __useAffiliationFindOrCreateMutation__
 *
 * To run a mutation, you first call `useAffiliationFindOrCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAffiliationFindOrCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [affiliationFindOrCreateMutation, { data, loading, error }] = useAffiliationFindOrCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAffiliationFindOrCreateMutation(baseOptions?: Apollo.MutationHookOptions<AffiliationFindOrCreateMutation, AffiliationFindOrCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AffiliationFindOrCreateMutation, AffiliationFindOrCreateMutationVariables>(AffiliationFindOrCreateDocument, options);
      }
export type AffiliationFindOrCreateMutationHookResult = ReturnType<typeof useAffiliationFindOrCreateMutation>;
export type AffiliationFindOrCreateMutationResult = Apollo.MutationResult<AffiliationFindOrCreateMutation>;
export type AffiliationFindOrCreateMutationOptions = Apollo.BaseMutationOptions<AffiliationFindOrCreateMutation, AffiliationFindOrCreateMutationVariables>;
export const AffiliationDeleteDocument = gql`
    mutation AffiliationDelete($input: AffiliationDeleteInput!) {
  affiliationDelete(input: $input) {
    __typename
    ... on Affiliation {
      id
      name
      type
    }
    ... on NotFoundError {
      message
    }
    ... on UnauthenticatedError {
      message
    }
  }
}
    `;
export type AffiliationDeleteMutationFn = Apollo.MutationFunction<AffiliationDeleteMutation, AffiliationDeleteMutationVariables>;

/**
 * __useAffiliationDeleteMutation__
 *
 * To run a mutation, you first call `useAffiliationDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAffiliationDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [affiliationDeleteMutation, { data, loading, error }] = useAffiliationDeleteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAffiliationDeleteMutation(baseOptions?: Apollo.MutationHookOptions<AffiliationDeleteMutation, AffiliationDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AffiliationDeleteMutation, AffiliationDeleteMutationVariables>(AffiliationDeleteDocument, options);
      }
export type AffiliationDeleteMutationHookResult = ReturnType<typeof useAffiliationDeleteMutation>;
export type AffiliationDeleteMutationResult = Apollo.MutationResult<AffiliationDeleteMutation>;
export type AffiliationDeleteMutationOptions = Apollo.BaseMutationOptions<AffiliationDeleteMutation, AffiliationDeleteMutationVariables>;
export const AffiliationSearchDocument = gql`
    query AffiliationSearch($query: String!, $type: AffiliationTypeFilter, $listingId: ID!) {
  affiliationSearch(query: $query, type: $type, listingId: $listingId) {
    __typename
    ... on AffiliationCollection {
      entries {
        id
        name
        type
      }
    }
    ... on UnauthenticatedError {
      message
    }
  }
}
    `;

/**
 * __useAffiliationSearchQuery__
 *
 * To run a query within a React component, call `useAffiliationSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useAffiliationSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAffiliationSearchQuery({
 *   variables: {
 *      query: // value for 'query'
 *      type: // value for 'type'
 *      listingId: // value for 'listingId'
 *   },
 * });
 */
export function useAffiliationSearchQuery(baseOptions: Apollo.QueryHookOptions<AffiliationSearchQuery, AffiliationSearchQueryVariables> & ({ variables: AffiliationSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AffiliationSearchQuery, AffiliationSearchQueryVariables>(AffiliationSearchDocument, options);
      }
export function useAffiliationSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AffiliationSearchQuery, AffiliationSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AffiliationSearchQuery, AffiliationSearchQueryVariables>(AffiliationSearchDocument, options);
        }
export function useAffiliationSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AffiliationSearchQuery, AffiliationSearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AffiliationSearchQuery, AffiliationSearchQueryVariables>(AffiliationSearchDocument, options);
        }
export type AffiliationSearchQueryHookResult = ReturnType<typeof useAffiliationSearchQuery>;
export type AffiliationSearchLazyQueryHookResult = ReturnType<typeof useAffiliationSearchLazyQuery>;
export type AffiliationSearchSuspenseQueryHookResult = ReturnType<typeof useAffiliationSearchSuspenseQuery>;
export type AffiliationSearchQueryResult = Apollo.QueryResult<AffiliationSearchQuery, AffiliationSearchQueryVariables>;
export function refetchAffiliationSearchQuery(variables: AffiliationSearchQueryVariables) {
      return { query: AffiliationSearchDocument, variables: variables }
    }
export const BlogPostsListAllFeaturedDocument = gql`
    query BlogPostsListAllFeatured {
  blogPostsListAllFeatured {
    id
    title
    publishedAt
    url
    imageUrl
  }
}
    `;

/**
 * __useBlogPostsListAllFeaturedQuery__
 *
 * To run a query within a React component, call `useBlogPostsListAllFeaturedQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlogPostsListAllFeaturedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlogPostsListAllFeaturedQuery({
 *   variables: {
 *   },
 * });
 */
export function useBlogPostsListAllFeaturedQuery(baseOptions?: Apollo.QueryHookOptions<BlogPostsListAllFeaturedQuery, BlogPostsListAllFeaturedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BlogPostsListAllFeaturedQuery, BlogPostsListAllFeaturedQueryVariables>(BlogPostsListAllFeaturedDocument, options);
      }
export function useBlogPostsListAllFeaturedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BlogPostsListAllFeaturedQuery, BlogPostsListAllFeaturedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BlogPostsListAllFeaturedQuery, BlogPostsListAllFeaturedQueryVariables>(BlogPostsListAllFeaturedDocument, options);
        }
export function useBlogPostsListAllFeaturedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BlogPostsListAllFeaturedQuery, BlogPostsListAllFeaturedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BlogPostsListAllFeaturedQuery, BlogPostsListAllFeaturedQueryVariables>(BlogPostsListAllFeaturedDocument, options);
        }
export type BlogPostsListAllFeaturedQueryHookResult = ReturnType<typeof useBlogPostsListAllFeaturedQuery>;
export type BlogPostsListAllFeaturedLazyQueryHookResult = ReturnType<typeof useBlogPostsListAllFeaturedLazyQuery>;
export type BlogPostsListAllFeaturedSuspenseQueryHookResult = ReturnType<typeof useBlogPostsListAllFeaturedSuspenseQuery>;
export type BlogPostsListAllFeaturedQueryResult = Apollo.QueryResult<BlogPostsListAllFeaturedQuery, BlogPostsListAllFeaturedQueryVariables>;
export function refetchBlogPostsListAllFeaturedQuery(variables?: BlogPostsListAllFeaturedQueryVariables) {
      return { query: BlogPostsListAllFeaturedDocument, variables: variables }
    }
export const BookingQuoteByListingAndDatesDocument = gql`
    query BookingQuoteByListingAndDates($slug: String!, $checkInDate: Date!, $checkOutDate: Date!, $adultCount: Int!, $childCount: Int!, $infantCount: Int!, $petCount: Int!) {
  bookingQuoteByListingAndDates(
    slug: $slug
    checkInDate: $checkInDate
    checkOutDate: $checkOutDate
    adultCount: $adultCount
    childCount: $childCount
    infantCount: $infantCount
    petCount: $petCount
  ) {
    __typename
    ... on BookingQuote {
      listing {
        priceDisplay(
          checkInDate: $checkInDate
          checkOutDate: $checkOutDate
          pets: $petCount
          guests: $adultCount
        ) {
          subtotalWithoutTaxesCents
          baseAmountCents
          nights
        }
      }
      listingId
      totalCostCents
      totalRecoverableCostCents
      totalWithoutTaxesCents
      checkInDate
      checkOutDate
      quoteItems {
        costCents
        type
        description
      }
      paymentSchedule {
        dueDate
        amountCents
        description
        paymentItemType
      }
    }
    ... on BookingQuoteUnavailable {
      message
    }
    ... on ServiceUnavailableError {
      message
    }
    ... on ValidationError {
      message
    }
  }
}
    `;

/**
 * __useBookingQuoteByListingAndDatesQuery__
 *
 * To run a query within a React component, call `useBookingQuoteByListingAndDatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingQuoteByListingAndDatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingQuoteByListingAndDatesQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      checkInDate: // value for 'checkInDate'
 *      checkOutDate: // value for 'checkOutDate'
 *      adultCount: // value for 'adultCount'
 *      childCount: // value for 'childCount'
 *      infantCount: // value for 'infantCount'
 *      petCount: // value for 'petCount'
 *   },
 * });
 */
export function useBookingQuoteByListingAndDatesQuery(baseOptions: Apollo.QueryHookOptions<BookingQuoteByListingAndDatesQuery, BookingQuoteByListingAndDatesQueryVariables> & ({ variables: BookingQuoteByListingAndDatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookingQuoteByListingAndDatesQuery, BookingQuoteByListingAndDatesQueryVariables>(BookingQuoteByListingAndDatesDocument, options);
      }
export function useBookingQuoteByListingAndDatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookingQuoteByListingAndDatesQuery, BookingQuoteByListingAndDatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookingQuoteByListingAndDatesQuery, BookingQuoteByListingAndDatesQueryVariables>(BookingQuoteByListingAndDatesDocument, options);
        }
export function useBookingQuoteByListingAndDatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BookingQuoteByListingAndDatesQuery, BookingQuoteByListingAndDatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BookingQuoteByListingAndDatesQuery, BookingQuoteByListingAndDatesQueryVariables>(BookingQuoteByListingAndDatesDocument, options);
        }
export type BookingQuoteByListingAndDatesQueryHookResult = ReturnType<typeof useBookingQuoteByListingAndDatesQuery>;
export type BookingQuoteByListingAndDatesLazyQueryHookResult = ReturnType<typeof useBookingQuoteByListingAndDatesLazyQuery>;
export type BookingQuoteByListingAndDatesSuspenseQueryHookResult = ReturnType<typeof useBookingQuoteByListingAndDatesSuspenseQuery>;
export type BookingQuoteByListingAndDatesQueryResult = Apollo.QueryResult<BookingQuoteByListingAndDatesQuery, BookingQuoteByListingAndDatesQueryVariables>;
export function refetchBookingQuoteByListingAndDatesQuery(variables: BookingQuoteByListingAndDatesQueryVariables) {
      return { query: BookingQuoteByListingAndDatesDocument, variables: variables }
    }
export const SetAccountCardDocument = gql`
    mutation SetAccountCard($token: String!) {
  setAccountCard(stripeTokenId: $token) {
    __typename
    ... on Card {
      brand
      addressZip
      last4
      expMonth
      expYear
    }
    ... on NotFoundError {
      message
    }
    ... on UnauthenticatedError {
      message
    }
    ... on UnauthorizedError {
      message
    }
    ... on ValidationErrorCollection {
      errors {
        message
        type
        field
      }
    }
    ... on ServiceUnavailableError {
      message
    }
  }
}
    `;
export type SetAccountCardMutationFn = Apollo.MutationFunction<SetAccountCardMutation, SetAccountCardMutationVariables>;

/**
 * __useSetAccountCardMutation__
 *
 * To run a mutation, you first call `useSetAccountCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAccountCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAccountCardMutation, { data, loading, error }] = useSetAccountCardMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useSetAccountCardMutation(baseOptions?: Apollo.MutationHookOptions<SetAccountCardMutation, SetAccountCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetAccountCardMutation, SetAccountCardMutationVariables>(SetAccountCardDocument, options);
      }
export type SetAccountCardMutationHookResult = ReturnType<typeof useSetAccountCardMutation>;
export type SetAccountCardMutationResult = Apollo.MutationResult<SetAccountCardMutation>;
export type SetAccountCardMutationOptions = Apollo.BaseMutationOptions<SetAccountCardMutation, SetAccountCardMutationVariables>;
export const CardsListAllDocument = gql`
    query CardsListAll {
  cardsListAll {
    __typename
    ... on CardCollection {
      entries {
        brand
        addressZip
        last4
        expMonth
        expYear
      }
      meta {
        currentPage
        nextPage
        previousPage
        totalEntries
        totalPages
      }
    }
    ... on UnauthenticatedError {
      message
    }
  }
}
    `;

/**
 * __useCardsListAllQuery__
 *
 * To run a query within a React component, call `useCardsListAllQuery` and pass it any options that fit your needs.
 * When your component renders, `useCardsListAllQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCardsListAllQuery({
 *   variables: {
 *   },
 * });
 */
export function useCardsListAllQuery(baseOptions?: Apollo.QueryHookOptions<CardsListAllQuery, CardsListAllQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CardsListAllQuery, CardsListAllQueryVariables>(CardsListAllDocument, options);
      }
export function useCardsListAllLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CardsListAllQuery, CardsListAllQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CardsListAllQuery, CardsListAllQueryVariables>(CardsListAllDocument, options);
        }
export function useCardsListAllSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CardsListAllQuery, CardsListAllQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CardsListAllQuery, CardsListAllQueryVariables>(CardsListAllDocument, options);
        }
export type CardsListAllQueryHookResult = ReturnType<typeof useCardsListAllQuery>;
export type CardsListAllLazyQueryHookResult = ReturnType<typeof useCardsListAllLazyQuery>;
export type CardsListAllSuspenseQueryHookResult = ReturnType<typeof useCardsListAllSuspenseQuery>;
export type CardsListAllQueryResult = Apollo.QueryResult<CardsListAllQuery, CardsListAllQueryVariables>;
export function refetchCardsListAllQuery(variables?: CardsListAllQueryVariables) {
      return { query: CardsListAllDocument, variables: variables }
    }
export const AccountCardsListAllDocument = gql`
    query AccountCardsListAll {
  accountCardsListAll {
    __typename
    ... on CardCollection {
      entries {
        brand
        addressZip
        last4
        expMonth
        expYear
      }
      meta {
        currentPage
        nextPage
        previousPage
        totalEntries
        totalPages
      }
    }
    ... on UnauthorizedError {
      message
    }
    ... on UnauthenticatedError {
      message
    }
  }
}
    `;

/**
 * __useAccountCardsListAllQuery__
 *
 * To run a query within a React component, call `useAccountCardsListAllQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountCardsListAllQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountCardsListAllQuery({
 *   variables: {
 *   },
 * });
 */
export function useAccountCardsListAllQuery(baseOptions?: Apollo.QueryHookOptions<AccountCardsListAllQuery, AccountCardsListAllQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountCardsListAllQuery, AccountCardsListAllQueryVariables>(AccountCardsListAllDocument, options);
      }
export function useAccountCardsListAllLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountCardsListAllQuery, AccountCardsListAllQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountCardsListAllQuery, AccountCardsListAllQueryVariables>(AccountCardsListAllDocument, options);
        }
export function useAccountCardsListAllSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountCardsListAllQuery, AccountCardsListAllQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AccountCardsListAllQuery, AccountCardsListAllQueryVariables>(AccountCardsListAllDocument, options);
        }
export type AccountCardsListAllQueryHookResult = ReturnType<typeof useAccountCardsListAllQuery>;
export type AccountCardsListAllLazyQueryHookResult = ReturnType<typeof useAccountCardsListAllLazyQuery>;
export type AccountCardsListAllSuspenseQueryHookResult = ReturnType<typeof useAccountCardsListAllSuspenseQuery>;
export type AccountCardsListAllQueryResult = Apollo.QueryResult<AccountCardsListAllQuery, AccountCardsListAllQueryVariables>;
export function refetchAccountCardsListAllQuery(variables?: AccountCardsListAllQueryVariables) {
      return { query: AccountCardsListAllDocument, variables: variables }
    }
export const ComparisonQuoteByListingAndDatesDocument = gql`
    query ComparisonQuoteByListingAndDates($checkInDate: Date!, $checkOutDate: Date!, $externalListingUrl: String!, $numberOfAdults: Int!, $numberOfChildren: Int, $numberOfInfants: Int, $numberOfPets: Int, $priceType: PriceType!) {
  comparisonQuoteByListingAndDates(
    checkInDate: $checkInDate
    checkOutDate: $checkOutDate
    externalListingUrl: $externalListingUrl
    numberOfAdults: $numberOfAdults
    numberOfChildren: $numberOfChildren
    numberOfInfants: $numberOfInfants
    numberOfPets: $numberOfPets
    priceType: $priceType
  ) {
    __typename
    ... on ComparisonQuote {
      checkInDate
      checkOutDate
      externalListingId
      externalSource
      numberOfAdults
      numberOfChildren
      numberOfInfants
      numberOfPets
      priceCents
    }
    ... on NotFoundError {
      message
    }
    ... on ValidationError {
      message
    }
    ... on UnprocessableContentError {
      message
    }
  }
}
    `;

/**
 * __useComparisonQuoteByListingAndDatesQuery__
 *
 * To run a query within a React component, call `useComparisonQuoteByListingAndDatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useComparisonQuoteByListingAndDatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useComparisonQuoteByListingAndDatesQuery({
 *   variables: {
 *      checkInDate: // value for 'checkInDate'
 *      checkOutDate: // value for 'checkOutDate'
 *      externalListingUrl: // value for 'externalListingUrl'
 *      numberOfAdults: // value for 'numberOfAdults'
 *      numberOfChildren: // value for 'numberOfChildren'
 *      numberOfInfants: // value for 'numberOfInfants'
 *      numberOfPets: // value for 'numberOfPets'
 *      priceType: // value for 'priceType'
 *   },
 * });
 */
export function useComparisonQuoteByListingAndDatesQuery(baseOptions: Apollo.QueryHookOptions<ComparisonQuoteByListingAndDatesQuery, ComparisonQuoteByListingAndDatesQueryVariables> & ({ variables: ComparisonQuoteByListingAndDatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ComparisonQuoteByListingAndDatesQuery, ComparisonQuoteByListingAndDatesQueryVariables>(ComparisonQuoteByListingAndDatesDocument, options);
      }
export function useComparisonQuoteByListingAndDatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ComparisonQuoteByListingAndDatesQuery, ComparisonQuoteByListingAndDatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ComparisonQuoteByListingAndDatesQuery, ComparisonQuoteByListingAndDatesQueryVariables>(ComparisonQuoteByListingAndDatesDocument, options);
        }
export function useComparisonQuoteByListingAndDatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ComparisonQuoteByListingAndDatesQuery, ComparisonQuoteByListingAndDatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ComparisonQuoteByListingAndDatesQuery, ComparisonQuoteByListingAndDatesQueryVariables>(ComparisonQuoteByListingAndDatesDocument, options);
        }
export type ComparisonQuoteByListingAndDatesQueryHookResult = ReturnType<typeof useComparisonQuoteByListingAndDatesQuery>;
export type ComparisonQuoteByListingAndDatesLazyQueryHookResult = ReturnType<typeof useComparisonQuoteByListingAndDatesLazyQuery>;
export type ComparisonQuoteByListingAndDatesSuspenseQueryHookResult = ReturnType<typeof useComparisonQuoteByListingAndDatesSuspenseQuery>;
export type ComparisonQuoteByListingAndDatesQueryResult = Apollo.QueryResult<ComparisonQuoteByListingAndDatesQuery, ComparisonQuoteByListingAndDatesQueryVariables>;
export function refetchComparisonQuoteByListingAndDatesQuery(variables: ComparisonQuoteByListingAndDatesQueryVariables) {
      return { query: ComparisonQuoteByListingAndDatesDocument, variables: variables }
    }
export const CouponFindAvailableForAccountDocument = gql`
    query CouponFindAvailableForAccount {
  couponFindAvailableForAccount {
    __typename
    ... on Coupon {
      amountOffCents
      applicableSubscriptions
      endDate
      name
      percentOff
      promoCode
    }
    ... on NotFoundError {
      message
    }
  }
}
    `;

/**
 * __useCouponFindAvailableForAccountQuery__
 *
 * To run a query within a React component, call `useCouponFindAvailableForAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useCouponFindAvailableForAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCouponFindAvailableForAccountQuery({
 *   variables: {
 *   },
 * });
 */
export function useCouponFindAvailableForAccountQuery(baseOptions?: Apollo.QueryHookOptions<CouponFindAvailableForAccountQuery, CouponFindAvailableForAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CouponFindAvailableForAccountQuery, CouponFindAvailableForAccountQueryVariables>(CouponFindAvailableForAccountDocument, options);
      }
export function useCouponFindAvailableForAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CouponFindAvailableForAccountQuery, CouponFindAvailableForAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CouponFindAvailableForAccountQuery, CouponFindAvailableForAccountQueryVariables>(CouponFindAvailableForAccountDocument, options);
        }
export function useCouponFindAvailableForAccountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CouponFindAvailableForAccountQuery, CouponFindAvailableForAccountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CouponFindAvailableForAccountQuery, CouponFindAvailableForAccountQueryVariables>(CouponFindAvailableForAccountDocument, options);
        }
export type CouponFindAvailableForAccountQueryHookResult = ReturnType<typeof useCouponFindAvailableForAccountQuery>;
export type CouponFindAvailableForAccountLazyQueryHookResult = ReturnType<typeof useCouponFindAvailableForAccountLazyQuery>;
export type CouponFindAvailableForAccountSuspenseQueryHookResult = ReturnType<typeof useCouponFindAvailableForAccountSuspenseQuery>;
export type CouponFindAvailableForAccountQueryResult = Apollo.QueryResult<CouponFindAvailableForAccountQuery, CouponFindAvailableForAccountQueryVariables>;
export function refetchCouponFindAvailableForAccountQuery(variables?: CouponFindAvailableForAccountQueryVariables) {
      return { query: CouponFindAvailableForAccountDocument, variables: variables }
    }
export const CouponFindByPromoCodeDocument = gql`
    query CouponFindByPromoCode($promoCode: String!) {
  couponFindByPromoCode(promoCode: $promoCode) {
    __typename
    ... on Coupon {
      amountOffCents
      applicableSubscriptions
      endDate
      name
      percentOff
      promoCode
    }
    ... on NotFoundError {
      message
    }
  }
}
    `;

/**
 * __useCouponFindByPromoCodeQuery__
 *
 * To run a query within a React component, call `useCouponFindByPromoCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useCouponFindByPromoCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCouponFindByPromoCodeQuery({
 *   variables: {
 *      promoCode: // value for 'promoCode'
 *   },
 * });
 */
export function useCouponFindByPromoCodeQuery(baseOptions: Apollo.QueryHookOptions<CouponFindByPromoCodeQuery, CouponFindByPromoCodeQueryVariables> & ({ variables: CouponFindByPromoCodeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CouponFindByPromoCodeQuery, CouponFindByPromoCodeQueryVariables>(CouponFindByPromoCodeDocument, options);
      }
export function useCouponFindByPromoCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CouponFindByPromoCodeQuery, CouponFindByPromoCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CouponFindByPromoCodeQuery, CouponFindByPromoCodeQueryVariables>(CouponFindByPromoCodeDocument, options);
        }
export function useCouponFindByPromoCodeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CouponFindByPromoCodeQuery, CouponFindByPromoCodeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CouponFindByPromoCodeQuery, CouponFindByPromoCodeQueryVariables>(CouponFindByPromoCodeDocument, options);
        }
export type CouponFindByPromoCodeQueryHookResult = ReturnType<typeof useCouponFindByPromoCodeQuery>;
export type CouponFindByPromoCodeLazyQueryHookResult = ReturnType<typeof useCouponFindByPromoCodeLazyQuery>;
export type CouponFindByPromoCodeSuspenseQueryHookResult = ReturnType<typeof useCouponFindByPromoCodeSuspenseQuery>;
export type CouponFindByPromoCodeQueryResult = Apollo.QueryResult<CouponFindByPromoCodeQuery, CouponFindByPromoCodeQueryVariables>;
export function refetchCouponFindByPromoCodeQuery(variables: CouponFindByPromoCodeQueryVariables) {
      return { query: CouponFindByPromoCodeDocument, variables: variables }
    }
export const CouponFindForAccountDocument = gql`
    query CouponFindForAccount {
  couponFindForAccount {
    __typename
    ... on Coupon {
      amountOffCents
      applicableSubscriptions
      endDate
      name
      percentOff
      promoCode
    }
    ... on NotFoundError {
      message
    }
    ... on UnauthenticatedError {
      message
    }
  }
}
    `;

/**
 * __useCouponFindForAccountQuery__
 *
 * To run a query within a React component, call `useCouponFindForAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useCouponFindForAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCouponFindForAccountQuery({
 *   variables: {
 *   },
 * });
 */
export function useCouponFindForAccountQuery(baseOptions?: Apollo.QueryHookOptions<CouponFindForAccountQuery, CouponFindForAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CouponFindForAccountQuery, CouponFindForAccountQueryVariables>(CouponFindForAccountDocument, options);
      }
export function useCouponFindForAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CouponFindForAccountQuery, CouponFindForAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CouponFindForAccountQuery, CouponFindForAccountQueryVariables>(CouponFindForAccountDocument, options);
        }
export function useCouponFindForAccountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CouponFindForAccountQuery, CouponFindForAccountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CouponFindForAccountQuery, CouponFindForAccountQueryVariables>(CouponFindForAccountDocument, options);
        }
export type CouponFindForAccountQueryHookResult = ReturnType<typeof useCouponFindForAccountQuery>;
export type CouponFindForAccountLazyQueryHookResult = ReturnType<typeof useCouponFindForAccountLazyQuery>;
export type CouponFindForAccountSuspenseQueryHookResult = ReturnType<typeof useCouponFindForAccountSuspenseQuery>;
export type CouponFindForAccountQueryResult = Apollo.QueryResult<CouponFindForAccountQuery, CouponFindForAccountQueryVariables>;
export function refetchCouponFindForAccountQuery(variables?: CouponFindForAccountQueryVariables) {
      return { query: CouponFindForAccountDocument, variables: variables }
    }
export const EmailVerificationUpdateDocument = gql`
    mutation EmailVerificationUpdate($token: String!) {
  emailVerificationUpdate(token: $token) {
    __typename
    ... on EmailVerificationMessage {
      message
    }
    ... on UnauthenticatedError {
      message
    }
    ... on NotFoundError {
      message
    }
    ... on ValidationErrorCollection {
      errors {
        message
        type
        field
      }
    }
  }
}
    `;
export type EmailVerificationUpdateMutationFn = Apollo.MutationFunction<EmailVerificationUpdateMutation, EmailVerificationUpdateMutationVariables>;

/**
 * __useEmailVerificationUpdateMutation__
 *
 * To run a mutation, you first call `useEmailVerificationUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmailVerificationUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [emailVerificationUpdateMutation, { data, loading, error }] = useEmailVerificationUpdateMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useEmailVerificationUpdateMutation(baseOptions?: Apollo.MutationHookOptions<EmailVerificationUpdateMutation, EmailVerificationUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EmailVerificationUpdateMutation, EmailVerificationUpdateMutationVariables>(EmailVerificationUpdateDocument, options);
      }
export type EmailVerificationUpdateMutationHookResult = ReturnType<typeof useEmailVerificationUpdateMutation>;
export type EmailVerificationUpdateMutationResult = Apollo.MutationResult<EmailVerificationUpdateMutation>;
export type EmailVerificationUpdateMutationOptions = Apollo.BaseMutationOptions<EmailVerificationUpdateMutation, EmailVerificationUpdateMutationVariables>;
export const FeaturesListAllDocument = gql`
    query FeaturesListAll($propertyType: PropertyType) {
  featuresListAll(propertyType: $propertyType) {
    key
    displayName
    categoryName
    promoted
  }
}
    `;

/**
 * __useFeaturesListAllQuery__
 *
 * To run a query within a React component, call `useFeaturesListAllQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeaturesListAllQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeaturesListAllQuery({
 *   variables: {
 *      propertyType: // value for 'propertyType'
 *   },
 * });
 */
export function useFeaturesListAllQuery(baseOptions?: Apollo.QueryHookOptions<FeaturesListAllQuery, FeaturesListAllQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeaturesListAllQuery, FeaturesListAllQueryVariables>(FeaturesListAllDocument, options);
      }
export function useFeaturesListAllLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeaturesListAllQuery, FeaturesListAllQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeaturesListAllQuery, FeaturesListAllQueryVariables>(FeaturesListAllDocument, options);
        }
export function useFeaturesListAllSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FeaturesListAllQuery, FeaturesListAllQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FeaturesListAllQuery, FeaturesListAllQueryVariables>(FeaturesListAllDocument, options);
        }
export type FeaturesListAllQueryHookResult = ReturnType<typeof useFeaturesListAllQuery>;
export type FeaturesListAllLazyQueryHookResult = ReturnType<typeof useFeaturesListAllLazyQuery>;
export type FeaturesListAllSuspenseQueryHookResult = ReturnType<typeof useFeaturesListAllSuspenseQuery>;
export type FeaturesListAllQueryResult = Apollo.QueryResult<FeaturesListAllQuery, FeaturesListAllQueryVariables>;
export function refetchFeaturesListAllQuery(variables?: FeaturesListAllQueryVariables) {
      return { query: FeaturesListAllDocument, variables: variables }
    }
export const FeaturesListAllForSearchFiltersDocument = gql`
    query FeaturesListAllForSearchFilters {
  featuresListAllForSearchFilters {
    categoryName
    displayName
    key
    promoted
  }
}
    `;

/**
 * __useFeaturesListAllForSearchFiltersQuery__
 *
 * To run a query within a React component, call `useFeaturesListAllForSearchFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeaturesListAllForSearchFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeaturesListAllForSearchFiltersQuery({
 *   variables: {
 *   },
 * });
 */
export function useFeaturesListAllForSearchFiltersQuery(baseOptions?: Apollo.QueryHookOptions<FeaturesListAllForSearchFiltersQuery, FeaturesListAllForSearchFiltersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeaturesListAllForSearchFiltersQuery, FeaturesListAllForSearchFiltersQueryVariables>(FeaturesListAllForSearchFiltersDocument, options);
      }
export function useFeaturesListAllForSearchFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeaturesListAllForSearchFiltersQuery, FeaturesListAllForSearchFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeaturesListAllForSearchFiltersQuery, FeaturesListAllForSearchFiltersQueryVariables>(FeaturesListAllForSearchFiltersDocument, options);
        }
export function useFeaturesListAllForSearchFiltersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FeaturesListAllForSearchFiltersQuery, FeaturesListAllForSearchFiltersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FeaturesListAllForSearchFiltersQuery, FeaturesListAllForSearchFiltersQueryVariables>(FeaturesListAllForSearchFiltersDocument, options);
        }
export type FeaturesListAllForSearchFiltersQueryHookResult = ReturnType<typeof useFeaturesListAllForSearchFiltersQuery>;
export type FeaturesListAllForSearchFiltersLazyQueryHookResult = ReturnType<typeof useFeaturesListAllForSearchFiltersLazyQuery>;
export type FeaturesListAllForSearchFiltersSuspenseQueryHookResult = ReturnType<typeof useFeaturesListAllForSearchFiltersSuspenseQuery>;
export type FeaturesListAllForSearchFiltersQueryResult = Apollo.QueryResult<FeaturesListAllForSearchFiltersQuery, FeaturesListAllForSearchFiltersQueryVariables>;
export function refetchFeaturesListAllForSearchFiltersQuery(variables?: FeaturesListAllForSearchFiltersQueryVariables) {
      return { query: FeaturesListAllForSearchFiltersDocument, variables: variables }
    }
export const GalleryAssetCreateDocument = gql`
    mutation GalleryAssetCreate($input: GalleryAssetCreateInput!) {
  galleryAssetCreate(input: $input) {
    __typename
    ... on GalleryAsset {
      id
      description
      processing
      rawUrl
      position
      url
    }
    ... on UnauthenticatedError {
      message
    }
    ... on ValidationErrorCollection {
      errors {
        message
        type
        field
      }
    }
  }
}
    `;
export type GalleryAssetCreateMutationFn = Apollo.MutationFunction<GalleryAssetCreateMutation, GalleryAssetCreateMutationVariables>;

/**
 * __useGalleryAssetCreateMutation__
 *
 * To run a mutation, you first call `useGalleryAssetCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGalleryAssetCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [galleryAssetCreateMutation, { data, loading, error }] = useGalleryAssetCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGalleryAssetCreateMutation(baseOptions?: Apollo.MutationHookOptions<GalleryAssetCreateMutation, GalleryAssetCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GalleryAssetCreateMutation, GalleryAssetCreateMutationVariables>(GalleryAssetCreateDocument, options);
      }
export type GalleryAssetCreateMutationHookResult = ReturnType<typeof useGalleryAssetCreateMutation>;
export type GalleryAssetCreateMutationResult = Apollo.MutationResult<GalleryAssetCreateMutation>;
export type GalleryAssetCreateMutationOptions = Apollo.BaseMutationOptions<GalleryAssetCreateMutation, GalleryAssetCreateMutationVariables>;
export const GalleryAssetDeleteDocument = gql`
    mutation GalleryAssetDelete($input: GalleryAssetDeleteInput!) {
  galleryAssetDelete(input: $input) {
    __typename
    ... on GalleryAsset {
      id
      description
      processing
      rawUrl
      position
      url
    }
    ... on NotFoundError {
      message
    }
    ... on UnauthenticatedError {
      message
    }
  }
}
    `;
export type GalleryAssetDeleteMutationFn = Apollo.MutationFunction<GalleryAssetDeleteMutation, GalleryAssetDeleteMutationVariables>;

/**
 * __useGalleryAssetDeleteMutation__
 *
 * To run a mutation, you first call `useGalleryAssetDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGalleryAssetDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [galleryAssetDeleteMutation, { data, loading, error }] = useGalleryAssetDeleteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGalleryAssetDeleteMutation(baseOptions?: Apollo.MutationHookOptions<GalleryAssetDeleteMutation, GalleryAssetDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GalleryAssetDeleteMutation, GalleryAssetDeleteMutationVariables>(GalleryAssetDeleteDocument, options);
      }
export type GalleryAssetDeleteMutationHookResult = ReturnType<typeof useGalleryAssetDeleteMutation>;
export type GalleryAssetDeleteMutationResult = Apollo.MutationResult<GalleryAssetDeleteMutation>;
export type GalleryAssetDeleteMutationOptions = Apollo.BaseMutationOptions<GalleryAssetDeleteMutation, GalleryAssetDeleteMutationVariables>;
export const GalleryAssetOrderDocument = gql`
    mutation GalleryAssetOrder($input: GalleryAssetOrderInput!) {
  galleryAssetOrder(input: $input) {
    __typename
    ... on GalleryAsset {
      id
      description
      processing
      rawUrl
      position
      url
    }
    ... on NotFoundError {
      message
    }
    ... on UnauthenticatedError {
      message
    }
    ... on ValidationErrorCollection {
      errors {
        message
        type
        field
      }
    }
  }
}
    `;
export type GalleryAssetOrderMutationFn = Apollo.MutationFunction<GalleryAssetOrderMutation, GalleryAssetOrderMutationVariables>;

/**
 * __useGalleryAssetOrderMutation__
 *
 * To run a mutation, you first call `useGalleryAssetOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGalleryAssetOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [galleryAssetOrderMutation, { data, loading, error }] = useGalleryAssetOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGalleryAssetOrderMutation(baseOptions?: Apollo.MutationHookOptions<GalleryAssetOrderMutation, GalleryAssetOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GalleryAssetOrderMutation, GalleryAssetOrderMutationVariables>(GalleryAssetOrderDocument, options);
      }
export type GalleryAssetOrderMutationHookResult = ReturnType<typeof useGalleryAssetOrderMutation>;
export type GalleryAssetOrderMutationResult = Apollo.MutationResult<GalleryAssetOrderMutation>;
export type GalleryAssetOrderMutationOptions = Apollo.BaseMutationOptions<GalleryAssetOrderMutation, GalleryAssetOrderMutationVariables>;
export const GalleryAssetUpdateImageDocument = gql`
    mutation GalleryAssetUpdateImage($input: GalleryAssetUpdateImageInput!) {
  galleryAssetUpdateImage(input: $input) {
    __typename
    ... on GalleryAsset {
      id
      description
      processing
      rawUrl
      position
      url
    }
    ... on NotFoundError {
      message
    }
    ... on UnauthenticatedError {
      message
    }
    ... on ValidationErrorCollection {
      errors {
        message
        type
        field
      }
    }
  }
}
    `;
export type GalleryAssetUpdateImageMutationFn = Apollo.MutationFunction<GalleryAssetUpdateImageMutation, GalleryAssetUpdateImageMutationVariables>;

/**
 * __useGalleryAssetUpdateImageMutation__
 *
 * To run a mutation, you first call `useGalleryAssetUpdateImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGalleryAssetUpdateImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [galleryAssetUpdateImageMutation, { data, loading, error }] = useGalleryAssetUpdateImageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGalleryAssetUpdateImageMutation(baseOptions?: Apollo.MutationHookOptions<GalleryAssetUpdateImageMutation, GalleryAssetUpdateImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GalleryAssetUpdateImageMutation, GalleryAssetUpdateImageMutationVariables>(GalleryAssetUpdateImageDocument, options);
      }
export type GalleryAssetUpdateImageMutationHookResult = ReturnType<typeof useGalleryAssetUpdateImageMutation>;
export type GalleryAssetUpdateImageMutationResult = Apollo.MutationResult<GalleryAssetUpdateImageMutation>;
export type GalleryAssetUpdateImageMutationOptions = Apollo.BaseMutationOptions<GalleryAssetUpdateImageMutation, GalleryAssetUpdateImageMutationVariables>;
export const GalleryAssetUpdateDocument = gql`
    mutation GalleryAssetUpdate($input: GalleryAssetUpdateInput!) {
  galleryAssetUpdate(input: $input) {
    __typename
    ... on GalleryAsset {
      id
      description
      processing
      rawUrl
      position
      url
    }
    ... on NotFoundError {
      message
    }
    ... on UnauthenticatedError {
      message
    }
    ... on ValidationErrorCollection {
      errors {
        message
        type
        field
      }
    }
  }
}
    `;
export type GalleryAssetUpdateMutationFn = Apollo.MutationFunction<GalleryAssetUpdateMutation, GalleryAssetUpdateMutationVariables>;

/**
 * __useGalleryAssetUpdateMutation__
 *
 * To run a mutation, you first call `useGalleryAssetUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGalleryAssetUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [galleryAssetUpdateMutation, { data, loading, error }] = useGalleryAssetUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGalleryAssetUpdateMutation(baseOptions?: Apollo.MutationHookOptions<GalleryAssetUpdateMutation, GalleryAssetUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GalleryAssetUpdateMutation, GalleryAssetUpdateMutationVariables>(GalleryAssetUpdateDocument, options);
      }
export type GalleryAssetUpdateMutationHookResult = ReturnType<typeof useGalleryAssetUpdateMutation>;
export type GalleryAssetUpdateMutationResult = Apollo.MutationResult<GalleryAssetUpdateMutation>;
export type GalleryAssetUpdateMutationOptions = Apollo.BaseMutationOptions<GalleryAssetUpdateMutation, GalleryAssetUpdateMutationVariables>;
export const GalleryAssetByIdDocument = gql`
    query GalleryAssetById($id: ID!) {
  galleryAssetById(id: $id) {
    __typename
    ... on GalleryAsset {
      id
      description
      processing
      rawUrl
      position
      url
    }
    ... on NotFoundError {
      message
    }
    ... on UnauthenticatedError {
      message
    }
  }
}
    `;

/**
 * __useGalleryAssetByIdQuery__
 *
 * To run a query within a React component, call `useGalleryAssetByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGalleryAssetByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGalleryAssetByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGalleryAssetByIdQuery(baseOptions: Apollo.QueryHookOptions<GalleryAssetByIdQuery, GalleryAssetByIdQueryVariables> & ({ variables: GalleryAssetByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GalleryAssetByIdQuery, GalleryAssetByIdQueryVariables>(GalleryAssetByIdDocument, options);
      }
export function useGalleryAssetByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GalleryAssetByIdQuery, GalleryAssetByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GalleryAssetByIdQuery, GalleryAssetByIdQueryVariables>(GalleryAssetByIdDocument, options);
        }
export function useGalleryAssetByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GalleryAssetByIdQuery, GalleryAssetByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GalleryAssetByIdQuery, GalleryAssetByIdQueryVariables>(GalleryAssetByIdDocument, options);
        }
export type GalleryAssetByIdQueryHookResult = ReturnType<typeof useGalleryAssetByIdQuery>;
export type GalleryAssetByIdLazyQueryHookResult = ReturnType<typeof useGalleryAssetByIdLazyQuery>;
export type GalleryAssetByIdSuspenseQueryHookResult = ReturnType<typeof useGalleryAssetByIdSuspenseQuery>;
export type GalleryAssetByIdQueryResult = Apollo.QueryResult<GalleryAssetByIdQuery, GalleryAssetByIdQueryVariables>;
export function refetchGalleryAssetByIdQuery(variables: GalleryAssetByIdQueryVariables) {
      return { query: GalleryAssetByIdDocument, variables: variables }
    }
export const GiftCardImageFindByIdDocument = gql`
    query GiftCardImageFindById($id: ID!) {
  giftCardImageById(id: $id) {
    __typename
    ... on GiftCardImage {
      id
      active
      imageProcessing
      imageUrl
    }
    ... on UnauthenticatedError {
      message
    }
    ... on NotFoundError {
      message
    }
  }
}
    `;

/**
 * __useGiftCardImageFindByIdQuery__
 *
 * To run a query within a React component, call `useGiftCardImageFindByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGiftCardImageFindByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGiftCardImageFindByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGiftCardImageFindByIdQuery(baseOptions: Apollo.QueryHookOptions<GiftCardImageFindByIdQuery, GiftCardImageFindByIdQueryVariables> & ({ variables: GiftCardImageFindByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GiftCardImageFindByIdQuery, GiftCardImageFindByIdQueryVariables>(GiftCardImageFindByIdDocument, options);
      }
export function useGiftCardImageFindByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GiftCardImageFindByIdQuery, GiftCardImageFindByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GiftCardImageFindByIdQuery, GiftCardImageFindByIdQueryVariables>(GiftCardImageFindByIdDocument, options);
        }
export function useGiftCardImageFindByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GiftCardImageFindByIdQuery, GiftCardImageFindByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GiftCardImageFindByIdQuery, GiftCardImageFindByIdQueryVariables>(GiftCardImageFindByIdDocument, options);
        }
export type GiftCardImageFindByIdQueryHookResult = ReturnType<typeof useGiftCardImageFindByIdQuery>;
export type GiftCardImageFindByIdLazyQueryHookResult = ReturnType<typeof useGiftCardImageFindByIdLazyQuery>;
export type GiftCardImageFindByIdSuspenseQueryHookResult = ReturnType<typeof useGiftCardImageFindByIdSuspenseQuery>;
export type GiftCardImageFindByIdQueryResult = Apollo.QueryResult<GiftCardImageFindByIdQuery, GiftCardImageFindByIdQueryVariables>;
export function refetchGiftCardImageFindByIdQuery(variables: GiftCardImageFindByIdQueryVariables) {
      return { query: GiftCardImageFindByIdDocument, variables: variables }
    }
export const GiftCardImageListAllActiveDocument = gql`
    query GiftCardImageListAllActive($page: Int!, $pageSize: Int!) {
  giftCardImageListAllActive(page: $page, pageSize: $pageSize) {
    entries {
      id
      active
      imageUrl
      imageProcessing
    }
    meta {
      nextPage
      previousPage
      currentPage
      totalEntries
    }
  }
}
    `;

/**
 * __useGiftCardImageListAllActiveQuery__
 *
 * To run a query within a React component, call `useGiftCardImageListAllActiveQuery` and pass it any options that fit your needs.
 * When your component renders, `useGiftCardImageListAllActiveQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGiftCardImageListAllActiveQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useGiftCardImageListAllActiveQuery(baseOptions: Apollo.QueryHookOptions<GiftCardImageListAllActiveQuery, GiftCardImageListAllActiveQueryVariables> & ({ variables: GiftCardImageListAllActiveQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GiftCardImageListAllActiveQuery, GiftCardImageListAllActiveQueryVariables>(GiftCardImageListAllActiveDocument, options);
      }
export function useGiftCardImageListAllActiveLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GiftCardImageListAllActiveQuery, GiftCardImageListAllActiveQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GiftCardImageListAllActiveQuery, GiftCardImageListAllActiveQueryVariables>(GiftCardImageListAllActiveDocument, options);
        }
export function useGiftCardImageListAllActiveSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GiftCardImageListAllActiveQuery, GiftCardImageListAllActiveQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GiftCardImageListAllActiveQuery, GiftCardImageListAllActiveQueryVariables>(GiftCardImageListAllActiveDocument, options);
        }
export type GiftCardImageListAllActiveQueryHookResult = ReturnType<typeof useGiftCardImageListAllActiveQuery>;
export type GiftCardImageListAllActiveLazyQueryHookResult = ReturnType<typeof useGiftCardImageListAllActiveLazyQuery>;
export type GiftCardImageListAllActiveSuspenseQueryHookResult = ReturnType<typeof useGiftCardImageListAllActiveSuspenseQuery>;
export type GiftCardImageListAllActiveQueryResult = Apollo.QueryResult<GiftCardImageListAllActiveQuery, GiftCardImageListAllActiveQueryVariables>;
export function refetchGiftCardImageListAllActiveQuery(variables: GiftCardImageListAllActiveQueryVariables) {
      return { query: GiftCardImageListAllActiveDocument, variables: variables }
    }
export const GiftCardCreateDocument = gql`
    mutation GiftCardCreate($input: GiftCardCreateInput!) {
  giftCardCreate(input: $input) {
    __typename
    ... on GiftCard {
      id
      paymentServiceTransactionClientSecret
    }
    ... on ValidationErrorCollection {
      errors {
        field
        message
        type
      }
    }
  }
}
    `;
export type GiftCardCreateMutationFn = Apollo.MutationFunction<GiftCardCreateMutation, GiftCardCreateMutationVariables>;

/**
 * __useGiftCardCreateMutation__
 *
 * To run a mutation, you first call `useGiftCardCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGiftCardCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [giftCardCreateMutation, { data, loading, error }] = useGiftCardCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGiftCardCreateMutation(baseOptions?: Apollo.MutationHookOptions<GiftCardCreateMutation, GiftCardCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GiftCardCreateMutation, GiftCardCreateMutationVariables>(GiftCardCreateDocument, options);
      }
export type GiftCardCreateMutationHookResult = ReturnType<typeof useGiftCardCreateMutation>;
export type GiftCardCreateMutationResult = Apollo.MutationResult<GiftCardCreateMutation>;
export type GiftCardCreateMutationOptions = Apollo.BaseMutationOptions<GiftCardCreateMutation, GiftCardCreateMutationVariables>;
export const GiftCardRedeemDocument = gql`
    mutation GiftCardRedeem($certificateNumber: String!, $input: GiftCardRedeemInput!) {
  giftCardRedeem(certificateNumber: $certificateNumber, input: $input) {
    __typename
    ... on GiftCard {
      id
      certificateNumber
      createdAt
      currentBalanceCents
      imageUrl
      imageProcessing
      issuedAt
      orderAmountCents
      orderNumber
      paymentServiceTransactionClientSecret
      recipientAddressLineOne
      recipientAddressLineTwo
      recipientCity
      recipientCountryShortName
      recipientEmail
      recipientFirstName
      recipientLastName
      recipientPostalCode
      recipientStateOrProvinceLongName
      recipientLat
      recipientLng
      senderAddressLineOne
      senderAddressLineTwo
      senderCity
      senderCountryShortName
      senderEmail
      senderFirstName
      senderLastName
      senderMessage
      senderPhoneNumber
      senderPostalCode
      senderStateOrProvinceLongName
      shippingType
      shippingFeeCents
      status
      type
      verifiedAt
      deactivationDescription
    }
    ... on NotFoundError {
      message
    }
    ... on UnauthenticatedError {
      message
    }
    ... on UnverifiedError {
      message
    }
    ... on ValidationErrorCollection {
      errors {
        message
        type
        field
      }
    }
  }
}
    `;
export type GiftCardRedeemMutationFn = Apollo.MutationFunction<GiftCardRedeemMutation, GiftCardRedeemMutationVariables>;

/**
 * __useGiftCardRedeemMutation__
 *
 * To run a mutation, you first call `useGiftCardRedeemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGiftCardRedeemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [giftCardRedeemMutation, { data, loading, error }] = useGiftCardRedeemMutation({
 *   variables: {
 *      certificateNumber: // value for 'certificateNumber'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGiftCardRedeemMutation(baseOptions?: Apollo.MutationHookOptions<GiftCardRedeemMutation, GiftCardRedeemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GiftCardRedeemMutation, GiftCardRedeemMutationVariables>(GiftCardRedeemDocument, options);
      }
export type GiftCardRedeemMutationHookResult = ReturnType<typeof useGiftCardRedeemMutation>;
export type GiftCardRedeemMutationResult = Apollo.MutationResult<GiftCardRedeemMutation>;
export type GiftCardRedeemMutationOptions = Apollo.BaseMutationOptions<GiftCardRedeemMutation, GiftCardRedeemMutationVariables>;
export const GiftCardUpdateUnpurchasedDocument = gql`
    mutation GiftCardUpdateUnpurchased($input: GiftCardUpdateUnpurchasedInput!) {
  giftCardUpdateUnpurchased(input: $input) {
    __typename
    ... on GiftCard {
      id
    }
    ... on NotFoundError {
      message
    }
    ... on ValidationErrorCollection {
      errors {
        message
        type
        field
      }
    }
  }
}
    `;
export type GiftCardUpdateUnpurchasedMutationFn = Apollo.MutationFunction<GiftCardUpdateUnpurchasedMutation, GiftCardUpdateUnpurchasedMutationVariables>;

/**
 * __useGiftCardUpdateUnpurchasedMutation__
 *
 * To run a mutation, you first call `useGiftCardUpdateUnpurchasedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGiftCardUpdateUnpurchasedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [giftCardUpdateUnpurchasedMutation, { data, loading, error }] = useGiftCardUpdateUnpurchasedMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGiftCardUpdateUnpurchasedMutation(baseOptions?: Apollo.MutationHookOptions<GiftCardUpdateUnpurchasedMutation, GiftCardUpdateUnpurchasedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GiftCardUpdateUnpurchasedMutation, GiftCardUpdateUnpurchasedMutationVariables>(GiftCardUpdateUnpurchasedDocument, options);
      }
export type GiftCardUpdateUnpurchasedMutationHookResult = ReturnType<typeof useGiftCardUpdateUnpurchasedMutation>;
export type GiftCardUpdateUnpurchasedMutationResult = Apollo.MutationResult<GiftCardUpdateUnpurchasedMutation>;
export type GiftCardUpdateUnpurchasedMutationOptions = Apollo.BaseMutationOptions<GiftCardUpdateUnpurchasedMutation, GiftCardUpdateUnpurchasedMutationVariables>;
export const GiftCardByCertificateNumberDocument = gql`
    query GiftCardByCertificateNumber($certificateNumber: String!) {
  giftCard: giftCardByCertificateNumber(certificateNumber: $certificateNumber) {
    __typename
    ... on GiftCard {
      id
      createdAt
      currentBalanceCents
      imageUrl
      imageProcessing
      issuedAt
      orderAmountCents
      orderNumber
      certificateNumber
      paymentServiceTransactionClientSecret
      recipientAddressLineOne
      recipientAddressLineTwo
      recipientCity
      recipientCountryShortName
      recipientEmail
      recipientFirstName
      recipientLastName
      recipientPostalCode
      recipientStateOrProvinceLongName
      recipientLat
      recipientLng
      senderAddressLineOne
      senderAddressLineTwo
      senderCity
      senderCountryShortName
      senderEmail
      senderFirstName
      senderLastName
      senderMessage
      senderPhoneNumber
      senderPostalCode
      senderStateOrProvinceLongName
      shippingType
      shippingFeeCents
      status
      type
      verifiedAt
    }
    ... on NotFoundError {
      message
    }
  }
}
    `;

/**
 * __useGiftCardByCertificateNumberQuery__
 *
 * To run a query within a React component, call `useGiftCardByCertificateNumberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGiftCardByCertificateNumberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGiftCardByCertificateNumberQuery({
 *   variables: {
 *      certificateNumber: // value for 'certificateNumber'
 *   },
 * });
 */
export function useGiftCardByCertificateNumberQuery(baseOptions: Apollo.QueryHookOptions<GiftCardByCertificateNumberQuery, GiftCardByCertificateNumberQueryVariables> & ({ variables: GiftCardByCertificateNumberQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GiftCardByCertificateNumberQuery, GiftCardByCertificateNumberQueryVariables>(GiftCardByCertificateNumberDocument, options);
      }
export function useGiftCardByCertificateNumberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GiftCardByCertificateNumberQuery, GiftCardByCertificateNumberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GiftCardByCertificateNumberQuery, GiftCardByCertificateNumberQueryVariables>(GiftCardByCertificateNumberDocument, options);
        }
export function useGiftCardByCertificateNumberSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GiftCardByCertificateNumberQuery, GiftCardByCertificateNumberQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GiftCardByCertificateNumberQuery, GiftCardByCertificateNumberQueryVariables>(GiftCardByCertificateNumberDocument, options);
        }
export type GiftCardByCertificateNumberQueryHookResult = ReturnType<typeof useGiftCardByCertificateNumberQuery>;
export type GiftCardByCertificateNumberLazyQueryHookResult = ReturnType<typeof useGiftCardByCertificateNumberLazyQuery>;
export type GiftCardByCertificateNumberSuspenseQueryHookResult = ReturnType<typeof useGiftCardByCertificateNumberSuspenseQuery>;
export type GiftCardByCertificateNumberQueryResult = Apollo.QueryResult<GiftCardByCertificateNumberQuery, GiftCardByCertificateNumberQueryVariables>;
export function refetchGiftCardByCertificateNumberQuery(variables: GiftCardByCertificateNumberQueryVariables) {
      return { query: GiftCardByCertificateNumberDocument, variables: variables }
    }
export const GiftCardByPaymentServiceTransactionClientSecretDocument = gql`
    query GiftCardByPaymentServiceTransactionClientSecret($clientSecret: String!) {
  giftCardByPaymentServiceTransactionClientSecret(clientSecret: $clientSecret) {
    __typename
    ... on GiftCard {
      id
      createdAt
      currentBalanceCents
      imageUploadUrl
      imageUrl
      imageProcessing
      issuedAt
      orderAmountCents
      orderNumber
      paymentServiceTransactionClientSecret
      recipientAddressLineOne
      recipientAddressLineTwo
      recipientCity
      recipientCountryShortName
      recipientEmail
      recipientFirstName
      recipientLastName
      recipientPostalCode
      recipientStateOrProvinceLongName
      recipientLat
      recipientLng
      senderAddressLineOne
      senderAddressLineTwo
      senderCity
      senderCountryShortName
      senderEmail
      senderFirstName
      senderLastName
      senderMessage
      senderPhoneNumber
      senderPostalCode
      senderStateOrProvinceLongName
      shippingType
      shippingFeeCents
      status
      type
      verifiedAt
      promo
    }
    ... on NotFoundError {
      message
    }
  }
}
    `;

/**
 * __useGiftCardByPaymentServiceTransactionClientSecretQuery__
 *
 * To run a query within a React component, call `useGiftCardByPaymentServiceTransactionClientSecretQuery` and pass it any options that fit your needs.
 * When your component renders, `useGiftCardByPaymentServiceTransactionClientSecretQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGiftCardByPaymentServiceTransactionClientSecretQuery({
 *   variables: {
 *      clientSecret: // value for 'clientSecret'
 *   },
 * });
 */
export function useGiftCardByPaymentServiceTransactionClientSecretQuery(baseOptions: Apollo.QueryHookOptions<GiftCardByPaymentServiceTransactionClientSecretQuery, GiftCardByPaymentServiceTransactionClientSecretQueryVariables> & ({ variables: GiftCardByPaymentServiceTransactionClientSecretQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GiftCardByPaymentServiceTransactionClientSecretQuery, GiftCardByPaymentServiceTransactionClientSecretQueryVariables>(GiftCardByPaymentServiceTransactionClientSecretDocument, options);
      }
export function useGiftCardByPaymentServiceTransactionClientSecretLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GiftCardByPaymentServiceTransactionClientSecretQuery, GiftCardByPaymentServiceTransactionClientSecretQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GiftCardByPaymentServiceTransactionClientSecretQuery, GiftCardByPaymentServiceTransactionClientSecretQueryVariables>(GiftCardByPaymentServiceTransactionClientSecretDocument, options);
        }
export function useGiftCardByPaymentServiceTransactionClientSecretSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GiftCardByPaymentServiceTransactionClientSecretQuery, GiftCardByPaymentServiceTransactionClientSecretQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GiftCardByPaymentServiceTransactionClientSecretQuery, GiftCardByPaymentServiceTransactionClientSecretQueryVariables>(GiftCardByPaymentServiceTransactionClientSecretDocument, options);
        }
export type GiftCardByPaymentServiceTransactionClientSecretQueryHookResult = ReturnType<typeof useGiftCardByPaymentServiceTransactionClientSecretQuery>;
export type GiftCardByPaymentServiceTransactionClientSecretLazyQueryHookResult = ReturnType<typeof useGiftCardByPaymentServiceTransactionClientSecretLazyQuery>;
export type GiftCardByPaymentServiceTransactionClientSecretSuspenseQueryHookResult = ReturnType<typeof useGiftCardByPaymentServiceTransactionClientSecretSuspenseQuery>;
export type GiftCardByPaymentServiceTransactionClientSecretQueryResult = Apollo.QueryResult<GiftCardByPaymentServiceTransactionClientSecretQuery, GiftCardByPaymentServiceTransactionClientSecretQueryVariables>;
export function refetchGiftCardByPaymentServiceTransactionClientSecretQuery(variables: GiftCardByPaymentServiceTransactionClientSecretQueryVariables) {
      return { query: GiftCardByPaymentServiceTransactionClientSecretDocument, variables: variables }
    }
export const GiftCardByIdDocument = gql`
    query GiftCardByID($id: ID!) {
  giftCardById(id: $id) {
    __typename
    ... on GiftCard {
      id
      createdAt
      currentBalanceCents
      imageUploadUrl
      imageUrl
      imageProcessing
      issuedAt
      orderAmountCents
      orderNumber
      paymentServiceTransactionClientSecret
      recipientAddressLineOne
      recipientAddressLineTwo
      recipientCity
      recipientCountryShortName
      recipientEmail
      recipientFirstName
      recipientLastName
      recipientPostalCode
      recipientStateOrProvinceLongName
      recipientLat
      recipientLng
      senderAddressLineOne
      senderAddressLineTwo
      senderCity
      senderCountryShortName
      senderEmail
      senderFirstName
      senderLastName
      senderMessage
      senderPhoneNumber
      senderPostalCode
      senderStateOrProvinceLongName
      shippingType
      shippingFeeCents
      status
      type
      verifiedAt
      promo
    }
    ... on NotFoundError {
      message
    }
  }
}
    `;

/**
 * __useGiftCardByIdQuery__
 *
 * To run a query within a React component, call `useGiftCardByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGiftCardByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGiftCardByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGiftCardByIdQuery(baseOptions: Apollo.QueryHookOptions<GiftCardByIdQuery, GiftCardByIdQueryVariables> & ({ variables: GiftCardByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GiftCardByIdQuery, GiftCardByIdQueryVariables>(GiftCardByIdDocument, options);
      }
export function useGiftCardByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GiftCardByIdQuery, GiftCardByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GiftCardByIdQuery, GiftCardByIdQueryVariables>(GiftCardByIdDocument, options);
        }
export function useGiftCardByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GiftCardByIdQuery, GiftCardByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GiftCardByIdQuery, GiftCardByIdQueryVariables>(GiftCardByIdDocument, options);
        }
export type GiftCardByIdQueryHookResult = ReturnType<typeof useGiftCardByIdQuery>;
export type GiftCardByIdLazyQueryHookResult = ReturnType<typeof useGiftCardByIdLazyQuery>;
export type GiftCardByIdSuspenseQueryHookResult = ReturnType<typeof useGiftCardByIdSuspenseQuery>;
export type GiftCardByIdQueryResult = Apollo.QueryResult<GiftCardByIdQuery, GiftCardByIdQueryVariables>;
export function refetchGiftCardByIdQuery(variables: GiftCardByIdQueryVariables) {
      return { query: GiftCardByIdDocument, variables: variables }
    }
export const CurrentInnkeeperDocument = gql`
    query CurrentInnkeeper {
  currentInnkeeper {
    __typename
    ... on Innkeeper {
      id
      accessToken
      claimable
      email
      firstName
      identityVerified
      lastName
      phoneNumber
      referredByUserId
      registeredAt
    }
    ... on UnauthenticatedError {
      message
    }
  }
}
    `;

/**
 * __useCurrentInnkeeperQuery__
 *
 * To run a query within a React component, call `useCurrentInnkeeperQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentInnkeeperQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentInnkeeperQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentInnkeeperQuery(baseOptions?: Apollo.QueryHookOptions<CurrentInnkeeperQuery, CurrentInnkeeperQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentInnkeeperQuery, CurrentInnkeeperQueryVariables>(CurrentInnkeeperDocument, options);
      }
export function useCurrentInnkeeperLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentInnkeeperQuery, CurrentInnkeeperQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentInnkeeperQuery, CurrentInnkeeperQueryVariables>(CurrentInnkeeperDocument, options);
        }
export function useCurrentInnkeeperSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentInnkeeperQuery, CurrentInnkeeperQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentInnkeeperQuery, CurrentInnkeeperQueryVariables>(CurrentInnkeeperDocument, options);
        }
export type CurrentInnkeeperQueryHookResult = ReturnType<typeof useCurrentInnkeeperQuery>;
export type CurrentInnkeeperLazyQueryHookResult = ReturnType<typeof useCurrentInnkeeperLazyQuery>;
export type CurrentInnkeeperSuspenseQueryHookResult = ReturnType<typeof useCurrentInnkeeperSuspenseQuery>;
export type CurrentInnkeeperQueryResult = Apollo.QueryResult<CurrentInnkeeperQuery, CurrentInnkeeperQueryVariables>;
export function refetchCurrentInnkeeperQuery(variables?: CurrentInnkeeperQueryVariables) {
      return { query: CurrentInnkeeperDocument, variables: variables }
    }
export const CreateLeadDocument = gql`
    mutation CreateLead($input: CreateLeadInput!) {
  createLead(input: $input) {
    __typename
    ... on LeadCreatedMessage {
      message
    }
    ... on ValidationErrorCollection {
      errors {
        message
        type
        field
      }
    }
  }
}
    `;
export type CreateLeadMutationFn = Apollo.MutationFunction<CreateLeadMutation, CreateLeadMutationVariables>;

/**
 * __useCreateLeadMutation__
 *
 * To run a mutation, you first call `useCreateLeadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLeadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLeadMutation, { data, loading, error }] = useCreateLeadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLeadMutation(baseOptions?: Apollo.MutationHookOptions<CreateLeadMutation, CreateLeadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLeadMutation, CreateLeadMutationVariables>(CreateLeadDocument, options);
      }
export type CreateLeadMutationHookResult = ReturnType<typeof useCreateLeadMutation>;
export type CreateLeadMutationResult = Apollo.MutationResult<CreateLeadMutation>;
export type CreateLeadMutationOptions = Apollo.BaseMutationOptions<CreateLeadMutation, CreateLeadMutationVariables>;
export const ListingBookingInfoDocument = gql`
    query ListingBookingInfo($slug: String!) {
  listingBookingInfo(slug: $slug) {
    __typename
    ... on ListingBookingInfo {
      availabilityDates {
        date
        available
        checkInAllowed
        checkOutAllowed
        minNights
        maxNights
      }
    }
    ... on NotFoundError {
      message
    }
  }
}
    `;

/**
 * __useListingBookingInfoQuery__
 *
 * To run a query within a React component, call `useListingBookingInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useListingBookingInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListingBookingInfoQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useListingBookingInfoQuery(baseOptions: Apollo.QueryHookOptions<ListingBookingInfoQuery, ListingBookingInfoQueryVariables> & ({ variables: ListingBookingInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListingBookingInfoQuery, ListingBookingInfoQueryVariables>(ListingBookingInfoDocument, options);
      }
export function useListingBookingInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListingBookingInfoQuery, ListingBookingInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListingBookingInfoQuery, ListingBookingInfoQueryVariables>(ListingBookingInfoDocument, options);
        }
export function useListingBookingInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListingBookingInfoQuery, ListingBookingInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListingBookingInfoQuery, ListingBookingInfoQueryVariables>(ListingBookingInfoDocument, options);
        }
export type ListingBookingInfoQueryHookResult = ReturnType<typeof useListingBookingInfoQuery>;
export type ListingBookingInfoLazyQueryHookResult = ReturnType<typeof useListingBookingInfoLazyQuery>;
export type ListingBookingInfoSuspenseQueryHookResult = ReturnType<typeof useListingBookingInfoSuspenseQuery>;
export type ListingBookingInfoQueryResult = Apollo.QueryResult<ListingBookingInfoQuery, ListingBookingInfoQueryVariables>;
export function refetchListingBookingInfoQuery(variables: ListingBookingInfoQueryVariables) {
      return { query: ListingBookingInfoDocument, variables: variables }
    }
export const ListingReviewsListAllForListingDocument = gql`
    query ListingReviewsListAllForListing($id: String!, $page: Int, $pageSize: Int) {
  listingReviewsListAllForListing(id: $id, page: $page, pageSize: $pageSize) {
    __typename
    ... on ListingReviewCollection {
      entries {
        id
        rating
        body
        authorName
        date
      }
      meta {
        currentPage
        nextPage
        previousPage
        totalEntries
      }
    }
    ... on NotFoundError {
      message
    }
  }
}
    `;

/**
 * __useListingReviewsListAllForListingQuery__
 *
 * To run a query within a React component, call `useListingReviewsListAllForListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useListingReviewsListAllForListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListingReviewsListAllForListingQuery({
 *   variables: {
 *      id: // value for 'id'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useListingReviewsListAllForListingQuery(baseOptions: Apollo.QueryHookOptions<ListingReviewsListAllForListingQuery, ListingReviewsListAllForListingQueryVariables> & ({ variables: ListingReviewsListAllForListingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListingReviewsListAllForListingQuery, ListingReviewsListAllForListingQueryVariables>(ListingReviewsListAllForListingDocument, options);
      }
export function useListingReviewsListAllForListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListingReviewsListAllForListingQuery, ListingReviewsListAllForListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListingReviewsListAllForListingQuery, ListingReviewsListAllForListingQueryVariables>(ListingReviewsListAllForListingDocument, options);
        }
export function useListingReviewsListAllForListingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListingReviewsListAllForListingQuery, ListingReviewsListAllForListingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListingReviewsListAllForListingQuery, ListingReviewsListAllForListingQueryVariables>(ListingReviewsListAllForListingDocument, options);
        }
export type ListingReviewsListAllForListingQueryHookResult = ReturnType<typeof useListingReviewsListAllForListingQuery>;
export type ListingReviewsListAllForListingLazyQueryHookResult = ReturnType<typeof useListingReviewsListAllForListingLazyQuery>;
export type ListingReviewsListAllForListingSuspenseQueryHookResult = ReturnType<typeof useListingReviewsListAllForListingSuspenseQuery>;
export type ListingReviewsListAllForListingQueryResult = Apollo.QueryResult<ListingReviewsListAllForListingQuery, ListingReviewsListAllForListingQueryVariables>;
export function refetchListingReviewsListAllForListingQuery(variables: ListingReviewsListAllForListingQueryVariables) {
      return { query: ListingReviewsListAllForListingDocument, variables: variables }
    }
export const ListingUpdateDocument = gql`
    mutation ListingUpdate($input: ListingUpdateInput!) {
  listingUpdate(input: $input) {
    __typename
    ... on Listing {
      ...OwnerListingFields
    }
    ... on ValidationErrorCollection {
      errors {
        message
        type
        field
      }
    }
    ... on UnauthenticatedError {
      message
    }
  }
}
    ${OwnerListingFieldsFragmentDoc}`;
export type ListingUpdateMutationFn = Apollo.MutationFunction<ListingUpdateMutation, ListingUpdateMutationVariables>;

/**
 * __useListingUpdateMutation__
 *
 * To run a mutation, you first call `useListingUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useListingUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [listingUpdateMutation, { data, loading, error }] = useListingUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListingUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ListingUpdateMutation, ListingUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ListingUpdateMutation, ListingUpdateMutationVariables>(ListingUpdateDocument, options);
      }
export type ListingUpdateMutationHookResult = ReturnType<typeof useListingUpdateMutation>;
export type ListingUpdateMutationResult = Apollo.MutationResult<ListingUpdateMutation>;
export type ListingUpdateMutationOptions = Apollo.BaseMutationOptions<ListingUpdateMutation, ListingUpdateMutationVariables>;
export const ListingPublishDocument = gql`
    mutation ListingPublish($input: ListingPublishInput!) {
  listingPublish(input: $input) {
    __typename
    ... on Listing {
      ...OwnerListingFields
    }
    ... on ValidationErrorCollection {
      errors {
        message
        type
        field
      }
    }
    ... on UnauthenticatedError {
      message
    }
  }
}
    ${OwnerListingFieldsFragmentDoc}`;
export type ListingPublishMutationFn = Apollo.MutationFunction<ListingPublishMutation, ListingPublishMutationVariables>;

/**
 * __useListingPublishMutation__
 *
 * To run a mutation, you first call `useListingPublishMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useListingPublishMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [listingPublishMutation, { data, loading, error }] = useListingPublishMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListingPublishMutation(baseOptions?: Apollo.MutationHookOptions<ListingPublishMutation, ListingPublishMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ListingPublishMutation, ListingPublishMutationVariables>(ListingPublishDocument, options);
      }
export type ListingPublishMutationHookResult = ReturnType<typeof useListingPublishMutation>;
export type ListingPublishMutationResult = Apollo.MutationResult<ListingPublishMutation>;
export type ListingPublishMutationOptions = Apollo.BaseMutationOptions<ListingPublishMutation, ListingPublishMutationVariables>;
export const ListingUnpublishDocument = gql`
    mutation ListingUnpublish($listingId: ID!) {
  listingUnpublish(listingId: $listingId) {
    __typename
    ... on Listing {
      ...OwnerListingFields
    }
    ... on UnauthenticatedError {
      message
    }
  }
}
    ${OwnerListingFieldsFragmentDoc}`;
export type ListingUnpublishMutationFn = Apollo.MutationFunction<ListingUnpublishMutation, ListingUnpublishMutationVariables>;

/**
 * __useListingUnpublishMutation__
 *
 * To run a mutation, you first call `useListingUnpublishMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useListingUnpublishMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [listingUnpublishMutation, { data, loading, error }] = useListingUnpublishMutation({
 *   variables: {
 *      listingId: // value for 'listingId'
 *   },
 * });
 */
export function useListingUnpublishMutation(baseOptions?: Apollo.MutationHookOptions<ListingUnpublishMutation, ListingUnpublishMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ListingUnpublishMutation, ListingUnpublishMutationVariables>(ListingUnpublishDocument, options);
      }
export type ListingUnpublishMutationHookResult = ReturnType<typeof useListingUnpublishMutation>;
export type ListingUnpublishMutationResult = Apollo.MutationResult<ListingUnpublishMutation>;
export type ListingUnpublishMutationOptions = Apollo.BaseMutationOptions<ListingUnpublishMutation, ListingUnpublishMutationVariables>;
export const SetSubscriptionDocument = gql`
    mutation SetSubscription($input: SetSubscriptionInput!) {
  setSubscription(input: $input) {
    __typename
    ... on Listing {
      ...ListingFields
    }
    ... on NotFoundError {
      message
    }
    ... on UnauthenticatedError {
      message
    }
    ... on ValidationErrorCollection {
      errors {
        message
        type
        field
      }
    }
  }
}
    ${ListingFieldsFragmentDoc}`;
export type SetSubscriptionMutationFn = Apollo.MutationFunction<SetSubscriptionMutation, SetSubscriptionMutationVariables>;

/**
 * __useSetSubscriptionMutation__
 *
 * To run a mutation, you first call `useSetSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setSubscriptionMutation, { data, loading, error }] = useSetSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<SetSubscriptionMutation, SetSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetSubscriptionMutation, SetSubscriptionMutationVariables>(SetSubscriptionDocument, options);
      }
export type SetSubscriptionMutationHookResult = ReturnType<typeof useSetSubscriptionMutation>;
export type SetSubscriptionMutationResult = Apollo.MutationResult<SetSubscriptionMutation>;
export type SetSubscriptionMutationOptions = Apollo.BaseMutationOptions<SetSubscriptionMutation, SetSubscriptionMutationVariables>;
export const AdminSetSubscriptionDocument = gql`
    mutation AdminSetSubscription($input: AdminSetSubscriptionInput!) {
  adminSetSubscription(input: $input) {
    __typename
    ... on Listing {
      ...ListingFields
    }
    ... on NotFoundError {
      message
    }
    ... on UnauthenticatedError {
      message
    }
    ... on ValidationErrorCollection {
      errors {
        message
        type
        field
      }
    }
  }
}
    ${ListingFieldsFragmentDoc}`;
export type AdminSetSubscriptionMutationFn = Apollo.MutationFunction<AdminSetSubscriptionMutation, AdminSetSubscriptionMutationVariables>;

/**
 * __useAdminSetSubscriptionMutation__
 *
 * To run a mutation, you first call `useAdminSetSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminSetSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminSetSubscriptionMutation, { data, loading, error }] = useAdminSetSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminSetSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<AdminSetSubscriptionMutation, AdminSetSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminSetSubscriptionMutation, AdminSetSubscriptionMutationVariables>(AdminSetSubscriptionDocument, options);
      }
export type AdminSetSubscriptionMutationHookResult = ReturnType<typeof useAdminSetSubscriptionMutation>;
export type AdminSetSubscriptionMutationResult = Apollo.MutationResult<AdminSetSubscriptionMutation>;
export type AdminSetSubscriptionMutationOptions = Apollo.BaseMutationOptions<AdminSetSubscriptionMutation, AdminSetSubscriptionMutationVariables>;
export const ListingCreateDocument = gql`
    mutation ListingCreate($input: ListingCreateInput!) {
  listingCreate(input: $input) {
    __typename
    ... on Listing {
      ...ListingFields
    }
    ... on UnauthenticatedError {
      message
    }
    ... on ValidationErrorCollection {
      errors {
        message
        type
        field
      }
    }
  }
}
    ${ListingFieldsFragmentDoc}`;
export type ListingCreateMutationFn = Apollo.MutationFunction<ListingCreateMutation, ListingCreateMutationVariables>;

/**
 * __useListingCreateMutation__
 *
 * To run a mutation, you first call `useListingCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useListingCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [listingCreateMutation, { data, loading, error }] = useListingCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListingCreateMutation(baseOptions?: Apollo.MutationHookOptions<ListingCreateMutation, ListingCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ListingCreateMutation, ListingCreateMutationVariables>(ListingCreateDocument, options);
      }
export type ListingCreateMutationHookResult = ReturnType<typeof useListingCreateMutation>;
export type ListingCreateMutationResult = Apollo.MutationResult<ListingCreateMutation>;
export type ListingCreateMutationOptions = Apollo.BaseMutationOptions<ListingCreateMutation, ListingCreateMutationVariables>;
export const ListingFavoriteCreateDocument = gql`
    mutation ListingFavoriteCreate($input: ListingFavoriteCreateInput!) {
  listingFavoriteCreate(input: $input) {
    __typename
    ... on Listing {
      ...ListingFields
    }
    ... on UnauthenticatedError {
      message
    }
    ... on ValidationErrorCollection {
      errors {
        message
        type
        field
      }
    }
  }
}
    ${ListingFieldsFragmentDoc}`;
export type ListingFavoriteCreateMutationFn = Apollo.MutationFunction<ListingFavoriteCreateMutation, ListingFavoriteCreateMutationVariables>;

/**
 * __useListingFavoriteCreateMutation__
 *
 * To run a mutation, you first call `useListingFavoriteCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useListingFavoriteCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [listingFavoriteCreateMutation, { data, loading, error }] = useListingFavoriteCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListingFavoriteCreateMutation(baseOptions?: Apollo.MutationHookOptions<ListingFavoriteCreateMutation, ListingFavoriteCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ListingFavoriteCreateMutation, ListingFavoriteCreateMutationVariables>(ListingFavoriteCreateDocument, options);
      }
export type ListingFavoriteCreateMutationHookResult = ReturnType<typeof useListingFavoriteCreateMutation>;
export type ListingFavoriteCreateMutationResult = Apollo.MutationResult<ListingFavoriteCreateMutation>;
export type ListingFavoriteCreateMutationOptions = Apollo.BaseMutationOptions<ListingFavoriteCreateMutation, ListingFavoriteCreateMutationVariables>;
export const ListingFavoriteDeleteDocument = gql`
    mutation ListingFavoriteDelete($input: ListingFavoriteDeleteInput!) {
  listingFavoriteDelete(input: $input) {
    __typename
    ... on Listing {
      ...ListingFields
    }
    ... on UnauthenticatedError {
      message
    }
  }
}
    ${ListingFieldsFragmentDoc}`;
export type ListingFavoriteDeleteMutationFn = Apollo.MutationFunction<ListingFavoriteDeleteMutation, ListingFavoriteDeleteMutationVariables>;

/**
 * __useListingFavoriteDeleteMutation__
 *
 * To run a mutation, you first call `useListingFavoriteDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useListingFavoriteDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [listingFavoriteDeleteMutation, { data, loading, error }] = useListingFavoriteDeleteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListingFavoriteDeleteMutation(baseOptions?: Apollo.MutationHookOptions<ListingFavoriteDeleteMutation, ListingFavoriteDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ListingFavoriteDeleteMutation, ListingFavoriteDeleteMutationVariables>(ListingFavoriteDeleteDocument, options);
      }
export type ListingFavoriteDeleteMutationHookResult = ReturnType<typeof useListingFavoriteDeleteMutation>;
export type ListingFavoriteDeleteMutationResult = Apollo.MutationResult<ListingFavoriteDeleteMutation>;
export type ListingFavoriteDeleteMutationOptions = Apollo.BaseMutationOptions<ListingFavoriteDeleteMutation, ListingFavoriteDeleteMutationVariables>;
export const ListingToggleFeaturedByOwnerDocument = gql`
    mutation ListingToggleFeaturedByOwner($listingId: ID!) {
  listingToggleFeaturedByOwner(listingId: $listingId) {
    __typename
    ... on Listing {
      ...ListingFields
    }
    ... on ValidationErrorCollection {
      errors {
        message
        type
        field
      }
    }
    ... on UnauthenticatedError {
      message
    }
  }
}
    ${ListingFieldsFragmentDoc}`;
export type ListingToggleFeaturedByOwnerMutationFn = Apollo.MutationFunction<ListingToggleFeaturedByOwnerMutation, ListingToggleFeaturedByOwnerMutationVariables>;

/**
 * __useListingToggleFeaturedByOwnerMutation__
 *
 * To run a mutation, you first call `useListingToggleFeaturedByOwnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useListingToggleFeaturedByOwnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [listingToggleFeaturedByOwnerMutation, { data, loading, error }] = useListingToggleFeaturedByOwnerMutation({
 *   variables: {
 *      listingId: // value for 'listingId'
 *   },
 * });
 */
export function useListingToggleFeaturedByOwnerMutation(baseOptions?: Apollo.MutationHookOptions<ListingToggleFeaturedByOwnerMutation, ListingToggleFeaturedByOwnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ListingToggleFeaturedByOwnerMutation, ListingToggleFeaturedByOwnerMutationVariables>(ListingToggleFeaturedByOwnerDocument, options);
      }
export type ListingToggleFeaturedByOwnerMutationHookResult = ReturnType<typeof useListingToggleFeaturedByOwnerMutation>;
export type ListingToggleFeaturedByOwnerMutationResult = Apollo.MutationResult<ListingToggleFeaturedByOwnerMutation>;
export type ListingToggleFeaturedByOwnerMutationOptions = Apollo.BaseMutationOptions<ListingToggleFeaturedByOwnerMutation, ListingToggleFeaturedByOwnerMutationVariables>;
export const AccountCollectionListingsListAllDocument = gql`
    query AccountCollectionListingsListAll($page: Int!, $pageSize: Int! = 20, $accountId: String!, $applyFeaturedByOwnerFilter: Boolean, $sort: ListingSortOptions, $checkInDate: Date, $checkOutDate: Date, $featuresFilter: [FeatureKey!] = [], $minGuestCapacity: Int, $minNumberOfBathrooms: Int, $minNumberOfRooms: Int, $propertyTypes: [PropertyType!] = []) {
  listingsListAllActive(
    page: $page
    pageSize: $pageSize
    accountId: $accountId
    sort: $sort
    applyFeaturedByOwnerFilter: $applyFeaturedByOwnerFilter
    checkInDate: $checkInDate
    checkOutDate: $checkOutDate
    featuresFilter: $featuresFilter
    minGuestCapacity: $minGuestCapacity
    minNumberOfBathrooms: $minNumberOfBathrooms
    minNumberOfRooms: $minNumberOfRooms
    propertyTypes: $propertyTypes
  ) {
    entries {
      checkIn
      checkout
      cancellationPolicy
      city
      licenseNumber
      numberOfRooms
      numberOfBathrooms
      guestCapacity
      name
      slug
      propertyType
      uniquePropertyType
      stateOrProvinceLongName
      marketingWebsiteUrl
      bookDirectWebsiteUrl
      description
      minPrice
      maxPrice
      galleryAssets(numberOfAssets: 10, processing: false) {
        id
        url
      }
      features {
        key
        displayName
        categoryName
        promoted
      }
      listingLevel
      isDiamondCollection
      account {
        id
        slug
        companyName
        avatarUrl
      }
      isFavorited
      id
      searchableAvailability
      featuredByOwner
    }
    meta {
      totalEntries
      totalPages
      nextPage
      previousPage
    }
  }
}
    `;

/**
 * __useAccountCollectionListingsListAllQuery__
 *
 * To run a query within a React component, call `useAccountCollectionListingsListAllQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountCollectionListingsListAllQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountCollectionListingsListAllQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      accountId: // value for 'accountId'
 *      applyFeaturedByOwnerFilter: // value for 'applyFeaturedByOwnerFilter'
 *      sort: // value for 'sort'
 *      checkInDate: // value for 'checkInDate'
 *      checkOutDate: // value for 'checkOutDate'
 *      featuresFilter: // value for 'featuresFilter'
 *      minGuestCapacity: // value for 'minGuestCapacity'
 *      minNumberOfBathrooms: // value for 'minNumberOfBathrooms'
 *      minNumberOfRooms: // value for 'minNumberOfRooms'
 *      propertyTypes: // value for 'propertyTypes'
 *   },
 * });
 */
export function useAccountCollectionListingsListAllQuery(baseOptions: Apollo.QueryHookOptions<AccountCollectionListingsListAllQuery, AccountCollectionListingsListAllQueryVariables> & ({ variables: AccountCollectionListingsListAllQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountCollectionListingsListAllQuery, AccountCollectionListingsListAllQueryVariables>(AccountCollectionListingsListAllDocument, options);
      }
export function useAccountCollectionListingsListAllLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountCollectionListingsListAllQuery, AccountCollectionListingsListAllQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountCollectionListingsListAllQuery, AccountCollectionListingsListAllQueryVariables>(AccountCollectionListingsListAllDocument, options);
        }
export function useAccountCollectionListingsListAllSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountCollectionListingsListAllQuery, AccountCollectionListingsListAllQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AccountCollectionListingsListAllQuery, AccountCollectionListingsListAllQueryVariables>(AccountCollectionListingsListAllDocument, options);
        }
export type AccountCollectionListingsListAllQueryHookResult = ReturnType<typeof useAccountCollectionListingsListAllQuery>;
export type AccountCollectionListingsListAllLazyQueryHookResult = ReturnType<typeof useAccountCollectionListingsListAllLazyQuery>;
export type AccountCollectionListingsListAllSuspenseQueryHookResult = ReturnType<typeof useAccountCollectionListingsListAllSuspenseQuery>;
export type AccountCollectionListingsListAllQueryResult = Apollo.QueryResult<AccountCollectionListingsListAllQuery, AccountCollectionListingsListAllQueryVariables>;
export function refetchAccountCollectionListingsListAllQuery(variables: AccountCollectionListingsListAllQueryVariables) {
      return { query: AccountCollectionListingsListAllDocument, variables: variables }
    }
export const FeaturedListingsListAllDocument = gql`
    query FeaturedListingsListAll($page: Int! = 1, $pageSize: Int! = 20, $sort: ListingSortOptions, $stateOrProvinceLongNameFilter: [String!]) {
  listingsListAllFeatured(
    page: $page
    pageSize: $pageSize
    sort: $sort
    stateOrProvinceLongNameFilter: $stateOrProvinceLongNameFilter
  ) {
    entries {
      id
      city
      listedFloor
      numberOfRooms
      numberOfBathrooms
      guestCapacity
      name
      slug
      propertyType
      uniquePropertyType
      stateOrProvinceLongName
      isFavorited
      bookDirectWebsiteUrl
      description
      marketingWebsiteUrl
      minPrice
      maxPrice
      listingLevel
      isDiamondCollection
      features {
        key
        displayName
        categoryName
        promoted
      }
      account {
        id
        slug
        companyName
        avatarUrl
      }
      galleryAssets(numberOfAssets: 10, processing: false) {
        id
        url
        description
      }
      searchableAvailability
    }
    meta {
      totalPages
      nextPage
      previousPage
    }
  }
}
    `;

/**
 * __useFeaturedListingsListAllQuery__
 *
 * To run a query within a React component, call `useFeaturedListingsListAllQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeaturedListingsListAllQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeaturedListingsListAllQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      sort: // value for 'sort'
 *      stateOrProvinceLongNameFilter: // value for 'stateOrProvinceLongNameFilter'
 *   },
 * });
 */
export function useFeaturedListingsListAllQuery(baseOptions?: Apollo.QueryHookOptions<FeaturedListingsListAllQuery, FeaturedListingsListAllQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeaturedListingsListAllQuery, FeaturedListingsListAllQueryVariables>(FeaturedListingsListAllDocument, options);
      }
export function useFeaturedListingsListAllLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeaturedListingsListAllQuery, FeaturedListingsListAllQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeaturedListingsListAllQuery, FeaturedListingsListAllQueryVariables>(FeaturedListingsListAllDocument, options);
        }
export function useFeaturedListingsListAllSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FeaturedListingsListAllQuery, FeaturedListingsListAllQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FeaturedListingsListAllQuery, FeaturedListingsListAllQueryVariables>(FeaturedListingsListAllDocument, options);
        }
export type FeaturedListingsListAllQueryHookResult = ReturnType<typeof useFeaturedListingsListAllQuery>;
export type FeaturedListingsListAllLazyQueryHookResult = ReturnType<typeof useFeaturedListingsListAllLazyQuery>;
export type FeaturedListingsListAllSuspenseQueryHookResult = ReturnType<typeof useFeaturedListingsListAllSuspenseQuery>;
export type FeaturedListingsListAllQueryResult = Apollo.QueryResult<FeaturedListingsListAllQuery, FeaturedListingsListAllQueryVariables>;
export function refetchFeaturedListingsListAllQuery(variables?: FeaturedListingsListAllQueryVariables) {
      return { query: FeaturedListingsListAllDocument, variables: variables }
    }
export const DiamondCollectionListingsListAllDocument = gql`
    query DiamondCollectionListingsListAll($page: Int!, $pageSize: Int! = 20, $stateOrProvinceLongNameFilter: [String!]) {
  listingsListAllActive(
    page: $page
    pageSize: $pageSize
    sort: STATE_OR_PROVINCE_LONG_NAME_ASC
    stateOrProvinceLongNameFilter: $stateOrProvinceLongNameFilter
    onlyDiamondCollection: true
  ) {
    entries {
      id
      city
      listedFloor
      numberOfRooms
      numberOfBathrooms
      guestCapacity
      name
      slug
      propertyType
      uniquePropertyType
      stateOrProvinceLongName
      isFavorited
      bookDirectWebsiteUrl
      description
      marketingWebsiteUrl
      minPrice
      maxPrice
      listingLevel
      isDiamondCollection
      features {
        key
        displayName
        categoryName
        promoted
      }
      account {
        id
        slug
        companyName
        avatarUrl
      }
      galleryAssets(numberOfAssets: 10, processing: false) {
        id
        url
        description
      }
      searchableAvailability
    }
    meta {
      totalPages
      nextPage
      previousPage
    }
  }
}
    `;

/**
 * __useDiamondCollectionListingsListAllQuery__
 *
 * To run a query within a React component, call `useDiamondCollectionListingsListAllQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiamondCollectionListingsListAllQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDiamondCollectionListingsListAllQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      stateOrProvinceLongNameFilter: // value for 'stateOrProvinceLongNameFilter'
 *   },
 * });
 */
export function useDiamondCollectionListingsListAllQuery(baseOptions: Apollo.QueryHookOptions<DiamondCollectionListingsListAllQuery, DiamondCollectionListingsListAllQueryVariables> & ({ variables: DiamondCollectionListingsListAllQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DiamondCollectionListingsListAllQuery, DiamondCollectionListingsListAllQueryVariables>(DiamondCollectionListingsListAllDocument, options);
      }
export function useDiamondCollectionListingsListAllLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DiamondCollectionListingsListAllQuery, DiamondCollectionListingsListAllQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DiamondCollectionListingsListAllQuery, DiamondCollectionListingsListAllQueryVariables>(DiamondCollectionListingsListAllDocument, options);
        }
export function useDiamondCollectionListingsListAllSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DiamondCollectionListingsListAllQuery, DiamondCollectionListingsListAllQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DiamondCollectionListingsListAllQuery, DiamondCollectionListingsListAllQueryVariables>(DiamondCollectionListingsListAllDocument, options);
        }
export type DiamondCollectionListingsListAllQueryHookResult = ReturnType<typeof useDiamondCollectionListingsListAllQuery>;
export type DiamondCollectionListingsListAllLazyQueryHookResult = ReturnType<typeof useDiamondCollectionListingsListAllLazyQuery>;
export type DiamondCollectionListingsListAllSuspenseQueryHookResult = ReturnType<typeof useDiamondCollectionListingsListAllSuspenseQuery>;
export type DiamondCollectionListingsListAllQueryResult = Apollo.QueryResult<DiamondCollectionListingsListAllQuery, DiamondCollectionListingsListAllQueryVariables>;
export function refetchDiamondCollectionListingsListAllQuery(variables: DiamondCollectionListingsListAllQueryVariables) {
      return { query: DiamondCollectionListingsListAllDocument, variables: variables }
    }
export const SearchRegionForListingsByPlaceNameWithSingleAssetDocument = gql`
    query searchRegionForListingsByPlaceNameWithSingleAsset($cursorAfter: String, $cursorBefore: String, $pageSize: Int! = 30, $featuresFilter: [FeatureKey!] = [], $propertyTypes: [PropertyType!], $minGuestCapacity: Int, $minNumberOfRooms: Int, $minNumberOfBathrooms: Int, $accountId: String, $regionPath: String) {
  regionListingsCollection: listingsSearchAllActiveForPlace(
    pageSize: $pageSize
    cursorAfter: $cursorAfter
    cursorBefore: $cursorBefore
    propertyTypes: $propertyTypes
    minGuestCapacity: $minGuestCapacity
    minNumberOfRooms: $minNumberOfRooms
    minNumberOfBathrooms: $minNumberOfBathrooms
    featuresFilter: $featuresFilter
    accountId: $accountId
    regionPath: $regionPath
  ) {
    entries {
      city
      propertyType
      numberOfRooms
      numberOfBathrooms
      guestCapacity
      name
      slug
      stateOrProvinceLongName
      marketingWebsiteUrl
      bookDirectWebsiteUrl
      description
      minPrice
      maxPrice
      galleryAssets(numberOfAssets: 1, processing: false) {
        id
        url
        description
      }
      priceDisplay {
        checkInDate
        checkOutDate
        baseAmountCents
        subtotalWithoutTaxesCents
        nights
      }
      listingLevel
      isDiamondCollection
      account {
        slug
        avatarUrl
        companyName
      }
      isFavorited
      id
      searchableAvailability
    }
  }
}
    `;

/**
 * __useSearchRegionForListingsByPlaceNameWithSingleAssetQuery__
 *
 * To run a query within a React component, call `useSearchRegionForListingsByPlaceNameWithSingleAssetQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchRegionForListingsByPlaceNameWithSingleAssetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchRegionForListingsByPlaceNameWithSingleAssetQuery({
 *   variables: {
 *      cursorAfter: // value for 'cursorAfter'
 *      cursorBefore: // value for 'cursorBefore'
 *      pageSize: // value for 'pageSize'
 *      featuresFilter: // value for 'featuresFilter'
 *      propertyTypes: // value for 'propertyTypes'
 *      minGuestCapacity: // value for 'minGuestCapacity'
 *      minNumberOfRooms: // value for 'minNumberOfRooms'
 *      minNumberOfBathrooms: // value for 'minNumberOfBathrooms'
 *      accountId: // value for 'accountId'
 *      regionPath: // value for 'regionPath'
 *   },
 * });
 */
export function useSearchRegionForListingsByPlaceNameWithSingleAssetQuery(baseOptions?: Apollo.QueryHookOptions<SearchRegionForListingsByPlaceNameWithSingleAssetQuery, SearchRegionForListingsByPlaceNameWithSingleAssetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchRegionForListingsByPlaceNameWithSingleAssetQuery, SearchRegionForListingsByPlaceNameWithSingleAssetQueryVariables>(SearchRegionForListingsByPlaceNameWithSingleAssetDocument, options);
      }
export function useSearchRegionForListingsByPlaceNameWithSingleAssetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchRegionForListingsByPlaceNameWithSingleAssetQuery, SearchRegionForListingsByPlaceNameWithSingleAssetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchRegionForListingsByPlaceNameWithSingleAssetQuery, SearchRegionForListingsByPlaceNameWithSingleAssetQueryVariables>(SearchRegionForListingsByPlaceNameWithSingleAssetDocument, options);
        }
export function useSearchRegionForListingsByPlaceNameWithSingleAssetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchRegionForListingsByPlaceNameWithSingleAssetQuery, SearchRegionForListingsByPlaceNameWithSingleAssetQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchRegionForListingsByPlaceNameWithSingleAssetQuery, SearchRegionForListingsByPlaceNameWithSingleAssetQueryVariables>(SearchRegionForListingsByPlaceNameWithSingleAssetDocument, options);
        }
export type SearchRegionForListingsByPlaceNameWithSingleAssetQueryHookResult = ReturnType<typeof useSearchRegionForListingsByPlaceNameWithSingleAssetQuery>;
export type SearchRegionForListingsByPlaceNameWithSingleAssetLazyQueryHookResult = ReturnType<typeof useSearchRegionForListingsByPlaceNameWithSingleAssetLazyQuery>;
export type SearchRegionForListingsByPlaceNameWithSingleAssetSuspenseQueryHookResult = ReturnType<typeof useSearchRegionForListingsByPlaceNameWithSingleAssetSuspenseQuery>;
export type SearchRegionForListingsByPlaceNameWithSingleAssetQueryResult = Apollo.QueryResult<SearchRegionForListingsByPlaceNameWithSingleAssetQuery, SearchRegionForListingsByPlaceNameWithSingleAssetQueryVariables>;
export function refetchSearchRegionForListingsByPlaceNameWithSingleAssetQuery(variables?: SearchRegionForListingsByPlaceNameWithSingleAssetQueryVariables) {
      return { query: SearchRegionForListingsByPlaceNameWithSingleAssetDocument, variables: variables }
    }
export const ListingByExternalIdAndSourceDocument = gql`
    query ListingByExternalIdAndSource($externalId: String!, $externalSource: ExternalSource!) {
  listingByExternalIdAndSource(
    externalId: $externalId
    externalSource: $externalSource
  ) {
    __typename
    ... on Listing {
      slug
    }
    ... on NotFoundError {
      message
    }
  }
}
    `;

/**
 * __useListingByExternalIdAndSourceQuery__
 *
 * To run a query within a React component, call `useListingByExternalIdAndSourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useListingByExternalIdAndSourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListingByExternalIdAndSourceQuery({
 *   variables: {
 *      externalId: // value for 'externalId'
 *      externalSource: // value for 'externalSource'
 *   },
 * });
 */
export function useListingByExternalIdAndSourceQuery(baseOptions: Apollo.QueryHookOptions<ListingByExternalIdAndSourceQuery, ListingByExternalIdAndSourceQueryVariables> & ({ variables: ListingByExternalIdAndSourceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListingByExternalIdAndSourceQuery, ListingByExternalIdAndSourceQueryVariables>(ListingByExternalIdAndSourceDocument, options);
      }
export function useListingByExternalIdAndSourceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListingByExternalIdAndSourceQuery, ListingByExternalIdAndSourceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListingByExternalIdAndSourceQuery, ListingByExternalIdAndSourceQueryVariables>(ListingByExternalIdAndSourceDocument, options);
        }
export function useListingByExternalIdAndSourceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListingByExternalIdAndSourceQuery, ListingByExternalIdAndSourceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListingByExternalIdAndSourceQuery, ListingByExternalIdAndSourceQueryVariables>(ListingByExternalIdAndSourceDocument, options);
        }
export type ListingByExternalIdAndSourceQueryHookResult = ReturnType<typeof useListingByExternalIdAndSourceQuery>;
export type ListingByExternalIdAndSourceLazyQueryHookResult = ReturnType<typeof useListingByExternalIdAndSourceLazyQuery>;
export type ListingByExternalIdAndSourceSuspenseQueryHookResult = ReturnType<typeof useListingByExternalIdAndSourceSuspenseQuery>;
export type ListingByExternalIdAndSourceQueryResult = Apollo.QueryResult<ListingByExternalIdAndSourceQuery, ListingByExternalIdAndSourceQueryVariables>;
export function refetchListingByExternalIdAndSourceQuery(variables: ListingByExternalIdAndSourceQueryVariables) {
      return { query: ListingByExternalIdAndSourceDocument, variables: variables }
    }
export const ListingBySlugDocument = gql`
    query ListingBySlug($slug: String!) {
  listingBySlug(slug: $slug) {
    __typename
    ... on Listing {
      id
      addressLineOne
      airbnbUrl
      vrboUrl
      bookDirectWebsiteUrl
      bookDirectWebsiteUrlParamsTemplate
      city
      checkIn
      checkout
      cancellationPolicy
      licenseNumber
      listedFloor
      numberOfFloors
      numberOfRooms
      numberOfBathrooms
      guestCapacity
      propertyType
      uniquePropertyType
      description
      facebookPageUrl
      hostBio
      hostDisplayName
      hostImageUrl
      instagramUrl
      lat
      lng
      locationObfuscated
      marketingWebsiteUrl
      name
      published
      pinterestUrl
      postalCode
      publicEmail
      publicPhoneNumber
      slug
      stateOrProvinceLongName
      twitterUrl
      youtubeUrl
      minPrice
      maxPrice
      galleryAssets(numberOfAssets: 100, processing: false) {
        id
        url
        rawUrl
        description
      }
      features {
        key
        legacyKey
        displayName
        promoted
        categoryName
      }
      affiliations {
        id
        type
        name
      }
      listingLevel
      isDiamondCollection
      account {
        id
        slug
        companyName
        title
        description
        avatarUrl
        inBusinessSince
        city
        stateOrProvinceLongName
        activeListingsCount
        marketingWebsiteUrl
        facebookPageUrl
        instagramUrl
        twitterUrl
        phoneNumber
        email
        linkedinUrl
        youtubeUrl
        accountReviewSummaries {
          id
          source
          sourceId
          numberOfReviews
          imageUrl
          rating
        }
      }
      isFavorited
      supportsQuotes
      supportsBookings
      searchableAvailability
      policies {
        ... on AccountTermsAndConditions {
          termsLink
        }
        ... on AccountCancellationPolicy {
          cancellationPolicy
        }
        ... on ListingCancellationPolicy {
          cancellationPolicy
        }
      }
      reviews(numberOfReviews: 5) {
        body
        rating
        authorName
        date
      }
      reviewsAverageRating
      reviewsCount
    }
    ... on NotFoundError {
      message
    }
  }
}
    `;

/**
 * __useListingBySlugQuery__
 *
 * To run a query within a React component, call `useListingBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useListingBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListingBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useListingBySlugQuery(baseOptions: Apollo.QueryHookOptions<ListingBySlugQuery, ListingBySlugQueryVariables> & ({ variables: ListingBySlugQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListingBySlugQuery, ListingBySlugQueryVariables>(ListingBySlugDocument, options);
      }
export function useListingBySlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListingBySlugQuery, ListingBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListingBySlugQuery, ListingBySlugQueryVariables>(ListingBySlugDocument, options);
        }
export function useListingBySlugSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListingBySlugQuery, ListingBySlugQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListingBySlugQuery, ListingBySlugQueryVariables>(ListingBySlugDocument, options);
        }
export type ListingBySlugQueryHookResult = ReturnType<typeof useListingBySlugQuery>;
export type ListingBySlugLazyQueryHookResult = ReturnType<typeof useListingBySlugLazyQuery>;
export type ListingBySlugSuspenseQueryHookResult = ReturnType<typeof useListingBySlugSuspenseQuery>;
export type ListingBySlugQueryResult = Apollo.QueryResult<ListingBySlugQuery, ListingBySlugQueryVariables>;
export function refetchListingBySlugQuery(variables: ListingBySlugQueryVariables) {
      return { query: ListingBySlugDocument, variables: variables }
    }
export const ListingByIdAndUserDocument = gql`
    query ListingByIdAndUser($id: String!) {
  listingByIdAndUser(id: $id) {
    __typename
    ... on Listing {
      ...OwnerListingFields
    }
    ... on NotFoundError {
      message
    }
  }
}
    ${OwnerListingFieldsFragmentDoc}`;

/**
 * __useListingByIdAndUserQuery__
 *
 * To run a query within a React component, call `useListingByIdAndUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useListingByIdAndUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListingByIdAndUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useListingByIdAndUserQuery(baseOptions: Apollo.QueryHookOptions<ListingByIdAndUserQuery, ListingByIdAndUserQueryVariables> & ({ variables: ListingByIdAndUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListingByIdAndUserQuery, ListingByIdAndUserQueryVariables>(ListingByIdAndUserDocument, options);
      }
export function useListingByIdAndUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListingByIdAndUserQuery, ListingByIdAndUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListingByIdAndUserQuery, ListingByIdAndUserQueryVariables>(ListingByIdAndUserDocument, options);
        }
export function useListingByIdAndUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListingByIdAndUserQuery, ListingByIdAndUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListingByIdAndUserQuery, ListingByIdAndUserQueryVariables>(ListingByIdAndUserDocument, options);
        }
export type ListingByIdAndUserQueryHookResult = ReturnType<typeof useListingByIdAndUserQuery>;
export type ListingByIdAndUserLazyQueryHookResult = ReturnType<typeof useListingByIdAndUserLazyQuery>;
export type ListingByIdAndUserSuspenseQueryHookResult = ReturnType<typeof useListingByIdAndUserSuspenseQuery>;
export type ListingByIdAndUserQueryResult = Apollo.QueryResult<ListingByIdAndUserQuery, ListingByIdAndUserQueryVariables>;
export function refetchListingByIdAndUserQuery(variables: ListingByIdAndUserQueryVariables) {
      return { query: ListingByIdAndUserDocument, variables: variables }
    }
export const AccountListingsDocument = gql`
    query AccountListings($page: Int, $pageSize: Int, $searchQuery: String) {
  accountListings(page: $page, pageSize: $pageSize, searchQuery: $searchQuery) {
    __typename
    ... on ListingCollection {
      entries {
        ...ListingFields
      }
      meta {
        nextPage
        previousPage
        currentPage
        totalEntries
        totalPages
      }
    }
    ... on UnauthenticatedError {
      message
    }
  }
}
    ${ListingFieldsFragmentDoc}`;

/**
 * __useAccountListingsQuery__
 *
 * To run a query within a React component, call `useAccountListingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountListingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountListingsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      searchQuery: // value for 'searchQuery'
 *   },
 * });
 */
export function useAccountListingsQuery(baseOptions?: Apollo.QueryHookOptions<AccountListingsQuery, AccountListingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountListingsQuery, AccountListingsQueryVariables>(AccountListingsDocument, options);
      }
export function useAccountListingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountListingsQuery, AccountListingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountListingsQuery, AccountListingsQueryVariables>(AccountListingsDocument, options);
        }
export function useAccountListingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountListingsQuery, AccountListingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AccountListingsQuery, AccountListingsQueryVariables>(AccountListingsDocument, options);
        }
export type AccountListingsQueryHookResult = ReturnType<typeof useAccountListingsQuery>;
export type AccountListingsLazyQueryHookResult = ReturnType<typeof useAccountListingsLazyQuery>;
export type AccountListingsSuspenseQueryHookResult = ReturnType<typeof useAccountListingsSuspenseQuery>;
export type AccountListingsQueryResult = Apollo.QueryResult<AccountListingsQuery, AccountListingsQueryVariables>;
export function refetchAccountListingsQuery(variables?: AccountListingsQueryVariables) {
      return { query: AccountListingsDocument, variables: variables }
    }
export const ListingsListAllFavoritedDocument = gql`
    query listingsListAllFavorited($page: Int, $pageSize: Int, $sort: ListingFavoriteSortOptions!) {
  listingsListAllFavorited(page: $page, pageSize: $pageSize, sort: $sort) {
    __typename
    ... on ListingCollection {
      entries {
        account {
          id
          slug
          avatarUrl
          companyName
        }
        lat
        lng
        locationObfuscated
        city
        propertyType
        numberOfRooms
        numberOfBathrooms
        guestCapacity
        name
        slug
        stateOrProvinceLongName
        marketingWebsiteUrl
        bookDirectWebsiteUrl
        description
        minPrice
        maxPrice
        galleryAssets(numberOfAssets: 10, processing: false) {
          id
          url
        }
        listingLevel
        isDiamondCollection
        isFavorited
        id
        searchableAvailability
      }
      meta {
        nextPage
        previousPage
        currentPage
        totalEntries
        totalPages
      }
    }
    ... on UnauthenticatedError {
      message
    }
  }
}
    `;

/**
 * __useListingsListAllFavoritedQuery__
 *
 * To run a query within a React component, call `useListingsListAllFavoritedQuery` and pass it any options that fit your needs.
 * When your component renders, `useListingsListAllFavoritedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListingsListAllFavoritedQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useListingsListAllFavoritedQuery(baseOptions: Apollo.QueryHookOptions<ListingsListAllFavoritedQuery, ListingsListAllFavoritedQueryVariables> & ({ variables: ListingsListAllFavoritedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListingsListAllFavoritedQuery, ListingsListAllFavoritedQueryVariables>(ListingsListAllFavoritedDocument, options);
      }
export function useListingsListAllFavoritedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListingsListAllFavoritedQuery, ListingsListAllFavoritedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListingsListAllFavoritedQuery, ListingsListAllFavoritedQueryVariables>(ListingsListAllFavoritedDocument, options);
        }
export function useListingsListAllFavoritedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListingsListAllFavoritedQuery, ListingsListAllFavoritedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListingsListAllFavoritedQuery, ListingsListAllFavoritedQueryVariables>(ListingsListAllFavoritedDocument, options);
        }
export type ListingsListAllFavoritedQueryHookResult = ReturnType<typeof useListingsListAllFavoritedQuery>;
export type ListingsListAllFavoritedLazyQueryHookResult = ReturnType<typeof useListingsListAllFavoritedLazyQuery>;
export type ListingsListAllFavoritedSuspenseQueryHookResult = ReturnType<typeof useListingsListAllFavoritedSuspenseQuery>;
export type ListingsListAllFavoritedQueryResult = Apollo.QueryResult<ListingsListAllFavoritedQuery, ListingsListAllFavoritedQueryVariables>;
export function refetchListingsListAllFavoritedQuery(variables: ListingsListAllFavoritedQueryVariables) {
      return { query: ListingsListAllFavoritedDocument, variables: variables }
    }
export const ListingsSearchDocument = gql`
    query ListingsSearch($accountId: String, $centerLat: Float, $centerLng: Float, $features: [FeatureKey!] = [], $propertyTypes: [PropertyType!], $uniquePropertyTypes: [UniquePropertyType], $minGuestCapacity: Int, $minNumberOfRooms: Int, $minNumberOfBathrooms: Int, $minPriceCents: Int, $maxPriceCents: Int, $northEastLat: Float, $northEastLng: Float, $cursorAfter: String, $cursorBefore: String, $pageSize: Int, $placeId: String, $searchType: ListingsSearchType!, $southWestLat: Float, $southWestLng: Float, $checkInDate: Date, $checkOutDate: Date, $petCount: Int) {
  listingsSearch(
    accountId: $accountId
    centerLat: $centerLat
    centerLng: $centerLng
    featuresFilter: $features
    propertyTypes: $propertyTypes
    uniquePropertyTypes: $uniquePropertyTypes
    minGuestCapacity: $minGuestCapacity
    minNumberOfRooms: $minNumberOfRooms
    minNumberOfBathrooms: $minNumberOfBathrooms
    minPriceCents: $minPriceCents
    maxPriceCents: $maxPriceCents
    northEastLat: $northEastLat
    northEastLng: $northEastLng
    cursorAfter: $cursorAfter
    cursorBefore: $cursorBefore
    pageSize: $pageSize
    placeId: $placeId
    searchType: $searchType
    southWestLat: $southWestLat
    southWestLng: $southWestLng
    checkInDate: $checkInDate
    checkOutDate: $checkOutDate
    petCount: $petCount
  ) {
    __typename
    ... on ListingSearchCursorCollection {
      entries {
        account {
          id
          slug
          avatarUrl
          companyName
        }
        lat
        lng
        locationObfuscated
        city
        propertyType
        uniquePropertyType
        numberOfRooms
        numberOfBathrooms
        guestCapacity
        name
        slug
        stateOrProvinceLongName
        marketingWebsiteUrl
        bookDirectWebsiteUrl
        description
        minPrice
        maxPrice
        priceDisplay(
          checkInDate: $checkInDate
          checkOutDate: $checkOutDate
          pets: $petCount
          guests: $minGuestCapacity
        ) {
          checkInDate
          checkOutDate
          baseAmountCents
          subtotalWithoutTaxesCents
          nights
        }
        searchPromotionType
        features {
          key
          categoryName
          displayName
          promoted
        }
        galleryAssets(numberOfAssets: 10, processing: false) {
          id
          url
        }
        listingLevel
        isDiamondCollection
        isFavorited
        id
        searchableAvailability
        reviewsAverageRating
        reviewsCount
      }
      metadata {
        cursorAfter
        cursorBefore
        totalCount
      }
      searchPlace {
        name
        placeType
        geometry {
          centerPoint {
            lat
            lng
          }
          northEastPoint {
            lat
            lng
          }
          southWestPoint {
            lat
            lng
          }
        }
      }
    }
    ... on ValidationErrorCollection {
      errors {
        field
        message
        type
      }
    }
  }
}
    `;

/**
 * __useListingsSearchQuery__
 *
 * To run a query within a React component, call `useListingsSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useListingsSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListingsSearchQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      centerLat: // value for 'centerLat'
 *      centerLng: // value for 'centerLng'
 *      features: // value for 'features'
 *      propertyTypes: // value for 'propertyTypes'
 *      uniquePropertyTypes: // value for 'uniquePropertyTypes'
 *      minGuestCapacity: // value for 'minGuestCapacity'
 *      minNumberOfRooms: // value for 'minNumberOfRooms'
 *      minNumberOfBathrooms: // value for 'minNumberOfBathrooms'
 *      minPriceCents: // value for 'minPriceCents'
 *      maxPriceCents: // value for 'maxPriceCents'
 *      northEastLat: // value for 'northEastLat'
 *      northEastLng: // value for 'northEastLng'
 *      cursorAfter: // value for 'cursorAfter'
 *      cursorBefore: // value for 'cursorBefore'
 *      pageSize: // value for 'pageSize'
 *      placeId: // value for 'placeId'
 *      searchType: // value for 'searchType'
 *      southWestLat: // value for 'southWestLat'
 *      southWestLng: // value for 'southWestLng'
 *      checkInDate: // value for 'checkInDate'
 *      checkOutDate: // value for 'checkOutDate'
 *      petCount: // value for 'petCount'
 *   },
 * });
 */
export function useListingsSearchQuery(baseOptions: Apollo.QueryHookOptions<ListingsSearchQuery, ListingsSearchQueryVariables> & ({ variables: ListingsSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListingsSearchQuery, ListingsSearchQueryVariables>(ListingsSearchDocument, options);
      }
export function useListingsSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListingsSearchQuery, ListingsSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListingsSearchQuery, ListingsSearchQueryVariables>(ListingsSearchDocument, options);
        }
export function useListingsSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListingsSearchQuery, ListingsSearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListingsSearchQuery, ListingsSearchQueryVariables>(ListingsSearchDocument, options);
        }
export type ListingsSearchQueryHookResult = ReturnType<typeof useListingsSearchQuery>;
export type ListingsSearchLazyQueryHookResult = ReturnType<typeof useListingsSearchLazyQuery>;
export type ListingsSearchSuspenseQueryHookResult = ReturnType<typeof useListingsSearchSuspenseQuery>;
export type ListingsSearchQueryResult = Apollo.QueryResult<ListingsSearchQuery, ListingsSearchQueryVariables>;
export function refetchListingsSearchQuery(variables: ListingsSearchQueryVariables) {
      return { query: ListingsSearchDocument, variables: variables }
    }
export const AdminListingsListAllForAccountDocument = gql`
    query AdminListingsListAllForAccount($accountId: String!, $searchQuery: String, $published: Boolean, $placeId: String, $stateOrProvinceLongNameFilter: [String!], $sort: AccountListingSortOptions, $page: Int!, $pageSize: Int! = 20) {
  adminListingsListAllForAccount(
    accountId: $accountId
    searchQuery: $searchQuery
    published: $published
    placeId: $placeId
    stateOrProvinceLongNameFilter: $stateOrProvinceLongNameFilter
    sort: $sort
    page: $page
    pageSize: $pageSize
  ) {
    __typename
    ... on ListingCollection {
      entries {
        id
        addressLineOne
        addressLineTwo
        affiliations {
          id
          name
          type
        }
        archived
        bookDirectWebsiteUrl
        city
        countryOrRegionLongName
        currentBalanceCents
        description
        distanceFromSearchPoint
        facebookPageUrl
        features {
          categoryName
          displayName
          key
          legacyKey
          promoted
        }
        galleryAssets {
          description
          id
          processing
          rawUrl
          thumbUrl
          url
        }
        hostBio
        hostDisplayName
        hostImageUrl
        instagramUrl
        instagramUsername
        firstPublishedAt
        lat
        lng
        locationSetManually
        marketingWebsiteUrl
        name
        pinterestUrl
        pinterestUsername
        placeId
        placeName
        postalCode
        publicEmail
        youtubeUrl
        wNineOnFile
        twitterUrl
        twitterHandle
        stateOrProvinceLongName
        slug
        published
        publishIpAddress
        publicPhoneNumber
        listingLevel
        isDiamondCollection
        insertedAt
        propertyType
        isFavorited
      }
      meta {
        currentPage
        nextPage
        totalPages
        previousPage
        totalEntries
      }
    }
    ... on UnauthenticatedError {
      message
    }
  }
}
    `;

/**
 * __useAdminListingsListAllForAccountQuery__
 *
 * To run a query within a React component, call `useAdminListingsListAllForAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminListingsListAllForAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminListingsListAllForAccountQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      searchQuery: // value for 'searchQuery'
 *      published: // value for 'published'
 *      placeId: // value for 'placeId'
 *      stateOrProvinceLongNameFilter: // value for 'stateOrProvinceLongNameFilter'
 *      sort: // value for 'sort'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useAdminListingsListAllForAccountQuery(baseOptions: Apollo.QueryHookOptions<AdminListingsListAllForAccountQuery, AdminListingsListAllForAccountQueryVariables> & ({ variables: AdminListingsListAllForAccountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminListingsListAllForAccountQuery, AdminListingsListAllForAccountQueryVariables>(AdminListingsListAllForAccountDocument, options);
      }
export function useAdminListingsListAllForAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminListingsListAllForAccountQuery, AdminListingsListAllForAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminListingsListAllForAccountQuery, AdminListingsListAllForAccountQueryVariables>(AdminListingsListAllForAccountDocument, options);
        }
export function useAdminListingsListAllForAccountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminListingsListAllForAccountQuery, AdminListingsListAllForAccountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminListingsListAllForAccountQuery, AdminListingsListAllForAccountQueryVariables>(AdminListingsListAllForAccountDocument, options);
        }
export type AdminListingsListAllForAccountQueryHookResult = ReturnType<typeof useAdminListingsListAllForAccountQuery>;
export type AdminListingsListAllForAccountLazyQueryHookResult = ReturnType<typeof useAdminListingsListAllForAccountLazyQuery>;
export type AdminListingsListAllForAccountSuspenseQueryHookResult = ReturnType<typeof useAdminListingsListAllForAccountSuspenseQuery>;
export type AdminListingsListAllForAccountQueryResult = Apollo.QueryResult<AdminListingsListAllForAccountQuery, AdminListingsListAllForAccountQueryVariables>;
export function refetchAdminListingsListAllForAccountQuery(variables: AdminListingsListAllForAccountQueryVariables) {
      return { query: AdminListingsListAllForAccountDocument, variables: variables }
    }
export const SubscribeEmailToNewsletterDocument = gql`
    mutation SubscribeEmailToNewsletter($email: String!) {
  subscribeEmailToNewsletter(email: $email) {
    __typename
    ... on NewsletterSubscription {
      email
    }
    ... on ValidationErrorCollection {
      errors {
        field
        message
        type
      }
    }
  }
}
    `;
export type SubscribeEmailToNewsletterMutationFn = Apollo.MutationFunction<SubscribeEmailToNewsletterMutation, SubscribeEmailToNewsletterMutationVariables>;

/**
 * __useSubscribeEmailToNewsletterMutation__
 *
 * To run a mutation, you first call `useSubscribeEmailToNewsletterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubscribeEmailToNewsletterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subscribeEmailToNewsletterMutation, { data, loading, error }] = useSubscribeEmailToNewsletterMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useSubscribeEmailToNewsletterMutation(baseOptions?: Apollo.MutationHookOptions<SubscribeEmailToNewsletterMutation, SubscribeEmailToNewsletterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubscribeEmailToNewsletterMutation, SubscribeEmailToNewsletterMutationVariables>(SubscribeEmailToNewsletterDocument, options);
      }
export type SubscribeEmailToNewsletterMutationHookResult = ReturnType<typeof useSubscribeEmailToNewsletterMutation>;
export type SubscribeEmailToNewsletterMutationResult = Apollo.MutationResult<SubscribeEmailToNewsletterMutation>;
export type SubscribeEmailToNewsletterMutationOptions = Apollo.BaseMutationOptions<SubscribeEmailToNewsletterMutation, SubscribeEmailToNewsletterMutationVariables>;
export const UserAddReferralCodeDocument = gql`
    mutation UserAddReferralCode($referralCode: String!) {
  userAddReferralCode(referralCode: $referralCode) {
    ... on ValidationErrorCollection {
      errors {
        field
        message
      }
    }
    ... on User {
      id
      email
      firstName
      lastName
    }
    ... on UnauthenticatedError {
      message
    }
  }
}
    `;
export type UserAddReferralCodeMutationFn = Apollo.MutationFunction<UserAddReferralCodeMutation, UserAddReferralCodeMutationVariables>;

/**
 * __useUserAddReferralCodeMutation__
 *
 * To run a mutation, you first call `useUserAddReferralCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserAddReferralCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userAddReferralCodeMutation, { data, loading, error }] = useUserAddReferralCodeMutation({
 *   variables: {
 *      referralCode: // value for 'referralCode'
 *   },
 * });
 */
export function useUserAddReferralCodeMutation(baseOptions?: Apollo.MutationHookOptions<UserAddReferralCodeMutation, UserAddReferralCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserAddReferralCodeMutation, UserAddReferralCodeMutationVariables>(UserAddReferralCodeDocument, options);
      }
export type UserAddReferralCodeMutationHookResult = ReturnType<typeof useUserAddReferralCodeMutation>;
export type UserAddReferralCodeMutationResult = Apollo.MutationResult<UserAddReferralCodeMutation>;
export type UserAddReferralCodeMutationOptions = Apollo.BaseMutationOptions<UserAddReferralCodeMutation, UserAddReferralCodeMutationVariables>;
export const OrderLoadDocument = gql`
    mutation OrderLoad($input: OrderLoadInput!) {
  orderLoad(input: $input) {
    __typename
    ... on Order {
      id
      quote {
        checkInDate
        checkOutDate
        listingId
        numberOfAdults
        numberOfChildren
        numberOfInfants
        numberOfPets
        totalCostCents
        totalWithoutTaxesCents
        totalRecoverableCostCents
        quoteItems {
          costCents
          type
          description
        }
        paymentSchedule {
          dueDate
          amountCents
          description
          paymentItemType
        }
      }
    }
    ... on UnauthenticatedError {
      message
    }
    ... on OrderUnavailable {
      message
    }
    ... on OrderUnsupported {
      message
    }
    ... on NotFoundError {
      message
    }
    ... on ValidationError {
      message
    }
  }
}
    `;
export type OrderLoadMutationFn = Apollo.MutationFunction<OrderLoadMutation, OrderLoadMutationVariables>;

/**
 * __useOrderLoadMutation__
 *
 * To run a mutation, you first call `useOrderLoadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrderLoadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderLoadMutation, { data, loading, error }] = useOrderLoadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOrderLoadMutation(baseOptions?: Apollo.MutationHookOptions<OrderLoadMutation, OrderLoadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrderLoadMutation, OrderLoadMutationVariables>(OrderLoadDocument, options);
      }
export type OrderLoadMutationHookResult = ReturnType<typeof useOrderLoadMutation>;
export type OrderLoadMutationResult = Apollo.MutationResult<OrderLoadMutation>;
export type OrderLoadMutationOptions = Apollo.BaseMutationOptions<OrderLoadMutation, OrderLoadMutationVariables>;
export const SendPasswordResetEmailDocument = gql`
    mutation SendPasswordResetEmail($input: SendPasswordResetEmailInput!) {
  sendPasswordResetEmail(input: $input) {
    __typename
    ... on PasswordResetMessage {
      message
    }
    ... on NotFoundError {
      message
    }
  }
}
    `;
export type SendPasswordResetEmailMutationFn = Apollo.MutationFunction<SendPasswordResetEmailMutation, SendPasswordResetEmailMutationVariables>;

/**
 * __useSendPasswordResetEmailMutation__
 *
 * To run a mutation, you first call `useSendPasswordResetEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendPasswordResetEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendPasswordResetEmailMutation, { data, loading, error }] = useSendPasswordResetEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendPasswordResetEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendPasswordResetEmailMutation, SendPasswordResetEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendPasswordResetEmailMutation, SendPasswordResetEmailMutationVariables>(SendPasswordResetEmailDocument, options);
      }
export type SendPasswordResetEmailMutationHookResult = ReturnType<typeof useSendPasswordResetEmailMutation>;
export type SendPasswordResetEmailMutationResult = Apollo.MutationResult<SendPasswordResetEmailMutation>;
export type SendPasswordResetEmailMutationOptions = Apollo.BaseMutationOptions<SendPasswordResetEmailMutation, SendPasswordResetEmailMutationVariables>;
export const ResetPasswordForTokenDocument = gql`
    mutation ResetPasswordForToken($input: ResetPasswordForTokenInput!) {
  resetPasswordForToken(input: $input) {
    __typename
    ... on PasswordResetMessage {
      message
    }
    ... on NotFoundError {
      message
    }
    ... on ValidationErrorCollection {
      errors {
        message
        field
        type
      }
    }
  }
}
    `;
export type ResetPasswordForTokenMutationFn = Apollo.MutationFunction<ResetPasswordForTokenMutation, ResetPasswordForTokenMutationVariables>;

/**
 * __useResetPasswordForTokenMutation__
 *
 * To run a mutation, you first call `useResetPasswordForTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordForTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordForTokenMutation, { data, loading, error }] = useResetPasswordForTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResetPasswordForTokenMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordForTokenMutation, ResetPasswordForTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordForTokenMutation, ResetPasswordForTokenMutationVariables>(ResetPasswordForTokenDocument, options);
      }
export type ResetPasswordForTokenMutationHookResult = ReturnType<typeof useResetPasswordForTokenMutation>;
export type ResetPasswordForTokenMutationResult = Apollo.MutationResult<ResetPasswordForTokenMutation>;
export type ResetPasswordForTokenMutationOptions = Apollo.BaseMutationOptions<ResetPasswordForTokenMutation, ResetPasswordForTokenMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation ResetPassword($input: ResetPasswordInput!) {
  resetPassword(input: $input) {
    __typename
    ... on PasswordResetMessage {
      message
    }
    ... on ValidationErrorCollection {
      errors {
        message
        field
        type
      }
    }
  }
}
    `;
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const PlacesAutocompleteDocument = gql`
    query PlacesAutocomplete($query: String!, $type: PlaceTypeFilter!) {
  placesAutocomplete(name: $query, placeTypeFilter: $type) {
    id
    name
  }
}
    `;

/**
 * __usePlacesAutocompleteQuery__
 *
 * To run a query within a React component, call `usePlacesAutocompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlacesAutocompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlacesAutocompleteQuery({
 *   variables: {
 *      query: // value for 'query'
 *      type: // value for 'type'
 *   },
 * });
 */
export function usePlacesAutocompleteQuery(baseOptions: Apollo.QueryHookOptions<PlacesAutocompleteQuery, PlacesAutocompleteQueryVariables> & ({ variables: PlacesAutocompleteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlacesAutocompleteQuery, PlacesAutocompleteQueryVariables>(PlacesAutocompleteDocument, options);
      }
export function usePlacesAutocompleteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlacesAutocompleteQuery, PlacesAutocompleteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlacesAutocompleteQuery, PlacesAutocompleteQueryVariables>(PlacesAutocompleteDocument, options);
        }
export function usePlacesAutocompleteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlacesAutocompleteQuery, PlacesAutocompleteQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlacesAutocompleteQuery, PlacesAutocompleteQueryVariables>(PlacesAutocompleteDocument, options);
        }
export type PlacesAutocompleteQueryHookResult = ReturnType<typeof usePlacesAutocompleteQuery>;
export type PlacesAutocompleteLazyQueryHookResult = ReturnType<typeof usePlacesAutocompleteLazyQuery>;
export type PlacesAutocompleteSuspenseQueryHookResult = ReturnType<typeof usePlacesAutocompleteSuspenseQuery>;
export type PlacesAutocompleteQueryResult = Apollo.QueryResult<PlacesAutocompleteQuery, PlacesAutocompleteQueryVariables>;
export function refetchPlacesAutocompleteQuery(variables: PlacesAutocompleteQueryVariables) {
      return { query: PlacesAutocompleteDocument, variables: variables }
    }
export const PlaceFindByIdDocument = gql`
    query PlaceFindById($id: ID!) {
  placeById(id: $id) {
    __typename
    ... on NotFoundError {
      message
    }
    ... on Place {
      addressLineOne
      addressLineTwo
      city
      countryOrRegionLongName
      countryOrRegionShortName
      geometry {
        centerPoint {
          lat
          lng
        }
        northEastPoint {
          lat
          lng
        }
        southWestPoint {
          lat
          lng
        }
      }
      id
      name
      postalCode
      ratingValue
      ratingValueMax
      rawAddressComponents {
        longName
        shortName
        types
      }
      rawTypes
      stateOrProvinceLongName
      stateOrProvinceShortName
    }
  }
}
    `;

/**
 * __usePlaceFindByIdQuery__
 *
 * To run a query within a React component, call `usePlaceFindByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlaceFindByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlaceFindByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePlaceFindByIdQuery(baseOptions: Apollo.QueryHookOptions<PlaceFindByIdQuery, PlaceFindByIdQueryVariables> & ({ variables: PlaceFindByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlaceFindByIdQuery, PlaceFindByIdQueryVariables>(PlaceFindByIdDocument, options);
      }
export function usePlaceFindByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlaceFindByIdQuery, PlaceFindByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlaceFindByIdQuery, PlaceFindByIdQueryVariables>(PlaceFindByIdDocument, options);
        }
export function usePlaceFindByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlaceFindByIdQuery, PlaceFindByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlaceFindByIdQuery, PlaceFindByIdQueryVariables>(PlaceFindByIdDocument, options);
        }
export type PlaceFindByIdQueryHookResult = ReturnType<typeof usePlaceFindByIdQuery>;
export type PlaceFindByIdLazyQueryHookResult = ReturnType<typeof usePlaceFindByIdLazyQuery>;
export type PlaceFindByIdSuspenseQueryHookResult = ReturnType<typeof usePlaceFindByIdSuspenseQuery>;
export type PlaceFindByIdQueryResult = Apollo.QueryResult<PlaceFindByIdQuery, PlaceFindByIdQueryVariables>;
export function refetchPlaceFindByIdQuery(variables: PlaceFindByIdQueryVariables) {
      return { query: PlaceFindByIdDocument, variables: variables }
    }
export const PlansListAllDocument = gql`
    query PlansListAll {
  plansListAll {
    __typename
    ... on PlanCollection {
      entries {
        id
        name
        amount
      }
    }
  }
}
    `;

/**
 * __usePlansListAllQuery__
 *
 * To run a query within a React component, call `usePlansListAllQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlansListAllQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlansListAllQuery({
 *   variables: {
 *   },
 * });
 */
export function usePlansListAllQuery(baseOptions?: Apollo.QueryHookOptions<PlansListAllQuery, PlansListAllQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlansListAllQuery, PlansListAllQueryVariables>(PlansListAllDocument, options);
      }
export function usePlansListAllLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlansListAllQuery, PlansListAllQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlansListAllQuery, PlansListAllQueryVariables>(PlansListAllDocument, options);
        }
export function usePlansListAllSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlansListAllQuery, PlansListAllQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlansListAllQuery, PlansListAllQueryVariables>(PlansListAllDocument, options);
        }
export type PlansListAllQueryHookResult = ReturnType<typeof usePlansListAllQuery>;
export type PlansListAllLazyQueryHookResult = ReturnType<typeof usePlansListAllLazyQuery>;
export type PlansListAllSuspenseQueryHookResult = ReturnType<typeof usePlansListAllSuspenseQuery>;
export type PlansListAllQueryResult = Apollo.QueryResult<PlansListAllQuery, PlansListAllQueryVariables>;
export function refetchPlansListAllQuery(variables?: PlansListAllQueryVariables) {
      return { query: PlansListAllDocument, variables: variables }
    }
export const GuestyPmsConnectionCreateDocument = gql`
    mutation GuestyPmsConnectionCreate($input: GuestyPmsConnectionCreateInput!) {
  guestyPmsConnectionCreate(input: $input) {
    __typename
    ... on PmsConnection {
      ...PmsConnectionFields
    }
    ... on ValidationErrorCollection {
      errors {
        field
        message
        type
      }
    }
  }
}
    ${PmsConnectionFieldsFragmentDoc}`;
export type GuestyPmsConnectionCreateMutationFn = Apollo.MutationFunction<GuestyPmsConnectionCreateMutation, GuestyPmsConnectionCreateMutationVariables>;

/**
 * __useGuestyPmsConnectionCreateMutation__
 *
 * To run a mutation, you first call `useGuestyPmsConnectionCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGuestyPmsConnectionCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [guestyPmsConnectionCreateMutation, { data, loading, error }] = useGuestyPmsConnectionCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGuestyPmsConnectionCreateMutation(baseOptions?: Apollo.MutationHookOptions<GuestyPmsConnectionCreateMutation, GuestyPmsConnectionCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GuestyPmsConnectionCreateMutation, GuestyPmsConnectionCreateMutationVariables>(GuestyPmsConnectionCreateDocument, options);
      }
export type GuestyPmsConnectionCreateMutationHookResult = ReturnType<typeof useGuestyPmsConnectionCreateMutation>;
export type GuestyPmsConnectionCreateMutationResult = Apollo.MutationResult<GuestyPmsConnectionCreateMutation>;
export type GuestyPmsConnectionCreateMutationOptions = Apollo.BaseMutationOptions<GuestyPmsConnectionCreateMutation, GuestyPmsConnectionCreateMutationVariables>;
export const HostawayPmsConnectionCreateDocument = gql`
    mutation HostawayPmsConnectionCreate($input: HostawayPmsConnectionCreateInput!) {
  hostawayPmsConnectionCreate(input: $input) {
    __typename
    ... on PmsConnection {
      ...PmsConnectionFields
    }
    ... on ValidationErrorCollection {
      errors {
        field
        message
        type
      }
    }
  }
}
    ${PmsConnectionFieldsFragmentDoc}`;
export type HostawayPmsConnectionCreateMutationFn = Apollo.MutationFunction<HostawayPmsConnectionCreateMutation, HostawayPmsConnectionCreateMutationVariables>;

/**
 * __useHostawayPmsConnectionCreateMutation__
 *
 * To run a mutation, you first call `useHostawayPmsConnectionCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHostawayPmsConnectionCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [hostawayPmsConnectionCreateMutation, { data, loading, error }] = useHostawayPmsConnectionCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHostawayPmsConnectionCreateMutation(baseOptions?: Apollo.MutationHookOptions<HostawayPmsConnectionCreateMutation, HostawayPmsConnectionCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HostawayPmsConnectionCreateMutation, HostawayPmsConnectionCreateMutationVariables>(HostawayPmsConnectionCreateDocument, options);
      }
export type HostawayPmsConnectionCreateMutationHookResult = ReturnType<typeof useHostawayPmsConnectionCreateMutation>;
export type HostawayPmsConnectionCreateMutationResult = Apollo.MutationResult<HostawayPmsConnectionCreateMutation>;
export type HostawayPmsConnectionCreateMutationOptions = Apollo.BaseMutationOptions<HostawayPmsConnectionCreateMutation, HostawayPmsConnectionCreateMutationVariables>;
export const LodgifyPmsConnectionCreateDocument = gql`
    mutation LodgifyPmsConnectionCreate($input: LodgifyPmsConnectionCreateInput!) {
  lodgifyPmsConnectionCreate(input: $input) {
    __typename
    ... on PmsConnection {
      ...PmsConnectionFields
    }
    ... on ValidationErrorCollection {
      errors {
        field
        message
        type
      }
    }
  }
}
    ${PmsConnectionFieldsFragmentDoc}`;
export type LodgifyPmsConnectionCreateMutationFn = Apollo.MutationFunction<LodgifyPmsConnectionCreateMutation, LodgifyPmsConnectionCreateMutationVariables>;

/**
 * __useLodgifyPmsConnectionCreateMutation__
 *
 * To run a mutation, you first call `useLodgifyPmsConnectionCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLodgifyPmsConnectionCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [lodgifyPmsConnectionCreateMutation, { data, loading, error }] = useLodgifyPmsConnectionCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLodgifyPmsConnectionCreateMutation(baseOptions?: Apollo.MutationHookOptions<LodgifyPmsConnectionCreateMutation, LodgifyPmsConnectionCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LodgifyPmsConnectionCreateMutation, LodgifyPmsConnectionCreateMutationVariables>(LodgifyPmsConnectionCreateDocument, options);
      }
export type LodgifyPmsConnectionCreateMutationHookResult = ReturnType<typeof useLodgifyPmsConnectionCreateMutation>;
export type LodgifyPmsConnectionCreateMutationResult = Apollo.MutationResult<LodgifyPmsConnectionCreateMutation>;
export type LodgifyPmsConnectionCreateMutationOptions = Apollo.BaseMutationOptions<LodgifyPmsConnectionCreateMutation, LodgifyPmsConnectionCreateMutationVariables>;
export const HostfullyPmsConnectionCreateDocument = gql`
    mutation HostfullyPmsConnectionCreate($input: HostfullyPmsConnectionCreateInput!) {
  hostfullyPmsConnectionCreate(input: $input) {
    __typename
    ... on PmsConnection {
      ...PmsConnectionFields
    }
    ... on ValidationErrorCollection {
      errors {
        field
        message
        type
      }
    }
  }
}
    ${PmsConnectionFieldsFragmentDoc}`;
export type HostfullyPmsConnectionCreateMutationFn = Apollo.MutationFunction<HostfullyPmsConnectionCreateMutation, HostfullyPmsConnectionCreateMutationVariables>;

/**
 * __useHostfullyPmsConnectionCreateMutation__
 *
 * To run a mutation, you first call `useHostfullyPmsConnectionCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHostfullyPmsConnectionCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [hostfullyPmsConnectionCreateMutation, { data, loading, error }] = useHostfullyPmsConnectionCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHostfullyPmsConnectionCreateMutation(baseOptions?: Apollo.MutationHookOptions<HostfullyPmsConnectionCreateMutation, HostfullyPmsConnectionCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HostfullyPmsConnectionCreateMutation, HostfullyPmsConnectionCreateMutationVariables>(HostfullyPmsConnectionCreateDocument, options);
      }
export type HostfullyPmsConnectionCreateMutationHookResult = ReturnType<typeof useHostfullyPmsConnectionCreateMutation>;
export type HostfullyPmsConnectionCreateMutationResult = Apollo.MutationResult<HostfullyPmsConnectionCreateMutation>;
export type HostfullyPmsConnectionCreateMutationOptions = Apollo.BaseMutationOptions<HostfullyPmsConnectionCreateMutation, HostfullyPmsConnectionCreateMutationVariables>;
export const OwnerRezPmsConnectionCreateDocument = gql`
    mutation OwnerRezPmsConnectionCreate($input: OwnerRezPmsConnectionCreateInput!) {
  ownerRezPmsConnectionCreate(input: $input) {
    __typename
    ... on PmsConnection {
      ...PmsConnectionFields
    }
    ... on ValidationErrorCollection {
      errors {
        field
        message
        type
      }
    }
  }
}
    ${PmsConnectionFieldsFragmentDoc}`;
export type OwnerRezPmsConnectionCreateMutationFn = Apollo.MutationFunction<OwnerRezPmsConnectionCreateMutation, OwnerRezPmsConnectionCreateMutationVariables>;

/**
 * __useOwnerRezPmsConnectionCreateMutation__
 *
 * To run a mutation, you first call `useOwnerRezPmsConnectionCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOwnerRezPmsConnectionCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ownerRezPmsConnectionCreateMutation, { data, loading, error }] = useOwnerRezPmsConnectionCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOwnerRezPmsConnectionCreateMutation(baseOptions?: Apollo.MutationHookOptions<OwnerRezPmsConnectionCreateMutation, OwnerRezPmsConnectionCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OwnerRezPmsConnectionCreateMutation, OwnerRezPmsConnectionCreateMutationVariables>(OwnerRezPmsConnectionCreateDocument, options);
      }
export type OwnerRezPmsConnectionCreateMutationHookResult = ReturnType<typeof useOwnerRezPmsConnectionCreateMutation>;
export type OwnerRezPmsConnectionCreateMutationResult = Apollo.MutationResult<OwnerRezPmsConnectionCreateMutation>;
export type OwnerRezPmsConnectionCreateMutationOptions = Apollo.BaseMutationOptions<OwnerRezPmsConnectionCreateMutation, OwnerRezPmsConnectionCreateMutationVariables>;
export const DemoPmsConnectionCreateDocument = gql`
    mutation DemoPmsConnectionCreate($input: DemoPmsConnectionCreateInput!) {
  demoPmsConnectionCreate(input: $input) {
    __typename
    ... on PmsConnection {
      ...PmsConnectionFields
    }
    ... on ValidationErrorCollection {
      errors {
        field
        message
        type
      }
    }
  }
}
    ${PmsConnectionFieldsFragmentDoc}`;
export type DemoPmsConnectionCreateMutationFn = Apollo.MutationFunction<DemoPmsConnectionCreateMutation, DemoPmsConnectionCreateMutationVariables>;

/**
 * __useDemoPmsConnectionCreateMutation__
 *
 * To run a mutation, you first call `useDemoPmsConnectionCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDemoPmsConnectionCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [demoPmsConnectionCreateMutation, { data, loading, error }] = useDemoPmsConnectionCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDemoPmsConnectionCreateMutation(baseOptions?: Apollo.MutationHookOptions<DemoPmsConnectionCreateMutation, DemoPmsConnectionCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DemoPmsConnectionCreateMutation, DemoPmsConnectionCreateMutationVariables>(DemoPmsConnectionCreateDocument, options);
      }
export type DemoPmsConnectionCreateMutationHookResult = ReturnType<typeof useDemoPmsConnectionCreateMutation>;
export type DemoPmsConnectionCreateMutationResult = Apollo.MutationResult<DemoPmsConnectionCreateMutation>;
export type DemoPmsConnectionCreateMutationOptions = Apollo.BaseMutationOptions<DemoPmsConnectionCreateMutation, DemoPmsConnectionCreateMutationVariables>;
export const BooksterPmsConnectionCreateDocument = gql`
    mutation BooksterPmsConnectionCreate($input: BooksterPmsConnectionCreateInput!) {
  booksterPmsConnectionCreate(input: $input) {
    __typename
    ... on PmsConnection {
      ...PmsConnectionFields
    }
    ... on ValidationErrorCollection {
      errors {
        field
        message
        type
      }
    }
  }
}
    ${PmsConnectionFieldsFragmentDoc}`;
export type BooksterPmsConnectionCreateMutationFn = Apollo.MutationFunction<BooksterPmsConnectionCreateMutation, BooksterPmsConnectionCreateMutationVariables>;

/**
 * __useBooksterPmsConnectionCreateMutation__
 *
 * To run a mutation, you first call `useBooksterPmsConnectionCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBooksterPmsConnectionCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [booksterPmsConnectionCreateMutation, { data, loading, error }] = useBooksterPmsConnectionCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBooksterPmsConnectionCreateMutation(baseOptions?: Apollo.MutationHookOptions<BooksterPmsConnectionCreateMutation, BooksterPmsConnectionCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BooksterPmsConnectionCreateMutation, BooksterPmsConnectionCreateMutationVariables>(BooksterPmsConnectionCreateDocument, options);
      }
export type BooksterPmsConnectionCreateMutationHookResult = ReturnType<typeof useBooksterPmsConnectionCreateMutation>;
export type BooksterPmsConnectionCreateMutationResult = Apollo.MutationResult<BooksterPmsConnectionCreateMutation>;
export type BooksterPmsConnectionCreateMutationOptions = Apollo.BaseMutationOptions<BooksterPmsConnectionCreateMutation, BooksterPmsConnectionCreateMutationVariables>;
export const LodgixPmsConnectionCreateDocument = gql`
    mutation LodgixPmsConnectionCreate($input: LodgixPmsConnectionCreateInput!) {
  lodgixPmsConnectionCreate(input: $input) {
    __typename
    ... on PmsConnection {
      ...PmsConnectionFields
    }
    ... on ValidationErrorCollection {
      errors {
        field
        message
        type
      }
    }
  }
}
    ${PmsConnectionFieldsFragmentDoc}`;
export type LodgixPmsConnectionCreateMutationFn = Apollo.MutationFunction<LodgixPmsConnectionCreateMutation, LodgixPmsConnectionCreateMutationVariables>;

/**
 * __useLodgixPmsConnectionCreateMutation__
 *
 * To run a mutation, you first call `useLodgixPmsConnectionCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLodgixPmsConnectionCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [lodgixPmsConnectionCreateMutation, { data, loading, error }] = useLodgixPmsConnectionCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLodgixPmsConnectionCreateMutation(baseOptions?: Apollo.MutationHookOptions<LodgixPmsConnectionCreateMutation, LodgixPmsConnectionCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LodgixPmsConnectionCreateMutation, LodgixPmsConnectionCreateMutationVariables>(LodgixPmsConnectionCreateDocument, options);
      }
export type LodgixPmsConnectionCreateMutationHookResult = ReturnType<typeof useLodgixPmsConnectionCreateMutation>;
export type LodgixPmsConnectionCreateMutationResult = Apollo.MutationResult<LodgixPmsConnectionCreateMutation>;
export type LodgixPmsConnectionCreateMutationOptions = Apollo.BaseMutationOptions<LodgixPmsConnectionCreateMutation, LodgixPmsConnectionCreateMutationVariables>;
export const StreamlinePartnerPmsConnectionCreateDocument = gql`
    mutation StreamlinePartnerPmsConnectionCreate($input: StreamlinePartnerPmsConnectionCreateInput!) {
  streamlinePartnerPmsConnectionCreate(input: $input) {
    __typename
    ... on PmsConnection {
      ...PmsConnectionFields
    }
    ... on ValidationErrorCollection {
      errors {
        field
        message
        type
      }
    }
  }
}
    ${PmsConnectionFieldsFragmentDoc}`;
export type StreamlinePartnerPmsConnectionCreateMutationFn = Apollo.MutationFunction<StreamlinePartnerPmsConnectionCreateMutation, StreamlinePartnerPmsConnectionCreateMutationVariables>;

/**
 * __useStreamlinePartnerPmsConnectionCreateMutation__
 *
 * To run a mutation, you first call `useStreamlinePartnerPmsConnectionCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStreamlinePartnerPmsConnectionCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [streamlinePartnerPmsConnectionCreateMutation, { data, loading, error }] = useStreamlinePartnerPmsConnectionCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStreamlinePartnerPmsConnectionCreateMutation(baseOptions?: Apollo.MutationHookOptions<StreamlinePartnerPmsConnectionCreateMutation, StreamlinePartnerPmsConnectionCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StreamlinePartnerPmsConnectionCreateMutation, StreamlinePartnerPmsConnectionCreateMutationVariables>(StreamlinePartnerPmsConnectionCreateDocument, options);
      }
export type StreamlinePartnerPmsConnectionCreateMutationHookResult = ReturnType<typeof useStreamlinePartnerPmsConnectionCreateMutation>;
export type StreamlinePartnerPmsConnectionCreateMutationResult = Apollo.MutationResult<StreamlinePartnerPmsConnectionCreateMutation>;
export type StreamlinePartnerPmsConnectionCreateMutationOptions = Apollo.BaseMutationOptions<StreamlinePartnerPmsConnectionCreateMutation, StreamlinePartnerPmsConnectionCreateMutationVariables>;
export const EscapiaPmsConnectionCreateDocument = gql`
    mutation EscapiaPmsConnectionCreate($input: EscapiaPmsConnectionCreateInput!) {
  escapiaPmsConnectionCreate(input: $input) {
    __typename
    ... on PmsConnection {
      ...PmsConnectionFields
    }
    ... on ValidationErrorCollection {
      errors {
        field
        message
        type
      }
    }
  }
}
    ${PmsConnectionFieldsFragmentDoc}`;
export type EscapiaPmsConnectionCreateMutationFn = Apollo.MutationFunction<EscapiaPmsConnectionCreateMutation, EscapiaPmsConnectionCreateMutationVariables>;

/**
 * __useEscapiaPmsConnectionCreateMutation__
 *
 * To run a mutation, you first call `useEscapiaPmsConnectionCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEscapiaPmsConnectionCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [escapiaPmsConnectionCreateMutation, { data, loading, error }] = useEscapiaPmsConnectionCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEscapiaPmsConnectionCreateMutation(baseOptions?: Apollo.MutationHookOptions<EscapiaPmsConnectionCreateMutation, EscapiaPmsConnectionCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EscapiaPmsConnectionCreateMutation, EscapiaPmsConnectionCreateMutationVariables>(EscapiaPmsConnectionCreateDocument, options);
      }
export type EscapiaPmsConnectionCreateMutationHookResult = ReturnType<typeof useEscapiaPmsConnectionCreateMutation>;
export type EscapiaPmsConnectionCreateMutationResult = Apollo.MutationResult<EscapiaPmsConnectionCreateMutation>;
export type EscapiaPmsConnectionCreateMutationOptions = Apollo.BaseMutationOptions<EscapiaPmsConnectionCreateMutation, EscapiaPmsConnectionCreateMutationVariables>;
export const BarefootPmsConnectionCreateDocument = gql`
    mutation BarefootPmsConnectionCreate($input: BarefootPmsConnectionCreateInput!) {
  barefootPmsConnectionCreate(input: $input) {
    __typename
    ... on PmsConnection {
      ...PmsConnectionFields
    }
    ... on ValidationErrorCollection {
      errors {
        field
        message
        type
      }
    }
  }
}
    ${PmsConnectionFieldsFragmentDoc}`;
export type BarefootPmsConnectionCreateMutationFn = Apollo.MutationFunction<BarefootPmsConnectionCreateMutation, BarefootPmsConnectionCreateMutationVariables>;

/**
 * __useBarefootPmsConnectionCreateMutation__
 *
 * To run a mutation, you first call `useBarefootPmsConnectionCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBarefootPmsConnectionCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [barefootPmsConnectionCreateMutation, { data, loading, error }] = useBarefootPmsConnectionCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBarefootPmsConnectionCreateMutation(baseOptions?: Apollo.MutationHookOptions<BarefootPmsConnectionCreateMutation, BarefootPmsConnectionCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BarefootPmsConnectionCreateMutation, BarefootPmsConnectionCreateMutationVariables>(BarefootPmsConnectionCreateDocument, options);
      }
export type BarefootPmsConnectionCreateMutationHookResult = ReturnType<typeof useBarefootPmsConnectionCreateMutation>;
export type BarefootPmsConnectionCreateMutationResult = Apollo.MutationResult<BarefootPmsConnectionCreateMutation>;
export type BarefootPmsConnectionCreateMutationOptions = Apollo.BaseMutationOptions<BarefootPmsConnectionCreateMutation, BarefootPmsConnectionCreateMutationVariables>;
export const TrackPmsConnectionCreateDocument = gql`
    mutation TrackPmsConnectionCreate($input: TrackPmsConnectionCreateInput!) {
  trackPmsConnectionCreate(input: $input) {
    __typename
    ... on PmsConnection {
      ...PmsConnectionFields
    }
    ... on ValidationErrorCollection {
      errors {
        field
        message
        type
      }
    }
  }
}
    ${PmsConnectionFieldsFragmentDoc}`;
export type TrackPmsConnectionCreateMutationFn = Apollo.MutationFunction<TrackPmsConnectionCreateMutation, TrackPmsConnectionCreateMutationVariables>;

/**
 * __useTrackPmsConnectionCreateMutation__
 *
 * To run a mutation, you first call `useTrackPmsConnectionCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTrackPmsConnectionCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [trackPmsConnectionCreateMutation, { data, loading, error }] = useTrackPmsConnectionCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTrackPmsConnectionCreateMutation(baseOptions?: Apollo.MutationHookOptions<TrackPmsConnectionCreateMutation, TrackPmsConnectionCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TrackPmsConnectionCreateMutation, TrackPmsConnectionCreateMutationVariables>(TrackPmsConnectionCreateDocument, options);
      }
export type TrackPmsConnectionCreateMutationHookResult = ReturnType<typeof useTrackPmsConnectionCreateMutation>;
export type TrackPmsConnectionCreateMutationResult = Apollo.MutationResult<TrackPmsConnectionCreateMutation>;
export type TrackPmsConnectionCreateMutationOptions = Apollo.BaseMutationOptions<TrackPmsConnectionCreateMutation, TrackPmsConnectionCreateMutationVariables>;
export const RentalsUnitedPmsConnectionCreateDocument = gql`
    mutation RentalsUnitedPmsConnectionCreate($input: RentalsUnitedPmsConnectionCreateInput!) {
  rentalsUnitedPmsConnectionCreate(input: $input) {
    __typename
    ... on PmsConnection {
      ...PmsConnectionFields
    }
    ... on ValidationErrorCollection {
      errors {
        field
        message
        type
      }
    }
  }
}
    ${PmsConnectionFieldsFragmentDoc}`;
export type RentalsUnitedPmsConnectionCreateMutationFn = Apollo.MutationFunction<RentalsUnitedPmsConnectionCreateMutation, RentalsUnitedPmsConnectionCreateMutationVariables>;

/**
 * __useRentalsUnitedPmsConnectionCreateMutation__
 *
 * To run a mutation, you first call `useRentalsUnitedPmsConnectionCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRentalsUnitedPmsConnectionCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rentalsUnitedPmsConnectionCreateMutation, { data, loading, error }] = useRentalsUnitedPmsConnectionCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRentalsUnitedPmsConnectionCreateMutation(baseOptions?: Apollo.MutationHookOptions<RentalsUnitedPmsConnectionCreateMutation, RentalsUnitedPmsConnectionCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RentalsUnitedPmsConnectionCreateMutation, RentalsUnitedPmsConnectionCreateMutationVariables>(RentalsUnitedPmsConnectionCreateDocument, options);
      }
export type RentalsUnitedPmsConnectionCreateMutationHookResult = ReturnType<typeof useRentalsUnitedPmsConnectionCreateMutation>;
export type RentalsUnitedPmsConnectionCreateMutationResult = Apollo.MutationResult<RentalsUnitedPmsConnectionCreateMutation>;
export type RentalsUnitedPmsConnectionCreateMutationOptions = Apollo.BaseMutationOptions<RentalsUnitedPmsConnectionCreateMutation, RentalsUnitedPmsConnectionCreateMutationVariables>;
export const NextPaxPmsConnectionCreateDocument = gql`
    mutation NextPaxPmsConnectionCreate($input: NextPaxPmsConnectionCreateInput!) {
  nextPaxPmsConnectionCreate(input: $input) {
    __typename
    ... on PmsConnection {
      ...PmsConnectionFields
    }
    ... on ValidationErrorCollection {
      errors {
        field
        message
        type
      }
    }
  }
}
    ${PmsConnectionFieldsFragmentDoc}`;
export type NextPaxPmsConnectionCreateMutationFn = Apollo.MutationFunction<NextPaxPmsConnectionCreateMutation, NextPaxPmsConnectionCreateMutationVariables>;

/**
 * __useNextPaxPmsConnectionCreateMutation__
 *
 * To run a mutation, you first call `useNextPaxPmsConnectionCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNextPaxPmsConnectionCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [nextPaxPmsConnectionCreateMutation, { data, loading, error }] = useNextPaxPmsConnectionCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useNextPaxPmsConnectionCreateMutation(baseOptions?: Apollo.MutationHookOptions<NextPaxPmsConnectionCreateMutation, NextPaxPmsConnectionCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NextPaxPmsConnectionCreateMutation, NextPaxPmsConnectionCreateMutationVariables>(NextPaxPmsConnectionCreateDocument, options);
      }
export type NextPaxPmsConnectionCreateMutationHookResult = ReturnType<typeof useNextPaxPmsConnectionCreateMutation>;
export type NextPaxPmsConnectionCreateMutationResult = Apollo.MutationResult<NextPaxPmsConnectionCreateMutation>;
export type NextPaxPmsConnectionCreateMutationOptions = Apollo.BaseMutationOptions<NextPaxPmsConnectionCreateMutation, NextPaxPmsConnectionCreateMutationVariables>;
export const CiirusPmsConnectionCreateDocument = gql`
    mutation CiirusPmsConnectionCreate($input: CiirusPmsConnectionCreateInput!) {
  ciirusPmsConnectionCreate(input: $input) {
    __typename
    ... on PmsConnection {
      ...PmsConnectionFields
    }
    ... on ValidationErrorCollection {
      errors {
        field
        message
        type
      }
    }
  }
}
    ${PmsConnectionFieldsFragmentDoc}`;
export type CiirusPmsConnectionCreateMutationFn = Apollo.MutationFunction<CiirusPmsConnectionCreateMutation, CiirusPmsConnectionCreateMutationVariables>;

/**
 * __useCiirusPmsConnectionCreateMutation__
 *
 * To run a mutation, you first call `useCiirusPmsConnectionCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCiirusPmsConnectionCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ciirusPmsConnectionCreateMutation, { data, loading, error }] = useCiirusPmsConnectionCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCiirusPmsConnectionCreateMutation(baseOptions?: Apollo.MutationHookOptions<CiirusPmsConnectionCreateMutation, CiirusPmsConnectionCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CiirusPmsConnectionCreateMutation, CiirusPmsConnectionCreateMutationVariables>(CiirusPmsConnectionCreateDocument, options);
      }
export type CiirusPmsConnectionCreateMutationHookResult = ReturnType<typeof useCiirusPmsConnectionCreateMutation>;
export type CiirusPmsConnectionCreateMutationResult = Apollo.MutationResult<CiirusPmsConnectionCreateMutation>;
export type CiirusPmsConnectionCreateMutationOptions = Apollo.BaseMutationOptions<CiirusPmsConnectionCreateMutation, CiirusPmsConnectionCreateMutationVariables>;
export const BoostPmsConnectionCreateDocument = gql`
    mutation BoostPmsConnectionCreate($input: BoostPmsConnectionCreateInput!) {
  boostPmsConnectionCreate(input: $input) {
    __typename
    ... on PmsConnection {
      ...PmsConnectionFields
    }
    ... on ValidationErrorCollection {
      errors {
        field
        message
        type
      }
    }
  }
}
    ${PmsConnectionFieldsFragmentDoc}`;
export type BoostPmsConnectionCreateMutationFn = Apollo.MutationFunction<BoostPmsConnectionCreateMutation, BoostPmsConnectionCreateMutationVariables>;

/**
 * __useBoostPmsConnectionCreateMutation__
 *
 * To run a mutation, you first call `useBoostPmsConnectionCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBoostPmsConnectionCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [boostPmsConnectionCreateMutation, { data, loading, error }] = useBoostPmsConnectionCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBoostPmsConnectionCreateMutation(baseOptions?: Apollo.MutationHookOptions<BoostPmsConnectionCreateMutation, BoostPmsConnectionCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BoostPmsConnectionCreateMutation, BoostPmsConnectionCreateMutationVariables>(BoostPmsConnectionCreateDocument, options);
      }
export type BoostPmsConnectionCreateMutationHookResult = ReturnType<typeof useBoostPmsConnectionCreateMutation>;
export type BoostPmsConnectionCreateMutationResult = Apollo.MutationResult<BoostPmsConnectionCreateMutation>;
export type BoostPmsConnectionCreateMutationOptions = Apollo.BaseMutationOptions<BoostPmsConnectionCreateMutation, BoostPmsConnectionCreateMutationVariables>;
export const LiveListPmsConnectionCreateDocument = gql`
    mutation LiveListPmsConnectionCreate($input: LiveListPmsConnectionCreateInput!) {
  liveListPmsConnectionCreate(input: $input) {
    __typename
    ... on PmsConnection {
      ...PmsConnectionFields
    }
    ... on ValidationErrorCollection {
      errors {
        field
        message
        type
      }
    }
  }
}
    ${PmsConnectionFieldsFragmentDoc}`;
export type LiveListPmsConnectionCreateMutationFn = Apollo.MutationFunction<LiveListPmsConnectionCreateMutation, LiveListPmsConnectionCreateMutationVariables>;

/**
 * __useLiveListPmsConnectionCreateMutation__
 *
 * To run a mutation, you first call `useLiveListPmsConnectionCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLiveListPmsConnectionCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [liveListPmsConnectionCreateMutation, { data, loading, error }] = useLiveListPmsConnectionCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLiveListPmsConnectionCreateMutation(baseOptions?: Apollo.MutationHookOptions<LiveListPmsConnectionCreateMutation, LiveListPmsConnectionCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LiveListPmsConnectionCreateMutation, LiveListPmsConnectionCreateMutationVariables>(LiveListPmsConnectionCreateDocument, options);
      }
export type LiveListPmsConnectionCreateMutationHookResult = ReturnType<typeof useLiveListPmsConnectionCreateMutation>;
export type LiveListPmsConnectionCreateMutationResult = Apollo.MutationResult<LiveListPmsConnectionCreateMutation>;
export type LiveListPmsConnectionCreateMutationOptions = Apollo.BaseMutationOptions<LiveListPmsConnectionCreateMutation, LiveListPmsConnectionCreateMutationVariables>;
export const VacayHomePmsConnectionCreateDocument = gql`
    mutation VacayHomePmsConnectionCreate($input: VacayHomePmsConnectionCreateInput!) {
  vacayHomePmsConnectionCreate(input: $input) {
    __typename
    ... on PmsConnection {
      ...PmsConnectionFields
    }
    ... on ValidationErrorCollection {
      errors {
        field
        message
        type
      }
    }
  }
}
    ${PmsConnectionFieldsFragmentDoc}`;
export type VacayHomePmsConnectionCreateMutationFn = Apollo.MutationFunction<VacayHomePmsConnectionCreateMutation, VacayHomePmsConnectionCreateMutationVariables>;

/**
 * __useVacayHomePmsConnectionCreateMutation__
 *
 * To run a mutation, you first call `useVacayHomePmsConnectionCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVacayHomePmsConnectionCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vacayHomePmsConnectionCreateMutation, { data, loading, error }] = useVacayHomePmsConnectionCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVacayHomePmsConnectionCreateMutation(baseOptions?: Apollo.MutationHookOptions<VacayHomePmsConnectionCreateMutation, VacayHomePmsConnectionCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VacayHomePmsConnectionCreateMutation, VacayHomePmsConnectionCreateMutationVariables>(VacayHomePmsConnectionCreateDocument, options);
      }
export type VacayHomePmsConnectionCreateMutationHookResult = ReturnType<typeof useVacayHomePmsConnectionCreateMutation>;
export type VacayHomePmsConnectionCreateMutationResult = Apollo.MutationResult<VacayHomePmsConnectionCreateMutation>;
export type VacayHomePmsConnectionCreateMutationOptions = Apollo.BaseMutationOptions<VacayHomePmsConnectionCreateMutation, VacayHomePmsConnectionCreateMutationVariables>;
export const PmsConnectionForCurrentUserDocument = gql`
    query PmsConnectionForCurrentUser {
  pmsConnectionForCurrentUser {
    __typename
    ... on PmsConnection {
      ...PmsConnectionFields
    }
    ... on NotFoundError {
      message
    }
    ... on UnauthenticatedError {
      message
    }
  }
}
    ${PmsConnectionFieldsFragmentDoc}`;

/**
 * __usePmsConnectionForCurrentUserQuery__
 *
 * To run a query within a React component, call `usePmsConnectionForCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `usePmsConnectionForCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePmsConnectionForCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function usePmsConnectionForCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<PmsConnectionForCurrentUserQuery, PmsConnectionForCurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PmsConnectionForCurrentUserQuery, PmsConnectionForCurrentUserQueryVariables>(PmsConnectionForCurrentUserDocument, options);
      }
export function usePmsConnectionForCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PmsConnectionForCurrentUserQuery, PmsConnectionForCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PmsConnectionForCurrentUserQuery, PmsConnectionForCurrentUserQueryVariables>(PmsConnectionForCurrentUserDocument, options);
        }
export function usePmsConnectionForCurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PmsConnectionForCurrentUserQuery, PmsConnectionForCurrentUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PmsConnectionForCurrentUserQuery, PmsConnectionForCurrentUserQueryVariables>(PmsConnectionForCurrentUserDocument, options);
        }
export type PmsConnectionForCurrentUserQueryHookResult = ReturnType<typeof usePmsConnectionForCurrentUserQuery>;
export type PmsConnectionForCurrentUserLazyQueryHookResult = ReturnType<typeof usePmsConnectionForCurrentUserLazyQuery>;
export type PmsConnectionForCurrentUserSuspenseQueryHookResult = ReturnType<typeof usePmsConnectionForCurrentUserSuspenseQuery>;
export type PmsConnectionForCurrentUserQueryResult = Apollo.QueryResult<PmsConnectionForCurrentUserQuery, PmsConnectionForCurrentUserQueryVariables>;
export function refetchPmsConnectionForCurrentUserQuery(variables?: PmsConnectionForCurrentUserQueryVariables) {
      return { query: PmsConnectionForCurrentUserDocument, variables: variables }
    }
export const PmsIntegrationListAllDocument = gql`
    query PmsIntegrationListAll {
  pmsIntegrationListAll {
    name
    docsUrl
    jiraTicketUrl
    authType
    status
    contentSync
    availabilitySync
    ratesSync
    supportsPricing
    supportsBookings
    supportedFields {
      fieldName
      description
      supported
    }
    supportsReviews
    fields {
      fieldName
      description
      supported
    }
  }
}
    `;

/**
 * __usePmsIntegrationListAllQuery__
 *
 * To run a query within a React component, call `usePmsIntegrationListAllQuery` and pass it any options that fit your needs.
 * When your component renders, `usePmsIntegrationListAllQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePmsIntegrationListAllQuery({
 *   variables: {
 *   },
 * });
 */
export function usePmsIntegrationListAllQuery(baseOptions?: Apollo.QueryHookOptions<PmsIntegrationListAllQuery, PmsIntegrationListAllQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PmsIntegrationListAllQuery, PmsIntegrationListAllQueryVariables>(PmsIntegrationListAllDocument, options);
      }
export function usePmsIntegrationListAllLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PmsIntegrationListAllQuery, PmsIntegrationListAllQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PmsIntegrationListAllQuery, PmsIntegrationListAllQueryVariables>(PmsIntegrationListAllDocument, options);
        }
export function usePmsIntegrationListAllSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PmsIntegrationListAllQuery, PmsIntegrationListAllQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PmsIntegrationListAllQuery, PmsIntegrationListAllQueryVariables>(PmsIntegrationListAllDocument, options);
        }
export type PmsIntegrationListAllQueryHookResult = ReturnType<typeof usePmsIntegrationListAllQuery>;
export type PmsIntegrationListAllLazyQueryHookResult = ReturnType<typeof usePmsIntegrationListAllLazyQuery>;
export type PmsIntegrationListAllSuspenseQueryHookResult = ReturnType<typeof usePmsIntegrationListAllSuspenseQuery>;
export type PmsIntegrationListAllQueryResult = Apollo.QueryResult<PmsIntegrationListAllQuery, PmsIntegrationListAllQueryVariables>;
export function refetchPmsIntegrationListAllQuery(variables?: PmsIntegrationListAllQueryVariables) {
      return { query: PmsIntegrationListAllDocument, variables: variables }
    }
export const PolicyUpsertAccountTermsAndConditionsDocument = gql`
    mutation PolicyUpsertAccountTermsAndConditions($input: PolicyUpsertAccountTermsAndConditionsInput!) {
  policyUpsertAccountTermsAndConditions(input: $input) {
    __typename
    ... on AccountTermsAndConditions {
      id
      type
      termsLink
    }
    ... on ValidationErrorCollection {
      errors {
        message
        type
        field
      }
    }
    ... on UnauthenticatedError {
      message
    }
    ... on NotFoundError {
      message
    }
  }
}
    `;
export type PolicyUpsertAccountTermsAndConditionsMutationFn = Apollo.MutationFunction<PolicyUpsertAccountTermsAndConditionsMutation, PolicyUpsertAccountTermsAndConditionsMutationVariables>;

/**
 * __usePolicyUpsertAccountTermsAndConditionsMutation__
 *
 * To run a mutation, you first call `usePolicyUpsertAccountTermsAndConditionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolicyUpsertAccountTermsAndConditionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [policyUpsertAccountTermsAndConditionsMutation, { data, loading, error }] = usePolicyUpsertAccountTermsAndConditionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePolicyUpsertAccountTermsAndConditionsMutation(baseOptions?: Apollo.MutationHookOptions<PolicyUpsertAccountTermsAndConditionsMutation, PolicyUpsertAccountTermsAndConditionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolicyUpsertAccountTermsAndConditionsMutation, PolicyUpsertAccountTermsAndConditionsMutationVariables>(PolicyUpsertAccountTermsAndConditionsDocument, options);
      }
export type PolicyUpsertAccountTermsAndConditionsMutationHookResult = ReturnType<typeof usePolicyUpsertAccountTermsAndConditionsMutation>;
export type PolicyUpsertAccountTermsAndConditionsMutationResult = Apollo.MutationResult<PolicyUpsertAccountTermsAndConditionsMutation>;
export type PolicyUpsertAccountTermsAndConditionsMutationOptions = Apollo.BaseMutationOptions<PolicyUpsertAccountTermsAndConditionsMutation, PolicyUpsertAccountTermsAndConditionsMutationVariables>;
export const PolicyUpsertAccountCancellationPolicyDocument = gql`
    mutation PolicyUpsertAccountCancellationPolicy($input: PolicyUpsertAccountCancellationPolicyInput!) {
  policyUpsertAccountCancellationPolicy(input: $input) {
    __typename
    ... on AccountCancellationPolicy {
      id
      type
      cancellationPolicy
    }
    ... on ValidationErrorCollection {
      errors {
        message
        type
        field
      }
    }
    ... on UnauthenticatedError {
      message
    }
    ... on NotFoundError {
      message
    }
  }
}
    `;
export type PolicyUpsertAccountCancellationPolicyMutationFn = Apollo.MutationFunction<PolicyUpsertAccountCancellationPolicyMutation, PolicyUpsertAccountCancellationPolicyMutationVariables>;

/**
 * __usePolicyUpsertAccountCancellationPolicyMutation__
 *
 * To run a mutation, you first call `usePolicyUpsertAccountCancellationPolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolicyUpsertAccountCancellationPolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [policyUpsertAccountCancellationPolicyMutation, { data, loading, error }] = usePolicyUpsertAccountCancellationPolicyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePolicyUpsertAccountCancellationPolicyMutation(baseOptions?: Apollo.MutationHookOptions<PolicyUpsertAccountCancellationPolicyMutation, PolicyUpsertAccountCancellationPolicyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolicyUpsertAccountCancellationPolicyMutation, PolicyUpsertAccountCancellationPolicyMutationVariables>(PolicyUpsertAccountCancellationPolicyDocument, options);
      }
export type PolicyUpsertAccountCancellationPolicyMutationHookResult = ReturnType<typeof usePolicyUpsertAccountCancellationPolicyMutation>;
export type PolicyUpsertAccountCancellationPolicyMutationResult = Apollo.MutationResult<PolicyUpsertAccountCancellationPolicyMutation>;
export type PolicyUpsertAccountCancellationPolicyMutationOptions = Apollo.BaseMutationOptions<PolicyUpsertAccountCancellationPolicyMutation, PolicyUpsertAccountCancellationPolicyMutationVariables>;
export const PolicyUpsertListingCancellationPolicyDocument = gql`
    mutation PolicyUpsertListingCancellationPolicy($input: PolicyUpsertListingCancellationPolicyInput!) {
  policyUpsertListingCancellationPolicy(input: $input) {
    __typename
    ... on ListingCancellationPolicy {
      type
      cancellationPolicy
    }
    ... on ValidationErrorCollection {
      errors {
        message
        type
        field
      }
    }
    ... on UnauthenticatedError {
      message
    }
    ... on NotFoundError {
      message
    }
  }
}
    `;
export type PolicyUpsertListingCancellationPolicyMutationFn = Apollo.MutationFunction<PolicyUpsertListingCancellationPolicyMutation, PolicyUpsertListingCancellationPolicyMutationVariables>;

/**
 * __usePolicyUpsertListingCancellationPolicyMutation__
 *
 * To run a mutation, you first call `usePolicyUpsertListingCancellationPolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolicyUpsertListingCancellationPolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [policyUpsertListingCancellationPolicyMutation, { data, loading, error }] = usePolicyUpsertListingCancellationPolicyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePolicyUpsertListingCancellationPolicyMutation(baseOptions?: Apollo.MutationHookOptions<PolicyUpsertListingCancellationPolicyMutation, PolicyUpsertListingCancellationPolicyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolicyUpsertListingCancellationPolicyMutation, PolicyUpsertListingCancellationPolicyMutationVariables>(PolicyUpsertListingCancellationPolicyDocument, options);
      }
export type PolicyUpsertListingCancellationPolicyMutationHookResult = ReturnType<typeof usePolicyUpsertListingCancellationPolicyMutation>;
export type PolicyUpsertListingCancellationPolicyMutationResult = Apollo.MutationResult<PolicyUpsertListingCancellationPolicyMutation>;
export type PolicyUpsertListingCancellationPolicyMutationOptions = Apollo.BaseMutationOptions<PolicyUpsertListingCancellationPolicyMutation, PolicyUpsertListingCancellationPolicyMutationVariables>;
export const RegionsListAllWithActiveSearchPageContentsDocument = gql`
    query RegionsListAllWithActiveSearchPageContents($page: Int!, $pageSize: Int!, $searchType: SearchPageContentType!) {
  regionsListAllWithActiveSearchPageContents(
    page: $page
    pageSize: $pageSize
    searchType: $searchType
  ) {
    entries {
      id
      countrySlug
      levelOneSlug
      citySlug
      slug
      name
    }
    meta {
      nextPage
      previousPage
      totalPages
    }
  }
}
    `;

/**
 * __useRegionsListAllWithActiveSearchPageContentsQuery__
 *
 * To run a query within a React component, call `useRegionsListAllWithActiveSearchPageContentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegionsListAllWithActiveSearchPageContentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegionsListAllWithActiveSearchPageContentsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      searchType: // value for 'searchType'
 *   },
 * });
 */
export function useRegionsListAllWithActiveSearchPageContentsQuery(baseOptions: Apollo.QueryHookOptions<RegionsListAllWithActiveSearchPageContentsQuery, RegionsListAllWithActiveSearchPageContentsQueryVariables> & ({ variables: RegionsListAllWithActiveSearchPageContentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RegionsListAllWithActiveSearchPageContentsQuery, RegionsListAllWithActiveSearchPageContentsQueryVariables>(RegionsListAllWithActiveSearchPageContentsDocument, options);
      }
export function useRegionsListAllWithActiveSearchPageContentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RegionsListAllWithActiveSearchPageContentsQuery, RegionsListAllWithActiveSearchPageContentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RegionsListAllWithActiveSearchPageContentsQuery, RegionsListAllWithActiveSearchPageContentsQueryVariables>(RegionsListAllWithActiveSearchPageContentsDocument, options);
        }
export function useRegionsListAllWithActiveSearchPageContentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RegionsListAllWithActiveSearchPageContentsQuery, RegionsListAllWithActiveSearchPageContentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RegionsListAllWithActiveSearchPageContentsQuery, RegionsListAllWithActiveSearchPageContentsQueryVariables>(RegionsListAllWithActiveSearchPageContentsDocument, options);
        }
export type RegionsListAllWithActiveSearchPageContentsQueryHookResult = ReturnType<typeof useRegionsListAllWithActiveSearchPageContentsQuery>;
export type RegionsListAllWithActiveSearchPageContentsLazyQueryHookResult = ReturnType<typeof useRegionsListAllWithActiveSearchPageContentsLazyQuery>;
export type RegionsListAllWithActiveSearchPageContentsSuspenseQueryHookResult = ReturnType<typeof useRegionsListAllWithActiveSearchPageContentsSuspenseQuery>;
export type RegionsListAllWithActiveSearchPageContentsQueryResult = Apollo.QueryResult<RegionsListAllWithActiveSearchPageContentsQuery, RegionsListAllWithActiveSearchPageContentsQueryVariables>;
export function refetchRegionsListAllWithActiveSearchPageContentsQuery(variables: RegionsListAllWithActiveSearchPageContentsQueryVariables) {
      return { query: RegionsListAllWithActiveSearchPageContentsDocument, variables: variables }
    }
export const RegionsListAllFeaturedDocument = gql`
    query RegionsListAllFeatured($page: Int!, $pageSize: Int!) {
  regionsListAllFeatured(page: $page, pageSize: $pageSize) {
    __typename
    ... on RegionCollection {
      entries {
        id
        name
        imageUrl
        placeId
      }
      meta {
        currentPage
        totalEntries
        nextPage
        previousPage
      }
    }
  }
}
    `;

/**
 * __useRegionsListAllFeaturedQuery__
 *
 * To run a query within a React component, call `useRegionsListAllFeaturedQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegionsListAllFeaturedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegionsListAllFeaturedQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useRegionsListAllFeaturedQuery(baseOptions: Apollo.QueryHookOptions<RegionsListAllFeaturedQuery, RegionsListAllFeaturedQueryVariables> & ({ variables: RegionsListAllFeaturedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RegionsListAllFeaturedQuery, RegionsListAllFeaturedQueryVariables>(RegionsListAllFeaturedDocument, options);
      }
export function useRegionsListAllFeaturedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RegionsListAllFeaturedQuery, RegionsListAllFeaturedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RegionsListAllFeaturedQuery, RegionsListAllFeaturedQueryVariables>(RegionsListAllFeaturedDocument, options);
        }
export function useRegionsListAllFeaturedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RegionsListAllFeaturedQuery, RegionsListAllFeaturedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RegionsListAllFeaturedQuery, RegionsListAllFeaturedQueryVariables>(RegionsListAllFeaturedDocument, options);
        }
export type RegionsListAllFeaturedQueryHookResult = ReturnType<typeof useRegionsListAllFeaturedQuery>;
export type RegionsListAllFeaturedLazyQueryHookResult = ReturnType<typeof useRegionsListAllFeaturedLazyQuery>;
export type RegionsListAllFeaturedSuspenseQueryHookResult = ReturnType<typeof useRegionsListAllFeaturedSuspenseQuery>;
export type RegionsListAllFeaturedQueryResult = Apollo.QueryResult<RegionsListAllFeaturedQuery, RegionsListAllFeaturedQueryVariables>;
export function refetchRegionsListAllFeaturedQuery(variables: RegionsListAllFeaturedQueryVariables) {
      return { query: RegionsListAllFeaturedDocument, variables: variables }
    }
export const CreateReservationDocument = gql`
    mutation CreateReservation($input: CreateReservationInput!) {
  createReservation(input: $input) {
    __typename
    ... on Reservation {
      startDate
      endDate
      status
      id
      externalReservationId
    }
    ... on NotFoundError {
      message
    }
    ... on ValidationErrorCollection {
      errors {
        type
        field
        message
      }
    }
  }
}
    `;
export type CreateReservationMutationFn = Apollo.MutationFunction<CreateReservationMutation, CreateReservationMutationVariables>;

/**
 * __useCreateReservationMutation__
 *
 * To run a mutation, you first call `useCreateReservationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReservationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReservationMutation, { data, loading, error }] = useCreateReservationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateReservationMutation(baseOptions?: Apollo.MutationHookOptions<CreateReservationMutation, CreateReservationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReservationMutation, CreateReservationMutationVariables>(CreateReservationDocument, options);
      }
export type CreateReservationMutationHookResult = ReturnType<typeof useCreateReservationMutation>;
export type CreateReservationMutationResult = Apollo.MutationResult<CreateReservationMutation>;
export type CreateReservationMutationOptions = Apollo.BaseMutationOptions<CreateReservationMutation, CreateReservationMutationVariables>;
export const CancelReservationDocument = gql`
    mutation CancelReservation($input: CancelReservationInput!) {
  cancelReservation(input: $input) {
    __typename
    ... on Reservation {
      startDate
      endDate
      status
      id
      externalReservationId
    }
    ... on NotFoundError {
      message
    }
    ... on ValidationErrorCollection {
      errors {
        type
        field
        message
      }
    }
  }
}
    `;
export type CancelReservationMutationFn = Apollo.MutationFunction<CancelReservationMutation, CancelReservationMutationVariables>;

/**
 * __useCancelReservationMutation__
 *
 * To run a mutation, you first call `useCancelReservationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelReservationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelReservationMutation, { data, loading, error }] = useCancelReservationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelReservationMutation(baseOptions?: Apollo.MutationHookOptions<CancelReservationMutation, CancelReservationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelReservationMutation, CancelReservationMutationVariables>(CancelReservationDocument, options);
      }
export type CancelReservationMutationHookResult = ReturnType<typeof useCancelReservationMutation>;
export type CancelReservationMutationResult = Apollo.MutationResult<CancelReservationMutation>;
export type CancelReservationMutationOptions = Apollo.BaseMutationOptions<CancelReservationMutation, CancelReservationMutationVariables>;
export const FreePromoCreateReservationDocument = gql`
    mutation FreePromoCreateReservation($input: FreePromoCreateReservationInput!) {
  freePromoCreateReservation(input: $input) {
    __typename
    ... on Reservation {
      startDate
      endDate
      status
      id
      externalReservationId
    }
    ... on NotFoundError {
      message
    }
    ... on ValidationErrorCollection {
      errors {
        type
        field
        message
      }
    }
  }
}
    `;
export type FreePromoCreateReservationMutationFn = Apollo.MutationFunction<FreePromoCreateReservationMutation, FreePromoCreateReservationMutationVariables>;

/**
 * __useFreePromoCreateReservationMutation__
 *
 * To run a mutation, you first call `useFreePromoCreateReservationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFreePromoCreateReservationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [freePromoCreateReservationMutation, { data, loading, error }] = useFreePromoCreateReservationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFreePromoCreateReservationMutation(baseOptions?: Apollo.MutationHookOptions<FreePromoCreateReservationMutation, FreePromoCreateReservationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FreePromoCreateReservationMutation, FreePromoCreateReservationMutationVariables>(FreePromoCreateReservationDocument, options);
      }
export type FreePromoCreateReservationMutationHookResult = ReturnType<typeof useFreePromoCreateReservationMutation>;
export type FreePromoCreateReservationMutationResult = Apollo.MutationResult<FreePromoCreateReservationMutation>;
export type FreePromoCreateReservationMutationOptions = Apollo.BaseMutationOptions<FreePromoCreateReservationMutation, FreePromoCreateReservationMutationVariables>;
export const ReservationByIdDocument = gql`
    query ReservationById($id: ID!) {
  reservationById(id: $id) {
    __typename
    ... on Reservation {
      id
      totalCostCents
      startDate
      endDate
      status
      externalReservationId
      numberOfAdults
      numberOfChildren
      numberOfInfants
      numberOfPets
      cancellationPolicy
      supportsCancellations
      paymentSchedule {
        dueDate
        amountCents
        description
        paymentItemType
      }
      listing {
        bookDirectWebsiteUrl
        city
        description
        marketingWebsiteUrl
        name
        slug
        stateOrProvinceLongName
        guestCapacity
        numberOfRooms
        numberOfBathrooms
        lat
        lng
        minPrice
        maxPrice
        propertyType
        uniquePropertyType
        id
        isFavorited
        listingLevel
        searchableAvailability
        isDiamondCollection
        addressLineOne
        cancellationPolicy
        publicPhoneNumber
        features {
          key
          displayName
          categoryName
          promoted
        }
        account {
          id
          slug
          companyName
          avatarUrl
          description
          email
          marketingWebsiteUrl
          phoneNumber
        }
        galleryAssets(numberOfAssets: 10, processing: false) {
          id
          url
          description
        }
      }
    }
    ... on NotFoundError {
      message
    }
  }
}
    `;

/**
 * __useReservationByIdQuery__
 *
 * To run a query within a React component, call `useReservationByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useReservationByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReservationByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReservationByIdQuery(baseOptions: Apollo.QueryHookOptions<ReservationByIdQuery, ReservationByIdQueryVariables> & ({ variables: ReservationByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReservationByIdQuery, ReservationByIdQueryVariables>(ReservationByIdDocument, options);
      }
export function useReservationByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReservationByIdQuery, ReservationByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReservationByIdQuery, ReservationByIdQueryVariables>(ReservationByIdDocument, options);
        }
export function useReservationByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReservationByIdQuery, ReservationByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReservationByIdQuery, ReservationByIdQueryVariables>(ReservationByIdDocument, options);
        }
export type ReservationByIdQueryHookResult = ReturnType<typeof useReservationByIdQuery>;
export type ReservationByIdLazyQueryHookResult = ReturnType<typeof useReservationByIdLazyQuery>;
export type ReservationByIdSuspenseQueryHookResult = ReturnType<typeof useReservationByIdSuspenseQuery>;
export type ReservationByIdQueryResult = Apollo.QueryResult<ReservationByIdQuery, ReservationByIdQueryVariables>;
export function refetchReservationByIdQuery(variables: ReservationByIdQueryVariables) {
      return { query: ReservationByIdDocument, variables: variables }
    }
export const ReservationsListAllForCurrentUserDocument = gql`
    query ReservationsListAllForCurrentUser($statusFilter: [ReservationStatuses], $page: Int!, $pageSize: Int! = 20) {
  reservationsListAllForUser(
    statusFilter: $statusFilter
    page: $page
    pageSize: $pageSize
  ) {
    __typename
    ... on ReservationCollection {
      entries {
        id
        totalCostCents
        startDate
        endDate
        status
        listing {
          bookDirectWebsiteUrl
          city
          description
          marketingWebsiteUrl
          name
          slug
          stateOrProvinceLongName
          guestCapacity
          numberOfRooms
          numberOfBathrooms
          lat
          lng
          minPrice
          maxPrice
          propertyType
          id
          isFavorited
          listingLevel
          searchableAvailability
          isDiamondCollection
          addressLineOne
          cancellationPolicy
          features {
            key
            displayName
            categoryName
            promoted
          }
          account {
            id
            slug
            companyName
            avatarUrl
          }
          galleryAssets(numberOfAssets: 10, processing: false) {
            id
            url
            description
          }
        }
      }
      meta {
        currentPage
        nextPage
        totalPages
        previousPage
        totalEntries
      }
    }
    ... on UnauthenticatedError {
      message
    }
  }
}
    `;

/**
 * __useReservationsListAllForCurrentUserQuery__
 *
 * To run a query within a React component, call `useReservationsListAllForCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useReservationsListAllForCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReservationsListAllForCurrentUserQuery({
 *   variables: {
 *      statusFilter: // value for 'statusFilter'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useReservationsListAllForCurrentUserQuery(baseOptions: Apollo.QueryHookOptions<ReservationsListAllForCurrentUserQuery, ReservationsListAllForCurrentUserQueryVariables> & ({ variables: ReservationsListAllForCurrentUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReservationsListAllForCurrentUserQuery, ReservationsListAllForCurrentUserQueryVariables>(ReservationsListAllForCurrentUserDocument, options);
      }
export function useReservationsListAllForCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReservationsListAllForCurrentUserQuery, ReservationsListAllForCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReservationsListAllForCurrentUserQuery, ReservationsListAllForCurrentUserQueryVariables>(ReservationsListAllForCurrentUserDocument, options);
        }
export function useReservationsListAllForCurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReservationsListAllForCurrentUserQuery, ReservationsListAllForCurrentUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReservationsListAllForCurrentUserQuery, ReservationsListAllForCurrentUserQueryVariables>(ReservationsListAllForCurrentUserDocument, options);
        }
export type ReservationsListAllForCurrentUserQueryHookResult = ReturnType<typeof useReservationsListAllForCurrentUserQuery>;
export type ReservationsListAllForCurrentUserLazyQueryHookResult = ReturnType<typeof useReservationsListAllForCurrentUserLazyQuery>;
export type ReservationsListAllForCurrentUserSuspenseQueryHookResult = ReturnType<typeof useReservationsListAllForCurrentUserSuspenseQuery>;
export type ReservationsListAllForCurrentUserQueryResult = Apollo.QueryResult<ReservationsListAllForCurrentUserQuery, ReservationsListAllForCurrentUserQueryVariables>;
export function refetchReservationsListAllForCurrentUserQuery(variables: ReservationsListAllForCurrentUserQueryVariables) {
      return { query: ReservationsListAllForCurrentUserDocument, variables: variables }
    }
export const SearchPageContentsListAllDocument = gql`
    query SearchPageContentsListAll($page: Int!, $pageSize: Int!, $h1Query: String, $type: SearchPageContentType) {
  searchPageContentListAll(
    page: $page
    pageSize: $pageSize
    h1Query: $h1Query
    type: $type
  ) {
    entries {
      active
      searchType
      h1
      h1ParagraphRaw
      h2
      h2ParagraphRaw
      heroImageHtmlAlt
      heroImageProcessing
      heroImageUploadUrl
      heroImageUrl
      htmlMetaDescription
      htmlMetaTitle
      id
      updatedAt
    }
    meta {
      previousPage
      nextPage
      totalEntries
      currentPage
    }
  }
}
    `;

/**
 * __useSearchPageContentsListAllQuery__
 *
 * To run a query within a React component, call `useSearchPageContentsListAllQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchPageContentsListAllQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchPageContentsListAllQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      h1Query: // value for 'h1Query'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useSearchPageContentsListAllQuery(baseOptions: Apollo.QueryHookOptions<SearchPageContentsListAllQuery, SearchPageContentsListAllQueryVariables> & ({ variables: SearchPageContentsListAllQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchPageContentsListAllQuery, SearchPageContentsListAllQueryVariables>(SearchPageContentsListAllDocument, options);
      }
export function useSearchPageContentsListAllLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchPageContentsListAllQuery, SearchPageContentsListAllQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchPageContentsListAllQuery, SearchPageContentsListAllQueryVariables>(SearchPageContentsListAllDocument, options);
        }
export function useSearchPageContentsListAllSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchPageContentsListAllQuery, SearchPageContentsListAllQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchPageContentsListAllQuery, SearchPageContentsListAllQueryVariables>(SearchPageContentsListAllDocument, options);
        }
export type SearchPageContentsListAllQueryHookResult = ReturnType<typeof useSearchPageContentsListAllQuery>;
export type SearchPageContentsListAllLazyQueryHookResult = ReturnType<typeof useSearchPageContentsListAllLazyQuery>;
export type SearchPageContentsListAllSuspenseQueryHookResult = ReturnType<typeof useSearchPageContentsListAllSuspenseQuery>;
export type SearchPageContentsListAllQueryResult = Apollo.QueryResult<SearchPageContentsListAllQuery, SearchPageContentsListAllQueryVariables>;
export function refetchSearchPageContentsListAllQuery(variables: SearchPageContentsListAllQueryVariables) {
      return { query: SearchPageContentsListAllDocument, variables: variables }
    }
export const SearchPageContentForUrlPathAndTypeDocument = gql`
    query SearchPageContentForUrlPathAndType($urlPath: String!, $searchType: SearchPageContentType!) {
  searchPageContentForUrlPathAndType(urlPath: $urlPath, searchType: $searchType) {
    __typename
    ... on NotFoundError {
      message
    }
    ... on SearchPageContent {
      active
      searchType
      h1
      h1ParagraphRaw
      h2
      h2ParagraphRaw
      heroImageHtmlAlt
      heroImageProcessing
      heroImageUploadUrl
      heroImageUrl
      htmlMetaDescription
      htmlMetaTitle
      aboutItemsTitle
      faqsTitle
      id
      cities {
        searchType
        region {
          description
          citySlug
          countrySlug
          slug
          levelOneSlug
        }
      }
      searchPageLinks {
        href
        id
        title
        type
      }
      searchPageParagraphs {
        bodyRaw
        id
        title
        type
      }
      region {
        description
        placeId
      }
      updatedAt
    }
  }
}
    `;

/**
 * __useSearchPageContentForUrlPathAndTypeQuery__
 *
 * To run a query within a React component, call `useSearchPageContentForUrlPathAndTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchPageContentForUrlPathAndTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchPageContentForUrlPathAndTypeQuery({
 *   variables: {
 *      urlPath: // value for 'urlPath'
 *      searchType: // value for 'searchType'
 *   },
 * });
 */
export function useSearchPageContentForUrlPathAndTypeQuery(baseOptions: Apollo.QueryHookOptions<SearchPageContentForUrlPathAndTypeQuery, SearchPageContentForUrlPathAndTypeQueryVariables> & ({ variables: SearchPageContentForUrlPathAndTypeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchPageContentForUrlPathAndTypeQuery, SearchPageContentForUrlPathAndTypeQueryVariables>(SearchPageContentForUrlPathAndTypeDocument, options);
      }
export function useSearchPageContentForUrlPathAndTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchPageContentForUrlPathAndTypeQuery, SearchPageContentForUrlPathAndTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchPageContentForUrlPathAndTypeQuery, SearchPageContentForUrlPathAndTypeQueryVariables>(SearchPageContentForUrlPathAndTypeDocument, options);
        }
export function useSearchPageContentForUrlPathAndTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchPageContentForUrlPathAndTypeQuery, SearchPageContentForUrlPathAndTypeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchPageContentForUrlPathAndTypeQuery, SearchPageContentForUrlPathAndTypeQueryVariables>(SearchPageContentForUrlPathAndTypeDocument, options);
        }
export type SearchPageContentForUrlPathAndTypeQueryHookResult = ReturnType<typeof useSearchPageContentForUrlPathAndTypeQuery>;
export type SearchPageContentForUrlPathAndTypeLazyQueryHookResult = ReturnType<typeof useSearchPageContentForUrlPathAndTypeLazyQuery>;
export type SearchPageContentForUrlPathAndTypeSuspenseQueryHookResult = ReturnType<typeof useSearchPageContentForUrlPathAndTypeSuspenseQuery>;
export type SearchPageContentForUrlPathAndTypeQueryResult = Apollo.QueryResult<SearchPageContentForUrlPathAndTypeQuery, SearchPageContentForUrlPathAndTypeQueryVariables>;
export function refetchSearchPageContentForUrlPathAndTypeQuery(variables: SearchPageContentForUrlPathAndTypeQueryVariables) {
      return { query: SearchPageContentForUrlPathAndTypeDocument, variables: variables }
    }
export const SitemapListingsTotalCountDocument = gql`
    query SitemapListingsTotalCount($page: Int!, $pageSize: Int!) {
  listingCollection: listingsListAllActive(
    propertyTypes: [BED_AND_BREAKFAST]
    page: $page
    pageSize: $pageSize
  ) {
    meta {
      totalEntries
    }
  }
}
    `;

/**
 * __useSitemapListingsTotalCountQuery__
 *
 * To run a query within a React component, call `useSitemapListingsTotalCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useSitemapListingsTotalCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSitemapListingsTotalCountQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useSitemapListingsTotalCountQuery(baseOptions: Apollo.QueryHookOptions<SitemapListingsTotalCountQuery, SitemapListingsTotalCountQueryVariables> & ({ variables: SitemapListingsTotalCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SitemapListingsTotalCountQuery, SitemapListingsTotalCountQueryVariables>(SitemapListingsTotalCountDocument, options);
      }
export function useSitemapListingsTotalCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SitemapListingsTotalCountQuery, SitemapListingsTotalCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SitemapListingsTotalCountQuery, SitemapListingsTotalCountQueryVariables>(SitemapListingsTotalCountDocument, options);
        }
export function useSitemapListingsTotalCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SitemapListingsTotalCountQuery, SitemapListingsTotalCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SitemapListingsTotalCountQuery, SitemapListingsTotalCountQueryVariables>(SitemapListingsTotalCountDocument, options);
        }
export type SitemapListingsTotalCountQueryHookResult = ReturnType<typeof useSitemapListingsTotalCountQuery>;
export type SitemapListingsTotalCountLazyQueryHookResult = ReturnType<typeof useSitemapListingsTotalCountLazyQuery>;
export type SitemapListingsTotalCountSuspenseQueryHookResult = ReturnType<typeof useSitemapListingsTotalCountSuspenseQuery>;
export type SitemapListingsTotalCountQueryResult = Apollo.QueryResult<SitemapListingsTotalCountQuery, SitemapListingsTotalCountQueryVariables>;
export function refetchSitemapListingsTotalCountQuery(variables: SitemapListingsTotalCountQueryVariables) {
      return { query: SitemapListingsTotalCountDocument, variables: variables }
    }
export const SitemapListingsListAllDocument = gql`
    query SitemapListingsListAll($page: Int!, $pageSize: Int!) {
  listingCollection: listingsListAllActive(
    page: $page
    pageSize: $pageSize
    propertyTypes: [BED_AND_BREAKFAST]
  ) {
    entries {
      slug
      updatedAt
    }
    meta {
      nextPage
      previousPage
    }
  }
}
    `;

/**
 * __useSitemapListingsListAllQuery__
 *
 * To run a query within a React component, call `useSitemapListingsListAllQuery` and pass it any options that fit your needs.
 * When your component renders, `useSitemapListingsListAllQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSitemapListingsListAllQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useSitemapListingsListAllQuery(baseOptions: Apollo.QueryHookOptions<SitemapListingsListAllQuery, SitemapListingsListAllQueryVariables> & ({ variables: SitemapListingsListAllQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SitemapListingsListAllQuery, SitemapListingsListAllQueryVariables>(SitemapListingsListAllDocument, options);
      }
export function useSitemapListingsListAllLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SitemapListingsListAllQuery, SitemapListingsListAllQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SitemapListingsListAllQuery, SitemapListingsListAllQueryVariables>(SitemapListingsListAllDocument, options);
        }
export function useSitemapListingsListAllSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SitemapListingsListAllQuery, SitemapListingsListAllQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SitemapListingsListAllQuery, SitemapListingsListAllQueryVariables>(SitemapListingsListAllDocument, options);
        }
export type SitemapListingsListAllQueryHookResult = ReturnType<typeof useSitemapListingsListAllQuery>;
export type SitemapListingsListAllLazyQueryHookResult = ReturnType<typeof useSitemapListingsListAllLazyQuery>;
export type SitemapListingsListAllSuspenseQueryHookResult = ReturnType<typeof useSitemapListingsListAllSuspenseQuery>;
export type SitemapListingsListAllQueryResult = Apollo.QueryResult<SitemapListingsListAllQuery, SitemapListingsListAllQueryVariables>;
export function refetchSitemapListingsListAllQuery(variables: SitemapListingsListAllQueryVariables) {
      return { query: SitemapListingsListAllDocument, variables: variables }
    }
export const SitemapRegionsListBedAndBreakfastDocument = gql`
    query SitemapRegionsListBedAndBreakfast($page: Int!, $pageSize: Int!) {
  regionsListAllWithActiveSearchPageContents(
    page: $page
    pageSize: $pageSize
    searchType: BED_AND_BREAKFAST
  ) {
    entries {
      id
      countrySlug
      levelOneSlug
      citySlug
      slug
    }
    meta {
      nextPage
      previousPage
    }
  }
}
    `;

/**
 * __useSitemapRegionsListBedAndBreakfastQuery__
 *
 * To run a query within a React component, call `useSitemapRegionsListBedAndBreakfastQuery` and pass it any options that fit your needs.
 * When your component renders, `useSitemapRegionsListBedAndBreakfastQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSitemapRegionsListBedAndBreakfastQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useSitemapRegionsListBedAndBreakfastQuery(baseOptions: Apollo.QueryHookOptions<SitemapRegionsListBedAndBreakfastQuery, SitemapRegionsListBedAndBreakfastQueryVariables> & ({ variables: SitemapRegionsListBedAndBreakfastQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SitemapRegionsListBedAndBreakfastQuery, SitemapRegionsListBedAndBreakfastQueryVariables>(SitemapRegionsListBedAndBreakfastDocument, options);
      }
export function useSitemapRegionsListBedAndBreakfastLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SitemapRegionsListBedAndBreakfastQuery, SitemapRegionsListBedAndBreakfastQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SitemapRegionsListBedAndBreakfastQuery, SitemapRegionsListBedAndBreakfastQueryVariables>(SitemapRegionsListBedAndBreakfastDocument, options);
        }
export function useSitemapRegionsListBedAndBreakfastSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SitemapRegionsListBedAndBreakfastQuery, SitemapRegionsListBedAndBreakfastQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SitemapRegionsListBedAndBreakfastQuery, SitemapRegionsListBedAndBreakfastQueryVariables>(SitemapRegionsListBedAndBreakfastDocument, options);
        }
export type SitemapRegionsListBedAndBreakfastQueryHookResult = ReturnType<typeof useSitemapRegionsListBedAndBreakfastQuery>;
export type SitemapRegionsListBedAndBreakfastLazyQueryHookResult = ReturnType<typeof useSitemapRegionsListBedAndBreakfastLazyQuery>;
export type SitemapRegionsListBedAndBreakfastSuspenseQueryHookResult = ReturnType<typeof useSitemapRegionsListBedAndBreakfastSuspenseQuery>;
export type SitemapRegionsListBedAndBreakfastQueryResult = Apollo.QueryResult<SitemapRegionsListBedAndBreakfastQuery, SitemapRegionsListBedAndBreakfastQueryVariables>;
export function refetchSitemapRegionsListBedAndBreakfastQuery(variables: SitemapRegionsListBedAndBreakfastQueryVariables) {
      return { query: SitemapRegionsListBedAndBreakfastDocument, variables: variables }
    }
export const SitemapRegionsListVacationRentalsDocument = gql`
    query SitemapRegionsListVacationRentals($page: Int!, $pageSize: Int!) {
  regionsListAllWithActiveSearchPageContents(
    page: $page
    pageSize: $pageSize
    searchType: VACATION_RENTAL
  ) {
    entries {
      id
      countrySlug
      levelOneSlug
      citySlug
      slug
    }
    meta {
      nextPage
      previousPage
    }
  }
}
    `;

/**
 * __useSitemapRegionsListVacationRentalsQuery__
 *
 * To run a query within a React component, call `useSitemapRegionsListVacationRentalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSitemapRegionsListVacationRentalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSitemapRegionsListVacationRentalsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useSitemapRegionsListVacationRentalsQuery(baseOptions: Apollo.QueryHookOptions<SitemapRegionsListVacationRentalsQuery, SitemapRegionsListVacationRentalsQueryVariables> & ({ variables: SitemapRegionsListVacationRentalsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SitemapRegionsListVacationRentalsQuery, SitemapRegionsListVacationRentalsQueryVariables>(SitemapRegionsListVacationRentalsDocument, options);
      }
export function useSitemapRegionsListVacationRentalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SitemapRegionsListVacationRentalsQuery, SitemapRegionsListVacationRentalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SitemapRegionsListVacationRentalsQuery, SitemapRegionsListVacationRentalsQueryVariables>(SitemapRegionsListVacationRentalsDocument, options);
        }
export function useSitemapRegionsListVacationRentalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SitemapRegionsListVacationRentalsQuery, SitemapRegionsListVacationRentalsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SitemapRegionsListVacationRentalsQuery, SitemapRegionsListVacationRentalsQueryVariables>(SitemapRegionsListVacationRentalsDocument, options);
        }
export type SitemapRegionsListVacationRentalsQueryHookResult = ReturnType<typeof useSitemapRegionsListVacationRentalsQuery>;
export type SitemapRegionsListVacationRentalsLazyQueryHookResult = ReturnType<typeof useSitemapRegionsListVacationRentalsLazyQuery>;
export type SitemapRegionsListVacationRentalsSuspenseQueryHookResult = ReturnType<typeof useSitemapRegionsListVacationRentalsSuspenseQuery>;
export type SitemapRegionsListVacationRentalsQueryResult = Apollo.QueryResult<SitemapRegionsListVacationRentalsQuery, SitemapRegionsListVacationRentalsQueryVariables>;
export function refetchSitemapRegionsListVacationRentalsQuery(variables: SitemapRegionsListVacationRentalsQueryVariables) {
      return { query: SitemapRegionsListVacationRentalsDocument, variables: variables }
    }
export const TaskStartPmsImportDocument = gql`
    mutation TaskStartPmsImport($accountId: ID!) {
  taskStartPmsImport(accountId: $accountId) {
    __typename
    ... on Task {
      id
    }
    ... on NotFoundError {
      message
    }
    ... on UnauthenticatedError {
      message
    }
    ... on ValidationErrorCollection {
      errors {
        message
        type
        field
      }
    }
  }
}
    `;
export type TaskStartPmsImportMutationFn = Apollo.MutationFunction<TaskStartPmsImportMutation, TaskStartPmsImportMutationVariables>;

/**
 * __useTaskStartPmsImportMutation__
 *
 * To run a mutation, you first call `useTaskStartPmsImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTaskStartPmsImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [taskStartPmsImportMutation, { data, loading, error }] = useTaskStartPmsImportMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useTaskStartPmsImportMutation(baseOptions?: Apollo.MutationHookOptions<TaskStartPmsImportMutation, TaskStartPmsImportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TaskStartPmsImportMutation, TaskStartPmsImportMutationVariables>(TaskStartPmsImportDocument, options);
      }
export type TaskStartPmsImportMutationHookResult = ReturnType<typeof useTaskStartPmsImportMutation>;
export type TaskStartPmsImportMutationResult = Apollo.MutationResult<TaskStartPmsImportMutation>;
export type TaskStartPmsImportMutationOptions = Apollo.BaseMutationOptions<TaskStartPmsImportMutation, TaskStartPmsImportMutationVariables>;
export const TestUnhandledErrorDocument = gql`
    query TestUnhandledError {
  testUnhandledError
}
    `;

/**
 * __useTestUnhandledErrorQuery__
 *
 * To run a query within a React component, call `useTestUnhandledErrorQuery` and pass it any options that fit your needs.
 * When your component renders, `useTestUnhandledErrorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTestUnhandledErrorQuery({
 *   variables: {
 *   },
 * });
 */
export function useTestUnhandledErrorQuery(baseOptions?: Apollo.QueryHookOptions<TestUnhandledErrorQuery, TestUnhandledErrorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TestUnhandledErrorQuery, TestUnhandledErrorQueryVariables>(TestUnhandledErrorDocument, options);
      }
export function useTestUnhandledErrorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TestUnhandledErrorQuery, TestUnhandledErrorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TestUnhandledErrorQuery, TestUnhandledErrorQueryVariables>(TestUnhandledErrorDocument, options);
        }
export function useTestUnhandledErrorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TestUnhandledErrorQuery, TestUnhandledErrorQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TestUnhandledErrorQuery, TestUnhandledErrorQueryVariables>(TestUnhandledErrorDocument, options);
        }
export type TestUnhandledErrorQueryHookResult = ReturnType<typeof useTestUnhandledErrorQuery>;
export type TestUnhandledErrorLazyQueryHookResult = ReturnType<typeof useTestUnhandledErrorLazyQuery>;
export type TestUnhandledErrorSuspenseQueryHookResult = ReturnType<typeof useTestUnhandledErrorSuspenseQuery>;
export type TestUnhandledErrorQueryResult = Apollo.QueryResult<TestUnhandledErrorQuery, TestUnhandledErrorQueryVariables>;
export function refetchTestUnhandledErrorQuery(variables?: TestUnhandledErrorQueryVariables) {
      return { query: TestUnhandledErrorDocument, variables: variables }
    }
export const UserCreateDocument = gql`
    mutation UserCreate($input: UserCreateInput!) {
  userCreate(input: $input) {
    __typename
    ... on User {
      ...UserFields
      refreshToken
    }
    ... on ValidationErrorCollection {
      errors {
        field
        message
        type
      }
    }
  }
}
    ${UserFieldsFragmentDoc}`;
export type UserCreateMutationFn = Apollo.MutationFunction<UserCreateMutation, UserCreateMutationVariables>;

/**
 * __useUserCreateMutation__
 *
 * To run a mutation, you first call `useUserCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userCreateMutation, { data, loading, error }] = useUserCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserCreateMutation(baseOptions?: Apollo.MutationHookOptions<UserCreateMutation, UserCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserCreateMutation, UserCreateMutationVariables>(UserCreateDocument, options);
      }
export type UserCreateMutationHookResult = ReturnType<typeof useUserCreateMutation>;
export type UserCreateMutationResult = Apollo.MutationResult<UserCreateMutation>;
export type UserCreateMutationOptions = Apollo.BaseMutationOptions<UserCreateMutation, UserCreateMutationVariables>;
export const UserSessionDocument = gql`
    mutation UserSession($input: UserSessionInput!) {
  userSession(input: $input) {
    __typename
    ... on User {
      ...UserSessionFields
    }
    ... on UnauthenticatedError {
      message
    }
  }
}
    ${UserSessionFieldsFragmentDoc}`;
export type UserSessionMutationFn = Apollo.MutationFunction<UserSessionMutation, UserSessionMutationVariables>;

/**
 * __useUserSessionMutation__
 *
 * To run a mutation, you first call `useUserSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userSessionMutation, { data, loading, error }] = useUserSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserSessionMutation(baseOptions?: Apollo.MutationHookOptions<UserSessionMutation, UserSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserSessionMutation, UserSessionMutationVariables>(UserSessionDocument, options);
      }
export type UserSessionMutationHookResult = ReturnType<typeof useUserSessionMutation>;
export type UserSessionMutationResult = Apollo.MutationResult<UserSessionMutation>;
export type UserSessionMutationOptions = Apollo.BaseMutationOptions<UserSessionMutation, UserSessionMutationVariables>;
export const UserAppleSocialSessionDocument = gql`
    mutation UserAppleSocialSession($input: UserAppleSocialSessionInput!) {
  userAppleSocialSession(input: $input) {
    __typename
    ... on User {
      ...UserSessionFields
    }
    ... on UnauthenticatedError {
      message
    }
  }
}
    ${UserSessionFieldsFragmentDoc}`;
export type UserAppleSocialSessionMutationFn = Apollo.MutationFunction<UserAppleSocialSessionMutation, UserAppleSocialSessionMutationVariables>;

/**
 * __useUserAppleSocialSessionMutation__
 *
 * To run a mutation, you first call `useUserAppleSocialSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserAppleSocialSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userAppleSocialSessionMutation, { data, loading, error }] = useUserAppleSocialSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserAppleSocialSessionMutation(baseOptions?: Apollo.MutationHookOptions<UserAppleSocialSessionMutation, UserAppleSocialSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserAppleSocialSessionMutation, UserAppleSocialSessionMutationVariables>(UserAppleSocialSessionDocument, options);
      }
export type UserAppleSocialSessionMutationHookResult = ReturnType<typeof useUserAppleSocialSessionMutation>;
export type UserAppleSocialSessionMutationResult = Apollo.MutationResult<UserAppleSocialSessionMutation>;
export type UserAppleSocialSessionMutationOptions = Apollo.BaseMutationOptions<UserAppleSocialSessionMutation, UserAppleSocialSessionMutationVariables>;
export const UserGoogleSocialSessionDocument = gql`
    mutation UserGoogleSocialSession($input: UserGoogleSocialSessionInput!) {
  userGoogleSocialSession(input: $input) {
    __typename
    ... on User {
      ...UserSessionFields
    }
    ... on UnauthenticatedError {
      message
    }
  }
}
    ${UserSessionFieldsFragmentDoc}`;
export type UserGoogleSocialSessionMutationFn = Apollo.MutationFunction<UserGoogleSocialSessionMutation, UserGoogleSocialSessionMutationVariables>;

/**
 * __useUserGoogleSocialSessionMutation__
 *
 * To run a mutation, you first call `useUserGoogleSocialSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserGoogleSocialSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userGoogleSocialSessionMutation, { data, loading, error }] = useUserGoogleSocialSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserGoogleSocialSessionMutation(baseOptions?: Apollo.MutationHookOptions<UserGoogleSocialSessionMutation, UserGoogleSocialSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserGoogleSocialSessionMutation, UserGoogleSocialSessionMutationVariables>(UserGoogleSocialSessionDocument, options);
      }
export type UserGoogleSocialSessionMutationHookResult = ReturnType<typeof useUserGoogleSocialSessionMutation>;
export type UserGoogleSocialSessionMutationResult = Apollo.MutationResult<UserGoogleSocialSessionMutation>;
export type UserGoogleSocialSessionMutationOptions = Apollo.BaseMutationOptions<UserGoogleSocialSessionMutation, UserGoogleSocialSessionMutationVariables>;
export const UserFacebookSocialSessionDocument = gql`
    mutation UserFacebookSocialSession($input: UserFacebookSocialSessionInput!) {
  userFacebookSocialSession(input: $input) {
    __typename
    ... on User {
      ...UserSessionFields
    }
    ... on UnauthenticatedError {
      message
    }
    ... on ValidationErrorCollection {
      errors {
        field
        message
        type
      }
    }
  }
}
    ${UserSessionFieldsFragmentDoc}`;
export type UserFacebookSocialSessionMutationFn = Apollo.MutationFunction<UserFacebookSocialSessionMutation, UserFacebookSocialSessionMutationVariables>;

/**
 * __useUserFacebookSocialSessionMutation__
 *
 * To run a mutation, you first call `useUserFacebookSocialSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserFacebookSocialSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userFacebookSocialSessionMutation, { data, loading, error }] = useUserFacebookSocialSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserFacebookSocialSessionMutation(baseOptions?: Apollo.MutationHookOptions<UserFacebookSocialSessionMutation, UserFacebookSocialSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserFacebookSocialSessionMutation, UserFacebookSocialSessionMutationVariables>(UserFacebookSocialSessionDocument, options);
      }
export type UserFacebookSocialSessionMutationHookResult = ReturnType<typeof useUserFacebookSocialSessionMutation>;
export type UserFacebookSocialSessionMutationResult = Apollo.MutationResult<UserFacebookSocialSessionMutation>;
export type UserFacebookSocialSessionMutationOptions = Apollo.BaseMutationOptions<UserFacebookSocialSessionMutation, UserFacebookSocialSessionMutationVariables>;
export const UserAccountAddDocument = gql`
    mutation UserAccountAdd($input: UserAccountAddInput!) {
  userAccountAdd(input: $input) {
    __typename
    ... on User {
      ...UserFieldsWithAccount
    }
    ... on ValidationErrorCollection {
      errors {
        field
        type
        message
      }
    }
    ... on NotFoundError {
      message
    }
    ... on ConflictError {
      message
    }
  }
}
    ${UserFieldsWithAccountFragmentDoc}`;
export type UserAccountAddMutationFn = Apollo.MutationFunction<UserAccountAddMutation, UserAccountAddMutationVariables>;

/**
 * __useUserAccountAddMutation__
 *
 * To run a mutation, you first call `useUserAccountAddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserAccountAddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userAccountAddMutation, { data, loading, error }] = useUserAccountAddMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserAccountAddMutation(baseOptions?: Apollo.MutationHookOptions<UserAccountAddMutation, UserAccountAddMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserAccountAddMutation, UserAccountAddMutationVariables>(UserAccountAddDocument, options);
      }
export type UserAccountAddMutationHookResult = ReturnType<typeof useUserAccountAddMutation>;
export type UserAccountAddMutationResult = Apollo.MutationResult<UserAccountAddMutation>;
export type UserAccountAddMutationOptions = Apollo.BaseMutationOptions<UserAccountAddMutation, UserAccountAddMutationVariables>;
export const UserSessionRefreshDocument = gql`
    mutation UserSessionRefresh($input: UserSessionRefreshInput!) {
  userSessionRefresh(input: $input) {
    __typename
    ... on User {
      ...UserSessionFields
    }
    ... on UnauthenticatedError {
      message
    }
  }
}
    ${UserSessionFieldsFragmentDoc}`;
export type UserSessionRefreshMutationFn = Apollo.MutationFunction<UserSessionRefreshMutation, UserSessionRefreshMutationVariables>;

/**
 * __useUserSessionRefreshMutation__
 *
 * To run a mutation, you first call `useUserSessionRefreshMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserSessionRefreshMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userSessionRefreshMutation, { data, loading, error }] = useUserSessionRefreshMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserSessionRefreshMutation(baseOptions?: Apollo.MutationHookOptions<UserSessionRefreshMutation, UserSessionRefreshMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserSessionRefreshMutation, UserSessionRefreshMutationVariables>(UserSessionRefreshDocument, options);
      }
export type UserSessionRefreshMutationHookResult = ReturnType<typeof useUserSessionRefreshMutation>;
export type UserSessionRefreshMutationResult = Apollo.MutationResult<UserSessionRefreshMutation>;
export type UserSessionRefreshMutationOptions = Apollo.BaseMutationOptions<UserSessionRefreshMutation, UserSessionRefreshMutationVariables>;
export const UserAccountRemoveDocument = gql`
    mutation UserAccountRemove($input: UserAccountRemoveInput!) {
  userAccountRemove(input: $input) {
    __typename
    ... on User {
      ...UserFieldsWithAccount
    }
    ... on ValidationErrorCollection {
      errors {
        field
        type
        message
      }
    }
    ... on NotFoundError {
      message
    }
    ... on ConflictError {
      message
    }
  }
}
    ${UserFieldsWithAccountFragmentDoc}`;
export type UserAccountRemoveMutationFn = Apollo.MutationFunction<UserAccountRemoveMutation, UserAccountRemoveMutationVariables>;

/**
 * __useUserAccountRemoveMutation__
 *
 * To run a mutation, you first call `useUserAccountRemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserAccountRemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userAccountRemoveMutation, { data, loading, error }] = useUserAccountRemoveMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserAccountRemoveMutation(baseOptions?: Apollo.MutationHookOptions<UserAccountRemoveMutation, UserAccountRemoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserAccountRemoveMutation, UserAccountRemoveMutationVariables>(UserAccountRemoveDocument, options);
      }
export type UserAccountRemoveMutationHookResult = ReturnType<typeof useUserAccountRemoveMutation>;
export type UserAccountRemoveMutationResult = Apollo.MutationResult<UserAccountRemoveMutation>;
export type UserAccountRemoveMutationOptions = Apollo.BaseMutationOptions<UserAccountRemoveMutation, UserAccountRemoveMutationVariables>;
export const UserUpdateDocument = gql`
    mutation UserUpdate($input: UserUpdateInput!) {
  userUpdate(input: $input) {
    __typename
    ... on User {
      id
      email
      firstName
      lastName
      phoneNumber
      avatarUrl
      dob
    }
    ... on UnauthenticatedError {
      message
    }
    ... on ValidationErrorCollection {
      errors {
        message
        type
        field
      }
    }
  }
}
    `;
export type UserUpdateMutationFn = Apollo.MutationFunction<UserUpdateMutation, UserUpdateMutationVariables>;

/**
 * __useUserUpdateMutation__
 *
 * To run a mutation, you first call `useUserUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userUpdateMutation, { data, loading, error }] = useUserUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserUpdateMutation(baseOptions?: Apollo.MutationHookOptions<UserUpdateMutation, UserUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserUpdateMutation, UserUpdateMutationVariables>(UserUpdateDocument, options);
      }
export type UserUpdateMutationHookResult = ReturnType<typeof useUserUpdateMutation>;
export type UserUpdateMutationResult = Apollo.MutationResult<UserUpdateMutation>;
export type UserUpdateMutationOptions = Apollo.BaseMutationOptions<UserUpdateMutation, UserUpdateMutationVariables>;
export const CurrentUserDocument = gql`
    query CurrentUser {
  currentUser {
    __typename
    ... on User {
      ...UserFieldsWithAccount
    }
    ... on UnauthenticatedError {
      message
    }
  }
}
    ${UserFieldsWithAccountFragmentDoc}`;

/**
 * __useCurrentUserQuery__
 *
 * To run a query within a React component, call `useCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
      }
export function useCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
        }
export function useCurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
        }
export type CurrentUserQueryHookResult = ReturnType<typeof useCurrentUserQuery>;
export type CurrentUserLazyQueryHookResult = ReturnType<typeof useCurrentUserLazyQuery>;
export type CurrentUserSuspenseQueryHookResult = ReturnType<typeof useCurrentUserSuspenseQuery>;
export type CurrentUserQueryResult = Apollo.QueryResult<CurrentUserQuery, CurrentUserQueryVariables>;
export function refetchCurrentUserQuery(variables?: CurrentUserQueryVariables) {
      return { query: CurrentUserDocument, variables: variables }
    }